import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | undefined;
export type InputMaybe<T> = T | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  _text: string[];
  bigint: any;
  date: any;
  float8: any;
  name: any;
  numeric: number;
  timestamptz: string;
  uuid: any;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type IBoolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']>;
  _gt?: InputMaybe<Scalars['Boolean']>;
  _gte?: InputMaybe<Scalars['Boolean']>;
  _in?: InputMaybe<Array<Scalars['Boolean']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Boolean']>;
  _lte?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Scalars['Boolean']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']>>;
};

export type ICoachMultilangTranslation = {
  bio?: InputMaybe<Scalars['String']>;
  locale_id?: InputMaybe<Scalars['Int']>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type IInt_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']>;
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

export type IRegisterCoachInput = {
  address_city: Scalars['String'];
  address_country: Scalars['String'];
  address_postal_code: Scalars['String'];
  address_street: Scalars['String'];
  coach_translations: Array<ICoachMultilangTranslation>;
  email: Scalars['String'];
  fiscal_id_number: Scalars['String'];
  name: Scalars['String'];
  password: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  platform_content_access: Scalars['Boolean'];
  platform_fee: Scalars['Float'];
  profile_picture?: InputMaybe<Scalars['String']>;
  public: Scalars['Boolean'];
  spoken_languages: Scalars['String'];
  sport_ids: Array<Scalars['String']>;
};

export type IRegisterInput = {
  address_city?: InputMaybe<Scalars['String']>;
  address_country?: InputMaybe<Scalars['String']>;
  address_postal_code?: InputMaybe<Scalars['String']>;
  address_street?: InputMaybe<Scalars['String']>;
  birthday: Scalars['Date'];
  coach_id?: InputMaybe<Scalars['Int']>;
  email: Scalars['String'];
  email_language: Scalars['String'];
  fiscal_id_number?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  goal?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Float']>;
  max_heart_rate?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  password: Scalars['String'];
  phone: Scalars['String'];
  rest_heart_rate?: InputMaybe<Scalars['Float']>;
  sport_id?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type IString_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']>;
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

export type IValidateCoachInput = {
  id: Scalars['Int'];
  is_verified: Scalars['Boolean'];
  mail: Scalars['String'];
  message: Scalars['String'];
  user_id: Scalars['Int'];
};

/** Boolean expression to compare columns of type "_text". All fields are combined with logical 'AND'. */
export type I_Text_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['_text']>;
  _gt?: InputMaybe<Scalars['_text']>;
  _gte?: InputMaybe<Scalars['_text']>;
  _in?: InputMaybe<Array<Scalars['_text']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['_text']>;
  _lte?: InputMaybe<Scalars['_text']>;
  _neq?: InputMaybe<Scalars['_text']>;
  _nin?: InputMaybe<Array<Scalars['_text']>>;
};

export type IAthlete_Aggregate_Bool_Exp = {
  count?: InputMaybe<IAthlete_Aggregate_Bool_Exp_Count>;
};

export type IAthlete_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<IAthlete_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IAthlete_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

/** order by aggregate values of table "athlete" */
export type IAthlete_Aggregate_Order_By = {
  avg?: InputMaybe<IAthlete_Avg_Order_By>;
  count?: InputMaybe<IOrder_By>;
  max?: InputMaybe<IAthlete_Max_Order_By>;
  min?: InputMaybe<IAthlete_Min_Order_By>;
  stddev?: InputMaybe<IAthlete_Stddev_Order_By>;
  stddev_pop?: InputMaybe<IAthlete_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<IAthlete_Stddev_Samp_Order_By>;
  sum?: InputMaybe<IAthlete_Sum_Order_By>;
  var_pop?: InputMaybe<IAthlete_Var_Pop_Order_By>;
  var_samp?: InputMaybe<IAthlete_Var_Samp_Order_By>;
  variance?: InputMaybe<IAthlete_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "athlete" */
export type IAthlete_Arr_Rel_Insert_Input = {
  data: Array<IAthlete_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<IAthlete_On_Conflict>;
};

/** order by avg() on columns of table "athlete" */
export type IAthlete_Avg_Order_By = {
  athlete_profile_id?: InputMaybe<IOrder_By>;
  birthday_month_day?: InputMaybe<IOrder_By>;
  coach_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  user_id?: InputMaybe<IOrder_By>;
};

export type IAthlete_Biometric_Data_Aggregate_Bool_Exp = {
  count?: InputMaybe<IAthlete_Biometric_Data_Aggregate_Bool_Exp_Count>;
};

export type IAthlete_Biometric_Data_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<IAthlete_Biometric_Data_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IAthlete_Biometric_Data_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

/** order by aggregate values of table "athlete_biometric_data" */
export type IAthlete_Biometric_Data_Aggregate_Order_By = {
  avg?: InputMaybe<IAthlete_Biometric_Data_Avg_Order_By>;
  count?: InputMaybe<IOrder_By>;
  max?: InputMaybe<IAthlete_Biometric_Data_Max_Order_By>;
  min?: InputMaybe<IAthlete_Biometric_Data_Min_Order_By>;
  stddev?: InputMaybe<IAthlete_Biometric_Data_Stddev_Order_By>;
  stddev_pop?: InputMaybe<IAthlete_Biometric_Data_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<IAthlete_Biometric_Data_Stddev_Samp_Order_By>;
  sum?: InputMaybe<IAthlete_Biometric_Data_Sum_Order_By>;
  var_pop?: InputMaybe<IAthlete_Biometric_Data_Var_Pop_Order_By>;
  var_samp?: InputMaybe<IAthlete_Biometric_Data_Var_Samp_Order_By>;
  variance?: InputMaybe<IAthlete_Biometric_Data_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "athlete_biometric_data" */
export type IAthlete_Biometric_Data_Arr_Rel_Insert_Input = {
  data: Array<IAthlete_Biometric_Data_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<IAthlete_Biometric_Data_On_Conflict>;
};

/** order by avg() on columns of table "athlete_biometric_data" */
export type IAthlete_Biometric_Data_Avg_Order_By = {
  athlete_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  value?: InputMaybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "athlete_biometric_data". All fields are combined with a logical 'AND'. */
export type IAthlete_Biometric_Data_Bool_Exp = {
  _and?: InputMaybe<Array<IAthlete_Biometric_Data_Bool_Exp>>;
  _not?: InputMaybe<IAthlete_Biometric_Data_Bool_Exp>;
  _or?: InputMaybe<Array<IAthlete_Biometric_Data_Bool_Exp>>;
  athlete?: InputMaybe<IAthlete_Bool_Exp>;
  athlete_id?: InputMaybe<IInt_Comparison_Exp>;
  biometric_parameter?: InputMaybe<IBiometric_Parameter_Bool_Exp>;
  biometric_parameter_id?: InputMaybe<IString_Comparison_Exp>;
  created_at?: InputMaybe<ITimestamptz_Comparison_Exp>;
  file_url?: InputMaybe<IString_Comparison_Exp>;
  id?: InputMaybe<IInt_Comparison_Exp>;
  value?: InputMaybe<INumeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "athlete_biometric_data" */
export enum IAthlete_Biometric_Data_Constraint {
  /** unique or primary key constraint on columns "id" */
  AthleteBiometricDataPkey = 'athlete_biometric_data_pkey'
}

/** input type for incrementing numeric columns in table "athlete_biometric_data" */
export type IAthlete_Biometric_Data_Inc_Input = {
  athlete_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "athlete_biometric_data" */
export type IAthlete_Biometric_Data_Insert_Input = {
  athlete?: InputMaybe<IAthlete_Obj_Rel_Insert_Input>;
  athlete_id?: InputMaybe<Scalars['Int']>;
  biometric_parameter?: InputMaybe<IBiometric_Parameter_Obj_Rel_Insert_Input>;
  biometric_parameter_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  file_url?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['numeric']>;
};

/** order by max() on columns of table "athlete_biometric_data" */
export type IAthlete_Biometric_Data_Max_Order_By = {
  athlete_id?: InputMaybe<IOrder_By>;
  biometric_parameter_id?: InputMaybe<IOrder_By>;
  created_at?: InputMaybe<IOrder_By>;
  file_url?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  value?: InputMaybe<IOrder_By>;
};

/** order by min() on columns of table "athlete_biometric_data" */
export type IAthlete_Biometric_Data_Min_Order_By = {
  athlete_id?: InputMaybe<IOrder_By>;
  biometric_parameter_id?: InputMaybe<IOrder_By>;
  created_at?: InputMaybe<IOrder_By>;
  file_url?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  value?: InputMaybe<IOrder_By>;
};

/** on_conflict condition type for table "athlete_biometric_data" */
export type IAthlete_Biometric_Data_On_Conflict = {
  constraint: IAthlete_Biometric_Data_Constraint;
  update_columns?: Array<IAthlete_Biometric_Data_Update_Column>;
  where?: InputMaybe<IAthlete_Biometric_Data_Bool_Exp>;
};

/** Ordering options when selecting data from "athlete_biometric_data". */
export type IAthlete_Biometric_Data_Order_By = {
  athlete?: InputMaybe<IAthlete_Order_By>;
  athlete_id?: InputMaybe<IOrder_By>;
  biometric_parameter?: InputMaybe<IBiometric_Parameter_Order_By>;
  biometric_parameter_id?: InputMaybe<IOrder_By>;
  created_at?: InputMaybe<IOrder_By>;
  file_url?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  value?: InputMaybe<IOrder_By>;
};

/** primary key columns input for table: athlete_biometric_data */
export type IAthlete_Biometric_Data_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "athlete_biometric_data" */
export enum IAthlete_Biometric_Data_Select_Column {
  /** column name */
  AthleteId = 'athlete_id',
  /** column name */
  BiometricParameterId = 'biometric_parameter_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FileUrl = 'file_url',
  /** column name */
  Id = 'id',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "athlete_biometric_data" */
export type IAthlete_Biometric_Data_Set_Input = {
  athlete_id?: InputMaybe<Scalars['Int']>;
  biometric_parameter_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  file_url?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['numeric']>;
};

/** order by stddev() on columns of table "athlete_biometric_data" */
export type IAthlete_Biometric_Data_Stddev_Order_By = {
  athlete_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  value?: InputMaybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "athlete_biometric_data" */
export type IAthlete_Biometric_Data_Stddev_Pop_Order_By = {
  athlete_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  value?: InputMaybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "athlete_biometric_data" */
export type IAthlete_Biometric_Data_Stddev_Samp_Order_By = {
  athlete_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  value?: InputMaybe<IOrder_By>;
};

/** Streaming cursor of the table "athlete_biometric_data" */
export type IAthlete_Biometric_Data_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IAthlete_Biometric_Data_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IAthlete_Biometric_Data_Stream_Cursor_Value_Input = {
  athlete_id?: InputMaybe<Scalars['Int']>;
  biometric_parameter_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  file_url?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "athlete_biometric_data" */
export type IAthlete_Biometric_Data_Sum_Order_By = {
  athlete_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  value?: InputMaybe<IOrder_By>;
};

/** update columns of table "athlete_biometric_data" */
export enum IAthlete_Biometric_Data_Update_Column {
  /** column name */
  AthleteId = 'athlete_id',
  /** column name */
  BiometricParameterId = 'biometric_parameter_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FileUrl = 'file_url',
  /** column name */
  Id = 'id',
  /** column name */
  Value = 'value'
}

export type IAthlete_Biometric_Data_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<IAthlete_Biometric_Data_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IAthlete_Biometric_Data_Set_Input>;
  /** filter the rows which have to be updated */
  where: IAthlete_Biometric_Data_Bool_Exp;
};

/** order by var_pop() on columns of table "athlete_biometric_data" */
export type IAthlete_Biometric_Data_Var_Pop_Order_By = {
  athlete_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  value?: InputMaybe<IOrder_By>;
};

/** order by var_samp() on columns of table "athlete_biometric_data" */
export type IAthlete_Biometric_Data_Var_Samp_Order_By = {
  athlete_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  value?: InputMaybe<IOrder_By>;
};

/** order by variance() on columns of table "athlete_biometric_data" */
export type IAthlete_Biometric_Data_Variance_Order_By = {
  athlete_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  value?: InputMaybe<IOrder_By>;
};

export type IAthlete_Block_Aggregate_Bool_Exp = {
  count?: InputMaybe<IAthlete_Block_Aggregate_Bool_Exp_Count>;
};

export type IAthlete_Block_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<IAthlete_Block_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IAthlete_Block_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

/** order by aggregate values of table "athlete_block" */
export type IAthlete_Block_Aggregate_Order_By = {
  avg?: InputMaybe<IAthlete_Block_Avg_Order_By>;
  count?: InputMaybe<IOrder_By>;
  max?: InputMaybe<IAthlete_Block_Max_Order_By>;
  min?: InputMaybe<IAthlete_Block_Min_Order_By>;
  stddev?: InputMaybe<IAthlete_Block_Stddev_Order_By>;
  stddev_pop?: InputMaybe<IAthlete_Block_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<IAthlete_Block_Stddev_Samp_Order_By>;
  sum?: InputMaybe<IAthlete_Block_Sum_Order_By>;
  var_pop?: InputMaybe<IAthlete_Block_Var_Pop_Order_By>;
  var_samp?: InputMaybe<IAthlete_Block_Var_Samp_Order_By>;
  variance?: InputMaybe<IAthlete_Block_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "athlete_block" */
export type IAthlete_Block_Arr_Rel_Insert_Input = {
  data: Array<IAthlete_Block_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<IAthlete_Block_On_Conflict>;
};

/** order by avg() on columns of table "athlete_block" */
export type IAthlete_Block_Avg_Order_By = {
  athlete_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "athlete_block". All fields are combined with a logical 'AND'. */
export type IAthlete_Block_Bool_Exp = {
  _and?: InputMaybe<Array<IAthlete_Block_Bool_Exp>>;
  _not?: InputMaybe<IAthlete_Block_Bool_Exp>;
  _or?: InputMaybe<Array<IAthlete_Block_Bool_Exp>>;
  athlete?: InputMaybe<IAthlete_Bool_Exp>;
  athlete_id?: InputMaybe<IInt_Comparison_Exp>;
  athlete_weeks?: InputMaybe<IAthlete_Week_Bool_Exp>;
  athlete_weeks_aggregate?: InputMaybe<IAthlete_Week_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<ITimestamptz_Comparison_Exp>;
  end_date?: InputMaybe<IDate_Comparison_Exp>;
  id?: InputMaybe<IInt_Comparison_Exp>;
  name?: InputMaybe<IString_Comparison_Exp>;
  sport?: InputMaybe<ISport_Bool_Exp>;
  sport_id?: InputMaybe<IString_Comparison_Exp>;
  start_date?: InputMaybe<IDate_Comparison_Exp>;
  updated_at?: InputMaybe<ITimestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "athlete_block" */
export enum IAthlete_Block_Constraint {
  /** unique or primary key constraint on columns "id" */
  AthleteBlockPkey = 'athlete_block_pkey'
}

/** input type for incrementing numeric columns in table "athlete_block" */
export type IAthlete_Block_Inc_Input = {
  athlete_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "athlete_block" */
export type IAthlete_Block_Insert_Input = {
  athlete?: InputMaybe<IAthlete_Obj_Rel_Insert_Input>;
  athlete_id?: InputMaybe<Scalars['Int']>;
  athlete_weeks?: InputMaybe<IAthlete_Week_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  end_date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  sport?: InputMaybe<ISport_Obj_Rel_Insert_Input>;
  sport_id?: InputMaybe<Scalars['String']>;
  start_date?: InputMaybe<Scalars['date']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "athlete_block" */
export type IAthlete_Block_Max_Order_By = {
  athlete_id?: InputMaybe<IOrder_By>;
  created_at?: InputMaybe<IOrder_By>;
  end_date?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  name?: InputMaybe<IOrder_By>;
  sport_id?: InputMaybe<IOrder_By>;
  start_date?: InputMaybe<IOrder_By>;
  updated_at?: InputMaybe<IOrder_By>;
};

/** order by min() on columns of table "athlete_block" */
export type IAthlete_Block_Min_Order_By = {
  athlete_id?: InputMaybe<IOrder_By>;
  created_at?: InputMaybe<IOrder_By>;
  end_date?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  name?: InputMaybe<IOrder_By>;
  sport_id?: InputMaybe<IOrder_By>;
  start_date?: InputMaybe<IOrder_By>;
  updated_at?: InputMaybe<IOrder_By>;
};

/** input type for inserting object relation for remote table "athlete_block" */
export type IAthlete_Block_Obj_Rel_Insert_Input = {
  data: IAthlete_Block_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<IAthlete_Block_On_Conflict>;
};

/** on_conflict condition type for table "athlete_block" */
export type IAthlete_Block_On_Conflict = {
  constraint: IAthlete_Block_Constraint;
  update_columns?: Array<IAthlete_Block_Update_Column>;
  where?: InputMaybe<IAthlete_Block_Bool_Exp>;
};

/** Ordering options when selecting data from "athlete_block". */
export type IAthlete_Block_Order_By = {
  athlete?: InputMaybe<IAthlete_Order_By>;
  athlete_id?: InputMaybe<IOrder_By>;
  athlete_weeks_aggregate?: InputMaybe<IAthlete_Week_Aggregate_Order_By>;
  created_at?: InputMaybe<IOrder_By>;
  end_date?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  name?: InputMaybe<IOrder_By>;
  sport?: InputMaybe<ISport_Order_By>;
  sport_id?: InputMaybe<IOrder_By>;
  start_date?: InputMaybe<IOrder_By>;
  updated_at?: InputMaybe<IOrder_By>;
};

/** primary key columns input for table: athlete_block */
export type IAthlete_Block_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "athlete_block" */
export enum IAthlete_Block_Select_Column {
  /** column name */
  AthleteId = 'athlete_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  SportId = 'sport_id',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "athlete_block" */
export type IAthlete_Block_Set_Input = {
  athlete_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  end_date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  sport_id?: InputMaybe<Scalars['String']>;
  start_date?: InputMaybe<Scalars['date']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** order by stddev() on columns of table "athlete_block" */
export type IAthlete_Block_Stddev_Order_By = {
  athlete_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "athlete_block" */
export type IAthlete_Block_Stddev_Pop_Order_By = {
  athlete_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "athlete_block" */
export type IAthlete_Block_Stddev_Samp_Order_By = {
  athlete_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
};

/** Streaming cursor of the table "athlete_block" */
export type IAthlete_Block_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IAthlete_Block_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IAthlete_Block_Stream_Cursor_Value_Input = {
  athlete_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  end_date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  sport_id?: InputMaybe<Scalars['String']>;
  start_date?: InputMaybe<Scalars['date']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** order by sum() on columns of table "athlete_block" */
export type IAthlete_Block_Sum_Order_By = {
  athlete_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
};

/** update columns of table "athlete_block" */
export enum IAthlete_Block_Update_Column {
  /** column name */
  AthleteId = 'athlete_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  SportId = 'sport_id',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type IAthlete_Block_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<IAthlete_Block_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IAthlete_Block_Set_Input>;
  /** filter the rows which have to be updated */
  where: IAthlete_Block_Bool_Exp;
};

/** order by var_pop() on columns of table "athlete_block" */
export type IAthlete_Block_Var_Pop_Order_By = {
  athlete_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
};

/** order by var_samp() on columns of table "athlete_block" */
export type IAthlete_Block_Var_Samp_Order_By = {
  athlete_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
};

/** order by variance() on columns of table "athlete_block" */
export type IAthlete_Block_Variance_Order_By = {
  athlete_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "athlete". All fields are combined with a logical 'AND'. */
export type IAthlete_Bool_Exp = {
  _and?: InputMaybe<Array<IAthlete_Bool_Exp>>;
  _not?: InputMaybe<IAthlete_Bool_Exp>;
  _or?: InputMaybe<Array<IAthlete_Bool_Exp>>;
  address_city?: InputMaybe<IString_Comparison_Exp>;
  address_country?: InputMaybe<IString_Comparison_Exp>;
  address_postal_code?: InputMaybe<IString_Comparison_Exp>;
  address_street?: InputMaybe<IString_Comparison_Exp>;
  athlete_biometric_data?: InputMaybe<IAthlete_Biometric_Data_Bool_Exp>;
  athlete_biometric_data_aggregate?: InputMaybe<IAthlete_Biometric_Data_Aggregate_Bool_Exp>;
  athlete_blocks?: InputMaybe<IAthlete_Block_Bool_Exp>;
  athlete_blocks_aggregate?: InputMaybe<IAthlete_Block_Aggregate_Bool_Exp>;
  athlete_challenges?: InputMaybe<IAthlete_Challenge_Bool_Exp>;
  athlete_challenges_aggregate?: InputMaybe<IAthlete_Challenge_Aggregate_Bool_Exp>;
  athlete_profile?: InputMaybe<IAthlete_Profile_Bool_Exp>;
  athlete_profile_id?: InputMaybe<IInt_Comparison_Exp>;
  athlete_speeds?: InputMaybe<IAthlete_Speed_Bool_Exp>;
  athlete_speeds_aggregate?: InputMaybe<IAthlete_Speed_Aggregate_Bool_Exp>;
  avatar?: InputMaybe<IString_Comparison_Exp>;
  birthday?: InputMaybe<IDate_Comparison_Exp>;
  birthday_month_day?: InputMaybe<IInt_Comparison_Exp>;
  coach?: InputMaybe<ICoach_Bool_Exp>;
  coach_id?: InputMaybe<IInt_Comparison_Exp>;
  created_at?: InputMaybe<ITimestamptz_Comparison_Exp>;
  email_language?: InputMaybe<IString_Comparison_Exp>;
  fiscal_id_number?: InputMaybe<IString_Comparison_Exp>;
  gender?: InputMaybe<IString_Comparison_Exp>;
  goal?: InputMaybe<IString_Comparison_Exp>;
  id?: InputMaybe<IInt_Comparison_Exp>;
  name?: InputMaybe<IString_Comparison_Exp>;
  phone?: InputMaybe<IString_Comparison_Exp>;
  sport?: InputMaybe<ISport_Bool_Exp>;
  sport_id?: InputMaybe<IString_Comparison_Exp>;
  status?: InputMaybe<IString_Comparison_Exp>;
  stripe_customer_id?: InputMaybe<IString_Comparison_Exp>;
  subscriptions?: InputMaybe<ISubscription_Bool_Exp>;
  subscriptions_aggregate?: InputMaybe<ISubscription_Aggregate_Bool_Exp>;
  type?: InputMaybe<IString_Comparison_Exp>;
  updated_at?: InputMaybe<ITimestamptz_Comparison_Exp>;
  user?: InputMaybe<IUser_Bool_Exp>;
  user_id?: InputMaybe<IInt_Comparison_Exp>;
};

export type IAthlete_Challenge_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<IAthlete_Challenge_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<IAthlete_Challenge_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<IAthlete_Challenge_Aggregate_Bool_Exp_Count>;
};

export type IAthlete_Challenge_Aggregate_Bool_Exp_Bool_And = {
  arguments: IAthlete_Challenge_Select_Column_Athlete_Challenge_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IAthlete_Challenge_Bool_Exp>;
  predicate: IBoolean_Comparison_Exp;
};

export type IAthlete_Challenge_Aggregate_Bool_Exp_Bool_Or = {
  arguments: IAthlete_Challenge_Select_Column_Athlete_Challenge_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IAthlete_Challenge_Bool_Exp>;
  predicate: IBoolean_Comparison_Exp;
};

export type IAthlete_Challenge_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<IAthlete_Challenge_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IAthlete_Challenge_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

/** order by aggregate values of table "athlete_challenge" */
export type IAthlete_Challenge_Aggregate_Order_By = {
  avg?: InputMaybe<IAthlete_Challenge_Avg_Order_By>;
  count?: InputMaybe<IOrder_By>;
  max?: InputMaybe<IAthlete_Challenge_Max_Order_By>;
  min?: InputMaybe<IAthlete_Challenge_Min_Order_By>;
  stddev?: InputMaybe<IAthlete_Challenge_Stddev_Order_By>;
  stddev_pop?: InputMaybe<IAthlete_Challenge_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<IAthlete_Challenge_Stddev_Samp_Order_By>;
  sum?: InputMaybe<IAthlete_Challenge_Sum_Order_By>;
  var_pop?: InputMaybe<IAthlete_Challenge_Var_Pop_Order_By>;
  var_samp?: InputMaybe<IAthlete_Challenge_Var_Samp_Order_By>;
  variance?: InputMaybe<IAthlete_Challenge_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "athlete_challenge" */
export type IAthlete_Challenge_Arr_Rel_Insert_Input = {
  data: Array<IAthlete_Challenge_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<IAthlete_Challenge_On_Conflict>;
};

/** order by avg() on columns of table "athlete_challenge" */
export type IAthlete_Challenge_Avg_Order_By = {
  athlete_id?: InputMaybe<IOrder_By>;
  cumulated_univeness?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  negative_univeness?: InputMaybe<IOrder_By>;
  positive_univeness?: InputMaybe<IOrder_By>;
  time_done_hours?: InputMaybe<IOrder_By>;
  time_done_minutes?: InputMaybe<IOrder_By>;
  time_goal_hours?: InputMaybe<IOrder_By>;
  time_goal_minutes?: InputMaybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "athlete_challenge". All fields are combined with a logical 'AND'. */
export type IAthlete_Challenge_Bool_Exp = {
  _and?: InputMaybe<Array<IAthlete_Challenge_Bool_Exp>>;
  _not?: InputMaybe<IAthlete_Challenge_Bool_Exp>;
  _or?: InputMaybe<Array<IAthlete_Challenge_Bool_Exp>>;
  athlete?: InputMaybe<IAthlete_Bool_Exp>;
  athlete_id?: InputMaybe<IInt_Comparison_Exp>;
  completed_at?: InputMaybe<IDate_Comparison_Exp>;
  created_at?: InputMaybe<ITimestamptz_Comparison_Exp>;
  cumulated_univeness?: InputMaybe<IInt_Comparison_Exp>;
  date?: InputMaybe<IDate_Comparison_Exp>;
  description?: InputMaybe<IString_Comparison_Exp>;
  distance?: InputMaybe<IString_Comparison_Exp>;
  id?: InputMaybe<IInt_Comparison_Exp>;
  is_main?: InputMaybe<IBoolean_Comparison_Exp>;
  negative_univeness?: InputMaybe<IInt_Comparison_Exp>;
  notes?: InputMaybe<IString_Comparison_Exp>;
  positive_univeness?: InputMaybe<IInt_Comparison_Exp>;
  result?: InputMaybe<IString_Comparison_Exp>;
  sport?: InputMaybe<ISport_Bool_Exp>;
  sport_id?: InputMaybe<IString_Comparison_Exp>;
  time_done_hours?: InputMaybe<IInt_Comparison_Exp>;
  time_done_minutes?: InputMaybe<IInt_Comparison_Exp>;
  time_goal_hours?: InputMaybe<IInt_Comparison_Exp>;
  time_goal_minutes?: InputMaybe<IInt_Comparison_Exp>;
};

/** unique or primary key constraints on table "athlete_challenge" */
export enum IAthlete_Challenge_Constraint {
  /** unique or primary key constraint on columns "id" */
  AthleteChallengePkey = 'athlete_challenge_pkey'
}

/** input type for incrementing numeric columns in table "athlete_challenge" */
export type IAthlete_Challenge_Inc_Input = {
  athlete_id?: InputMaybe<Scalars['Int']>;
  cumulated_univeness?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  negative_univeness?: InputMaybe<Scalars['Int']>;
  positive_univeness?: InputMaybe<Scalars['Int']>;
  time_done_hours?: InputMaybe<Scalars['Int']>;
  time_done_minutes?: InputMaybe<Scalars['Int']>;
  time_goal_hours?: InputMaybe<Scalars['Int']>;
  time_goal_minutes?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "athlete_challenge" */
export type IAthlete_Challenge_Insert_Input = {
  athlete?: InputMaybe<IAthlete_Obj_Rel_Insert_Input>;
  athlete_id?: InputMaybe<Scalars['Int']>;
  completed_at?: InputMaybe<Scalars['date']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  cumulated_univeness?: InputMaybe<Scalars['Int']>;
  date?: InputMaybe<Scalars['date']>;
  description?: InputMaybe<Scalars['String']>;
  distance?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_main?: InputMaybe<Scalars['Boolean']>;
  negative_univeness?: InputMaybe<Scalars['Int']>;
  notes?: InputMaybe<Scalars['String']>;
  positive_univeness?: InputMaybe<Scalars['Int']>;
  result?: InputMaybe<Scalars['String']>;
  sport?: InputMaybe<ISport_Obj_Rel_Insert_Input>;
  sport_id?: InputMaybe<Scalars['String']>;
  time_done_hours?: InputMaybe<Scalars['Int']>;
  time_done_minutes?: InputMaybe<Scalars['Int']>;
  time_goal_hours?: InputMaybe<Scalars['Int']>;
  time_goal_minutes?: InputMaybe<Scalars['Int']>;
};

/** order by max() on columns of table "athlete_challenge" */
export type IAthlete_Challenge_Max_Order_By = {
  athlete_id?: InputMaybe<IOrder_By>;
  completed_at?: InputMaybe<IOrder_By>;
  created_at?: InputMaybe<IOrder_By>;
  cumulated_univeness?: InputMaybe<IOrder_By>;
  date?: InputMaybe<IOrder_By>;
  description?: InputMaybe<IOrder_By>;
  distance?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  negative_univeness?: InputMaybe<IOrder_By>;
  notes?: InputMaybe<IOrder_By>;
  positive_univeness?: InputMaybe<IOrder_By>;
  result?: InputMaybe<IOrder_By>;
  sport_id?: InputMaybe<IOrder_By>;
  time_done_hours?: InputMaybe<IOrder_By>;
  time_done_minutes?: InputMaybe<IOrder_By>;
  time_goal_hours?: InputMaybe<IOrder_By>;
  time_goal_minutes?: InputMaybe<IOrder_By>;
};

/** order by min() on columns of table "athlete_challenge" */
export type IAthlete_Challenge_Min_Order_By = {
  athlete_id?: InputMaybe<IOrder_By>;
  completed_at?: InputMaybe<IOrder_By>;
  created_at?: InputMaybe<IOrder_By>;
  cumulated_univeness?: InputMaybe<IOrder_By>;
  date?: InputMaybe<IOrder_By>;
  description?: InputMaybe<IOrder_By>;
  distance?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  negative_univeness?: InputMaybe<IOrder_By>;
  notes?: InputMaybe<IOrder_By>;
  positive_univeness?: InputMaybe<IOrder_By>;
  result?: InputMaybe<IOrder_By>;
  sport_id?: InputMaybe<IOrder_By>;
  time_done_hours?: InputMaybe<IOrder_By>;
  time_done_minutes?: InputMaybe<IOrder_By>;
  time_goal_hours?: InputMaybe<IOrder_By>;
  time_goal_minutes?: InputMaybe<IOrder_By>;
};

/** on_conflict condition type for table "athlete_challenge" */
export type IAthlete_Challenge_On_Conflict = {
  constraint: IAthlete_Challenge_Constraint;
  update_columns?: Array<IAthlete_Challenge_Update_Column>;
  where?: InputMaybe<IAthlete_Challenge_Bool_Exp>;
};

/** Ordering options when selecting data from "athlete_challenge". */
export type IAthlete_Challenge_Order_By = {
  athlete?: InputMaybe<IAthlete_Order_By>;
  athlete_id?: InputMaybe<IOrder_By>;
  completed_at?: InputMaybe<IOrder_By>;
  created_at?: InputMaybe<IOrder_By>;
  cumulated_univeness?: InputMaybe<IOrder_By>;
  date?: InputMaybe<IOrder_By>;
  description?: InputMaybe<IOrder_By>;
  distance?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  is_main?: InputMaybe<IOrder_By>;
  negative_univeness?: InputMaybe<IOrder_By>;
  notes?: InputMaybe<IOrder_By>;
  positive_univeness?: InputMaybe<IOrder_By>;
  result?: InputMaybe<IOrder_By>;
  sport?: InputMaybe<ISport_Order_By>;
  sport_id?: InputMaybe<IOrder_By>;
  time_done_hours?: InputMaybe<IOrder_By>;
  time_done_minutes?: InputMaybe<IOrder_By>;
  time_goal_hours?: InputMaybe<IOrder_By>;
  time_goal_minutes?: InputMaybe<IOrder_By>;
};

/** primary key columns input for table: athlete_challenge */
export type IAthlete_Challenge_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "athlete_challenge" */
export enum IAthlete_Challenge_Select_Column {
  /** column name */
  AthleteId = 'athlete_id',
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CumulatedUniveness = 'cumulated_univeness',
  /** column name */
  Date = 'date',
  /** column name */
  Description = 'description',
  /** column name */
  Distance = 'distance',
  /** column name */
  Id = 'id',
  /** column name */
  IsMain = 'is_main',
  /** column name */
  NegativeUniveness = 'negative_univeness',
  /** column name */
  Notes = 'notes',
  /** column name */
  PositiveUniveness = 'positive_univeness',
  /** column name */
  Result = 'result',
  /** column name */
  SportId = 'sport_id',
  /** column name */
  TimeDoneHours = 'time_done_hours',
  /** column name */
  TimeDoneMinutes = 'time_done_minutes',
  /** column name */
  TimeGoalHours = 'time_goal_hours',
  /** column name */
  TimeGoalMinutes = 'time_goal_minutes'
}

/** select "athlete_challenge_aggregate_bool_exp_bool_and_arguments_columns" columns of table "athlete_challenge" */
export enum IAthlete_Challenge_Select_Column_Athlete_Challenge_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsMain = 'is_main'
}

/** select "athlete_challenge_aggregate_bool_exp_bool_or_arguments_columns" columns of table "athlete_challenge" */
export enum IAthlete_Challenge_Select_Column_Athlete_Challenge_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsMain = 'is_main'
}

/** input type for updating data in table "athlete_challenge" */
export type IAthlete_Challenge_Set_Input = {
  athlete_id?: InputMaybe<Scalars['Int']>;
  completed_at?: InputMaybe<Scalars['date']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  cumulated_univeness?: InputMaybe<Scalars['Int']>;
  date?: InputMaybe<Scalars['date']>;
  description?: InputMaybe<Scalars['String']>;
  distance?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_main?: InputMaybe<Scalars['Boolean']>;
  negative_univeness?: InputMaybe<Scalars['Int']>;
  notes?: InputMaybe<Scalars['String']>;
  positive_univeness?: InputMaybe<Scalars['Int']>;
  result?: InputMaybe<Scalars['String']>;
  sport_id?: InputMaybe<Scalars['String']>;
  time_done_hours?: InputMaybe<Scalars['Int']>;
  time_done_minutes?: InputMaybe<Scalars['Int']>;
  time_goal_hours?: InputMaybe<Scalars['Int']>;
  time_goal_minutes?: InputMaybe<Scalars['Int']>;
};

/** order by stddev() on columns of table "athlete_challenge" */
export type IAthlete_Challenge_Stddev_Order_By = {
  athlete_id?: InputMaybe<IOrder_By>;
  cumulated_univeness?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  negative_univeness?: InputMaybe<IOrder_By>;
  positive_univeness?: InputMaybe<IOrder_By>;
  time_done_hours?: InputMaybe<IOrder_By>;
  time_done_minutes?: InputMaybe<IOrder_By>;
  time_goal_hours?: InputMaybe<IOrder_By>;
  time_goal_minutes?: InputMaybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "athlete_challenge" */
export type IAthlete_Challenge_Stddev_Pop_Order_By = {
  athlete_id?: InputMaybe<IOrder_By>;
  cumulated_univeness?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  negative_univeness?: InputMaybe<IOrder_By>;
  positive_univeness?: InputMaybe<IOrder_By>;
  time_done_hours?: InputMaybe<IOrder_By>;
  time_done_minutes?: InputMaybe<IOrder_By>;
  time_goal_hours?: InputMaybe<IOrder_By>;
  time_goal_minutes?: InputMaybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "athlete_challenge" */
export type IAthlete_Challenge_Stddev_Samp_Order_By = {
  athlete_id?: InputMaybe<IOrder_By>;
  cumulated_univeness?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  negative_univeness?: InputMaybe<IOrder_By>;
  positive_univeness?: InputMaybe<IOrder_By>;
  time_done_hours?: InputMaybe<IOrder_By>;
  time_done_minutes?: InputMaybe<IOrder_By>;
  time_goal_hours?: InputMaybe<IOrder_By>;
  time_goal_minutes?: InputMaybe<IOrder_By>;
};

/** Streaming cursor of the table "athlete_challenge" */
export type IAthlete_Challenge_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IAthlete_Challenge_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IAthlete_Challenge_Stream_Cursor_Value_Input = {
  athlete_id?: InputMaybe<Scalars['Int']>;
  completed_at?: InputMaybe<Scalars['date']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  cumulated_univeness?: InputMaybe<Scalars['Int']>;
  date?: InputMaybe<Scalars['date']>;
  description?: InputMaybe<Scalars['String']>;
  distance?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_main?: InputMaybe<Scalars['Boolean']>;
  negative_univeness?: InputMaybe<Scalars['Int']>;
  notes?: InputMaybe<Scalars['String']>;
  positive_univeness?: InputMaybe<Scalars['Int']>;
  result?: InputMaybe<Scalars['String']>;
  sport_id?: InputMaybe<Scalars['String']>;
  time_done_hours?: InputMaybe<Scalars['Int']>;
  time_done_minutes?: InputMaybe<Scalars['Int']>;
  time_goal_hours?: InputMaybe<Scalars['Int']>;
  time_goal_minutes?: InputMaybe<Scalars['Int']>;
};

/** order by sum() on columns of table "athlete_challenge" */
export type IAthlete_Challenge_Sum_Order_By = {
  athlete_id?: InputMaybe<IOrder_By>;
  cumulated_univeness?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  negative_univeness?: InputMaybe<IOrder_By>;
  positive_univeness?: InputMaybe<IOrder_By>;
  time_done_hours?: InputMaybe<IOrder_By>;
  time_done_minutes?: InputMaybe<IOrder_By>;
  time_goal_hours?: InputMaybe<IOrder_By>;
  time_goal_minutes?: InputMaybe<IOrder_By>;
};

/** update columns of table "athlete_challenge" */
export enum IAthlete_Challenge_Update_Column {
  /** column name */
  AthleteId = 'athlete_id',
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CumulatedUniveness = 'cumulated_univeness',
  /** column name */
  Date = 'date',
  /** column name */
  Description = 'description',
  /** column name */
  Distance = 'distance',
  /** column name */
  Id = 'id',
  /** column name */
  IsMain = 'is_main',
  /** column name */
  NegativeUniveness = 'negative_univeness',
  /** column name */
  Notes = 'notes',
  /** column name */
  PositiveUniveness = 'positive_univeness',
  /** column name */
  Result = 'result',
  /** column name */
  SportId = 'sport_id',
  /** column name */
  TimeDoneHours = 'time_done_hours',
  /** column name */
  TimeDoneMinutes = 'time_done_minutes',
  /** column name */
  TimeGoalHours = 'time_goal_hours',
  /** column name */
  TimeGoalMinutes = 'time_goal_minutes'
}

export type IAthlete_Challenge_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<IAthlete_Challenge_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IAthlete_Challenge_Set_Input>;
  /** filter the rows which have to be updated */
  where: IAthlete_Challenge_Bool_Exp;
};

/** order by var_pop() on columns of table "athlete_challenge" */
export type IAthlete_Challenge_Var_Pop_Order_By = {
  athlete_id?: InputMaybe<IOrder_By>;
  cumulated_univeness?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  negative_univeness?: InputMaybe<IOrder_By>;
  positive_univeness?: InputMaybe<IOrder_By>;
  time_done_hours?: InputMaybe<IOrder_By>;
  time_done_minutes?: InputMaybe<IOrder_By>;
  time_goal_hours?: InputMaybe<IOrder_By>;
  time_goal_minutes?: InputMaybe<IOrder_By>;
};

/** order by var_samp() on columns of table "athlete_challenge" */
export type IAthlete_Challenge_Var_Samp_Order_By = {
  athlete_id?: InputMaybe<IOrder_By>;
  cumulated_univeness?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  negative_univeness?: InputMaybe<IOrder_By>;
  positive_univeness?: InputMaybe<IOrder_By>;
  time_done_hours?: InputMaybe<IOrder_By>;
  time_done_minutes?: InputMaybe<IOrder_By>;
  time_goal_hours?: InputMaybe<IOrder_By>;
  time_goal_minutes?: InputMaybe<IOrder_By>;
};

/** order by variance() on columns of table "athlete_challenge" */
export type IAthlete_Challenge_Variance_Order_By = {
  athlete_id?: InputMaybe<IOrder_By>;
  cumulated_univeness?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  negative_univeness?: InputMaybe<IOrder_By>;
  positive_univeness?: InputMaybe<IOrder_By>;
  time_done_hours?: InputMaybe<IOrder_By>;
  time_done_minutes?: InputMaybe<IOrder_By>;
  time_goal_hours?: InputMaybe<IOrder_By>;
  time_goal_minutes?: InputMaybe<IOrder_By>;
};

/** unique or primary key constraints on table "athlete" */
export enum IAthlete_Constraint {
  /** unique or primary key constraint on columns "id" */
  AthletePkey = 'athlete_pkey',
  /** unique or primary key constraint on columns "user_id" */
  AthleteUserIdKey = 'athlete_user_id_key'
}

/** input type for incrementing numeric columns in table "athlete" */
export type IAthlete_Inc_Input = {
  athlete_profile_id?: InputMaybe<Scalars['Int']>;
  coach_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "athlete" */
export type IAthlete_Insert_Input = {
  address_city?: InputMaybe<Scalars['String']>;
  address_country?: InputMaybe<Scalars['String']>;
  address_postal_code?: InputMaybe<Scalars['String']>;
  address_street?: InputMaybe<Scalars['String']>;
  athlete_biometric_data?: InputMaybe<IAthlete_Biometric_Data_Arr_Rel_Insert_Input>;
  athlete_blocks?: InputMaybe<IAthlete_Block_Arr_Rel_Insert_Input>;
  athlete_challenges?: InputMaybe<IAthlete_Challenge_Arr_Rel_Insert_Input>;
  athlete_profile?: InputMaybe<IAthlete_Profile_Obj_Rel_Insert_Input>;
  athlete_profile_id?: InputMaybe<Scalars['Int']>;
  athlete_speeds?: InputMaybe<IAthlete_Speed_Arr_Rel_Insert_Input>;
  avatar?: InputMaybe<Scalars['String']>;
  birthday?: InputMaybe<Scalars['date']>;
  coach?: InputMaybe<ICoach_Obj_Rel_Insert_Input>;
  coach_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email_language?: InputMaybe<Scalars['String']>;
  fiscal_id_number?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  goal?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  sport?: InputMaybe<ISport_Obj_Rel_Insert_Input>;
  sport_id?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  stripe_customer_id?: InputMaybe<Scalars['String']>;
  subscriptions?: InputMaybe<ISubscription_Arr_Rel_Insert_Input>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<IUser_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** order by max() on columns of table "athlete" */
export type IAthlete_Max_Order_By = {
  address_city?: InputMaybe<IOrder_By>;
  address_country?: InputMaybe<IOrder_By>;
  address_postal_code?: InputMaybe<IOrder_By>;
  address_street?: InputMaybe<IOrder_By>;
  athlete_profile_id?: InputMaybe<IOrder_By>;
  avatar?: InputMaybe<IOrder_By>;
  birthday?: InputMaybe<IOrder_By>;
  birthday_month_day?: InputMaybe<IOrder_By>;
  coach_id?: InputMaybe<IOrder_By>;
  created_at?: InputMaybe<IOrder_By>;
  email_language?: InputMaybe<IOrder_By>;
  fiscal_id_number?: InputMaybe<IOrder_By>;
  gender?: InputMaybe<IOrder_By>;
  goal?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  name?: InputMaybe<IOrder_By>;
  phone?: InputMaybe<IOrder_By>;
  sport_id?: InputMaybe<IOrder_By>;
  status?: InputMaybe<IOrder_By>;
  stripe_customer_id?: InputMaybe<IOrder_By>;
  type?: InputMaybe<IOrder_By>;
  updated_at?: InputMaybe<IOrder_By>;
  user_id?: InputMaybe<IOrder_By>;
};

/** order by min() on columns of table "athlete" */
export type IAthlete_Min_Order_By = {
  address_city?: InputMaybe<IOrder_By>;
  address_country?: InputMaybe<IOrder_By>;
  address_postal_code?: InputMaybe<IOrder_By>;
  address_street?: InputMaybe<IOrder_By>;
  athlete_profile_id?: InputMaybe<IOrder_By>;
  avatar?: InputMaybe<IOrder_By>;
  birthday?: InputMaybe<IOrder_By>;
  birthday_month_day?: InputMaybe<IOrder_By>;
  coach_id?: InputMaybe<IOrder_By>;
  created_at?: InputMaybe<IOrder_By>;
  email_language?: InputMaybe<IOrder_By>;
  fiscal_id_number?: InputMaybe<IOrder_By>;
  gender?: InputMaybe<IOrder_By>;
  goal?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  name?: InputMaybe<IOrder_By>;
  phone?: InputMaybe<IOrder_By>;
  sport_id?: InputMaybe<IOrder_By>;
  status?: InputMaybe<IOrder_By>;
  stripe_customer_id?: InputMaybe<IOrder_By>;
  type?: InputMaybe<IOrder_By>;
  updated_at?: InputMaybe<IOrder_By>;
  user_id?: InputMaybe<IOrder_By>;
};

/** input type for inserting object relation for remote table "athlete" */
export type IAthlete_Obj_Rel_Insert_Input = {
  data: IAthlete_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<IAthlete_On_Conflict>;
};

/** on_conflict condition type for table "athlete" */
export type IAthlete_On_Conflict = {
  constraint: IAthlete_Constraint;
  update_columns?: Array<IAthlete_Update_Column>;
  where?: InputMaybe<IAthlete_Bool_Exp>;
};

/** Ordering options when selecting data from "athlete". */
export type IAthlete_Order_By = {
  address_city?: InputMaybe<IOrder_By>;
  address_country?: InputMaybe<IOrder_By>;
  address_postal_code?: InputMaybe<IOrder_By>;
  address_street?: InputMaybe<IOrder_By>;
  athlete_biometric_data_aggregate?: InputMaybe<IAthlete_Biometric_Data_Aggregate_Order_By>;
  athlete_blocks_aggregate?: InputMaybe<IAthlete_Block_Aggregate_Order_By>;
  athlete_challenges_aggregate?: InputMaybe<IAthlete_Challenge_Aggregate_Order_By>;
  athlete_profile?: InputMaybe<IAthlete_Profile_Order_By>;
  athlete_profile_id?: InputMaybe<IOrder_By>;
  athlete_speeds_aggregate?: InputMaybe<IAthlete_Speed_Aggregate_Order_By>;
  avatar?: InputMaybe<IOrder_By>;
  birthday?: InputMaybe<IOrder_By>;
  birthday_month_day?: InputMaybe<IOrder_By>;
  coach?: InputMaybe<ICoach_Order_By>;
  coach_id?: InputMaybe<IOrder_By>;
  created_at?: InputMaybe<IOrder_By>;
  email_language?: InputMaybe<IOrder_By>;
  fiscal_id_number?: InputMaybe<IOrder_By>;
  gender?: InputMaybe<IOrder_By>;
  goal?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  name?: InputMaybe<IOrder_By>;
  phone?: InputMaybe<IOrder_By>;
  sport?: InputMaybe<ISport_Order_By>;
  sport_id?: InputMaybe<IOrder_By>;
  status?: InputMaybe<IOrder_By>;
  stripe_customer_id?: InputMaybe<IOrder_By>;
  subscriptions_aggregate?: InputMaybe<ISubscription_Aggregate_Order_By>;
  type?: InputMaybe<IOrder_By>;
  updated_at?: InputMaybe<IOrder_By>;
  user?: InputMaybe<IUser_Order_By>;
  user_id?: InputMaybe<IOrder_By>;
};

/** primary key columns input for table: athlete */
export type IAthlete_Pk_Columns_Input = {
  id: Scalars['Int'];
};

export type IAthlete_Profile_Altimetry_Adjustment_Aggregate_Bool_Exp = {
  count?: InputMaybe<IAthlete_Profile_Altimetry_Adjustment_Aggregate_Bool_Exp_Count>;
};

export type IAthlete_Profile_Altimetry_Adjustment_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<IAthlete_Profile_Altimetry_Adjustment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IAthlete_Profile_Altimetry_Adjustment_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

/** order by aggregate values of table "athlete_profile_altimetry_adjustment" */
export type IAthlete_Profile_Altimetry_Adjustment_Aggregate_Order_By = {
  avg?: InputMaybe<IAthlete_Profile_Altimetry_Adjustment_Avg_Order_By>;
  count?: InputMaybe<IOrder_By>;
  max?: InputMaybe<IAthlete_Profile_Altimetry_Adjustment_Max_Order_By>;
  min?: InputMaybe<IAthlete_Profile_Altimetry_Adjustment_Min_Order_By>;
  stddev?: InputMaybe<IAthlete_Profile_Altimetry_Adjustment_Stddev_Order_By>;
  stddev_pop?: InputMaybe<IAthlete_Profile_Altimetry_Adjustment_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<IAthlete_Profile_Altimetry_Adjustment_Stddev_Samp_Order_By>;
  sum?: InputMaybe<IAthlete_Profile_Altimetry_Adjustment_Sum_Order_By>;
  var_pop?: InputMaybe<IAthlete_Profile_Altimetry_Adjustment_Var_Pop_Order_By>;
  var_samp?: InputMaybe<IAthlete_Profile_Altimetry_Adjustment_Var_Samp_Order_By>;
  variance?: InputMaybe<IAthlete_Profile_Altimetry_Adjustment_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "athlete_profile_altimetry_adjustment" */
export type IAthlete_Profile_Altimetry_Adjustment_Arr_Rel_Insert_Input = {
  data: Array<IAthlete_Profile_Altimetry_Adjustment_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<IAthlete_Profile_Altimetry_Adjustment_On_Conflict>;
};

/** order by avg() on columns of table "athlete_profile_altimetry_adjustment" */
export type IAthlete_Profile_Altimetry_Adjustment_Avg_Order_By = {
  athlete_profile_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  value?: InputMaybe<IOrder_By>;
  workout_altimetry_id?: InputMaybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "athlete_profile_altimetry_adjustment". All fields are combined with a logical 'AND'. */
export type IAthlete_Profile_Altimetry_Adjustment_Bool_Exp = {
  _and?: InputMaybe<Array<IAthlete_Profile_Altimetry_Adjustment_Bool_Exp>>;
  _not?: InputMaybe<IAthlete_Profile_Altimetry_Adjustment_Bool_Exp>;
  _or?: InputMaybe<Array<IAthlete_Profile_Altimetry_Adjustment_Bool_Exp>>;
  athlete_profile?: InputMaybe<IAthlete_Profile_Bool_Exp>;
  athlete_profile_id?: InputMaybe<IInt_Comparison_Exp>;
  id?: InputMaybe<IInt_Comparison_Exp>;
  value?: InputMaybe<INumeric_Comparison_Exp>;
  workout_altimetry?: InputMaybe<IWorkout_Altimetry_Bool_Exp>;
  workout_altimetry_id?: InputMaybe<IInt_Comparison_Exp>;
};

/** unique or primary key constraints on table "athlete_profile_altimetry_adjustment" */
export enum IAthlete_Profile_Altimetry_Adjustment_Constraint {
  /** unique or primary key constraint on columns "id" */
  AthleteProfileAltimetryAdjustmentPkey = 'athlete_profile_altimetry_adjustment_pkey'
}

/** input type for incrementing numeric columns in table "athlete_profile_altimetry_adjustment" */
export type IAthlete_Profile_Altimetry_Adjustment_Inc_Input = {
  athlete_profile_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['numeric']>;
  workout_altimetry_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "athlete_profile_altimetry_adjustment" */
export type IAthlete_Profile_Altimetry_Adjustment_Insert_Input = {
  athlete_profile?: InputMaybe<IAthlete_Profile_Obj_Rel_Insert_Input>;
  athlete_profile_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['numeric']>;
  workout_altimetry?: InputMaybe<IWorkout_Altimetry_Obj_Rel_Insert_Input>;
  workout_altimetry_id?: InputMaybe<Scalars['Int']>;
};

/** order by max() on columns of table "athlete_profile_altimetry_adjustment" */
export type IAthlete_Profile_Altimetry_Adjustment_Max_Order_By = {
  athlete_profile_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  value?: InputMaybe<IOrder_By>;
  workout_altimetry_id?: InputMaybe<IOrder_By>;
};

/** order by min() on columns of table "athlete_profile_altimetry_adjustment" */
export type IAthlete_Profile_Altimetry_Adjustment_Min_Order_By = {
  athlete_profile_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  value?: InputMaybe<IOrder_By>;
  workout_altimetry_id?: InputMaybe<IOrder_By>;
};

/** on_conflict condition type for table "athlete_profile_altimetry_adjustment" */
export type IAthlete_Profile_Altimetry_Adjustment_On_Conflict = {
  constraint: IAthlete_Profile_Altimetry_Adjustment_Constraint;
  update_columns?: Array<IAthlete_Profile_Altimetry_Adjustment_Update_Column>;
  where?: InputMaybe<IAthlete_Profile_Altimetry_Adjustment_Bool_Exp>;
};

/** Ordering options when selecting data from "athlete_profile_altimetry_adjustment". */
export type IAthlete_Profile_Altimetry_Adjustment_Order_By = {
  athlete_profile?: InputMaybe<IAthlete_Profile_Order_By>;
  athlete_profile_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  value?: InputMaybe<IOrder_By>;
  workout_altimetry?: InputMaybe<IWorkout_Altimetry_Order_By>;
  workout_altimetry_id?: InputMaybe<IOrder_By>;
};

/** primary key columns input for table: athlete_profile_altimetry_adjustment */
export type IAthlete_Profile_Altimetry_Adjustment_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "athlete_profile_altimetry_adjustment" */
export enum IAthlete_Profile_Altimetry_Adjustment_Select_Column {
  /** column name */
  AthleteProfileId = 'athlete_profile_id',
  /** column name */
  Id = 'id',
  /** column name */
  Value = 'value',
  /** column name */
  WorkoutAltimetryId = 'workout_altimetry_id'
}

/** input type for updating data in table "athlete_profile_altimetry_adjustment" */
export type IAthlete_Profile_Altimetry_Adjustment_Set_Input = {
  athlete_profile_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['numeric']>;
  workout_altimetry_id?: InputMaybe<Scalars['Int']>;
};

/** order by stddev() on columns of table "athlete_profile_altimetry_adjustment" */
export type IAthlete_Profile_Altimetry_Adjustment_Stddev_Order_By = {
  athlete_profile_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  value?: InputMaybe<IOrder_By>;
  workout_altimetry_id?: InputMaybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "athlete_profile_altimetry_adjustment" */
export type IAthlete_Profile_Altimetry_Adjustment_Stddev_Pop_Order_By = {
  athlete_profile_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  value?: InputMaybe<IOrder_By>;
  workout_altimetry_id?: InputMaybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "athlete_profile_altimetry_adjustment" */
export type IAthlete_Profile_Altimetry_Adjustment_Stddev_Samp_Order_By = {
  athlete_profile_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  value?: InputMaybe<IOrder_By>;
  workout_altimetry_id?: InputMaybe<IOrder_By>;
};

/** Streaming cursor of the table "athlete_profile_altimetry_adjustment" */
export type IAthlete_Profile_Altimetry_Adjustment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IAthlete_Profile_Altimetry_Adjustment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IAthlete_Profile_Altimetry_Adjustment_Stream_Cursor_Value_Input = {
  athlete_profile_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['numeric']>;
  workout_altimetry_id?: InputMaybe<Scalars['Int']>;
};

/** order by sum() on columns of table "athlete_profile_altimetry_adjustment" */
export type IAthlete_Profile_Altimetry_Adjustment_Sum_Order_By = {
  athlete_profile_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  value?: InputMaybe<IOrder_By>;
  workout_altimetry_id?: InputMaybe<IOrder_By>;
};

/** update columns of table "athlete_profile_altimetry_adjustment" */
export enum IAthlete_Profile_Altimetry_Adjustment_Update_Column {
  /** column name */
  AthleteProfileId = 'athlete_profile_id',
  /** column name */
  Id = 'id',
  /** column name */
  Value = 'value',
  /** column name */
  WorkoutAltimetryId = 'workout_altimetry_id'
}

export type IAthlete_Profile_Altimetry_Adjustment_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<IAthlete_Profile_Altimetry_Adjustment_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IAthlete_Profile_Altimetry_Adjustment_Set_Input>;
  /** filter the rows which have to be updated */
  where: IAthlete_Profile_Altimetry_Adjustment_Bool_Exp;
};

/** order by var_pop() on columns of table "athlete_profile_altimetry_adjustment" */
export type IAthlete_Profile_Altimetry_Adjustment_Var_Pop_Order_By = {
  athlete_profile_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  value?: InputMaybe<IOrder_By>;
  workout_altimetry_id?: InputMaybe<IOrder_By>;
};

/** order by var_samp() on columns of table "athlete_profile_altimetry_adjustment" */
export type IAthlete_Profile_Altimetry_Adjustment_Var_Samp_Order_By = {
  athlete_profile_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  value?: InputMaybe<IOrder_By>;
  workout_altimetry_id?: InputMaybe<IOrder_By>;
};

/** order by variance() on columns of table "athlete_profile_altimetry_adjustment" */
export type IAthlete_Profile_Altimetry_Adjustment_Variance_Order_By = {
  athlete_profile_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  value?: InputMaybe<IOrder_By>;
  workout_altimetry_id?: InputMaybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "athlete_profile". All fields are combined with a logical 'AND'. */
export type IAthlete_Profile_Bool_Exp = {
  _and?: InputMaybe<Array<IAthlete_Profile_Bool_Exp>>;
  _not?: InputMaybe<IAthlete_Profile_Bool_Exp>;
  _or?: InputMaybe<Array<IAthlete_Profile_Bool_Exp>>;
  athlete_profile_altimetry_adjustments?: InputMaybe<IAthlete_Profile_Altimetry_Adjustment_Bool_Exp>;
  athlete_profile_altimetry_adjustments_aggregate?: InputMaybe<IAthlete_Profile_Altimetry_Adjustment_Aggregate_Bool_Exp>;
  athletes?: InputMaybe<IAthlete_Bool_Exp>;
  athletes_aggregate?: InputMaybe<IAthlete_Aggregate_Bool_Exp>;
  gender?: InputMaybe<IString_Comparison_Exp>;
  id?: InputMaybe<IInt_Comparison_Exp>;
  level?: InputMaybe<IInt_Comparison_Exp>;
  name?: InputMaybe<IString_Comparison_Exp>;
  order?: InputMaybe<IInt_Comparison_Exp>;
  param_calories?: InputMaybe<INumeric_Comparison_Exp>;
  param_distance_variation?: InputMaybe<INumeric_Comparison_Exp>;
  param_effort?: InputMaybe<INumeric_Comparison_Exp>;
  param_motivation?: InputMaybe<INumeric_Comparison_Exp>;
  param_ziut?: InputMaybe<INumeric_Comparison_Exp>;
  type?: InputMaybe<IString_Comparison_Exp>;
};

/** unique or primary key constraints on table "athlete_profile" */
export enum IAthlete_Profile_Constraint {
  /** unique or primary key constraint on columns "id" */
  AthleteProfilePkey = 'athlete_profile_pkey'
}

/** input type for incrementing numeric columns in table "athlete_profile" */
export type IAthlete_Profile_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  level?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  param_calories?: InputMaybe<Scalars['numeric']>;
  param_distance_variation?: InputMaybe<Scalars['numeric']>;
  param_effort?: InputMaybe<Scalars['numeric']>;
  param_motivation?: InputMaybe<Scalars['numeric']>;
  param_ziut?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "athlete_profile" */
export type IAthlete_Profile_Insert_Input = {
  athlete_profile_altimetry_adjustments?: InputMaybe<IAthlete_Profile_Altimetry_Adjustment_Arr_Rel_Insert_Input>;
  athletes?: InputMaybe<IAthlete_Arr_Rel_Insert_Input>;
  gender?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  level?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  param_calories?: InputMaybe<Scalars['numeric']>;
  param_distance_variation?: InputMaybe<Scalars['numeric']>;
  param_effort?: InputMaybe<Scalars['numeric']>;
  param_motivation?: InputMaybe<Scalars['numeric']>;
  param_ziut?: InputMaybe<Scalars['numeric']>;
  type?: InputMaybe<Scalars['String']>;
};

/** input type for inserting object relation for remote table "athlete_profile" */
export type IAthlete_Profile_Obj_Rel_Insert_Input = {
  data: IAthlete_Profile_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<IAthlete_Profile_On_Conflict>;
};

/** on_conflict condition type for table "athlete_profile" */
export type IAthlete_Profile_On_Conflict = {
  constraint: IAthlete_Profile_Constraint;
  update_columns?: Array<IAthlete_Profile_Update_Column>;
  where?: InputMaybe<IAthlete_Profile_Bool_Exp>;
};

/** Ordering options when selecting data from "athlete_profile". */
export type IAthlete_Profile_Order_By = {
  athlete_profile_altimetry_adjustments_aggregate?: InputMaybe<IAthlete_Profile_Altimetry_Adjustment_Aggregate_Order_By>;
  athletes_aggregate?: InputMaybe<IAthlete_Aggregate_Order_By>;
  gender?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  level?: InputMaybe<IOrder_By>;
  name?: InputMaybe<IOrder_By>;
  order?: InputMaybe<IOrder_By>;
  param_calories?: InputMaybe<IOrder_By>;
  param_distance_variation?: InputMaybe<IOrder_By>;
  param_effort?: InputMaybe<IOrder_By>;
  param_motivation?: InputMaybe<IOrder_By>;
  param_ziut?: InputMaybe<IOrder_By>;
  type?: InputMaybe<IOrder_By>;
};

/** primary key columns input for table: athlete_profile */
export type IAthlete_Profile_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "athlete_profile" */
export enum IAthlete_Profile_Select_Column {
  /** column name */
  Gender = 'gender',
  /** column name */
  Id = 'id',
  /** column name */
  Level = 'level',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  ParamCalories = 'param_calories',
  /** column name */
  ParamDistanceVariation = 'param_distance_variation',
  /** column name */
  ParamEffort = 'param_effort',
  /** column name */
  ParamMotivation = 'param_motivation',
  /** column name */
  ParamZiut = 'param_ziut',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "athlete_profile" */
export type IAthlete_Profile_Set_Input = {
  gender?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  level?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  param_calories?: InputMaybe<Scalars['numeric']>;
  param_distance_variation?: InputMaybe<Scalars['numeric']>;
  param_effort?: InputMaybe<Scalars['numeric']>;
  param_motivation?: InputMaybe<Scalars['numeric']>;
  param_ziut?: InputMaybe<Scalars['numeric']>;
  type?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "athlete_profile" */
export type IAthlete_Profile_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IAthlete_Profile_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IAthlete_Profile_Stream_Cursor_Value_Input = {
  gender?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  level?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  param_calories?: InputMaybe<Scalars['numeric']>;
  param_distance_variation?: InputMaybe<Scalars['numeric']>;
  param_effort?: InputMaybe<Scalars['numeric']>;
  param_motivation?: InputMaybe<Scalars['numeric']>;
  param_ziut?: InputMaybe<Scalars['numeric']>;
  type?: InputMaybe<Scalars['String']>;
};

/** update columns of table "athlete_profile" */
export enum IAthlete_Profile_Update_Column {
  /** column name */
  Gender = 'gender',
  /** column name */
  Id = 'id',
  /** column name */
  Level = 'level',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  ParamCalories = 'param_calories',
  /** column name */
  ParamDistanceVariation = 'param_distance_variation',
  /** column name */
  ParamEffort = 'param_effort',
  /** column name */
  ParamMotivation = 'param_motivation',
  /** column name */
  ParamZiut = 'param_ziut',
  /** column name */
  Type = 'type'
}

export type IAthlete_Profile_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<IAthlete_Profile_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IAthlete_Profile_Set_Input>;
  /** filter the rows which have to be updated */
  where: IAthlete_Profile_Bool_Exp;
};

/** select columns of table "athlete" */
export enum IAthlete_Select_Column {
  /** column name */
  AddressCity = 'address_city',
  /** column name */
  AddressCountry = 'address_country',
  /** column name */
  AddressPostalCode = 'address_postal_code',
  /** column name */
  AddressStreet = 'address_street',
  /** column name */
  AthleteProfileId = 'athlete_profile_id',
  /** column name */
  Avatar = 'avatar',
  /** column name */
  Birthday = 'birthday',
  /** column name */
  BirthdayMonthDay = 'birthday_month_day',
  /** column name */
  CoachId = 'coach_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EmailLanguage = 'email_language',
  /** column name */
  FiscalIdNumber = 'fiscal_id_number',
  /** column name */
  Gender = 'gender',
  /** column name */
  Goal = 'goal',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Phone = 'phone',
  /** column name */
  SportId = 'sport_id',
  /** column name */
  Status = 'status',
  /** column name */
  StripeCustomerId = 'stripe_customer_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "athlete" */
export type IAthlete_Set_Input = {
  address_city?: InputMaybe<Scalars['String']>;
  address_country?: InputMaybe<Scalars['String']>;
  address_postal_code?: InputMaybe<Scalars['String']>;
  address_street?: InputMaybe<Scalars['String']>;
  athlete_profile_id?: InputMaybe<Scalars['Int']>;
  avatar?: InputMaybe<Scalars['String']>;
  birthday?: InputMaybe<Scalars['date']>;
  coach_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email_language?: InputMaybe<Scalars['String']>;
  fiscal_id_number?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  goal?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  sport_id?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  stripe_customer_id?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

export type IAthlete_Speed_Aggregate_Bool_Exp = {
  count?: InputMaybe<IAthlete_Speed_Aggregate_Bool_Exp_Count>;
};

export type IAthlete_Speed_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<IAthlete_Speed_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IAthlete_Speed_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

/** order by aggregate values of table "athlete_speed" */
export type IAthlete_Speed_Aggregate_Order_By = {
  avg?: InputMaybe<IAthlete_Speed_Avg_Order_By>;
  count?: InputMaybe<IOrder_By>;
  max?: InputMaybe<IAthlete_Speed_Max_Order_By>;
  min?: InputMaybe<IAthlete_Speed_Min_Order_By>;
  stddev?: InputMaybe<IAthlete_Speed_Stddev_Order_By>;
  stddev_pop?: InputMaybe<IAthlete_Speed_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<IAthlete_Speed_Stddev_Samp_Order_By>;
  sum?: InputMaybe<IAthlete_Speed_Sum_Order_By>;
  var_pop?: InputMaybe<IAthlete_Speed_Var_Pop_Order_By>;
  var_samp?: InputMaybe<IAthlete_Speed_Var_Samp_Order_By>;
  variance?: InputMaybe<IAthlete_Speed_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "athlete_speed" */
export type IAthlete_Speed_Arr_Rel_Insert_Input = {
  data: Array<IAthlete_Speed_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<IAthlete_Speed_On_Conflict>;
};

/** order by avg() on columns of table "athlete_speed" */
export type IAthlete_Speed_Avg_Order_By = {
  athlete_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  value?: InputMaybe<IOrder_By>;
  workout_type_id?: InputMaybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "athlete_speed". All fields are combined with a logical 'AND'. */
export type IAthlete_Speed_Bool_Exp = {
  _and?: InputMaybe<Array<IAthlete_Speed_Bool_Exp>>;
  _not?: InputMaybe<IAthlete_Speed_Bool_Exp>;
  _or?: InputMaybe<Array<IAthlete_Speed_Bool_Exp>>;
  athlete?: InputMaybe<IAthlete_Bool_Exp>;
  athlete_id?: InputMaybe<IInt_Comparison_Exp>;
  created_at?: InputMaybe<ITimestamptz_Comparison_Exp>;
  id?: InputMaybe<IInt_Comparison_Exp>;
  value?: InputMaybe<INumeric_Comparison_Exp>;
  workout_type?: InputMaybe<IWorkout_Type_Bool_Exp>;
  workout_type_id?: InputMaybe<IInt_Comparison_Exp>;
};

/** unique or primary key constraints on table "athlete_speed" */
export enum IAthlete_Speed_Constraint {
  /** unique or primary key constraint on columns "workout_type_id", "athlete_id" */
  AthleteSpeedAthleteIdWorkoutTypeIdKey = 'athlete_speed_athlete_id_workout_type_id_key',
  /** unique or primary key constraint on columns "id" */
  AthleteSpeedPkey = 'athlete_speed_pkey'
}

/** input type for incrementing numeric columns in table "athlete_speed" */
export type IAthlete_Speed_Inc_Input = {
  athlete_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['numeric']>;
  workout_type_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "athlete_speed" */
export type IAthlete_Speed_Insert_Input = {
  athlete?: InputMaybe<IAthlete_Obj_Rel_Insert_Input>;
  athlete_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['numeric']>;
  workout_type?: InputMaybe<IWorkout_Type_Obj_Rel_Insert_Input>;
  workout_type_id?: InputMaybe<Scalars['Int']>;
};

/** order by max() on columns of table "athlete_speed" */
export type IAthlete_Speed_Max_Order_By = {
  athlete_id?: InputMaybe<IOrder_By>;
  created_at?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  value?: InputMaybe<IOrder_By>;
  workout_type_id?: InputMaybe<IOrder_By>;
};

/** order by min() on columns of table "athlete_speed" */
export type IAthlete_Speed_Min_Order_By = {
  athlete_id?: InputMaybe<IOrder_By>;
  created_at?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  value?: InputMaybe<IOrder_By>;
  workout_type_id?: InputMaybe<IOrder_By>;
};

/** on_conflict condition type for table "athlete_speed" */
export type IAthlete_Speed_On_Conflict = {
  constraint: IAthlete_Speed_Constraint;
  update_columns?: Array<IAthlete_Speed_Update_Column>;
  where?: InputMaybe<IAthlete_Speed_Bool_Exp>;
};

/** Ordering options when selecting data from "athlete_speed". */
export type IAthlete_Speed_Order_By = {
  athlete?: InputMaybe<IAthlete_Order_By>;
  athlete_id?: InputMaybe<IOrder_By>;
  created_at?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  value?: InputMaybe<IOrder_By>;
  workout_type?: InputMaybe<IWorkout_Type_Order_By>;
  workout_type_id?: InputMaybe<IOrder_By>;
};

/** primary key columns input for table: athlete_speed */
export type IAthlete_Speed_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "athlete_speed" */
export enum IAthlete_Speed_Select_Column {
  /** column name */
  AthleteId = 'athlete_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Value = 'value',
  /** column name */
  WorkoutTypeId = 'workout_type_id'
}

/** input type for updating data in table "athlete_speed" */
export type IAthlete_Speed_Set_Input = {
  athlete_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['numeric']>;
  workout_type_id?: InputMaybe<Scalars['Int']>;
};

/** order by stddev() on columns of table "athlete_speed" */
export type IAthlete_Speed_Stddev_Order_By = {
  athlete_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  value?: InputMaybe<IOrder_By>;
  workout_type_id?: InputMaybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "athlete_speed" */
export type IAthlete_Speed_Stddev_Pop_Order_By = {
  athlete_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  value?: InputMaybe<IOrder_By>;
  workout_type_id?: InputMaybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "athlete_speed" */
export type IAthlete_Speed_Stddev_Samp_Order_By = {
  athlete_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  value?: InputMaybe<IOrder_By>;
  workout_type_id?: InputMaybe<IOrder_By>;
};

/** Streaming cursor of the table "athlete_speed" */
export type IAthlete_Speed_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IAthlete_Speed_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IAthlete_Speed_Stream_Cursor_Value_Input = {
  athlete_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['numeric']>;
  workout_type_id?: InputMaybe<Scalars['Int']>;
};

/** order by sum() on columns of table "athlete_speed" */
export type IAthlete_Speed_Sum_Order_By = {
  athlete_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  value?: InputMaybe<IOrder_By>;
  workout_type_id?: InputMaybe<IOrder_By>;
};

/** update columns of table "athlete_speed" */
export enum IAthlete_Speed_Update_Column {
  /** column name */
  AthleteId = 'athlete_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Value = 'value',
  /** column name */
  WorkoutTypeId = 'workout_type_id'
}

export type IAthlete_Speed_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<IAthlete_Speed_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IAthlete_Speed_Set_Input>;
  /** filter the rows which have to be updated */
  where: IAthlete_Speed_Bool_Exp;
};

/** order by var_pop() on columns of table "athlete_speed" */
export type IAthlete_Speed_Var_Pop_Order_By = {
  athlete_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  value?: InputMaybe<IOrder_By>;
  workout_type_id?: InputMaybe<IOrder_By>;
};

/** order by var_samp() on columns of table "athlete_speed" */
export type IAthlete_Speed_Var_Samp_Order_By = {
  athlete_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  value?: InputMaybe<IOrder_By>;
  workout_type_id?: InputMaybe<IOrder_By>;
};

/** order by variance() on columns of table "athlete_speed" */
export type IAthlete_Speed_Variance_Order_By = {
  athlete_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  value?: InputMaybe<IOrder_By>;
  workout_type_id?: InputMaybe<IOrder_By>;
};

/** order by stddev() on columns of table "athlete" */
export type IAthlete_Stddev_Order_By = {
  athlete_profile_id?: InputMaybe<IOrder_By>;
  birthday_month_day?: InputMaybe<IOrder_By>;
  coach_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  user_id?: InputMaybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "athlete" */
export type IAthlete_Stddev_Pop_Order_By = {
  athlete_profile_id?: InputMaybe<IOrder_By>;
  birthday_month_day?: InputMaybe<IOrder_By>;
  coach_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  user_id?: InputMaybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "athlete" */
export type IAthlete_Stddev_Samp_Order_By = {
  athlete_profile_id?: InputMaybe<IOrder_By>;
  birthday_month_day?: InputMaybe<IOrder_By>;
  coach_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  user_id?: InputMaybe<IOrder_By>;
};

/** Streaming cursor of the table "athlete" */
export type IAthlete_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IAthlete_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IAthlete_Stream_Cursor_Value_Input = {
  address_city?: InputMaybe<Scalars['String']>;
  address_country?: InputMaybe<Scalars['String']>;
  address_postal_code?: InputMaybe<Scalars['String']>;
  address_street?: InputMaybe<Scalars['String']>;
  athlete_profile_id?: InputMaybe<Scalars['Int']>;
  avatar?: InputMaybe<Scalars['String']>;
  birthday?: InputMaybe<Scalars['date']>;
  birthday_month_day?: InputMaybe<Scalars['Int']>;
  coach_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email_language?: InputMaybe<Scalars['String']>;
  fiscal_id_number?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  goal?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  sport_id?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  stripe_customer_id?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** order by sum() on columns of table "athlete" */
export type IAthlete_Sum_Order_By = {
  athlete_profile_id?: InputMaybe<IOrder_By>;
  birthday_month_day?: InputMaybe<IOrder_By>;
  coach_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  user_id?: InputMaybe<IOrder_By>;
};

/** update columns of table "athlete" */
export enum IAthlete_Update_Column {
  /** column name */
  AddressCity = 'address_city',
  /** column name */
  AddressCountry = 'address_country',
  /** column name */
  AddressPostalCode = 'address_postal_code',
  /** column name */
  AddressStreet = 'address_street',
  /** column name */
  AthleteProfileId = 'athlete_profile_id',
  /** column name */
  Avatar = 'avatar',
  /** column name */
  Birthday = 'birthday',
  /** column name */
  CoachId = 'coach_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EmailLanguage = 'email_language',
  /** column name */
  FiscalIdNumber = 'fiscal_id_number',
  /** column name */
  Gender = 'gender',
  /** column name */
  Goal = 'goal',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Phone = 'phone',
  /** column name */
  SportId = 'sport_id',
  /** column name */
  Status = 'status',
  /** column name */
  StripeCustomerId = 'stripe_customer_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type IAthlete_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<IAthlete_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IAthlete_Set_Input>;
  /** filter the rows which have to be updated */
  where: IAthlete_Bool_Exp;
};

/** order by var_pop() on columns of table "athlete" */
export type IAthlete_Var_Pop_Order_By = {
  athlete_profile_id?: InputMaybe<IOrder_By>;
  birthday_month_day?: InputMaybe<IOrder_By>;
  coach_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  user_id?: InputMaybe<IOrder_By>;
};

/** order by var_samp() on columns of table "athlete" */
export type IAthlete_Var_Samp_Order_By = {
  athlete_profile_id?: InputMaybe<IOrder_By>;
  birthday_month_day?: InputMaybe<IOrder_By>;
  coach_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  user_id?: InputMaybe<IOrder_By>;
};

/** order by variance() on columns of table "athlete" */
export type IAthlete_Variance_Order_By = {
  athlete_profile_id?: InputMaybe<IOrder_By>;
  birthday_month_day?: InputMaybe<IOrder_By>;
  coach_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  user_id?: InputMaybe<IOrder_By>;
};

export type IAthlete_Week_Aggregate_Bool_Exp = {
  count?: InputMaybe<IAthlete_Week_Aggregate_Bool_Exp_Count>;
};

export type IAthlete_Week_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<IAthlete_Week_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IAthlete_Week_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

/** order by aggregate values of table "athlete_week" */
export type IAthlete_Week_Aggregate_Order_By = {
  avg?: InputMaybe<IAthlete_Week_Avg_Order_By>;
  count?: InputMaybe<IOrder_By>;
  max?: InputMaybe<IAthlete_Week_Max_Order_By>;
  min?: InputMaybe<IAthlete_Week_Min_Order_By>;
  stddev?: InputMaybe<IAthlete_Week_Stddev_Order_By>;
  stddev_pop?: InputMaybe<IAthlete_Week_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<IAthlete_Week_Stddev_Samp_Order_By>;
  sum?: InputMaybe<IAthlete_Week_Sum_Order_By>;
  var_pop?: InputMaybe<IAthlete_Week_Var_Pop_Order_By>;
  var_samp?: InputMaybe<IAthlete_Week_Var_Samp_Order_By>;
  variance?: InputMaybe<IAthlete_Week_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "athlete_week" */
export type IAthlete_Week_Arr_Rel_Insert_Input = {
  data: Array<IAthlete_Week_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<IAthlete_Week_On_Conflict>;
};

/** order by avg() on columns of table "athlete_week" */
export type IAthlete_Week_Avg_Order_By = {
  athlete_block_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  order?: InputMaybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "athlete_week". All fields are combined with a logical 'AND'. */
export type IAthlete_Week_Bool_Exp = {
  _and?: InputMaybe<Array<IAthlete_Week_Bool_Exp>>;
  _not?: InputMaybe<IAthlete_Week_Bool_Exp>;
  _or?: InputMaybe<Array<IAthlete_Week_Bool_Exp>>;
  athlete_block?: InputMaybe<IAthlete_Block_Bool_Exp>;
  athlete_block_id?: InputMaybe<IInt_Comparison_Exp>;
  athlete_workouts?: InputMaybe<IAthlete_Workout_Bool_Exp>;
  athlete_workouts_aggregate?: InputMaybe<IAthlete_Workout_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<ITimestamptz_Comparison_Exp>;
  end_date?: InputMaybe<IDate_Comparison_Exp>;
  id?: InputMaybe<IInt_Comparison_Exp>;
  name?: InputMaybe<IString_Comparison_Exp>;
  order?: InputMaybe<IInt_Comparison_Exp>;
  sport?: InputMaybe<ISport_Bool_Exp>;
  sport_id?: InputMaybe<IString_Comparison_Exp>;
  start_date?: InputMaybe<IDate_Comparison_Exp>;
  updated_at?: InputMaybe<ITimestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "athlete_week" */
export enum IAthlete_Week_Constraint {
  /** unique or primary key constraint on columns "id" */
  AthleteWeekPkey = 'athlete_week_pkey'
}

/** input type for incrementing numeric columns in table "athlete_week" */
export type IAthlete_Week_Inc_Input = {
  athlete_block_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "athlete_week" */
export type IAthlete_Week_Insert_Input = {
  athlete_block?: InputMaybe<IAthlete_Block_Obj_Rel_Insert_Input>;
  athlete_block_id?: InputMaybe<Scalars['Int']>;
  athlete_workouts?: InputMaybe<IAthlete_Workout_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  end_date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  sport?: InputMaybe<ISport_Obj_Rel_Insert_Input>;
  sport_id?: InputMaybe<Scalars['String']>;
  start_date?: InputMaybe<Scalars['date']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "athlete_week" */
export type IAthlete_Week_Max_Order_By = {
  athlete_block_id?: InputMaybe<IOrder_By>;
  created_at?: InputMaybe<IOrder_By>;
  end_date?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  name?: InputMaybe<IOrder_By>;
  order?: InputMaybe<IOrder_By>;
  sport_id?: InputMaybe<IOrder_By>;
  start_date?: InputMaybe<IOrder_By>;
  updated_at?: InputMaybe<IOrder_By>;
};

/** order by min() on columns of table "athlete_week" */
export type IAthlete_Week_Min_Order_By = {
  athlete_block_id?: InputMaybe<IOrder_By>;
  created_at?: InputMaybe<IOrder_By>;
  end_date?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  name?: InputMaybe<IOrder_By>;
  order?: InputMaybe<IOrder_By>;
  sport_id?: InputMaybe<IOrder_By>;
  start_date?: InputMaybe<IOrder_By>;
  updated_at?: InputMaybe<IOrder_By>;
};

/** input type for inserting object relation for remote table "athlete_week" */
export type IAthlete_Week_Obj_Rel_Insert_Input = {
  data: IAthlete_Week_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<IAthlete_Week_On_Conflict>;
};

/** on_conflict condition type for table "athlete_week" */
export type IAthlete_Week_On_Conflict = {
  constraint: IAthlete_Week_Constraint;
  update_columns?: Array<IAthlete_Week_Update_Column>;
  where?: InputMaybe<IAthlete_Week_Bool_Exp>;
};

/** Ordering options when selecting data from "athlete_week". */
export type IAthlete_Week_Order_By = {
  athlete_block?: InputMaybe<IAthlete_Block_Order_By>;
  athlete_block_id?: InputMaybe<IOrder_By>;
  athlete_workouts_aggregate?: InputMaybe<IAthlete_Workout_Aggregate_Order_By>;
  created_at?: InputMaybe<IOrder_By>;
  end_date?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  name?: InputMaybe<IOrder_By>;
  order?: InputMaybe<IOrder_By>;
  sport?: InputMaybe<ISport_Order_By>;
  sport_id?: InputMaybe<IOrder_By>;
  start_date?: InputMaybe<IOrder_By>;
  updated_at?: InputMaybe<IOrder_By>;
};

/** primary key columns input for table: athlete_week */
export type IAthlete_Week_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "athlete_week" */
export enum IAthlete_Week_Select_Column {
  /** column name */
  AthleteBlockId = 'athlete_block_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  SportId = 'sport_id',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "athlete_week" */
export type IAthlete_Week_Set_Input = {
  athlete_block_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  end_date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  sport_id?: InputMaybe<Scalars['String']>;
  start_date?: InputMaybe<Scalars['date']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** order by stddev() on columns of table "athlete_week" */
export type IAthlete_Week_Stddev_Order_By = {
  athlete_block_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  order?: InputMaybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "athlete_week" */
export type IAthlete_Week_Stddev_Pop_Order_By = {
  athlete_block_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  order?: InputMaybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "athlete_week" */
export type IAthlete_Week_Stddev_Samp_Order_By = {
  athlete_block_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  order?: InputMaybe<IOrder_By>;
};

/** Streaming cursor of the table "athlete_week" */
export type IAthlete_Week_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IAthlete_Week_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IAthlete_Week_Stream_Cursor_Value_Input = {
  athlete_block_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  end_date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  sport_id?: InputMaybe<Scalars['String']>;
  start_date?: InputMaybe<Scalars['date']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** order by sum() on columns of table "athlete_week" */
export type IAthlete_Week_Sum_Order_By = {
  athlete_block_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  order?: InputMaybe<IOrder_By>;
};

/** update columns of table "athlete_week" */
export enum IAthlete_Week_Update_Column {
  /** column name */
  AthleteBlockId = 'athlete_block_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  SportId = 'sport_id',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type IAthlete_Week_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<IAthlete_Week_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IAthlete_Week_Set_Input>;
  /** filter the rows which have to be updated */
  where: IAthlete_Week_Bool_Exp;
};

/** order by var_pop() on columns of table "athlete_week" */
export type IAthlete_Week_Var_Pop_Order_By = {
  athlete_block_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  order?: InputMaybe<IOrder_By>;
};

/** order by var_samp() on columns of table "athlete_week" */
export type IAthlete_Week_Var_Samp_Order_By = {
  athlete_block_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  order?: InputMaybe<IOrder_By>;
};

/** order by variance() on columns of table "athlete_week" */
export type IAthlete_Week_Variance_Order_By = {
  athlete_block_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  order?: InputMaybe<IOrder_By>;
};

export type IAthlete_Workout_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<IAthlete_Workout_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<IAthlete_Workout_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<IAthlete_Workout_Aggregate_Bool_Exp_Count>;
};

export type IAthlete_Workout_Aggregate_Bool_Exp_Bool_And = {
  arguments: IAthlete_Workout_Select_Column_Athlete_Workout_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IAthlete_Workout_Bool_Exp>;
  predicate: IBoolean_Comparison_Exp;
};

export type IAthlete_Workout_Aggregate_Bool_Exp_Bool_Or = {
  arguments: IAthlete_Workout_Select_Column_Athlete_Workout_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IAthlete_Workout_Bool_Exp>;
  predicate: IBoolean_Comparison_Exp;
};

export type IAthlete_Workout_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<IAthlete_Workout_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IAthlete_Workout_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

/** order by aggregate values of table "athlete_workout" */
export type IAthlete_Workout_Aggregate_Order_By = {
  avg?: InputMaybe<IAthlete_Workout_Avg_Order_By>;
  count?: InputMaybe<IOrder_By>;
  max?: InputMaybe<IAthlete_Workout_Max_Order_By>;
  min?: InputMaybe<IAthlete_Workout_Min_Order_By>;
  stddev?: InputMaybe<IAthlete_Workout_Stddev_Order_By>;
  stddev_pop?: InputMaybe<IAthlete_Workout_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<IAthlete_Workout_Stddev_Samp_Order_By>;
  sum?: InputMaybe<IAthlete_Workout_Sum_Order_By>;
  var_pop?: InputMaybe<IAthlete_Workout_Var_Pop_Order_By>;
  var_samp?: InputMaybe<IAthlete_Workout_Var_Samp_Order_By>;
  variance?: InputMaybe<IAthlete_Workout_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "athlete_workout" */
export type IAthlete_Workout_Arr_Rel_Insert_Input = {
  data: Array<IAthlete_Workout_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<IAthlete_Workout_On_Conflict>;
};

/** order by avg() on columns of table "athlete_workout" */
export type IAthlete_Workout_Avg_Order_By = {
  athlete_week_id?: InputMaybe<IOrder_By>;
  calories?: InputMaybe<IOrder_By>;
  completed_stretching_circuit?: InputMaybe<IOrder_By>;
  completed_weight_circuit?: InputMaybe<IOrder_By>;
  cumulative_elevation?: InputMaybe<IOrder_By>;
  day?: InputMaybe<IOrder_By>;
  effort?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  measured_calories?: InputMaybe<IOrder_By>;
  measured_cumulative_elevation?: InputMaybe<IOrder_By>;
  measured_negative_elevation?: InputMaybe<IOrder_By>;
  measured_positive_elevation?: InputMaybe<IOrder_By>;
  motivation?: InputMaybe<IOrder_By>;
  negative_elevation?: InputMaybe<IOrder_By>;
  positive_elevation?: InputMaybe<IOrder_By>;
  strava_activity_id?: InputMaybe<IOrder_By>;
  stretching_circuit_id?: InputMaybe<IOrder_By>;
  stretching_circuit_repetitions?: InputMaybe<IOrder_By>;
  sum_elevation?: InputMaybe<IOrder_By>;
  sum_measured_elevation?: InputMaybe<IOrder_By>;
  weight_circuit_id?: InputMaybe<IOrder_By>;
  weight_circuit_repetitions?: InputMaybe<IOrder_By>;
  workout_altimetry_id?: InputMaybe<IOrder_By>;
  workout_template_id?: InputMaybe<IOrder_By>;
  workout_terrain_id?: InputMaybe<IOrder_By>;
  workout_type_id?: InputMaybe<IOrder_By>;
  workout_zone_id?: InputMaybe<IOrder_By>;
  zuit?: InputMaybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "athlete_workout". All fields are combined with a logical 'AND'. */
export type IAthlete_Workout_Bool_Exp = {
  _and?: InputMaybe<Array<IAthlete_Workout_Bool_Exp>>;
  _not?: InputMaybe<IAthlete_Workout_Bool_Exp>;
  _or?: InputMaybe<Array<IAthlete_Workout_Bool_Exp>>;
  athlete_week?: InputMaybe<IAthlete_Week_Bool_Exp>;
  athlete_week_id?: InputMaybe<IInt_Comparison_Exp>;
  athlete_workout_sections?: InputMaybe<IAthlete_Workout_Section_Bool_Exp>;
  athlete_workout_sections_aggregate?: InputMaybe<IAthlete_Workout_Section_Aggregate_Bool_Exp>;
  calories?: InputMaybe<INumeric_Comparison_Exp>;
  comments?: InputMaybe<IString_Comparison_Exp>;
  completed_stretching_circuit?: InputMaybe<INumeric_Comparison_Exp>;
  completed_weight_circuit?: InputMaybe<INumeric_Comparison_Exp>;
  created_at?: InputMaybe<ITimestamptz_Comparison_Exp>;
  cumulative_elevation?: InputMaybe<IInt_Comparison_Exp>;
  date?: InputMaybe<IDate_Comparison_Exp>;
  day?: InputMaybe<IInt_Comparison_Exp>;
  effort?: InputMaybe<IInt_Comparison_Exp>;
  id?: InputMaybe<IInt_Comparison_Exp>;
  is_primary?: InputMaybe<IBoolean_Comparison_Exp>;
  measured_calories?: InputMaybe<INumeric_Comparison_Exp>;
  measured_cumulative_elevation?: InputMaybe<IInt_Comparison_Exp>;
  measured_negative_elevation?: InputMaybe<IInt_Comparison_Exp>;
  measured_positive_elevation?: InputMaybe<IInt_Comparison_Exp>;
  motivation?: InputMaybe<IInt_Comparison_Exp>;
  negative_elevation?: InputMaybe<IInt_Comparison_Exp>;
  positive_elevation?: InputMaybe<IInt_Comparison_Exp>;
  series?: InputMaybe<IString_Comparison_Exp>;
  strava_activity_id?: InputMaybe<IBigint_Comparison_Exp>;
  stretching_circuit?: InputMaybe<ICircuit_Bool_Exp>;
  stretching_circuit_id?: InputMaybe<IInt_Comparison_Exp>;
  stretching_circuit_repetitions?: InputMaybe<IInt_Comparison_Exp>;
  sum_elevation?: InputMaybe<IInt_Comparison_Exp>;
  sum_measured_elevation?: InputMaybe<IInt_Comparison_Exp>;
  type?: InputMaybe<IString_Comparison_Exp>;
  updated_at?: InputMaybe<ITimestamptz_Comparison_Exp>;
  weight_circuit?: InputMaybe<ICircuit_Bool_Exp>;
  weight_circuit_id?: InputMaybe<IInt_Comparison_Exp>;
  weight_circuit_repetitions?: InputMaybe<IInt_Comparison_Exp>;
  workout_altimetry?: InputMaybe<IWorkout_Altimetry_Bool_Exp>;
  workout_altimetry_id?: InputMaybe<IInt_Comparison_Exp>;
  workout_template?: InputMaybe<IWorkout_Template_Bool_Exp>;
  workout_template_id?: InputMaybe<IInt_Comparison_Exp>;
  workout_terrain?: InputMaybe<IWorkout_Terrain_Bool_Exp>;
  workout_terrain_id?: InputMaybe<IInt_Comparison_Exp>;
  workout_type?: InputMaybe<IWorkout_Type_Bool_Exp>;
  workout_type_id?: InputMaybe<IInt_Comparison_Exp>;
  workout_zone?: InputMaybe<IWorkout_Zone_Bool_Exp>;
  workout_zone_id?: InputMaybe<IInt_Comparison_Exp>;
  zuit?: InputMaybe<INumeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "athlete_workout" */
export enum IAthlete_Workout_Constraint {
  /** unique or primary key constraint on columns "id" */
  AthleteWorkoutPkey = 'athlete_workout_pkey',
  /** unique or primary key constraint on columns "day", "athlete_week_id", "is_primary" */
  UniqueAthleteWorkoutPerWeekKey = 'unique_athlete_workout_per_week_key'
}

/** input type for incrementing numeric columns in table "athlete_workout" */
export type IAthlete_Workout_Inc_Input = {
  athlete_week_id?: InputMaybe<Scalars['Int']>;
  calories?: InputMaybe<Scalars['numeric']>;
  completed_stretching_circuit?: InputMaybe<Scalars['numeric']>;
  completed_weight_circuit?: InputMaybe<Scalars['numeric']>;
  cumulative_elevation?: InputMaybe<Scalars['Int']>;
  day?: InputMaybe<Scalars['Int']>;
  effort?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  measured_calories?: InputMaybe<Scalars['numeric']>;
  measured_cumulative_elevation?: InputMaybe<Scalars['Int']>;
  measured_negative_elevation?: InputMaybe<Scalars['Int']>;
  measured_positive_elevation?: InputMaybe<Scalars['Int']>;
  motivation?: InputMaybe<Scalars['Int']>;
  negative_elevation?: InputMaybe<Scalars['Int']>;
  positive_elevation?: InputMaybe<Scalars['Int']>;
  strava_activity_id?: InputMaybe<Scalars['bigint']>;
  stretching_circuit_id?: InputMaybe<Scalars['Int']>;
  stretching_circuit_repetitions?: InputMaybe<Scalars['Int']>;
  weight_circuit_id?: InputMaybe<Scalars['Int']>;
  weight_circuit_repetitions?: InputMaybe<Scalars['Int']>;
  workout_altimetry_id?: InputMaybe<Scalars['Int']>;
  workout_template_id?: InputMaybe<Scalars['Int']>;
  workout_terrain_id?: InputMaybe<Scalars['Int']>;
  workout_type_id?: InputMaybe<Scalars['Int']>;
  workout_zone_id?: InputMaybe<Scalars['Int']>;
  zuit?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "athlete_workout" */
export type IAthlete_Workout_Insert_Input = {
  athlete_week?: InputMaybe<IAthlete_Week_Obj_Rel_Insert_Input>;
  athlete_week_id?: InputMaybe<Scalars['Int']>;
  athlete_workout_sections?: InputMaybe<IAthlete_Workout_Section_Arr_Rel_Insert_Input>;
  calories?: InputMaybe<Scalars['numeric']>;
  comments?: InputMaybe<Scalars['String']>;
  completed_stretching_circuit?: InputMaybe<Scalars['numeric']>;
  completed_weight_circuit?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  cumulative_elevation?: InputMaybe<Scalars['Int']>;
  date?: InputMaybe<Scalars['date']>;
  day?: InputMaybe<Scalars['Int']>;
  effort?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_primary?: InputMaybe<Scalars['Boolean']>;
  measured_calories?: InputMaybe<Scalars['numeric']>;
  measured_cumulative_elevation?: InputMaybe<Scalars['Int']>;
  measured_negative_elevation?: InputMaybe<Scalars['Int']>;
  measured_positive_elevation?: InputMaybe<Scalars['Int']>;
  motivation?: InputMaybe<Scalars['Int']>;
  negative_elevation?: InputMaybe<Scalars['Int']>;
  positive_elevation?: InputMaybe<Scalars['Int']>;
  series?: InputMaybe<Scalars['String']>;
  strava_activity_id?: InputMaybe<Scalars['bigint']>;
  stretching_circuit?: InputMaybe<ICircuit_Obj_Rel_Insert_Input>;
  stretching_circuit_id?: InputMaybe<Scalars['Int']>;
  stretching_circuit_repetitions?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  weight_circuit?: InputMaybe<ICircuit_Obj_Rel_Insert_Input>;
  weight_circuit_id?: InputMaybe<Scalars['Int']>;
  weight_circuit_repetitions?: InputMaybe<Scalars['Int']>;
  workout_altimetry?: InputMaybe<IWorkout_Altimetry_Obj_Rel_Insert_Input>;
  workout_altimetry_id?: InputMaybe<Scalars['Int']>;
  workout_template?: InputMaybe<IWorkout_Template_Obj_Rel_Insert_Input>;
  workout_template_id?: InputMaybe<Scalars['Int']>;
  workout_terrain?: InputMaybe<IWorkout_Terrain_Obj_Rel_Insert_Input>;
  workout_terrain_id?: InputMaybe<Scalars['Int']>;
  workout_type?: InputMaybe<IWorkout_Type_Obj_Rel_Insert_Input>;
  workout_type_id?: InputMaybe<Scalars['Int']>;
  workout_zone?: InputMaybe<IWorkout_Zone_Obj_Rel_Insert_Input>;
  workout_zone_id?: InputMaybe<Scalars['Int']>;
  zuit?: InputMaybe<Scalars['numeric']>;
};

/** order by max() on columns of table "athlete_workout" */
export type IAthlete_Workout_Max_Order_By = {
  athlete_week_id?: InputMaybe<IOrder_By>;
  calories?: InputMaybe<IOrder_By>;
  comments?: InputMaybe<IOrder_By>;
  completed_stretching_circuit?: InputMaybe<IOrder_By>;
  completed_weight_circuit?: InputMaybe<IOrder_By>;
  created_at?: InputMaybe<IOrder_By>;
  cumulative_elevation?: InputMaybe<IOrder_By>;
  date?: InputMaybe<IOrder_By>;
  day?: InputMaybe<IOrder_By>;
  effort?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  measured_calories?: InputMaybe<IOrder_By>;
  measured_cumulative_elevation?: InputMaybe<IOrder_By>;
  measured_negative_elevation?: InputMaybe<IOrder_By>;
  measured_positive_elevation?: InputMaybe<IOrder_By>;
  motivation?: InputMaybe<IOrder_By>;
  negative_elevation?: InputMaybe<IOrder_By>;
  positive_elevation?: InputMaybe<IOrder_By>;
  series?: InputMaybe<IOrder_By>;
  strava_activity_id?: InputMaybe<IOrder_By>;
  stretching_circuit_id?: InputMaybe<IOrder_By>;
  stretching_circuit_repetitions?: InputMaybe<IOrder_By>;
  sum_elevation?: InputMaybe<IOrder_By>;
  sum_measured_elevation?: InputMaybe<IOrder_By>;
  type?: InputMaybe<IOrder_By>;
  updated_at?: InputMaybe<IOrder_By>;
  weight_circuit_id?: InputMaybe<IOrder_By>;
  weight_circuit_repetitions?: InputMaybe<IOrder_By>;
  workout_altimetry_id?: InputMaybe<IOrder_By>;
  workout_template_id?: InputMaybe<IOrder_By>;
  workout_terrain_id?: InputMaybe<IOrder_By>;
  workout_type_id?: InputMaybe<IOrder_By>;
  workout_zone_id?: InputMaybe<IOrder_By>;
  zuit?: InputMaybe<IOrder_By>;
};

/** order by min() on columns of table "athlete_workout" */
export type IAthlete_Workout_Min_Order_By = {
  athlete_week_id?: InputMaybe<IOrder_By>;
  calories?: InputMaybe<IOrder_By>;
  comments?: InputMaybe<IOrder_By>;
  completed_stretching_circuit?: InputMaybe<IOrder_By>;
  completed_weight_circuit?: InputMaybe<IOrder_By>;
  created_at?: InputMaybe<IOrder_By>;
  cumulative_elevation?: InputMaybe<IOrder_By>;
  date?: InputMaybe<IOrder_By>;
  day?: InputMaybe<IOrder_By>;
  effort?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  measured_calories?: InputMaybe<IOrder_By>;
  measured_cumulative_elevation?: InputMaybe<IOrder_By>;
  measured_negative_elevation?: InputMaybe<IOrder_By>;
  measured_positive_elevation?: InputMaybe<IOrder_By>;
  motivation?: InputMaybe<IOrder_By>;
  negative_elevation?: InputMaybe<IOrder_By>;
  positive_elevation?: InputMaybe<IOrder_By>;
  series?: InputMaybe<IOrder_By>;
  strava_activity_id?: InputMaybe<IOrder_By>;
  stretching_circuit_id?: InputMaybe<IOrder_By>;
  stretching_circuit_repetitions?: InputMaybe<IOrder_By>;
  sum_elevation?: InputMaybe<IOrder_By>;
  sum_measured_elevation?: InputMaybe<IOrder_By>;
  type?: InputMaybe<IOrder_By>;
  updated_at?: InputMaybe<IOrder_By>;
  weight_circuit_id?: InputMaybe<IOrder_By>;
  weight_circuit_repetitions?: InputMaybe<IOrder_By>;
  workout_altimetry_id?: InputMaybe<IOrder_By>;
  workout_template_id?: InputMaybe<IOrder_By>;
  workout_terrain_id?: InputMaybe<IOrder_By>;
  workout_type_id?: InputMaybe<IOrder_By>;
  workout_zone_id?: InputMaybe<IOrder_By>;
  zuit?: InputMaybe<IOrder_By>;
};

/** input type for inserting object relation for remote table "athlete_workout" */
export type IAthlete_Workout_Obj_Rel_Insert_Input = {
  data: IAthlete_Workout_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<IAthlete_Workout_On_Conflict>;
};

/** on_conflict condition type for table "athlete_workout" */
export type IAthlete_Workout_On_Conflict = {
  constraint: IAthlete_Workout_Constraint;
  update_columns?: Array<IAthlete_Workout_Update_Column>;
  where?: InputMaybe<IAthlete_Workout_Bool_Exp>;
};

/** Ordering options when selecting data from "athlete_workout". */
export type IAthlete_Workout_Order_By = {
  athlete_week?: InputMaybe<IAthlete_Week_Order_By>;
  athlete_week_id?: InputMaybe<IOrder_By>;
  athlete_workout_sections_aggregate?: InputMaybe<IAthlete_Workout_Section_Aggregate_Order_By>;
  calories?: InputMaybe<IOrder_By>;
  comments?: InputMaybe<IOrder_By>;
  completed_stretching_circuit?: InputMaybe<IOrder_By>;
  completed_weight_circuit?: InputMaybe<IOrder_By>;
  created_at?: InputMaybe<IOrder_By>;
  cumulative_elevation?: InputMaybe<IOrder_By>;
  date?: InputMaybe<IOrder_By>;
  day?: InputMaybe<IOrder_By>;
  effort?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  is_primary?: InputMaybe<IOrder_By>;
  measured_calories?: InputMaybe<IOrder_By>;
  measured_cumulative_elevation?: InputMaybe<IOrder_By>;
  measured_negative_elevation?: InputMaybe<IOrder_By>;
  measured_positive_elevation?: InputMaybe<IOrder_By>;
  motivation?: InputMaybe<IOrder_By>;
  negative_elevation?: InputMaybe<IOrder_By>;
  positive_elevation?: InputMaybe<IOrder_By>;
  series?: InputMaybe<IOrder_By>;
  strava_activity_id?: InputMaybe<IOrder_By>;
  stretching_circuit?: InputMaybe<ICircuit_Order_By>;
  stretching_circuit_id?: InputMaybe<IOrder_By>;
  stretching_circuit_repetitions?: InputMaybe<IOrder_By>;
  sum_elevation?: InputMaybe<IOrder_By>;
  sum_measured_elevation?: InputMaybe<IOrder_By>;
  type?: InputMaybe<IOrder_By>;
  updated_at?: InputMaybe<IOrder_By>;
  weight_circuit?: InputMaybe<ICircuit_Order_By>;
  weight_circuit_id?: InputMaybe<IOrder_By>;
  weight_circuit_repetitions?: InputMaybe<IOrder_By>;
  workout_altimetry?: InputMaybe<IWorkout_Altimetry_Order_By>;
  workout_altimetry_id?: InputMaybe<IOrder_By>;
  workout_template?: InputMaybe<IWorkout_Template_Order_By>;
  workout_template_id?: InputMaybe<IOrder_By>;
  workout_terrain?: InputMaybe<IWorkout_Terrain_Order_By>;
  workout_terrain_id?: InputMaybe<IOrder_By>;
  workout_type?: InputMaybe<IWorkout_Type_Order_By>;
  workout_type_id?: InputMaybe<IOrder_By>;
  workout_zone?: InputMaybe<IWorkout_Zone_Order_By>;
  workout_zone_id?: InputMaybe<IOrder_By>;
  zuit?: InputMaybe<IOrder_By>;
};

/** primary key columns input for table: athlete_workout */
export type IAthlete_Workout_Pk_Columns_Input = {
  id: Scalars['Int'];
};

export type IAthlete_Workout_Section_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<IAthlete_Workout_Section_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<IAthlete_Workout_Section_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<IAthlete_Workout_Section_Aggregate_Bool_Exp_Count>;
};

export type IAthlete_Workout_Section_Aggregate_Bool_Exp_Bool_And = {
  arguments: IAthlete_Workout_Section_Select_Column_Athlete_Workout_Section_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IAthlete_Workout_Section_Bool_Exp>;
  predicate: IBoolean_Comparison_Exp;
};

export type IAthlete_Workout_Section_Aggregate_Bool_Exp_Bool_Or = {
  arguments: IAthlete_Workout_Section_Select_Column_Athlete_Workout_Section_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IAthlete_Workout_Section_Bool_Exp>;
  predicate: IBoolean_Comparison_Exp;
};

export type IAthlete_Workout_Section_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<IAthlete_Workout_Section_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IAthlete_Workout_Section_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

/** order by aggregate values of table "athlete_workout_section" */
export type IAthlete_Workout_Section_Aggregate_Order_By = {
  avg?: InputMaybe<IAthlete_Workout_Section_Avg_Order_By>;
  count?: InputMaybe<IOrder_By>;
  max?: InputMaybe<IAthlete_Workout_Section_Max_Order_By>;
  min?: InputMaybe<IAthlete_Workout_Section_Min_Order_By>;
  stddev?: InputMaybe<IAthlete_Workout_Section_Stddev_Order_By>;
  stddev_pop?: InputMaybe<IAthlete_Workout_Section_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<IAthlete_Workout_Section_Stddev_Samp_Order_By>;
  sum?: InputMaybe<IAthlete_Workout_Section_Sum_Order_By>;
  var_pop?: InputMaybe<IAthlete_Workout_Section_Var_Pop_Order_By>;
  var_samp?: InputMaybe<IAthlete_Workout_Section_Var_Samp_Order_By>;
  variance?: InputMaybe<IAthlete_Workout_Section_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "athlete_workout_section" */
export type IAthlete_Workout_Section_Arr_Rel_Insert_Input = {
  data: Array<IAthlete_Workout_Section_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<IAthlete_Workout_Section_On_Conflict>;
};

/** order by avg() on columns of table "athlete_workout_section" */
export type IAthlete_Workout_Section_Avg_Order_By = {
  athlete_workout_id?: InputMaybe<IOrder_By>;
  average_heart_rate?: InputMaybe<IOrder_By>;
  average_heart_rate_percentage?: InputMaybe<IOrder_By>;
  duration?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  max_heart_rate?: InputMaybe<IOrder_By>;
  measured_average_heart_rate?: InputMaybe<IOrder_By>;
  measured_duration?: InputMaybe<IOrder_By>;
  measured_max_heart_rate?: InputMaybe<IOrder_By>;
  measured_speed?: InputMaybe<IOrder_By>;
  order?: InputMaybe<IOrder_By>;
  section_zuit?: InputMaybe<IOrder_By>;
  series_id?: InputMaybe<IOrder_By>;
  speed?: InputMaybe<IOrder_By>;
  speed_percentage?: InputMaybe<IOrder_By>;
  workout_section_template_id?: InputMaybe<IOrder_By>;
  workout_zone_id?: InputMaybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "athlete_workout_section". All fields are combined with a logical 'AND'. */
export type IAthlete_Workout_Section_Bool_Exp = {
  _and?: InputMaybe<Array<IAthlete_Workout_Section_Bool_Exp>>;
  _not?: InputMaybe<IAthlete_Workout_Section_Bool_Exp>;
  _or?: InputMaybe<Array<IAthlete_Workout_Section_Bool_Exp>>;
  athlete_workout?: InputMaybe<IAthlete_Workout_Bool_Exp>;
  athlete_workout_id?: InputMaybe<IInt_Comparison_Exp>;
  average_heart_rate?: InputMaybe<INumeric_Comparison_Exp>;
  average_heart_rate_percentage?: InputMaybe<INumeric_Comparison_Exp>;
  created_at?: InputMaybe<ITimestamptz_Comparison_Exp>;
  duration?: InputMaybe<INumeric_Comparison_Exp>;
  executed_stress_score?: InputMaybe<INumeric_Comparison_Exp>;
  id?: InputMaybe<IInt_Comparison_Exp>;
  is_main?: InputMaybe<IBoolean_Comparison_Exp>;
  max_heart_rate?: InputMaybe<INumeric_Comparison_Exp>;
  measured_average_heart_rate?: InputMaybe<INumeric_Comparison_Exp>;
  measured_duration?: InputMaybe<INumeric_Comparison_Exp>;
  measured_max_heart_rate?: InputMaybe<INumeric_Comparison_Exp>;
  measured_speed?: InputMaybe<INumeric_Comparison_Exp>;
  order?: InputMaybe<IInt_Comparison_Exp>;
  planned_stress_score?: InputMaybe<INumeric_Comparison_Exp>;
  section_zuit?: InputMaybe<INumeric_Comparison_Exp>;
  series_id?: InputMaybe<IInt_Comparison_Exp>;
  speed?: InputMaybe<INumeric_Comparison_Exp>;
  speed_percentage?: InputMaybe<INumeric_Comparison_Exp>;
  type?: InputMaybe<IString_Comparison_Exp>;
  updated_at?: InputMaybe<ITimestamptz_Comparison_Exp>;
  workout_section_template?: InputMaybe<IWorkout_Section_Template_Bool_Exp>;
  workout_section_template_id?: InputMaybe<IInt_Comparison_Exp>;
  workout_zone?: InputMaybe<IWorkout_Zone_Bool_Exp>;
  workout_zone_id?: InputMaybe<IInt_Comparison_Exp>;
};

/** unique or primary key constraints on table "athlete_workout_section" */
export enum IAthlete_Workout_Section_Constraint {
  /** unique or primary key constraint on columns "id" */
  AthleteWorkoutSectionPkey = 'athlete_workout_section_pkey'
}

/** input type for incrementing numeric columns in table "athlete_workout_section" */
export type IAthlete_Workout_Section_Inc_Input = {
  athlete_workout_id?: InputMaybe<Scalars['Int']>;
  average_heart_rate?: InputMaybe<Scalars['numeric']>;
  average_heart_rate_percentage?: InputMaybe<Scalars['numeric']>;
  duration?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['Int']>;
  max_heart_rate?: InputMaybe<Scalars['numeric']>;
  measured_average_heart_rate?: InputMaybe<Scalars['numeric']>;
  measured_duration?: InputMaybe<Scalars['numeric']>;
  measured_max_heart_rate?: InputMaybe<Scalars['numeric']>;
  measured_speed?: InputMaybe<Scalars['numeric']>;
  order?: InputMaybe<Scalars['Int']>;
  section_zuit?: InputMaybe<Scalars['numeric']>;
  series_id?: InputMaybe<Scalars['Int']>;
  speed?: InputMaybe<Scalars['numeric']>;
  speed_percentage?: InputMaybe<Scalars['numeric']>;
  workout_section_template_id?: InputMaybe<Scalars['Int']>;
  workout_zone_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "athlete_workout_section" */
export type IAthlete_Workout_Section_Insert_Input = {
  athlete_workout?: InputMaybe<IAthlete_Workout_Obj_Rel_Insert_Input>;
  athlete_workout_id?: InputMaybe<Scalars['Int']>;
  average_heart_rate?: InputMaybe<Scalars['numeric']>;
  average_heart_rate_percentage?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  duration?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['Int']>;
  is_main?: InputMaybe<Scalars['Boolean']>;
  max_heart_rate?: InputMaybe<Scalars['numeric']>;
  measured_average_heart_rate?: InputMaybe<Scalars['numeric']>;
  measured_duration?: InputMaybe<Scalars['numeric']>;
  measured_max_heart_rate?: InputMaybe<Scalars['numeric']>;
  measured_speed?: InputMaybe<Scalars['numeric']>;
  order?: InputMaybe<Scalars['Int']>;
  section_zuit?: InputMaybe<Scalars['numeric']>;
  series_id?: InputMaybe<Scalars['Int']>;
  speed?: InputMaybe<Scalars['numeric']>;
  speed_percentage?: InputMaybe<Scalars['numeric']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workout_section_template?: InputMaybe<IWorkout_Section_Template_Obj_Rel_Insert_Input>;
  workout_section_template_id?: InputMaybe<Scalars['Int']>;
  workout_zone?: InputMaybe<IWorkout_Zone_Obj_Rel_Insert_Input>;
  workout_zone_id?: InputMaybe<Scalars['Int']>;
};

/** order by max() on columns of table "athlete_workout_section" */
export type IAthlete_Workout_Section_Max_Order_By = {
  athlete_workout_id?: InputMaybe<IOrder_By>;
  average_heart_rate?: InputMaybe<IOrder_By>;
  average_heart_rate_percentage?: InputMaybe<IOrder_By>;
  created_at?: InputMaybe<IOrder_By>;
  duration?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  max_heart_rate?: InputMaybe<IOrder_By>;
  measured_average_heart_rate?: InputMaybe<IOrder_By>;
  measured_duration?: InputMaybe<IOrder_By>;
  measured_max_heart_rate?: InputMaybe<IOrder_By>;
  measured_speed?: InputMaybe<IOrder_By>;
  order?: InputMaybe<IOrder_By>;
  section_zuit?: InputMaybe<IOrder_By>;
  series_id?: InputMaybe<IOrder_By>;
  speed?: InputMaybe<IOrder_By>;
  speed_percentage?: InputMaybe<IOrder_By>;
  type?: InputMaybe<IOrder_By>;
  updated_at?: InputMaybe<IOrder_By>;
  workout_section_template_id?: InputMaybe<IOrder_By>;
  workout_zone_id?: InputMaybe<IOrder_By>;
};

/** order by min() on columns of table "athlete_workout_section" */
export type IAthlete_Workout_Section_Min_Order_By = {
  athlete_workout_id?: InputMaybe<IOrder_By>;
  average_heart_rate?: InputMaybe<IOrder_By>;
  average_heart_rate_percentage?: InputMaybe<IOrder_By>;
  created_at?: InputMaybe<IOrder_By>;
  duration?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  max_heart_rate?: InputMaybe<IOrder_By>;
  measured_average_heart_rate?: InputMaybe<IOrder_By>;
  measured_duration?: InputMaybe<IOrder_By>;
  measured_max_heart_rate?: InputMaybe<IOrder_By>;
  measured_speed?: InputMaybe<IOrder_By>;
  order?: InputMaybe<IOrder_By>;
  section_zuit?: InputMaybe<IOrder_By>;
  series_id?: InputMaybe<IOrder_By>;
  speed?: InputMaybe<IOrder_By>;
  speed_percentage?: InputMaybe<IOrder_By>;
  type?: InputMaybe<IOrder_By>;
  updated_at?: InputMaybe<IOrder_By>;
  workout_section_template_id?: InputMaybe<IOrder_By>;
  workout_zone_id?: InputMaybe<IOrder_By>;
};

/** on_conflict condition type for table "athlete_workout_section" */
export type IAthlete_Workout_Section_On_Conflict = {
  constraint: IAthlete_Workout_Section_Constraint;
  update_columns?: Array<IAthlete_Workout_Section_Update_Column>;
  where?: InputMaybe<IAthlete_Workout_Section_Bool_Exp>;
};

/** Ordering options when selecting data from "athlete_workout_section". */
export type IAthlete_Workout_Section_Order_By = {
  athlete_workout?: InputMaybe<IAthlete_Workout_Order_By>;
  athlete_workout_id?: InputMaybe<IOrder_By>;
  average_heart_rate?: InputMaybe<IOrder_By>;
  average_heart_rate_percentage?: InputMaybe<IOrder_By>;
  created_at?: InputMaybe<IOrder_By>;
  duration?: InputMaybe<IOrder_By>;
  executed_stress_score?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  is_main?: InputMaybe<IOrder_By>;
  max_heart_rate?: InputMaybe<IOrder_By>;
  measured_average_heart_rate?: InputMaybe<IOrder_By>;
  measured_duration?: InputMaybe<IOrder_By>;
  measured_max_heart_rate?: InputMaybe<IOrder_By>;
  measured_speed?: InputMaybe<IOrder_By>;
  order?: InputMaybe<IOrder_By>;
  planned_stress_score?: InputMaybe<IOrder_By>;
  section_zuit?: InputMaybe<IOrder_By>;
  series_id?: InputMaybe<IOrder_By>;
  speed?: InputMaybe<IOrder_By>;
  speed_percentage?: InputMaybe<IOrder_By>;
  type?: InputMaybe<IOrder_By>;
  updated_at?: InputMaybe<IOrder_By>;
  workout_section_template?: InputMaybe<IWorkout_Section_Template_Order_By>;
  workout_section_template_id?: InputMaybe<IOrder_By>;
  workout_zone?: InputMaybe<IWorkout_Zone_Order_By>;
  workout_zone_id?: InputMaybe<IOrder_By>;
};

/** primary key columns input for table: athlete_workout_section */
export type IAthlete_Workout_Section_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "athlete_workout_section" */
export enum IAthlete_Workout_Section_Select_Column {
  /** column name */
  AthleteWorkoutId = 'athlete_workout_id',
  /** column name */
  AverageHeartRate = 'average_heart_rate',
  /** column name */
  AverageHeartRatePercentage = 'average_heart_rate_percentage',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Duration = 'duration',
  /** column name */
  Id = 'id',
  /** column name */
  IsMain = 'is_main',
  /** column name */
  MaxHeartRate = 'max_heart_rate',
  /** column name */
  MeasuredAverageHeartRate = 'measured_average_heart_rate',
  /** column name */
  MeasuredDuration = 'measured_duration',
  /** column name */
  MeasuredMaxHeartRate = 'measured_max_heart_rate',
  /** column name */
  MeasuredSpeed = 'measured_speed',
  /** column name */
  Order = 'order',
  /** column name */
  SectionZuit = 'section_zuit',
  /** column name */
  SeriesId = 'series_id',
  /** column name */
  Speed = 'speed',
  /** column name */
  SpeedPercentage = 'speed_percentage',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WorkoutSectionTemplateId = 'workout_section_template_id',
  /** column name */
  WorkoutZoneId = 'workout_zone_id'
}

/** select "athlete_workout_section_aggregate_bool_exp_bool_and_arguments_columns" columns of table "athlete_workout_section" */
export enum IAthlete_Workout_Section_Select_Column_Athlete_Workout_Section_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsMain = 'is_main'
}

/** select "athlete_workout_section_aggregate_bool_exp_bool_or_arguments_columns" columns of table "athlete_workout_section" */
export enum IAthlete_Workout_Section_Select_Column_Athlete_Workout_Section_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsMain = 'is_main'
}

/** input type for updating data in table "athlete_workout_section" */
export type IAthlete_Workout_Section_Set_Input = {
  athlete_workout_id?: InputMaybe<Scalars['Int']>;
  average_heart_rate?: InputMaybe<Scalars['numeric']>;
  average_heart_rate_percentage?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  duration?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['Int']>;
  is_main?: InputMaybe<Scalars['Boolean']>;
  max_heart_rate?: InputMaybe<Scalars['numeric']>;
  measured_average_heart_rate?: InputMaybe<Scalars['numeric']>;
  measured_duration?: InputMaybe<Scalars['numeric']>;
  measured_max_heart_rate?: InputMaybe<Scalars['numeric']>;
  measured_speed?: InputMaybe<Scalars['numeric']>;
  order?: InputMaybe<Scalars['Int']>;
  section_zuit?: InputMaybe<Scalars['numeric']>;
  series_id?: InputMaybe<Scalars['Int']>;
  speed?: InputMaybe<Scalars['numeric']>;
  speed_percentage?: InputMaybe<Scalars['numeric']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workout_section_template_id?: InputMaybe<Scalars['Int']>;
  workout_zone_id?: InputMaybe<Scalars['Int']>;
};

/** order by stddev() on columns of table "athlete_workout_section" */
export type IAthlete_Workout_Section_Stddev_Order_By = {
  athlete_workout_id?: InputMaybe<IOrder_By>;
  average_heart_rate?: InputMaybe<IOrder_By>;
  average_heart_rate_percentage?: InputMaybe<IOrder_By>;
  duration?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  max_heart_rate?: InputMaybe<IOrder_By>;
  measured_average_heart_rate?: InputMaybe<IOrder_By>;
  measured_duration?: InputMaybe<IOrder_By>;
  measured_max_heart_rate?: InputMaybe<IOrder_By>;
  measured_speed?: InputMaybe<IOrder_By>;
  order?: InputMaybe<IOrder_By>;
  section_zuit?: InputMaybe<IOrder_By>;
  series_id?: InputMaybe<IOrder_By>;
  speed?: InputMaybe<IOrder_By>;
  speed_percentage?: InputMaybe<IOrder_By>;
  workout_section_template_id?: InputMaybe<IOrder_By>;
  workout_zone_id?: InputMaybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "athlete_workout_section" */
export type IAthlete_Workout_Section_Stddev_Pop_Order_By = {
  athlete_workout_id?: InputMaybe<IOrder_By>;
  average_heart_rate?: InputMaybe<IOrder_By>;
  average_heart_rate_percentage?: InputMaybe<IOrder_By>;
  duration?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  max_heart_rate?: InputMaybe<IOrder_By>;
  measured_average_heart_rate?: InputMaybe<IOrder_By>;
  measured_duration?: InputMaybe<IOrder_By>;
  measured_max_heart_rate?: InputMaybe<IOrder_By>;
  measured_speed?: InputMaybe<IOrder_By>;
  order?: InputMaybe<IOrder_By>;
  section_zuit?: InputMaybe<IOrder_By>;
  series_id?: InputMaybe<IOrder_By>;
  speed?: InputMaybe<IOrder_By>;
  speed_percentage?: InputMaybe<IOrder_By>;
  workout_section_template_id?: InputMaybe<IOrder_By>;
  workout_zone_id?: InputMaybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "athlete_workout_section" */
export type IAthlete_Workout_Section_Stddev_Samp_Order_By = {
  athlete_workout_id?: InputMaybe<IOrder_By>;
  average_heart_rate?: InputMaybe<IOrder_By>;
  average_heart_rate_percentage?: InputMaybe<IOrder_By>;
  duration?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  max_heart_rate?: InputMaybe<IOrder_By>;
  measured_average_heart_rate?: InputMaybe<IOrder_By>;
  measured_duration?: InputMaybe<IOrder_By>;
  measured_max_heart_rate?: InputMaybe<IOrder_By>;
  measured_speed?: InputMaybe<IOrder_By>;
  order?: InputMaybe<IOrder_By>;
  section_zuit?: InputMaybe<IOrder_By>;
  series_id?: InputMaybe<IOrder_By>;
  speed?: InputMaybe<IOrder_By>;
  speed_percentage?: InputMaybe<IOrder_By>;
  workout_section_template_id?: InputMaybe<IOrder_By>;
  workout_zone_id?: InputMaybe<IOrder_By>;
};

/** Streaming cursor of the table "athlete_workout_section" */
export type IAthlete_Workout_Section_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IAthlete_Workout_Section_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IAthlete_Workout_Section_Stream_Cursor_Value_Input = {
  athlete_workout_id?: InputMaybe<Scalars['Int']>;
  average_heart_rate?: InputMaybe<Scalars['numeric']>;
  average_heart_rate_percentage?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  duration?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['Int']>;
  is_main?: InputMaybe<Scalars['Boolean']>;
  max_heart_rate?: InputMaybe<Scalars['numeric']>;
  measured_average_heart_rate?: InputMaybe<Scalars['numeric']>;
  measured_duration?: InputMaybe<Scalars['numeric']>;
  measured_max_heart_rate?: InputMaybe<Scalars['numeric']>;
  measured_speed?: InputMaybe<Scalars['numeric']>;
  order?: InputMaybe<Scalars['Int']>;
  section_zuit?: InputMaybe<Scalars['numeric']>;
  series_id?: InputMaybe<Scalars['Int']>;
  speed?: InputMaybe<Scalars['numeric']>;
  speed_percentage?: InputMaybe<Scalars['numeric']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workout_section_template_id?: InputMaybe<Scalars['Int']>;
  workout_zone_id?: InputMaybe<Scalars['Int']>;
};

/** order by sum() on columns of table "athlete_workout_section" */
export type IAthlete_Workout_Section_Sum_Order_By = {
  athlete_workout_id?: InputMaybe<IOrder_By>;
  average_heart_rate?: InputMaybe<IOrder_By>;
  average_heart_rate_percentage?: InputMaybe<IOrder_By>;
  duration?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  max_heart_rate?: InputMaybe<IOrder_By>;
  measured_average_heart_rate?: InputMaybe<IOrder_By>;
  measured_duration?: InputMaybe<IOrder_By>;
  measured_max_heart_rate?: InputMaybe<IOrder_By>;
  measured_speed?: InputMaybe<IOrder_By>;
  order?: InputMaybe<IOrder_By>;
  section_zuit?: InputMaybe<IOrder_By>;
  series_id?: InputMaybe<IOrder_By>;
  speed?: InputMaybe<IOrder_By>;
  speed_percentage?: InputMaybe<IOrder_By>;
  workout_section_template_id?: InputMaybe<IOrder_By>;
  workout_zone_id?: InputMaybe<IOrder_By>;
};

/** update columns of table "athlete_workout_section" */
export enum IAthlete_Workout_Section_Update_Column {
  /** column name */
  AthleteWorkoutId = 'athlete_workout_id',
  /** column name */
  AverageHeartRate = 'average_heart_rate',
  /** column name */
  AverageHeartRatePercentage = 'average_heart_rate_percentage',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Duration = 'duration',
  /** column name */
  Id = 'id',
  /** column name */
  IsMain = 'is_main',
  /** column name */
  MaxHeartRate = 'max_heart_rate',
  /** column name */
  MeasuredAverageHeartRate = 'measured_average_heart_rate',
  /** column name */
  MeasuredDuration = 'measured_duration',
  /** column name */
  MeasuredMaxHeartRate = 'measured_max_heart_rate',
  /** column name */
  MeasuredSpeed = 'measured_speed',
  /** column name */
  Order = 'order',
  /** column name */
  SectionZuit = 'section_zuit',
  /** column name */
  SeriesId = 'series_id',
  /** column name */
  Speed = 'speed',
  /** column name */
  SpeedPercentage = 'speed_percentage',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WorkoutSectionTemplateId = 'workout_section_template_id',
  /** column name */
  WorkoutZoneId = 'workout_zone_id'
}

export type IAthlete_Workout_Section_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<IAthlete_Workout_Section_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IAthlete_Workout_Section_Set_Input>;
  /** filter the rows which have to be updated */
  where: IAthlete_Workout_Section_Bool_Exp;
};

/** order by var_pop() on columns of table "athlete_workout_section" */
export type IAthlete_Workout_Section_Var_Pop_Order_By = {
  athlete_workout_id?: InputMaybe<IOrder_By>;
  average_heart_rate?: InputMaybe<IOrder_By>;
  average_heart_rate_percentage?: InputMaybe<IOrder_By>;
  duration?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  max_heart_rate?: InputMaybe<IOrder_By>;
  measured_average_heart_rate?: InputMaybe<IOrder_By>;
  measured_duration?: InputMaybe<IOrder_By>;
  measured_max_heart_rate?: InputMaybe<IOrder_By>;
  measured_speed?: InputMaybe<IOrder_By>;
  order?: InputMaybe<IOrder_By>;
  section_zuit?: InputMaybe<IOrder_By>;
  series_id?: InputMaybe<IOrder_By>;
  speed?: InputMaybe<IOrder_By>;
  speed_percentage?: InputMaybe<IOrder_By>;
  workout_section_template_id?: InputMaybe<IOrder_By>;
  workout_zone_id?: InputMaybe<IOrder_By>;
};

/** order by var_samp() on columns of table "athlete_workout_section" */
export type IAthlete_Workout_Section_Var_Samp_Order_By = {
  athlete_workout_id?: InputMaybe<IOrder_By>;
  average_heart_rate?: InputMaybe<IOrder_By>;
  average_heart_rate_percentage?: InputMaybe<IOrder_By>;
  duration?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  max_heart_rate?: InputMaybe<IOrder_By>;
  measured_average_heart_rate?: InputMaybe<IOrder_By>;
  measured_duration?: InputMaybe<IOrder_By>;
  measured_max_heart_rate?: InputMaybe<IOrder_By>;
  measured_speed?: InputMaybe<IOrder_By>;
  order?: InputMaybe<IOrder_By>;
  section_zuit?: InputMaybe<IOrder_By>;
  series_id?: InputMaybe<IOrder_By>;
  speed?: InputMaybe<IOrder_By>;
  speed_percentage?: InputMaybe<IOrder_By>;
  workout_section_template_id?: InputMaybe<IOrder_By>;
  workout_zone_id?: InputMaybe<IOrder_By>;
};

/** order by variance() on columns of table "athlete_workout_section" */
export type IAthlete_Workout_Section_Variance_Order_By = {
  athlete_workout_id?: InputMaybe<IOrder_By>;
  average_heart_rate?: InputMaybe<IOrder_By>;
  average_heart_rate_percentage?: InputMaybe<IOrder_By>;
  duration?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  max_heart_rate?: InputMaybe<IOrder_By>;
  measured_average_heart_rate?: InputMaybe<IOrder_By>;
  measured_duration?: InputMaybe<IOrder_By>;
  measured_max_heart_rate?: InputMaybe<IOrder_By>;
  measured_speed?: InputMaybe<IOrder_By>;
  order?: InputMaybe<IOrder_By>;
  section_zuit?: InputMaybe<IOrder_By>;
  series_id?: InputMaybe<IOrder_By>;
  speed?: InputMaybe<IOrder_By>;
  speed_percentage?: InputMaybe<IOrder_By>;
  workout_section_template_id?: InputMaybe<IOrder_By>;
  workout_zone_id?: InputMaybe<IOrder_By>;
};

/** select columns of table "athlete_workout" */
export enum IAthlete_Workout_Select_Column {
  /** column name */
  AthleteWeekId = 'athlete_week_id',
  /** column name */
  Calories = 'calories',
  /** column name */
  Comments = 'comments',
  /** column name */
  CompletedStretchingCircuit = 'completed_stretching_circuit',
  /** column name */
  CompletedWeightCircuit = 'completed_weight_circuit',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CumulativeElevation = 'cumulative_elevation',
  /** column name */
  Date = 'date',
  /** column name */
  Day = 'day',
  /** column name */
  Effort = 'effort',
  /** column name */
  Id = 'id',
  /** column name */
  IsPrimary = 'is_primary',
  /** column name */
  MeasuredCalories = 'measured_calories',
  /** column name */
  MeasuredCumulativeElevation = 'measured_cumulative_elevation',
  /** column name */
  MeasuredNegativeElevation = 'measured_negative_elevation',
  /** column name */
  MeasuredPositiveElevation = 'measured_positive_elevation',
  /** column name */
  Motivation = 'motivation',
  /** column name */
  NegativeElevation = 'negative_elevation',
  /** column name */
  PositiveElevation = 'positive_elevation',
  /** column name */
  Series = 'series',
  /** column name */
  StravaActivityId = 'strava_activity_id',
  /** column name */
  StretchingCircuitId = 'stretching_circuit_id',
  /** column name */
  StretchingCircuitRepetitions = 'stretching_circuit_repetitions',
  /** column name */
  SumElevation = 'sum_elevation',
  /** column name */
  SumMeasuredElevation = 'sum_measured_elevation',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WeightCircuitId = 'weight_circuit_id',
  /** column name */
  WeightCircuitRepetitions = 'weight_circuit_repetitions',
  /** column name */
  WorkoutAltimetryId = 'workout_altimetry_id',
  /** column name */
  WorkoutTemplateId = 'workout_template_id',
  /** column name */
  WorkoutTerrainId = 'workout_terrain_id',
  /** column name */
  WorkoutTypeId = 'workout_type_id',
  /** column name */
  WorkoutZoneId = 'workout_zone_id',
  /** column name */
  Zuit = 'zuit'
}

/** select "athlete_workout_aggregate_bool_exp_bool_and_arguments_columns" columns of table "athlete_workout" */
export enum IAthlete_Workout_Select_Column_Athlete_Workout_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsPrimary = 'is_primary'
}

/** select "athlete_workout_aggregate_bool_exp_bool_or_arguments_columns" columns of table "athlete_workout" */
export enum IAthlete_Workout_Select_Column_Athlete_Workout_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsPrimary = 'is_primary'
}

/** input type for updating data in table "athlete_workout" */
export type IAthlete_Workout_Set_Input = {
  athlete_week_id?: InputMaybe<Scalars['Int']>;
  calories?: InputMaybe<Scalars['numeric']>;
  comments?: InputMaybe<Scalars['String']>;
  completed_stretching_circuit?: InputMaybe<Scalars['numeric']>;
  completed_weight_circuit?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  cumulative_elevation?: InputMaybe<Scalars['Int']>;
  date?: InputMaybe<Scalars['date']>;
  day?: InputMaybe<Scalars['Int']>;
  effort?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_primary?: InputMaybe<Scalars['Boolean']>;
  measured_calories?: InputMaybe<Scalars['numeric']>;
  measured_cumulative_elevation?: InputMaybe<Scalars['Int']>;
  measured_negative_elevation?: InputMaybe<Scalars['Int']>;
  measured_positive_elevation?: InputMaybe<Scalars['Int']>;
  motivation?: InputMaybe<Scalars['Int']>;
  negative_elevation?: InputMaybe<Scalars['Int']>;
  positive_elevation?: InputMaybe<Scalars['Int']>;
  series?: InputMaybe<Scalars['String']>;
  strava_activity_id?: InputMaybe<Scalars['bigint']>;
  stretching_circuit_id?: InputMaybe<Scalars['Int']>;
  stretching_circuit_repetitions?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  weight_circuit_id?: InputMaybe<Scalars['Int']>;
  weight_circuit_repetitions?: InputMaybe<Scalars['Int']>;
  workout_altimetry_id?: InputMaybe<Scalars['Int']>;
  workout_template_id?: InputMaybe<Scalars['Int']>;
  workout_terrain_id?: InputMaybe<Scalars['Int']>;
  workout_type_id?: InputMaybe<Scalars['Int']>;
  workout_zone_id?: InputMaybe<Scalars['Int']>;
  zuit?: InputMaybe<Scalars['numeric']>;
};

/** order by stddev() on columns of table "athlete_workout" */
export type IAthlete_Workout_Stddev_Order_By = {
  athlete_week_id?: InputMaybe<IOrder_By>;
  calories?: InputMaybe<IOrder_By>;
  completed_stretching_circuit?: InputMaybe<IOrder_By>;
  completed_weight_circuit?: InputMaybe<IOrder_By>;
  cumulative_elevation?: InputMaybe<IOrder_By>;
  day?: InputMaybe<IOrder_By>;
  effort?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  measured_calories?: InputMaybe<IOrder_By>;
  measured_cumulative_elevation?: InputMaybe<IOrder_By>;
  measured_negative_elevation?: InputMaybe<IOrder_By>;
  measured_positive_elevation?: InputMaybe<IOrder_By>;
  motivation?: InputMaybe<IOrder_By>;
  negative_elevation?: InputMaybe<IOrder_By>;
  positive_elevation?: InputMaybe<IOrder_By>;
  strava_activity_id?: InputMaybe<IOrder_By>;
  stretching_circuit_id?: InputMaybe<IOrder_By>;
  stretching_circuit_repetitions?: InputMaybe<IOrder_By>;
  sum_elevation?: InputMaybe<IOrder_By>;
  sum_measured_elevation?: InputMaybe<IOrder_By>;
  weight_circuit_id?: InputMaybe<IOrder_By>;
  weight_circuit_repetitions?: InputMaybe<IOrder_By>;
  workout_altimetry_id?: InputMaybe<IOrder_By>;
  workout_template_id?: InputMaybe<IOrder_By>;
  workout_terrain_id?: InputMaybe<IOrder_By>;
  workout_type_id?: InputMaybe<IOrder_By>;
  workout_zone_id?: InputMaybe<IOrder_By>;
  zuit?: InputMaybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "athlete_workout" */
export type IAthlete_Workout_Stddev_Pop_Order_By = {
  athlete_week_id?: InputMaybe<IOrder_By>;
  calories?: InputMaybe<IOrder_By>;
  completed_stretching_circuit?: InputMaybe<IOrder_By>;
  completed_weight_circuit?: InputMaybe<IOrder_By>;
  cumulative_elevation?: InputMaybe<IOrder_By>;
  day?: InputMaybe<IOrder_By>;
  effort?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  measured_calories?: InputMaybe<IOrder_By>;
  measured_cumulative_elevation?: InputMaybe<IOrder_By>;
  measured_negative_elevation?: InputMaybe<IOrder_By>;
  measured_positive_elevation?: InputMaybe<IOrder_By>;
  motivation?: InputMaybe<IOrder_By>;
  negative_elevation?: InputMaybe<IOrder_By>;
  positive_elevation?: InputMaybe<IOrder_By>;
  strava_activity_id?: InputMaybe<IOrder_By>;
  stretching_circuit_id?: InputMaybe<IOrder_By>;
  stretching_circuit_repetitions?: InputMaybe<IOrder_By>;
  sum_elevation?: InputMaybe<IOrder_By>;
  sum_measured_elevation?: InputMaybe<IOrder_By>;
  weight_circuit_id?: InputMaybe<IOrder_By>;
  weight_circuit_repetitions?: InputMaybe<IOrder_By>;
  workout_altimetry_id?: InputMaybe<IOrder_By>;
  workout_template_id?: InputMaybe<IOrder_By>;
  workout_terrain_id?: InputMaybe<IOrder_By>;
  workout_type_id?: InputMaybe<IOrder_By>;
  workout_zone_id?: InputMaybe<IOrder_By>;
  zuit?: InputMaybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "athlete_workout" */
export type IAthlete_Workout_Stddev_Samp_Order_By = {
  athlete_week_id?: InputMaybe<IOrder_By>;
  calories?: InputMaybe<IOrder_By>;
  completed_stretching_circuit?: InputMaybe<IOrder_By>;
  completed_weight_circuit?: InputMaybe<IOrder_By>;
  cumulative_elevation?: InputMaybe<IOrder_By>;
  day?: InputMaybe<IOrder_By>;
  effort?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  measured_calories?: InputMaybe<IOrder_By>;
  measured_cumulative_elevation?: InputMaybe<IOrder_By>;
  measured_negative_elevation?: InputMaybe<IOrder_By>;
  measured_positive_elevation?: InputMaybe<IOrder_By>;
  motivation?: InputMaybe<IOrder_By>;
  negative_elevation?: InputMaybe<IOrder_By>;
  positive_elevation?: InputMaybe<IOrder_By>;
  strava_activity_id?: InputMaybe<IOrder_By>;
  stretching_circuit_id?: InputMaybe<IOrder_By>;
  stretching_circuit_repetitions?: InputMaybe<IOrder_By>;
  sum_elevation?: InputMaybe<IOrder_By>;
  sum_measured_elevation?: InputMaybe<IOrder_By>;
  weight_circuit_id?: InputMaybe<IOrder_By>;
  weight_circuit_repetitions?: InputMaybe<IOrder_By>;
  workout_altimetry_id?: InputMaybe<IOrder_By>;
  workout_template_id?: InputMaybe<IOrder_By>;
  workout_terrain_id?: InputMaybe<IOrder_By>;
  workout_type_id?: InputMaybe<IOrder_By>;
  workout_zone_id?: InputMaybe<IOrder_By>;
  zuit?: InputMaybe<IOrder_By>;
};

/** Streaming cursor of the table "athlete_workout" */
export type IAthlete_Workout_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IAthlete_Workout_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IAthlete_Workout_Stream_Cursor_Value_Input = {
  athlete_week_id?: InputMaybe<Scalars['Int']>;
  calories?: InputMaybe<Scalars['numeric']>;
  comments?: InputMaybe<Scalars['String']>;
  completed_stretching_circuit?: InputMaybe<Scalars['numeric']>;
  completed_weight_circuit?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  cumulative_elevation?: InputMaybe<Scalars['Int']>;
  date?: InputMaybe<Scalars['date']>;
  day?: InputMaybe<Scalars['Int']>;
  effort?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_primary?: InputMaybe<Scalars['Boolean']>;
  measured_calories?: InputMaybe<Scalars['numeric']>;
  measured_cumulative_elevation?: InputMaybe<Scalars['Int']>;
  measured_negative_elevation?: InputMaybe<Scalars['Int']>;
  measured_positive_elevation?: InputMaybe<Scalars['Int']>;
  motivation?: InputMaybe<Scalars['Int']>;
  negative_elevation?: InputMaybe<Scalars['Int']>;
  positive_elevation?: InputMaybe<Scalars['Int']>;
  series?: InputMaybe<Scalars['String']>;
  strava_activity_id?: InputMaybe<Scalars['bigint']>;
  stretching_circuit_id?: InputMaybe<Scalars['Int']>;
  stretching_circuit_repetitions?: InputMaybe<Scalars['Int']>;
  sum_elevation?: InputMaybe<Scalars['Int']>;
  sum_measured_elevation?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  weight_circuit_id?: InputMaybe<Scalars['Int']>;
  weight_circuit_repetitions?: InputMaybe<Scalars['Int']>;
  workout_altimetry_id?: InputMaybe<Scalars['Int']>;
  workout_template_id?: InputMaybe<Scalars['Int']>;
  workout_terrain_id?: InputMaybe<Scalars['Int']>;
  workout_type_id?: InputMaybe<Scalars['Int']>;
  workout_zone_id?: InputMaybe<Scalars['Int']>;
  zuit?: InputMaybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "athlete_workout" */
export type IAthlete_Workout_Sum_Order_By = {
  athlete_week_id?: InputMaybe<IOrder_By>;
  calories?: InputMaybe<IOrder_By>;
  completed_stretching_circuit?: InputMaybe<IOrder_By>;
  completed_weight_circuit?: InputMaybe<IOrder_By>;
  cumulative_elevation?: InputMaybe<IOrder_By>;
  day?: InputMaybe<IOrder_By>;
  effort?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  measured_calories?: InputMaybe<IOrder_By>;
  measured_cumulative_elevation?: InputMaybe<IOrder_By>;
  measured_negative_elevation?: InputMaybe<IOrder_By>;
  measured_positive_elevation?: InputMaybe<IOrder_By>;
  motivation?: InputMaybe<IOrder_By>;
  negative_elevation?: InputMaybe<IOrder_By>;
  positive_elevation?: InputMaybe<IOrder_By>;
  strava_activity_id?: InputMaybe<IOrder_By>;
  stretching_circuit_id?: InputMaybe<IOrder_By>;
  stretching_circuit_repetitions?: InputMaybe<IOrder_By>;
  sum_elevation?: InputMaybe<IOrder_By>;
  sum_measured_elevation?: InputMaybe<IOrder_By>;
  weight_circuit_id?: InputMaybe<IOrder_By>;
  weight_circuit_repetitions?: InputMaybe<IOrder_By>;
  workout_altimetry_id?: InputMaybe<IOrder_By>;
  workout_template_id?: InputMaybe<IOrder_By>;
  workout_terrain_id?: InputMaybe<IOrder_By>;
  workout_type_id?: InputMaybe<IOrder_By>;
  workout_zone_id?: InputMaybe<IOrder_By>;
  zuit?: InputMaybe<IOrder_By>;
};

/** update columns of table "athlete_workout" */
export enum IAthlete_Workout_Update_Column {
  /** column name */
  AthleteWeekId = 'athlete_week_id',
  /** column name */
  Calories = 'calories',
  /** column name */
  Comments = 'comments',
  /** column name */
  CompletedStretchingCircuit = 'completed_stretching_circuit',
  /** column name */
  CompletedWeightCircuit = 'completed_weight_circuit',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CumulativeElevation = 'cumulative_elevation',
  /** column name */
  Date = 'date',
  /** column name */
  Day = 'day',
  /** column name */
  Effort = 'effort',
  /** column name */
  Id = 'id',
  /** column name */
  IsPrimary = 'is_primary',
  /** column name */
  MeasuredCalories = 'measured_calories',
  /** column name */
  MeasuredCumulativeElevation = 'measured_cumulative_elevation',
  /** column name */
  MeasuredNegativeElevation = 'measured_negative_elevation',
  /** column name */
  MeasuredPositiveElevation = 'measured_positive_elevation',
  /** column name */
  Motivation = 'motivation',
  /** column name */
  NegativeElevation = 'negative_elevation',
  /** column name */
  PositiveElevation = 'positive_elevation',
  /** column name */
  Series = 'series',
  /** column name */
  StravaActivityId = 'strava_activity_id',
  /** column name */
  StretchingCircuitId = 'stretching_circuit_id',
  /** column name */
  StretchingCircuitRepetitions = 'stretching_circuit_repetitions',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WeightCircuitId = 'weight_circuit_id',
  /** column name */
  WeightCircuitRepetitions = 'weight_circuit_repetitions',
  /** column name */
  WorkoutAltimetryId = 'workout_altimetry_id',
  /** column name */
  WorkoutTemplateId = 'workout_template_id',
  /** column name */
  WorkoutTerrainId = 'workout_terrain_id',
  /** column name */
  WorkoutTypeId = 'workout_type_id',
  /** column name */
  WorkoutZoneId = 'workout_zone_id',
  /** column name */
  Zuit = 'zuit'
}

export type IAthlete_Workout_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<IAthlete_Workout_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IAthlete_Workout_Set_Input>;
  /** filter the rows which have to be updated */
  where: IAthlete_Workout_Bool_Exp;
};

/** order by var_pop() on columns of table "athlete_workout" */
export type IAthlete_Workout_Var_Pop_Order_By = {
  athlete_week_id?: InputMaybe<IOrder_By>;
  calories?: InputMaybe<IOrder_By>;
  completed_stretching_circuit?: InputMaybe<IOrder_By>;
  completed_weight_circuit?: InputMaybe<IOrder_By>;
  cumulative_elevation?: InputMaybe<IOrder_By>;
  day?: InputMaybe<IOrder_By>;
  effort?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  measured_calories?: InputMaybe<IOrder_By>;
  measured_cumulative_elevation?: InputMaybe<IOrder_By>;
  measured_negative_elevation?: InputMaybe<IOrder_By>;
  measured_positive_elevation?: InputMaybe<IOrder_By>;
  motivation?: InputMaybe<IOrder_By>;
  negative_elevation?: InputMaybe<IOrder_By>;
  positive_elevation?: InputMaybe<IOrder_By>;
  strava_activity_id?: InputMaybe<IOrder_By>;
  stretching_circuit_id?: InputMaybe<IOrder_By>;
  stretching_circuit_repetitions?: InputMaybe<IOrder_By>;
  sum_elevation?: InputMaybe<IOrder_By>;
  sum_measured_elevation?: InputMaybe<IOrder_By>;
  weight_circuit_id?: InputMaybe<IOrder_By>;
  weight_circuit_repetitions?: InputMaybe<IOrder_By>;
  workout_altimetry_id?: InputMaybe<IOrder_By>;
  workout_template_id?: InputMaybe<IOrder_By>;
  workout_terrain_id?: InputMaybe<IOrder_By>;
  workout_type_id?: InputMaybe<IOrder_By>;
  workout_zone_id?: InputMaybe<IOrder_By>;
  zuit?: InputMaybe<IOrder_By>;
};

/** order by var_samp() on columns of table "athlete_workout" */
export type IAthlete_Workout_Var_Samp_Order_By = {
  athlete_week_id?: InputMaybe<IOrder_By>;
  calories?: InputMaybe<IOrder_By>;
  completed_stretching_circuit?: InputMaybe<IOrder_By>;
  completed_weight_circuit?: InputMaybe<IOrder_By>;
  cumulative_elevation?: InputMaybe<IOrder_By>;
  day?: InputMaybe<IOrder_By>;
  effort?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  measured_calories?: InputMaybe<IOrder_By>;
  measured_cumulative_elevation?: InputMaybe<IOrder_By>;
  measured_negative_elevation?: InputMaybe<IOrder_By>;
  measured_positive_elevation?: InputMaybe<IOrder_By>;
  motivation?: InputMaybe<IOrder_By>;
  negative_elevation?: InputMaybe<IOrder_By>;
  positive_elevation?: InputMaybe<IOrder_By>;
  strava_activity_id?: InputMaybe<IOrder_By>;
  stretching_circuit_id?: InputMaybe<IOrder_By>;
  stretching_circuit_repetitions?: InputMaybe<IOrder_By>;
  sum_elevation?: InputMaybe<IOrder_By>;
  sum_measured_elevation?: InputMaybe<IOrder_By>;
  weight_circuit_id?: InputMaybe<IOrder_By>;
  weight_circuit_repetitions?: InputMaybe<IOrder_By>;
  workout_altimetry_id?: InputMaybe<IOrder_By>;
  workout_template_id?: InputMaybe<IOrder_By>;
  workout_terrain_id?: InputMaybe<IOrder_By>;
  workout_type_id?: InputMaybe<IOrder_By>;
  workout_zone_id?: InputMaybe<IOrder_By>;
  zuit?: InputMaybe<IOrder_By>;
};

/** order by variance() on columns of table "athlete_workout" */
export type IAthlete_Workout_Variance_Order_By = {
  athlete_week_id?: InputMaybe<IOrder_By>;
  calories?: InputMaybe<IOrder_By>;
  completed_stretching_circuit?: InputMaybe<IOrder_By>;
  completed_weight_circuit?: InputMaybe<IOrder_By>;
  cumulative_elevation?: InputMaybe<IOrder_By>;
  day?: InputMaybe<IOrder_By>;
  effort?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  measured_calories?: InputMaybe<IOrder_By>;
  measured_cumulative_elevation?: InputMaybe<IOrder_By>;
  measured_negative_elevation?: InputMaybe<IOrder_By>;
  measured_positive_elevation?: InputMaybe<IOrder_By>;
  motivation?: InputMaybe<IOrder_By>;
  negative_elevation?: InputMaybe<IOrder_By>;
  positive_elevation?: InputMaybe<IOrder_By>;
  strava_activity_id?: InputMaybe<IOrder_By>;
  stretching_circuit_id?: InputMaybe<IOrder_By>;
  stretching_circuit_repetitions?: InputMaybe<IOrder_By>;
  sum_elevation?: InputMaybe<IOrder_By>;
  sum_measured_elevation?: InputMaybe<IOrder_By>;
  weight_circuit_id?: InputMaybe<IOrder_By>;
  weight_circuit_repetitions?: InputMaybe<IOrder_By>;
  workout_altimetry_id?: InputMaybe<IOrder_By>;
  workout_template_id?: InputMaybe<IOrder_By>;
  workout_terrain_id?: InputMaybe<IOrder_By>;
  workout_type_id?: InputMaybe<IOrder_By>;
  workout_zone_id?: InputMaybe<IOrder_By>;
  zuit?: InputMaybe<IOrder_By>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type IBigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']>;
  _gt?: InputMaybe<Scalars['bigint']>;
  _gte?: InputMaybe<Scalars['bigint']>;
  _in?: InputMaybe<Array<Scalars['bigint']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['bigint']>;
  _lte?: InputMaybe<Scalars['bigint']>;
  _neq?: InputMaybe<Scalars['bigint']>;
  _nin?: InputMaybe<Array<Scalars['bigint']>>;
};

/** Boolean expression to filter rows from the table "biometric_parameter". All fields are combined with a logical 'AND'. */
export type IBiometric_Parameter_Bool_Exp = {
  _and?: InputMaybe<Array<IBiometric_Parameter_Bool_Exp>>;
  _not?: InputMaybe<IBiometric_Parameter_Bool_Exp>;
  _or?: InputMaybe<Array<IBiometric_Parameter_Bool_Exp>>;
  athlete_biometric_data?: InputMaybe<IAthlete_Biometric_Data_Bool_Exp>;
  athlete_biometric_data_aggregate?: InputMaybe<IAthlete_Biometric_Data_Aggregate_Bool_Exp>;
  id?: InputMaybe<IName_Comparison_Exp>;
  label?: InputMaybe<IString_Comparison_Exp>;
};

/** unique or primary key constraints on table "biometric_parameter" */
export enum IBiometric_Parameter_Constraint {
  /** unique or primary key constraint on columns "id" */
  BiometricParameterPkey = 'biometric_parameter_pkey'
}

/** input type for inserting data into table "biometric_parameter" */
export type IBiometric_Parameter_Insert_Input = {
  athlete_biometric_data?: InputMaybe<IAthlete_Biometric_Data_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['name']>;
  label?: InputMaybe<Scalars['String']>;
};

/** input type for inserting object relation for remote table "biometric_parameter" */
export type IBiometric_Parameter_Obj_Rel_Insert_Input = {
  data: IBiometric_Parameter_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<IBiometric_Parameter_On_Conflict>;
};

/** on_conflict condition type for table "biometric_parameter" */
export type IBiometric_Parameter_On_Conflict = {
  constraint: IBiometric_Parameter_Constraint;
  update_columns?: Array<IBiometric_Parameter_Update_Column>;
  where?: InputMaybe<IBiometric_Parameter_Bool_Exp>;
};

/** Ordering options when selecting data from "biometric_parameter". */
export type IBiometric_Parameter_Order_By = {
  athlete_biometric_data_aggregate?: InputMaybe<IAthlete_Biometric_Data_Aggregate_Order_By>;
  id?: InputMaybe<IOrder_By>;
  label?: InputMaybe<IOrder_By>;
};

/** primary key columns input for table: biometric_parameter */
export type IBiometric_Parameter_Pk_Columns_Input = {
  id: Scalars['name'];
};

/** select columns of table "biometric_parameter" */
export enum IBiometric_Parameter_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label'
}

/** input type for updating data in table "biometric_parameter" */
export type IBiometric_Parameter_Set_Input = {
  id?: InputMaybe<Scalars['name']>;
  label?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "biometric_parameter" */
export type IBiometric_Parameter_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IBiometric_Parameter_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IBiometric_Parameter_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['name']>;
  label?: InputMaybe<Scalars['String']>;
};

/** update columns of table "biometric_parameter" */
export enum IBiometric_Parameter_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label'
}

export type IBiometric_Parameter_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IBiometric_Parameter_Set_Input>;
  /** filter the rows which have to be updated */
  where: IBiometric_Parameter_Bool_Exp;
};

export type IBlock_Template_Aggregate_Bool_Exp = {
  count?: InputMaybe<IBlock_Template_Aggregate_Bool_Exp_Count>;
};

export type IBlock_Template_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<IBlock_Template_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IBlock_Template_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

/** order by aggregate values of table "block_template" */
export type IBlock_Template_Aggregate_Order_By = {
  avg?: InputMaybe<IBlock_Template_Avg_Order_By>;
  count?: InputMaybe<IOrder_By>;
  max?: InputMaybe<IBlock_Template_Max_Order_By>;
  min?: InputMaybe<IBlock_Template_Min_Order_By>;
  stddev?: InputMaybe<IBlock_Template_Stddev_Order_By>;
  stddev_pop?: InputMaybe<IBlock_Template_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<IBlock_Template_Stddev_Samp_Order_By>;
  sum?: InputMaybe<IBlock_Template_Sum_Order_By>;
  var_pop?: InputMaybe<IBlock_Template_Var_Pop_Order_By>;
  var_samp?: InputMaybe<IBlock_Template_Var_Samp_Order_By>;
  variance?: InputMaybe<IBlock_Template_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "block_template" */
export type IBlock_Template_Arr_Rel_Insert_Input = {
  data: Array<IBlock_Template_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<IBlock_Template_On_Conflict>;
};

/** order by avg() on columns of table "block_template" */
export type IBlock_Template_Avg_Order_By = {
  coach_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "block_template". All fields are combined with a logical 'AND'. */
export type IBlock_Template_Bool_Exp = {
  _and?: InputMaybe<Array<IBlock_Template_Bool_Exp>>;
  _not?: InputMaybe<IBlock_Template_Bool_Exp>;
  _or?: InputMaybe<Array<IBlock_Template_Bool_Exp>>;
  coach?: InputMaybe<ICoach_Bool_Exp>;
  coach_id?: InputMaybe<IInt_Comparison_Exp>;
  created_at?: InputMaybe<ITimestamptz_Comparison_Exp>;
  description?: InputMaybe<IString_Comparison_Exp>;
  id?: InputMaybe<IInt_Comparison_Exp>;
  name?: InputMaybe<IString_Comparison_Exp>;
  sport?: InputMaybe<ISport_Bool_Exp>;
  sport_id?: InputMaybe<IString_Comparison_Exp>;
  updated_at?: InputMaybe<ITimestamptz_Comparison_Exp>;
  week_templates?: InputMaybe<IWeek_Template_Bool_Exp>;
  week_templates_aggregate?: InputMaybe<IWeek_Template_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "block_template" */
export enum IBlock_Template_Constraint {
  /** unique or primary key constraint on columns "id" */
  BlockTemplatePkey = 'block_template_pkey'
}

/** input type for incrementing numeric columns in table "block_template" */
export type IBlock_Template_Inc_Input = {
  coach_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "block_template" */
export type IBlock_Template_Insert_Input = {
  coach?: InputMaybe<ICoach_Obj_Rel_Insert_Input>;
  coach_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  sport?: InputMaybe<ISport_Obj_Rel_Insert_Input>;
  sport_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  week_templates?: InputMaybe<IWeek_Template_Arr_Rel_Insert_Input>;
};

/** order by max() on columns of table "block_template" */
export type IBlock_Template_Max_Order_By = {
  coach_id?: InputMaybe<IOrder_By>;
  created_at?: InputMaybe<IOrder_By>;
  description?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  name?: InputMaybe<IOrder_By>;
  sport_id?: InputMaybe<IOrder_By>;
  updated_at?: InputMaybe<IOrder_By>;
};

/** order by min() on columns of table "block_template" */
export type IBlock_Template_Min_Order_By = {
  coach_id?: InputMaybe<IOrder_By>;
  created_at?: InputMaybe<IOrder_By>;
  description?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  name?: InputMaybe<IOrder_By>;
  sport_id?: InputMaybe<IOrder_By>;
  updated_at?: InputMaybe<IOrder_By>;
};

/** input type for inserting object relation for remote table "block_template" */
export type IBlock_Template_Obj_Rel_Insert_Input = {
  data: IBlock_Template_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<IBlock_Template_On_Conflict>;
};

/** on_conflict condition type for table "block_template" */
export type IBlock_Template_On_Conflict = {
  constraint: IBlock_Template_Constraint;
  update_columns?: Array<IBlock_Template_Update_Column>;
  where?: InputMaybe<IBlock_Template_Bool_Exp>;
};

/** Ordering options when selecting data from "block_template". */
export type IBlock_Template_Order_By = {
  coach?: InputMaybe<ICoach_Order_By>;
  coach_id?: InputMaybe<IOrder_By>;
  created_at?: InputMaybe<IOrder_By>;
  description?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  name?: InputMaybe<IOrder_By>;
  sport?: InputMaybe<ISport_Order_By>;
  sport_id?: InputMaybe<IOrder_By>;
  updated_at?: InputMaybe<IOrder_By>;
  week_templates_aggregate?: InputMaybe<IWeek_Template_Aggregate_Order_By>;
};

/** primary key columns input for table: block_template */
export type IBlock_Template_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "block_template" */
export enum IBlock_Template_Select_Column {
  /** column name */
  CoachId = 'coach_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  SportId = 'sport_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "block_template" */
export type IBlock_Template_Set_Input = {
  coach_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  sport_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** order by stddev() on columns of table "block_template" */
export type IBlock_Template_Stddev_Order_By = {
  coach_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "block_template" */
export type IBlock_Template_Stddev_Pop_Order_By = {
  coach_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "block_template" */
export type IBlock_Template_Stddev_Samp_Order_By = {
  coach_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
};

/** Streaming cursor of the table "block_template" */
export type IBlock_Template_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IBlock_Template_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IBlock_Template_Stream_Cursor_Value_Input = {
  coach_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  sport_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** order by sum() on columns of table "block_template" */
export type IBlock_Template_Sum_Order_By = {
  coach_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
};

/** update columns of table "block_template" */
export enum IBlock_Template_Update_Column {
  /** column name */
  CoachId = 'coach_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  SportId = 'sport_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type IBlock_Template_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<IBlock_Template_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IBlock_Template_Set_Input>;
  /** filter the rows which have to be updated */
  where: IBlock_Template_Bool_Exp;
};

/** order by var_pop() on columns of table "block_template" */
export type IBlock_Template_Var_Pop_Order_By = {
  coach_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
};

/** order by var_samp() on columns of table "block_template" */
export type IBlock_Template_Var_Samp_Order_By = {
  coach_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
};

/** order by variance() on columns of table "block_template" */
export type IBlock_Template_Variance_Order_By = {
  coach_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
};

export type ICircuit_Aggregate_Bool_Exp = {
  count?: InputMaybe<ICircuit_Aggregate_Bool_Exp_Count>;
};

export type ICircuit_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ICircuit_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ICircuit_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

/** order by aggregate values of table "circuit" */
export type ICircuit_Aggregate_Order_By = {
  avg?: InputMaybe<ICircuit_Avg_Order_By>;
  count?: InputMaybe<IOrder_By>;
  max?: InputMaybe<ICircuit_Max_Order_By>;
  min?: InputMaybe<ICircuit_Min_Order_By>;
  stddev?: InputMaybe<ICircuit_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ICircuit_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ICircuit_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ICircuit_Sum_Order_By>;
  var_pop?: InputMaybe<ICircuit_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ICircuit_Var_Samp_Order_By>;
  variance?: InputMaybe<ICircuit_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "circuit" */
export type ICircuit_Arr_Rel_Insert_Input = {
  data: Array<ICircuit_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ICircuit_On_Conflict>;
};

/** order by avg() on columns of table "circuit" */
export type ICircuit_Avg_Order_By = {
  coach_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  recovery_interval?: InputMaybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "circuit". All fields are combined with a logical 'AND'. */
export type ICircuit_Bool_Exp = {
  _and?: InputMaybe<Array<ICircuit_Bool_Exp>>;
  _not?: InputMaybe<ICircuit_Bool_Exp>;
  _or?: InputMaybe<Array<ICircuit_Bool_Exp>>;
  athleteWorkoutsByWeightCircuitId?: InputMaybe<IAthlete_Workout_Bool_Exp>;
  athleteWorkoutsByWeightCircuitId_aggregate?: InputMaybe<IAthlete_Workout_Aggregate_Bool_Exp>;
  athlete_workouts?: InputMaybe<IAthlete_Workout_Bool_Exp>;
  athlete_workouts_aggregate?: InputMaybe<IAthlete_Workout_Aggregate_Bool_Exp>;
  circuit_exercises?: InputMaybe<ICircuit_Exercise_Bool_Exp>;
  circuit_exercises_aggregate?: InputMaybe<ICircuit_Exercise_Aggregate_Bool_Exp>;
  circuit_translations?: InputMaybe<ICircuit_Translation_Bool_Exp>;
  circuit_translations_aggregate?: InputMaybe<ICircuit_Translation_Aggregate_Bool_Exp>;
  coach?: InputMaybe<ICoach_Bool_Exp>;
  coach_id?: InputMaybe<IInt_Comparison_Exp>;
  id?: InputMaybe<IInt_Comparison_Exp>;
  recovery_interval?: InputMaybe<INumeric_Comparison_Exp>;
  sports?: InputMaybe<ICircuit_Sport_Bool_Exp>;
  sports_aggregate?: InputMaybe<ICircuit_Sport_Aggregate_Bool_Exp>;
  type?: InputMaybe<IString_Comparison_Exp>;
  workoutTemplatesByWeightCircuitId?: InputMaybe<IWorkout_Template_Bool_Exp>;
  workoutTemplatesByWeightCircuitId_aggregate?: InputMaybe<IWorkout_Template_Aggregate_Bool_Exp>;
  workout_templates?: InputMaybe<IWorkout_Template_Bool_Exp>;
  workout_templates_aggregate?: InputMaybe<IWorkout_Template_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "circuit" */
export enum ICircuit_Constraint {
  /** unique or primary key constraint on columns "id" */
  CircuitPkey = 'circuit_pkey'
}

export type ICircuit_Exercise_Aggregate_Bool_Exp = {
  count?: InputMaybe<ICircuit_Exercise_Aggregate_Bool_Exp_Count>;
};

export type ICircuit_Exercise_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ICircuit_Exercise_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ICircuit_Exercise_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

/** order by aggregate values of table "circuit_exercise" */
export type ICircuit_Exercise_Aggregate_Order_By = {
  avg?: InputMaybe<ICircuit_Exercise_Avg_Order_By>;
  count?: InputMaybe<IOrder_By>;
  max?: InputMaybe<ICircuit_Exercise_Max_Order_By>;
  min?: InputMaybe<ICircuit_Exercise_Min_Order_By>;
  stddev?: InputMaybe<ICircuit_Exercise_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ICircuit_Exercise_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ICircuit_Exercise_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ICircuit_Exercise_Sum_Order_By>;
  var_pop?: InputMaybe<ICircuit_Exercise_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ICircuit_Exercise_Var_Samp_Order_By>;
  variance?: InputMaybe<ICircuit_Exercise_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "circuit_exercise" */
export type ICircuit_Exercise_Arr_Rel_Insert_Input = {
  data: Array<ICircuit_Exercise_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ICircuit_Exercise_On_Conflict>;
};

/** order by avg() on columns of table "circuit_exercise" */
export type ICircuit_Exercise_Avg_Order_By = {
  circuit_id?: InputMaybe<IOrder_By>;
  duration?: InputMaybe<IOrder_By>;
  exercise_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  no_of_series?: InputMaybe<IOrder_By>;
  order?: InputMaybe<IOrder_By>;
  repetitions?: InputMaybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "circuit_exercise". All fields are combined with a logical 'AND'. */
export type ICircuit_Exercise_Bool_Exp = {
  _and?: InputMaybe<Array<ICircuit_Exercise_Bool_Exp>>;
  _not?: InputMaybe<ICircuit_Exercise_Bool_Exp>;
  _or?: InputMaybe<Array<ICircuit_Exercise_Bool_Exp>>;
  circuit?: InputMaybe<ICircuit_Bool_Exp>;
  circuit_id?: InputMaybe<IInt_Comparison_Exp>;
  duration?: InputMaybe<INumeric_Comparison_Exp>;
  exercise?: InputMaybe<IExercise_Bool_Exp>;
  exercise_id?: InputMaybe<IInt_Comparison_Exp>;
  id?: InputMaybe<IInt_Comparison_Exp>;
  no_of_series?: InputMaybe<INumeric_Comparison_Exp>;
  order?: InputMaybe<IInt_Comparison_Exp>;
  repetitions?: InputMaybe<INumeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "circuit_exercise" */
export enum ICircuit_Exercise_Constraint {
  /** unique or primary key constraint on columns "id" */
  CircuitExercisePkey = 'circuit_exercise_pkey'
}

/** input type for incrementing numeric columns in table "circuit_exercise" */
export type ICircuit_Exercise_Inc_Input = {
  circuit_id?: InputMaybe<Scalars['Int']>;
  duration?: InputMaybe<Scalars['numeric']>;
  exercise_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  no_of_series?: InputMaybe<Scalars['numeric']>;
  order?: InputMaybe<Scalars['Int']>;
  repetitions?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "circuit_exercise" */
export type ICircuit_Exercise_Insert_Input = {
  circuit?: InputMaybe<ICircuit_Obj_Rel_Insert_Input>;
  circuit_id?: InputMaybe<Scalars['Int']>;
  duration?: InputMaybe<Scalars['numeric']>;
  exercise?: InputMaybe<IExercise_Obj_Rel_Insert_Input>;
  exercise_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  no_of_series?: InputMaybe<Scalars['numeric']>;
  order?: InputMaybe<Scalars['Int']>;
  repetitions?: InputMaybe<Scalars['numeric']>;
};

/** order by max() on columns of table "circuit_exercise" */
export type ICircuit_Exercise_Max_Order_By = {
  circuit_id?: InputMaybe<IOrder_By>;
  duration?: InputMaybe<IOrder_By>;
  exercise_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  no_of_series?: InputMaybe<IOrder_By>;
  order?: InputMaybe<IOrder_By>;
  repetitions?: InputMaybe<IOrder_By>;
};

/** order by min() on columns of table "circuit_exercise" */
export type ICircuit_Exercise_Min_Order_By = {
  circuit_id?: InputMaybe<IOrder_By>;
  duration?: InputMaybe<IOrder_By>;
  exercise_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  no_of_series?: InputMaybe<IOrder_By>;
  order?: InputMaybe<IOrder_By>;
  repetitions?: InputMaybe<IOrder_By>;
};

/** on_conflict condition type for table "circuit_exercise" */
export type ICircuit_Exercise_On_Conflict = {
  constraint: ICircuit_Exercise_Constraint;
  update_columns?: Array<ICircuit_Exercise_Update_Column>;
  where?: InputMaybe<ICircuit_Exercise_Bool_Exp>;
};

/** Ordering options when selecting data from "circuit_exercise". */
export type ICircuit_Exercise_Order_By = {
  circuit?: InputMaybe<ICircuit_Order_By>;
  circuit_id?: InputMaybe<IOrder_By>;
  duration?: InputMaybe<IOrder_By>;
  exercise?: InputMaybe<IExercise_Order_By>;
  exercise_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  no_of_series?: InputMaybe<IOrder_By>;
  order?: InputMaybe<IOrder_By>;
  repetitions?: InputMaybe<IOrder_By>;
};

/** primary key columns input for table: circuit_exercise */
export type ICircuit_Exercise_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "circuit_exercise" */
export enum ICircuit_Exercise_Select_Column {
  /** column name */
  CircuitId = 'circuit_id',
  /** column name */
  Duration = 'duration',
  /** column name */
  ExerciseId = 'exercise_id',
  /** column name */
  Id = 'id',
  /** column name */
  NoOfSeries = 'no_of_series',
  /** column name */
  Order = 'order',
  /** column name */
  Repetitions = 'repetitions'
}

/** input type for updating data in table "circuit_exercise" */
export type ICircuit_Exercise_Set_Input = {
  circuit_id?: InputMaybe<Scalars['Int']>;
  duration?: InputMaybe<Scalars['numeric']>;
  exercise_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  no_of_series?: InputMaybe<Scalars['numeric']>;
  order?: InputMaybe<Scalars['Int']>;
  repetitions?: InputMaybe<Scalars['numeric']>;
};

/** order by stddev() on columns of table "circuit_exercise" */
export type ICircuit_Exercise_Stddev_Order_By = {
  circuit_id?: InputMaybe<IOrder_By>;
  duration?: InputMaybe<IOrder_By>;
  exercise_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  no_of_series?: InputMaybe<IOrder_By>;
  order?: InputMaybe<IOrder_By>;
  repetitions?: InputMaybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "circuit_exercise" */
export type ICircuit_Exercise_Stddev_Pop_Order_By = {
  circuit_id?: InputMaybe<IOrder_By>;
  duration?: InputMaybe<IOrder_By>;
  exercise_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  no_of_series?: InputMaybe<IOrder_By>;
  order?: InputMaybe<IOrder_By>;
  repetitions?: InputMaybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "circuit_exercise" */
export type ICircuit_Exercise_Stddev_Samp_Order_By = {
  circuit_id?: InputMaybe<IOrder_By>;
  duration?: InputMaybe<IOrder_By>;
  exercise_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  no_of_series?: InputMaybe<IOrder_By>;
  order?: InputMaybe<IOrder_By>;
  repetitions?: InputMaybe<IOrder_By>;
};

/** Streaming cursor of the table "circuit_exercise" */
export type ICircuit_Exercise_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ICircuit_Exercise_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ICircuit_Exercise_Stream_Cursor_Value_Input = {
  circuit_id?: InputMaybe<Scalars['Int']>;
  duration?: InputMaybe<Scalars['numeric']>;
  exercise_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  no_of_series?: InputMaybe<Scalars['numeric']>;
  order?: InputMaybe<Scalars['Int']>;
  repetitions?: InputMaybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "circuit_exercise" */
export type ICircuit_Exercise_Sum_Order_By = {
  circuit_id?: InputMaybe<IOrder_By>;
  duration?: InputMaybe<IOrder_By>;
  exercise_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  no_of_series?: InputMaybe<IOrder_By>;
  order?: InputMaybe<IOrder_By>;
  repetitions?: InputMaybe<IOrder_By>;
};

/** update columns of table "circuit_exercise" */
export enum ICircuit_Exercise_Update_Column {
  /** column name */
  CircuitId = 'circuit_id',
  /** column name */
  Duration = 'duration',
  /** column name */
  ExerciseId = 'exercise_id',
  /** column name */
  Id = 'id',
  /** column name */
  NoOfSeries = 'no_of_series',
  /** column name */
  Order = 'order',
  /** column name */
  Repetitions = 'repetitions'
}

export type ICircuit_Exercise_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ICircuit_Exercise_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ICircuit_Exercise_Set_Input>;
  /** filter the rows which have to be updated */
  where: ICircuit_Exercise_Bool_Exp;
};

/** order by var_pop() on columns of table "circuit_exercise" */
export type ICircuit_Exercise_Var_Pop_Order_By = {
  circuit_id?: InputMaybe<IOrder_By>;
  duration?: InputMaybe<IOrder_By>;
  exercise_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  no_of_series?: InputMaybe<IOrder_By>;
  order?: InputMaybe<IOrder_By>;
  repetitions?: InputMaybe<IOrder_By>;
};

/** order by var_samp() on columns of table "circuit_exercise" */
export type ICircuit_Exercise_Var_Samp_Order_By = {
  circuit_id?: InputMaybe<IOrder_By>;
  duration?: InputMaybe<IOrder_By>;
  exercise_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  no_of_series?: InputMaybe<IOrder_By>;
  order?: InputMaybe<IOrder_By>;
  repetitions?: InputMaybe<IOrder_By>;
};

/** order by variance() on columns of table "circuit_exercise" */
export type ICircuit_Exercise_Variance_Order_By = {
  circuit_id?: InputMaybe<IOrder_By>;
  duration?: InputMaybe<IOrder_By>;
  exercise_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  no_of_series?: InputMaybe<IOrder_By>;
  order?: InputMaybe<IOrder_By>;
  repetitions?: InputMaybe<IOrder_By>;
};

/** input type for incrementing numeric columns in table "circuit" */
export type ICircuit_Inc_Input = {
  coach_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  recovery_interval?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "circuit" */
export type ICircuit_Insert_Input = {
  athleteWorkoutsByWeightCircuitId?: InputMaybe<IAthlete_Workout_Arr_Rel_Insert_Input>;
  athlete_workouts?: InputMaybe<IAthlete_Workout_Arr_Rel_Insert_Input>;
  circuit_exercises?: InputMaybe<ICircuit_Exercise_Arr_Rel_Insert_Input>;
  circuit_translations?: InputMaybe<ICircuit_Translation_Arr_Rel_Insert_Input>;
  coach?: InputMaybe<ICoach_Obj_Rel_Insert_Input>;
  coach_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  recovery_interval?: InputMaybe<Scalars['numeric']>;
  sports?: InputMaybe<ICircuit_Sport_Arr_Rel_Insert_Input>;
  type?: InputMaybe<Scalars['String']>;
  workoutTemplatesByWeightCircuitId?: InputMaybe<IWorkout_Template_Arr_Rel_Insert_Input>;
  workout_templates?: InputMaybe<IWorkout_Template_Arr_Rel_Insert_Input>;
};

/** order by max() on columns of table "circuit" */
export type ICircuit_Max_Order_By = {
  coach_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  recovery_interval?: InputMaybe<IOrder_By>;
  type?: InputMaybe<IOrder_By>;
};

/** order by min() on columns of table "circuit" */
export type ICircuit_Min_Order_By = {
  coach_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  recovery_interval?: InputMaybe<IOrder_By>;
  type?: InputMaybe<IOrder_By>;
};

/** input type for inserting object relation for remote table "circuit" */
export type ICircuit_Obj_Rel_Insert_Input = {
  data: ICircuit_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ICircuit_On_Conflict>;
};

/** on_conflict condition type for table "circuit" */
export type ICircuit_On_Conflict = {
  constraint: ICircuit_Constraint;
  update_columns?: Array<ICircuit_Update_Column>;
  where?: InputMaybe<ICircuit_Bool_Exp>;
};

/** Ordering options when selecting data from "circuit". */
export type ICircuit_Order_By = {
  athleteWorkoutsByWeightCircuitId_aggregate?: InputMaybe<IAthlete_Workout_Aggregate_Order_By>;
  athlete_workouts_aggregate?: InputMaybe<IAthlete_Workout_Aggregate_Order_By>;
  circuit_exercises_aggregate?: InputMaybe<ICircuit_Exercise_Aggregate_Order_By>;
  circuit_translations_aggregate?: InputMaybe<ICircuit_Translation_Aggregate_Order_By>;
  coach?: InputMaybe<ICoach_Order_By>;
  coach_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  recovery_interval?: InputMaybe<IOrder_By>;
  sports_aggregate?: InputMaybe<ICircuit_Sport_Aggregate_Order_By>;
  type?: InputMaybe<IOrder_By>;
  workoutTemplatesByWeightCircuitId_aggregate?: InputMaybe<IWorkout_Template_Aggregate_Order_By>;
  workout_templates_aggregate?: InputMaybe<IWorkout_Template_Aggregate_Order_By>;
};

/** primary key columns input for table: circuit */
export type ICircuit_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "circuit" */
export enum ICircuit_Select_Column {
  /** column name */
  CoachId = 'coach_id',
  /** column name */
  Id = 'id',
  /** column name */
  RecoveryInterval = 'recovery_interval',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "circuit" */
export type ICircuit_Set_Input = {
  coach_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  recovery_interval?: InputMaybe<Scalars['numeric']>;
  type?: InputMaybe<Scalars['String']>;
};

export type ICircuit_Sport_Aggregate_Bool_Exp = {
  count?: InputMaybe<ICircuit_Sport_Aggregate_Bool_Exp_Count>;
};

export type ICircuit_Sport_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ICircuit_Sport_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ICircuit_Sport_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

/** order by aggregate values of table "circuit_sport" */
export type ICircuit_Sport_Aggregate_Order_By = {
  avg?: InputMaybe<ICircuit_Sport_Avg_Order_By>;
  count?: InputMaybe<IOrder_By>;
  max?: InputMaybe<ICircuit_Sport_Max_Order_By>;
  min?: InputMaybe<ICircuit_Sport_Min_Order_By>;
  stddev?: InputMaybe<ICircuit_Sport_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ICircuit_Sport_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ICircuit_Sport_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ICircuit_Sport_Sum_Order_By>;
  var_pop?: InputMaybe<ICircuit_Sport_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ICircuit_Sport_Var_Samp_Order_By>;
  variance?: InputMaybe<ICircuit_Sport_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "circuit_sport" */
export type ICircuit_Sport_Arr_Rel_Insert_Input = {
  data: Array<ICircuit_Sport_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ICircuit_Sport_On_Conflict>;
};

/** order by avg() on columns of table "circuit_sport" */
export type ICircuit_Sport_Avg_Order_By = {
  circuit_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "circuit_sport". All fields are combined with a logical 'AND'. */
export type ICircuit_Sport_Bool_Exp = {
  _and?: InputMaybe<Array<ICircuit_Sport_Bool_Exp>>;
  _not?: InputMaybe<ICircuit_Sport_Bool_Exp>;
  _or?: InputMaybe<Array<ICircuit_Sport_Bool_Exp>>;
  circuit?: InputMaybe<ICircuit_Bool_Exp>;
  circuit_id?: InputMaybe<IInt_Comparison_Exp>;
  id?: InputMaybe<IInt_Comparison_Exp>;
  sport?: InputMaybe<ISport_Bool_Exp>;
  sport_id?: InputMaybe<IName_Comparison_Exp>;
};

/** unique or primary key constraints on table "circuit_sport" */
export enum ICircuit_Sport_Constraint {
  /** unique or primary key constraint on columns "id" */
  CircuitSportPkey = 'circuit_sport_pkey',
  /** unique or primary key constraint on columns "sport_id", "circuit_id" */
  CircuitSportSportIdCircuitIdKey = 'circuit_sport_sport_id_circuit_id_key'
}

/** input type for incrementing numeric columns in table "circuit_sport" */
export type ICircuit_Sport_Inc_Input = {
  circuit_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "circuit_sport" */
export type ICircuit_Sport_Insert_Input = {
  circuit?: InputMaybe<ICircuit_Obj_Rel_Insert_Input>;
  circuit_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  sport?: InputMaybe<ISport_Obj_Rel_Insert_Input>;
  sport_id?: InputMaybe<Scalars['name']>;
};

/** order by max() on columns of table "circuit_sport" */
export type ICircuit_Sport_Max_Order_By = {
  circuit_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
};

/** order by min() on columns of table "circuit_sport" */
export type ICircuit_Sport_Min_Order_By = {
  circuit_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
};

/** on_conflict condition type for table "circuit_sport" */
export type ICircuit_Sport_On_Conflict = {
  constraint: ICircuit_Sport_Constraint;
  update_columns?: Array<ICircuit_Sport_Update_Column>;
  where?: InputMaybe<ICircuit_Sport_Bool_Exp>;
};

/** Ordering options when selecting data from "circuit_sport". */
export type ICircuit_Sport_Order_By = {
  circuit?: InputMaybe<ICircuit_Order_By>;
  circuit_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  sport?: InputMaybe<ISport_Order_By>;
  sport_id?: InputMaybe<IOrder_By>;
};

/** primary key columns input for table: circuit_sport */
export type ICircuit_Sport_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "circuit_sport" */
export enum ICircuit_Sport_Select_Column {
  /** column name */
  CircuitId = 'circuit_id',
  /** column name */
  Id = 'id',
  /** column name */
  SportId = 'sport_id'
}

/** input type for updating data in table "circuit_sport" */
export type ICircuit_Sport_Set_Input = {
  circuit_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  sport_id?: InputMaybe<Scalars['name']>;
};

/** order by stddev() on columns of table "circuit_sport" */
export type ICircuit_Sport_Stddev_Order_By = {
  circuit_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "circuit_sport" */
export type ICircuit_Sport_Stddev_Pop_Order_By = {
  circuit_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "circuit_sport" */
export type ICircuit_Sport_Stddev_Samp_Order_By = {
  circuit_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
};

/** Streaming cursor of the table "circuit_sport" */
export type ICircuit_Sport_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ICircuit_Sport_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ICircuit_Sport_Stream_Cursor_Value_Input = {
  circuit_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  sport_id?: InputMaybe<Scalars['name']>;
};

/** order by sum() on columns of table "circuit_sport" */
export type ICircuit_Sport_Sum_Order_By = {
  circuit_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
};

/** update columns of table "circuit_sport" */
export enum ICircuit_Sport_Update_Column {
  /** column name */
  CircuitId = 'circuit_id',
  /** column name */
  Id = 'id',
  /** column name */
  SportId = 'sport_id'
}

export type ICircuit_Sport_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ICircuit_Sport_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ICircuit_Sport_Set_Input>;
  /** filter the rows which have to be updated */
  where: ICircuit_Sport_Bool_Exp;
};

/** order by var_pop() on columns of table "circuit_sport" */
export type ICircuit_Sport_Var_Pop_Order_By = {
  circuit_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
};

/** order by var_samp() on columns of table "circuit_sport" */
export type ICircuit_Sport_Var_Samp_Order_By = {
  circuit_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
};

/** order by variance() on columns of table "circuit_sport" */
export type ICircuit_Sport_Variance_Order_By = {
  circuit_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
};

/** order by stddev() on columns of table "circuit" */
export type ICircuit_Stddev_Order_By = {
  coach_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  recovery_interval?: InputMaybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "circuit" */
export type ICircuit_Stddev_Pop_Order_By = {
  coach_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  recovery_interval?: InputMaybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "circuit" */
export type ICircuit_Stddev_Samp_Order_By = {
  coach_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  recovery_interval?: InputMaybe<IOrder_By>;
};

/** Streaming cursor of the table "circuit" */
export type ICircuit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ICircuit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ICircuit_Stream_Cursor_Value_Input = {
  coach_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  recovery_interval?: InputMaybe<Scalars['numeric']>;
  type?: InputMaybe<Scalars['String']>;
};

/** order by sum() on columns of table "circuit" */
export type ICircuit_Sum_Order_By = {
  coach_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  recovery_interval?: InputMaybe<IOrder_By>;
};

export type ICircuit_Translation_Aggregate_Bool_Exp = {
  count?: InputMaybe<ICircuit_Translation_Aggregate_Bool_Exp_Count>;
};

export type ICircuit_Translation_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ICircuit_Translation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ICircuit_Translation_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

/** order by aggregate values of table "circuit_translation" */
export type ICircuit_Translation_Aggregate_Order_By = {
  avg?: InputMaybe<ICircuit_Translation_Avg_Order_By>;
  count?: InputMaybe<IOrder_By>;
  max?: InputMaybe<ICircuit_Translation_Max_Order_By>;
  min?: InputMaybe<ICircuit_Translation_Min_Order_By>;
  stddev?: InputMaybe<ICircuit_Translation_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ICircuit_Translation_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ICircuit_Translation_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ICircuit_Translation_Sum_Order_By>;
  var_pop?: InputMaybe<ICircuit_Translation_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ICircuit_Translation_Var_Samp_Order_By>;
  variance?: InputMaybe<ICircuit_Translation_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "circuit_translation" */
export type ICircuit_Translation_Arr_Rel_Insert_Input = {
  data: Array<ICircuit_Translation_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ICircuit_Translation_On_Conflict>;
};

/** order by avg() on columns of table "circuit_translation" */
export type ICircuit_Translation_Avg_Order_By = {
  circuit_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "circuit_translation". All fields are combined with a logical 'AND'. */
export type ICircuit_Translation_Bool_Exp = {
  _and?: InputMaybe<Array<ICircuit_Translation_Bool_Exp>>;
  _not?: InputMaybe<ICircuit_Translation_Bool_Exp>;
  _or?: InputMaybe<Array<ICircuit_Translation_Bool_Exp>>;
  circuit?: InputMaybe<ICircuit_Bool_Exp>;
  circuit_id?: InputMaybe<IInt_Comparison_Exp>;
  created_at?: InputMaybe<ITimestamptz_Comparison_Exp>;
  description?: InputMaybe<IString_Comparison_Exp>;
  id?: InputMaybe<IInt_Comparison_Exp>;
  locale?: InputMaybe<ILocale_Bool_Exp>;
  locale_id?: InputMaybe<IInt_Comparison_Exp>;
  name?: InputMaybe<IString_Comparison_Exp>;
};

/** unique or primary key constraints on table "circuit_translation" */
export enum ICircuit_Translation_Constraint {
  /** unique or primary key constraint on columns "id" */
  CircuitTranslationPkey = 'circuit_translation_pkey'
}

/** input type for incrementing numeric columns in table "circuit_translation" */
export type ICircuit_Translation_Inc_Input = {
  circuit_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  locale_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "circuit_translation" */
export type ICircuit_Translation_Insert_Input = {
  circuit?: InputMaybe<ICircuit_Obj_Rel_Insert_Input>;
  circuit_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<ILocale_Obj_Rel_Insert_Input>;
  locale_id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** order by max() on columns of table "circuit_translation" */
export type ICircuit_Translation_Max_Order_By = {
  circuit_id?: InputMaybe<IOrder_By>;
  created_at?: InputMaybe<IOrder_By>;
  description?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
  name?: InputMaybe<IOrder_By>;
};

/** order by min() on columns of table "circuit_translation" */
export type ICircuit_Translation_Min_Order_By = {
  circuit_id?: InputMaybe<IOrder_By>;
  created_at?: InputMaybe<IOrder_By>;
  description?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
  name?: InputMaybe<IOrder_By>;
};

/** on_conflict condition type for table "circuit_translation" */
export type ICircuit_Translation_On_Conflict = {
  constraint: ICircuit_Translation_Constraint;
  update_columns?: Array<ICircuit_Translation_Update_Column>;
  where?: InputMaybe<ICircuit_Translation_Bool_Exp>;
};

/** Ordering options when selecting data from "circuit_translation". */
export type ICircuit_Translation_Order_By = {
  circuit?: InputMaybe<ICircuit_Order_By>;
  circuit_id?: InputMaybe<IOrder_By>;
  created_at?: InputMaybe<IOrder_By>;
  description?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  locale?: InputMaybe<ILocale_Order_By>;
  locale_id?: InputMaybe<IOrder_By>;
  name?: InputMaybe<IOrder_By>;
};

/** primary key columns input for table: circuit_translation */
export type ICircuit_Translation_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "circuit_translation" */
export enum ICircuit_Translation_Select_Column {
  /** column name */
  CircuitId = 'circuit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  LocaleId = 'locale_id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "circuit_translation" */
export type ICircuit_Translation_Set_Input = {
  circuit_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  locale_id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** order by stddev() on columns of table "circuit_translation" */
export type ICircuit_Translation_Stddev_Order_By = {
  circuit_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "circuit_translation" */
export type ICircuit_Translation_Stddev_Pop_Order_By = {
  circuit_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "circuit_translation" */
export type ICircuit_Translation_Stddev_Samp_Order_By = {
  circuit_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
};

/** Streaming cursor of the table "circuit_translation" */
export type ICircuit_Translation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ICircuit_Translation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ICircuit_Translation_Stream_Cursor_Value_Input = {
  circuit_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  locale_id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** order by sum() on columns of table "circuit_translation" */
export type ICircuit_Translation_Sum_Order_By = {
  circuit_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
};

/** update columns of table "circuit_translation" */
export enum ICircuit_Translation_Update_Column {
  /** column name */
  CircuitId = 'circuit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  LocaleId = 'locale_id',
  /** column name */
  Name = 'name'
}

export type ICircuit_Translation_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ICircuit_Translation_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ICircuit_Translation_Set_Input>;
  /** filter the rows which have to be updated */
  where: ICircuit_Translation_Bool_Exp;
};

/** order by var_pop() on columns of table "circuit_translation" */
export type ICircuit_Translation_Var_Pop_Order_By = {
  circuit_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
};

/** order by var_samp() on columns of table "circuit_translation" */
export type ICircuit_Translation_Var_Samp_Order_By = {
  circuit_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
};

/** order by variance() on columns of table "circuit_translation" */
export type ICircuit_Translation_Variance_Order_By = {
  circuit_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
};

/** update columns of table "circuit" */
export enum ICircuit_Update_Column {
  /** column name */
  CoachId = 'coach_id',
  /** column name */
  Id = 'id',
  /** column name */
  RecoveryInterval = 'recovery_interval',
  /** column name */
  Type = 'type'
}

export type ICircuit_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ICircuit_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ICircuit_Set_Input>;
  /** filter the rows which have to be updated */
  where: ICircuit_Bool_Exp;
};

/** order by var_pop() on columns of table "circuit" */
export type ICircuit_Var_Pop_Order_By = {
  coach_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  recovery_interval?: InputMaybe<IOrder_By>;
};

/** order by var_samp() on columns of table "circuit" */
export type ICircuit_Var_Samp_Order_By = {
  coach_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  recovery_interval?: InputMaybe<IOrder_By>;
};

/** order by variance() on columns of table "circuit" */
export type ICircuit_Variance_Order_By = {
  coach_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  recovery_interval?: InputMaybe<IOrder_By>;
};

export type ICoach_Aggregate_Bool_Exp = {
  avg?: InputMaybe<ICoach_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<ICoach_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<ICoach_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<ICoach_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<ICoach_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<ICoach_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<ICoach_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<ICoach_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<ICoach_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<ICoach_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<ICoach_Aggregate_Bool_Exp_Var_Samp>;
};

export type ICoach_Aggregate_Bool_Exp_Avg = {
  arguments: ICoach_Select_Column_Coach_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ICoach_Bool_Exp>;
  predicate: IFloat8_Comparison_Exp;
};

export type ICoach_Aggregate_Bool_Exp_Bool_And = {
  arguments: ICoach_Select_Column_Coach_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ICoach_Bool_Exp>;
  predicate: IBoolean_Comparison_Exp;
};

export type ICoach_Aggregate_Bool_Exp_Bool_Or = {
  arguments: ICoach_Select_Column_Coach_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ICoach_Bool_Exp>;
  predicate: IBoolean_Comparison_Exp;
};

export type ICoach_Aggregate_Bool_Exp_Corr = {
  arguments: ICoach_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ICoach_Bool_Exp>;
  predicate: IFloat8_Comparison_Exp;
};

export type ICoach_Aggregate_Bool_Exp_Corr_Arguments = {
  X: ICoach_Select_Column_Coach_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: ICoach_Select_Column_Coach_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type ICoach_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ICoach_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ICoach_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

export type ICoach_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: ICoach_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ICoach_Bool_Exp>;
  predicate: IFloat8_Comparison_Exp;
};

export type ICoach_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: ICoach_Select_Column_Coach_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: ICoach_Select_Column_Coach_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type ICoach_Aggregate_Bool_Exp_Max = {
  arguments: ICoach_Select_Column_Coach_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ICoach_Bool_Exp>;
  predicate: IFloat8_Comparison_Exp;
};

export type ICoach_Aggregate_Bool_Exp_Min = {
  arguments: ICoach_Select_Column_Coach_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ICoach_Bool_Exp>;
  predicate: IFloat8_Comparison_Exp;
};

export type ICoach_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: ICoach_Select_Column_Coach_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ICoach_Bool_Exp>;
  predicate: IFloat8_Comparison_Exp;
};

export type ICoach_Aggregate_Bool_Exp_Sum = {
  arguments: ICoach_Select_Column_Coach_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ICoach_Bool_Exp>;
  predicate: IFloat8_Comparison_Exp;
};

export type ICoach_Aggregate_Bool_Exp_Var_Samp = {
  arguments: ICoach_Select_Column_Coach_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ICoach_Bool_Exp>;
  predicate: IFloat8_Comparison_Exp;
};

/** order by aggregate values of table "coach" */
export type ICoach_Aggregate_Order_By = {
  avg?: InputMaybe<ICoach_Avg_Order_By>;
  count?: InputMaybe<IOrder_By>;
  max?: InputMaybe<ICoach_Max_Order_By>;
  min?: InputMaybe<ICoach_Min_Order_By>;
  stddev?: InputMaybe<ICoach_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ICoach_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ICoach_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ICoach_Sum_Order_By>;
  var_pop?: InputMaybe<ICoach_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ICoach_Var_Samp_Order_By>;
  variance?: InputMaybe<ICoach_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "coach" */
export type ICoach_Arr_Rel_Insert_Input = {
  data: Array<ICoach_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ICoach_On_Conflict>;
};

/** order by avg() on columns of table "coach" */
export type ICoach_Avg_Order_By = {
  id?: InputMaybe<IOrder_By>;
  platform_fee?: InputMaybe<IOrder_By>;
  user_id?: InputMaybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "coach". All fields are combined with a logical 'AND'. */
export type ICoach_Bool_Exp = {
  _and?: InputMaybe<Array<ICoach_Bool_Exp>>;
  _not?: InputMaybe<ICoach_Bool_Exp>;
  _or?: InputMaybe<Array<ICoach_Bool_Exp>>;
  address_city?: InputMaybe<IString_Comparison_Exp>;
  address_country?: InputMaybe<IString_Comparison_Exp>;
  address_postal_code?: InputMaybe<IString_Comparison_Exp>;
  address_street?: InputMaybe<IString_Comparison_Exp>;
  athletes?: InputMaybe<IAthlete_Bool_Exp>;
  athletes_aggregate?: InputMaybe<IAthlete_Aggregate_Bool_Exp>;
  block_templates?: InputMaybe<IBlock_Template_Bool_Exp>;
  block_templates_aggregate?: InputMaybe<IBlock_Template_Aggregate_Bool_Exp>;
  circuits?: InputMaybe<ICircuit_Bool_Exp>;
  circuits_aggregate?: InputMaybe<ICircuit_Aggregate_Bool_Exp>;
  coach_translations?: InputMaybe<ICoach_Translation_Bool_Exp>;
  coach_translations_aggregate?: InputMaybe<ICoach_Translation_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<ITimestamptz_Comparison_Exp>;
  exercises?: InputMaybe<IExercise_Bool_Exp>;
  exercises_aggregate?: InputMaybe<IExercise_Aggregate_Bool_Exp>;
  fiscal_id_number?: InputMaybe<IString_Comparison_Exp>;
  id?: InputMaybe<IInt_Comparison_Exp>;
  is_verified?: InputMaybe<IBoolean_Comparison_Exp>;
  name?: InputMaybe<IString_Comparison_Exp>;
  phone?: InputMaybe<IString_Comparison_Exp>;
  platform_content_access?: InputMaybe<IBoolean_Comparison_Exp>;
  platform_fee?: InputMaybe<IFloat8_Comparison_Exp>;
  profile_picture?: InputMaybe<IString_Comparison_Exp>;
  public?: InputMaybe<IBoolean_Comparison_Exp>;
  spoken_languages?: InputMaybe<I_Text_Comparison_Exp>;
  sports?: InputMaybe<ICoach_Sport_Bool_Exp>;
  sports_aggregate?: InputMaybe<ICoach_Sport_Aggregate_Bool_Exp>;
  subscription_plans?: InputMaybe<ISubscription_Plan_Bool_Exp>;
  subscription_plans_aggregate?: InputMaybe<ISubscription_Plan_Aggregate_Bool_Exp>;
  user?: InputMaybe<IUser_Bool_Exp>;
  user_id?: InputMaybe<IInt_Comparison_Exp>;
};

/** unique or primary key constraints on table "coach" */
export enum ICoach_Constraint {
  /** unique or primary key constraint on columns "id" */
  CoachPkey = 'coach_pkey'
}

/** input type for incrementing numeric columns in table "coach" */
export type ICoach_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  platform_fee?: InputMaybe<Scalars['float8']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "coach" */
export type ICoach_Insert_Input = {
  address_city?: InputMaybe<Scalars['String']>;
  address_country?: InputMaybe<Scalars['String']>;
  address_postal_code?: InputMaybe<Scalars['String']>;
  address_street?: InputMaybe<Scalars['String']>;
  athletes?: InputMaybe<IAthlete_Arr_Rel_Insert_Input>;
  block_templates?: InputMaybe<IBlock_Template_Arr_Rel_Insert_Input>;
  circuits?: InputMaybe<ICircuit_Arr_Rel_Insert_Input>;
  coach_translations?: InputMaybe<ICoach_Translation_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  exercises?: InputMaybe<IExercise_Arr_Rel_Insert_Input>;
  fiscal_id_number?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  platform_content_access?: InputMaybe<Scalars['Boolean']>;
  platform_fee?: InputMaybe<Scalars['float8']>;
  profile_picture?: InputMaybe<Scalars['String']>;
  public?: InputMaybe<Scalars['Boolean']>;
  spoken_languages?: InputMaybe<Scalars['_text']>;
  sports?: InputMaybe<ICoach_Sport_Arr_Rel_Insert_Input>;
  subscription_plans?: InputMaybe<ISubscription_Plan_Arr_Rel_Insert_Input>;
  user?: InputMaybe<IUser_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** order by max() on columns of table "coach" */
export type ICoach_Max_Order_By = {
  address_city?: InputMaybe<IOrder_By>;
  address_country?: InputMaybe<IOrder_By>;
  address_postal_code?: InputMaybe<IOrder_By>;
  address_street?: InputMaybe<IOrder_By>;
  created_at?: InputMaybe<IOrder_By>;
  fiscal_id_number?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  name?: InputMaybe<IOrder_By>;
  phone?: InputMaybe<IOrder_By>;
  platform_fee?: InputMaybe<IOrder_By>;
  profile_picture?: InputMaybe<IOrder_By>;
  user_id?: InputMaybe<IOrder_By>;
};

/** order by min() on columns of table "coach" */
export type ICoach_Min_Order_By = {
  address_city?: InputMaybe<IOrder_By>;
  address_country?: InputMaybe<IOrder_By>;
  address_postal_code?: InputMaybe<IOrder_By>;
  address_street?: InputMaybe<IOrder_By>;
  created_at?: InputMaybe<IOrder_By>;
  fiscal_id_number?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  name?: InputMaybe<IOrder_By>;
  phone?: InputMaybe<IOrder_By>;
  platform_fee?: InputMaybe<IOrder_By>;
  profile_picture?: InputMaybe<IOrder_By>;
  user_id?: InputMaybe<IOrder_By>;
};

/** input type for inserting object relation for remote table "coach" */
export type ICoach_Obj_Rel_Insert_Input = {
  data: ICoach_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ICoach_On_Conflict>;
};

/** on_conflict condition type for table "coach" */
export type ICoach_On_Conflict = {
  constraint: ICoach_Constraint;
  update_columns?: Array<ICoach_Update_Column>;
  where?: InputMaybe<ICoach_Bool_Exp>;
};

/** Ordering options when selecting data from "coach". */
export type ICoach_Order_By = {
  address_city?: InputMaybe<IOrder_By>;
  address_country?: InputMaybe<IOrder_By>;
  address_postal_code?: InputMaybe<IOrder_By>;
  address_street?: InputMaybe<IOrder_By>;
  athletes_aggregate?: InputMaybe<IAthlete_Aggregate_Order_By>;
  block_templates_aggregate?: InputMaybe<IBlock_Template_Aggregate_Order_By>;
  circuits_aggregate?: InputMaybe<ICircuit_Aggregate_Order_By>;
  coach_translations_aggregate?: InputMaybe<ICoach_Translation_Aggregate_Order_By>;
  created_at?: InputMaybe<IOrder_By>;
  exercises_aggregate?: InputMaybe<IExercise_Aggregate_Order_By>;
  fiscal_id_number?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  is_verified?: InputMaybe<IOrder_By>;
  name?: InputMaybe<IOrder_By>;
  phone?: InputMaybe<IOrder_By>;
  platform_content_access?: InputMaybe<IOrder_By>;
  platform_fee?: InputMaybe<IOrder_By>;
  profile_picture?: InputMaybe<IOrder_By>;
  public?: InputMaybe<IOrder_By>;
  spoken_languages?: InputMaybe<IOrder_By>;
  sports_aggregate?: InputMaybe<ICoach_Sport_Aggregate_Order_By>;
  subscription_plans_aggregate?: InputMaybe<ISubscription_Plan_Aggregate_Order_By>;
  user?: InputMaybe<IUser_Order_By>;
  user_id?: InputMaybe<IOrder_By>;
};

/** primary key columns input for table: coach */
export type ICoach_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "coach" */
export enum ICoach_Select_Column {
  /** column name */
  AddressCity = 'address_city',
  /** column name */
  AddressCountry = 'address_country',
  /** column name */
  AddressPostalCode = 'address_postal_code',
  /** column name */
  AddressStreet = 'address_street',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FiscalIdNumber = 'fiscal_id_number',
  /** column name */
  Id = 'id',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  Name = 'name',
  /** column name */
  Phone = 'phone',
  /** column name */
  PlatformContentAccess = 'platform_content_access',
  /** column name */
  PlatformFee = 'platform_fee',
  /** column name */
  ProfilePicture = 'profile_picture',
  /** column name */
  Public = 'public',
  /** column name */
  SpokenLanguages = 'spoken_languages',
  /** column name */
  UserId = 'user_id'
}

/** select "coach_aggregate_bool_exp_avg_arguments_columns" columns of table "coach" */
export enum ICoach_Select_Column_Coach_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  PlatformFee = 'platform_fee'
}

/** select "coach_aggregate_bool_exp_bool_and_arguments_columns" columns of table "coach" */
export enum ICoach_Select_Column_Coach_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  PlatformContentAccess = 'platform_content_access',
  /** column name */
  Public = 'public'
}

/** select "coach_aggregate_bool_exp_bool_or_arguments_columns" columns of table "coach" */
export enum ICoach_Select_Column_Coach_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  PlatformContentAccess = 'platform_content_access',
  /** column name */
  Public = 'public'
}

/** select "coach_aggregate_bool_exp_corr_arguments_columns" columns of table "coach" */
export enum ICoach_Select_Column_Coach_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  PlatformFee = 'platform_fee'
}

/** select "coach_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "coach" */
export enum ICoach_Select_Column_Coach_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  PlatformFee = 'platform_fee'
}

/** select "coach_aggregate_bool_exp_max_arguments_columns" columns of table "coach" */
export enum ICoach_Select_Column_Coach_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  PlatformFee = 'platform_fee'
}

/** select "coach_aggregate_bool_exp_min_arguments_columns" columns of table "coach" */
export enum ICoach_Select_Column_Coach_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  PlatformFee = 'platform_fee'
}

/** select "coach_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "coach" */
export enum ICoach_Select_Column_Coach_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  PlatformFee = 'platform_fee'
}

/** select "coach_aggregate_bool_exp_sum_arguments_columns" columns of table "coach" */
export enum ICoach_Select_Column_Coach_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  PlatformFee = 'platform_fee'
}

/** select "coach_aggregate_bool_exp_var_samp_arguments_columns" columns of table "coach" */
export enum ICoach_Select_Column_Coach_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  PlatformFee = 'platform_fee'
}

/** input type for updating data in table "coach" */
export type ICoach_Set_Input = {
  address_city?: InputMaybe<Scalars['String']>;
  address_country?: InputMaybe<Scalars['String']>;
  address_postal_code?: InputMaybe<Scalars['String']>;
  address_street?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  fiscal_id_number?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  platform_content_access?: InputMaybe<Scalars['Boolean']>;
  platform_fee?: InputMaybe<Scalars['float8']>;
  profile_picture?: InputMaybe<Scalars['String']>;
  public?: InputMaybe<Scalars['Boolean']>;
  spoken_languages?: InputMaybe<Scalars['_text']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

export type ICoach_Sport_Aggregate_Bool_Exp = {
  count?: InputMaybe<ICoach_Sport_Aggregate_Bool_Exp_Count>;
};

export type ICoach_Sport_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ICoach_Sport_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ICoach_Sport_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

/** order by aggregate values of table "coach_sport" */
export type ICoach_Sport_Aggregate_Order_By = {
  avg?: InputMaybe<ICoach_Sport_Avg_Order_By>;
  count?: InputMaybe<IOrder_By>;
  max?: InputMaybe<ICoach_Sport_Max_Order_By>;
  min?: InputMaybe<ICoach_Sport_Min_Order_By>;
  stddev?: InputMaybe<ICoach_Sport_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ICoach_Sport_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ICoach_Sport_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ICoach_Sport_Sum_Order_By>;
  var_pop?: InputMaybe<ICoach_Sport_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ICoach_Sport_Var_Samp_Order_By>;
  variance?: InputMaybe<ICoach_Sport_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "coach_sport" */
export type ICoach_Sport_Arr_Rel_Insert_Input = {
  data: Array<ICoach_Sport_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ICoach_Sport_On_Conflict>;
};

/** order by avg() on columns of table "coach_sport" */
export type ICoach_Sport_Avg_Order_By = {
  coach_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "coach_sport". All fields are combined with a logical 'AND'. */
export type ICoach_Sport_Bool_Exp = {
  _and?: InputMaybe<Array<ICoach_Sport_Bool_Exp>>;
  _not?: InputMaybe<ICoach_Sport_Bool_Exp>;
  _or?: InputMaybe<Array<ICoach_Sport_Bool_Exp>>;
  coach?: InputMaybe<ICoach_Bool_Exp>;
  coach_id?: InputMaybe<IInt_Comparison_Exp>;
  id?: InputMaybe<IInt_Comparison_Exp>;
  sport?: InputMaybe<ISport_Bool_Exp>;
  sport_id?: InputMaybe<IName_Comparison_Exp>;
};

/** unique or primary key constraints on table "coach_sport" */
export enum ICoach_Sport_Constraint {
  /** unique or primary key constraint on columns "id" */
  CoachSportPkey = 'coach_sport_pkey'
}

/** input type for incrementing numeric columns in table "coach_sport" */
export type ICoach_Sport_Inc_Input = {
  coach_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "coach_sport" */
export type ICoach_Sport_Insert_Input = {
  coach?: InputMaybe<ICoach_Obj_Rel_Insert_Input>;
  coach_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  sport?: InputMaybe<ISport_Obj_Rel_Insert_Input>;
  sport_id?: InputMaybe<Scalars['name']>;
};

/** order by max() on columns of table "coach_sport" */
export type ICoach_Sport_Max_Order_By = {
  coach_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
};

/** order by min() on columns of table "coach_sport" */
export type ICoach_Sport_Min_Order_By = {
  coach_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
};

/** on_conflict condition type for table "coach_sport" */
export type ICoach_Sport_On_Conflict = {
  constraint: ICoach_Sport_Constraint;
  update_columns?: Array<ICoach_Sport_Update_Column>;
  where?: InputMaybe<ICoach_Sport_Bool_Exp>;
};

/** Ordering options when selecting data from "coach_sport". */
export type ICoach_Sport_Order_By = {
  coach?: InputMaybe<ICoach_Order_By>;
  coach_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  sport?: InputMaybe<ISport_Order_By>;
  sport_id?: InputMaybe<IOrder_By>;
};

/** primary key columns input for table: coach_sport */
export type ICoach_Sport_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "coach_sport" */
export enum ICoach_Sport_Select_Column {
  /** column name */
  CoachId = 'coach_id',
  /** column name */
  Id = 'id',
  /** column name */
  SportId = 'sport_id'
}

/** input type for updating data in table "coach_sport" */
export type ICoach_Sport_Set_Input = {
  coach_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  sport_id?: InputMaybe<Scalars['name']>;
};

/** order by stddev() on columns of table "coach_sport" */
export type ICoach_Sport_Stddev_Order_By = {
  coach_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "coach_sport" */
export type ICoach_Sport_Stddev_Pop_Order_By = {
  coach_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "coach_sport" */
export type ICoach_Sport_Stddev_Samp_Order_By = {
  coach_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
};

/** Streaming cursor of the table "coach_sport" */
export type ICoach_Sport_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ICoach_Sport_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ICoach_Sport_Stream_Cursor_Value_Input = {
  coach_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  sport_id?: InputMaybe<Scalars['name']>;
};

/** order by sum() on columns of table "coach_sport" */
export type ICoach_Sport_Sum_Order_By = {
  coach_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
};

/** update columns of table "coach_sport" */
export enum ICoach_Sport_Update_Column {
  /** column name */
  CoachId = 'coach_id',
  /** column name */
  Id = 'id',
  /** column name */
  SportId = 'sport_id'
}

export type ICoach_Sport_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ICoach_Sport_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ICoach_Sport_Set_Input>;
  /** filter the rows which have to be updated */
  where: ICoach_Sport_Bool_Exp;
};

/** order by var_pop() on columns of table "coach_sport" */
export type ICoach_Sport_Var_Pop_Order_By = {
  coach_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
};

/** order by var_samp() on columns of table "coach_sport" */
export type ICoach_Sport_Var_Samp_Order_By = {
  coach_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
};

/** order by variance() on columns of table "coach_sport" */
export type ICoach_Sport_Variance_Order_By = {
  coach_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
};

/** order by stddev() on columns of table "coach" */
export type ICoach_Stddev_Order_By = {
  id?: InputMaybe<IOrder_By>;
  platform_fee?: InputMaybe<IOrder_By>;
  user_id?: InputMaybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "coach" */
export type ICoach_Stddev_Pop_Order_By = {
  id?: InputMaybe<IOrder_By>;
  platform_fee?: InputMaybe<IOrder_By>;
  user_id?: InputMaybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "coach" */
export type ICoach_Stddev_Samp_Order_By = {
  id?: InputMaybe<IOrder_By>;
  platform_fee?: InputMaybe<IOrder_By>;
  user_id?: InputMaybe<IOrder_By>;
};

/** Streaming cursor of the table "coach" */
export type ICoach_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ICoach_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ICoach_Stream_Cursor_Value_Input = {
  address_city?: InputMaybe<Scalars['String']>;
  address_country?: InputMaybe<Scalars['String']>;
  address_postal_code?: InputMaybe<Scalars['String']>;
  address_street?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  fiscal_id_number?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  platform_content_access?: InputMaybe<Scalars['Boolean']>;
  platform_fee?: InputMaybe<Scalars['float8']>;
  profile_picture?: InputMaybe<Scalars['String']>;
  public?: InputMaybe<Scalars['Boolean']>;
  spoken_languages?: InputMaybe<Scalars['_text']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** order by sum() on columns of table "coach" */
export type ICoach_Sum_Order_By = {
  id?: InputMaybe<IOrder_By>;
  platform_fee?: InputMaybe<IOrder_By>;
  user_id?: InputMaybe<IOrder_By>;
};

export type ICoach_Translation_Aggregate_Bool_Exp = {
  count?: InputMaybe<ICoach_Translation_Aggregate_Bool_Exp_Count>;
};

export type ICoach_Translation_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ICoach_Translation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ICoach_Translation_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

/** order by aggregate values of table "coach_translation" */
export type ICoach_Translation_Aggregate_Order_By = {
  avg?: InputMaybe<ICoach_Translation_Avg_Order_By>;
  count?: InputMaybe<IOrder_By>;
  max?: InputMaybe<ICoach_Translation_Max_Order_By>;
  min?: InputMaybe<ICoach_Translation_Min_Order_By>;
  stddev?: InputMaybe<ICoach_Translation_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ICoach_Translation_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ICoach_Translation_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ICoach_Translation_Sum_Order_By>;
  var_pop?: InputMaybe<ICoach_Translation_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ICoach_Translation_Var_Samp_Order_By>;
  variance?: InputMaybe<ICoach_Translation_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "coach_translation" */
export type ICoach_Translation_Arr_Rel_Insert_Input = {
  data: Array<ICoach_Translation_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ICoach_Translation_On_Conflict>;
};

/** order by avg() on columns of table "coach_translation" */
export type ICoach_Translation_Avg_Order_By = {
  coach_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "coach_translation". All fields are combined with a logical 'AND'. */
export type ICoach_Translation_Bool_Exp = {
  _and?: InputMaybe<Array<ICoach_Translation_Bool_Exp>>;
  _not?: InputMaybe<ICoach_Translation_Bool_Exp>;
  _or?: InputMaybe<Array<ICoach_Translation_Bool_Exp>>;
  bio?: InputMaybe<IString_Comparison_Exp>;
  coach?: InputMaybe<ICoach_Bool_Exp>;
  coach_id?: InputMaybe<IInt_Comparison_Exp>;
  created_at?: InputMaybe<ITimestamptz_Comparison_Exp>;
  id?: InputMaybe<IInt_Comparison_Exp>;
  locale?: InputMaybe<ILocale_Bool_Exp>;
  locale_id?: InputMaybe<IInt_Comparison_Exp>;
};

/** unique or primary key constraints on table "coach_translation" */
export enum ICoach_Translation_Constraint {
  /** unique or primary key constraint on columns "id" */
  CoachTranslationPkey = 'coach_translation_pkey'
}

/** input type for incrementing numeric columns in table "coach_translation" */
export type ICoach_Translation_Inc_Input = {
  coach_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  locale_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "coach_translation" */
export type ICoach_Translation_Insert_Input = {
  bio?: InputMaybe<Scalars['String']>;
  coach?: InputMaybe<ICoach_Obj_Rel_Insert_Input>;
  coach_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<ILocale_Obj_Rel_Insert_Input>;
  locale_id?: InputMaybe<Scalars['Int']>;
};

/** order by max() on columns of table "coach_translation" */
export type ICoach_Translation_Max_Order_By = {
  bio?: InputMaybe<IOrder_By>;
  coach_id?: InputMaybe<IOrder_By>;
  created_at?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
};

/** order by min() on columns of table "coach_translation" */
export type ICoach_Translation_Min_Order_By = {
  bio?: InputMaybe<IOrder_By>;
  coach_id?: InputMaybe<IOrder_By>;
  created_at?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
};

/** on_conflict condition type for table "coach_translation" */
export type ICoach_Translation_On_Conflict = {
  constraint: ICoach_Translation_Constraint;
  update_columns?: Array<ICoach_Translation_Update_Column>;
  where?: InputMaybe<ICoach_Translation_Bool_Exp>;
};

/** Ordering options when selecting data from "coach_translation". */
export type ICoach_Translation_Order_By = {
  bio?: InputMaybe<IOrder_By>;
  coach?: InputMaybe<ICoach_Order_By>;
  coach_id?: InputMaybe<IOrder_By>;
  created_at?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  locale?: InputMaybe<ILocale_Order_By>;
  locale_id?: InputMaybe<IOrder_By>;
};

/** primary key columns input for table: coach_translation */
export type ICoach_Translation_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "coach_translation" */
export enum ICoach_Translation_Select_Column {
  /** column name */
  Bio = 'bio',
  /** column name */
  CoachId = 'coach_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LocaleId = 'locale_id'
}

/** input type for updating data in table "coach_translation" */
export type ICoach_Translation_Set_Input = {
  bio?: InputMaybe<Scalars['String']>;
  coach_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  locale_id?: InputMaybe<Scalars['Int']>;
};

/** order by stddev() on columns of table "coach_translation" */
export type ICoach_Translation_Stddev_Order_By = {
  coach_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "coach_translation" */
export type ICoach_Translation_Stddev_Pop_Order_By = {
  coach_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "coach_translation" */
export type ICoach_Translation_Stddev_Samp_Order_By = {
  coach_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
};

/** Streaming cursor of the table "coach_translation" */
export type ICoach_Translation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ICoach_Translation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ICoach_Translation_Stream_Cursor_Value_Input = {
  bio?: InputMaybe<Scalars['String']>;
  coach_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  locale_id?: InputMaybe<Scalars['Int']>;
};

/** order by sum() on columns of table "coach_translation" */
export type ICoach_Translation_Sum_Order_By = {
  coach_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
};

/** update columns of table "coach_translation" */
export enum ICoach_Translation_Update_Column {
  /** column name */
  Bio = 'bio',
  /** column name */
  CoachId = 'coach_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LocaleId = 'locale_id'
}

export type ICoach_Translation_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ICoach_Translation_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ICoach_Translation_Set_Input>;
  /** filter the rows which have to be updated */
  where: ICoach_Translation_Bool_Exp;
};

/** order by var_pop() on columns of table "coach_translation" */
export type ICoach_Translation_Var_Pop_Order_By = {
  coach_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
};

/** order by var_samp() on columns of table "coach_translation" */
export type ICoach_Translation_Var_Samp_Order_By = {
  coach_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
};

/** order by variance() on columns of table "coach_translation" */
export type ICoach_Translation_Variance_Order_By = {
  coach_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
};

/** update columns of table "coach" */
export enum ICoach_Update_Column {
  /** column name */
  AddressCity = 'address_city',
  /** column name */
  AddressCountry = 'address_country',
  /** column name */
  AddressPostalCode = 'address_postal_code',
  /** column name */
  AddressStreet = 'address_street',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FiscalIdNumber = 'fiscal_id_number',
  /** column name */
  Id = 'id',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  Name = 'name',
  /** column name */
  Phone = 'phone',
  /** column name */
  PlatformContentAccess = 'platform_content_access',
  /** column name */
  PlatformFee = 'platform_fee',
  /** column name */
  ProfilePicture = 'profile_picture',
  /** column name */
  Public = 'public',
  /** column name */
  SpokenLanguages = 'spoken_languages',
  /** column name */
  UserId = 'user_id'
}

export type ICoach_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ICoach_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ICoach_Set_Input>;
  /** filter the rows which have to be updated */
  where: ICoach_Bool_Exp;
};

/** order by var_pop() on columns of table "coach" */
export type ICoach_Var_Pop_Order_By = {
  id?: InputMaybe<IOrder_By>;
  platform_fee?: InputMaybe<IOrder_By>;
  user_id?: InputMaybe<IOrder_By>;
};

/** order by var_samp() on columns of table "coach" */
export type ICoach_Var_Samp_Order_By = {
  id?: InputMaybe<IOrder_By>;
  platform_fee?: InputMaybe<IOrder_By>;
  user_id?: InputMaybe<IOrder_By>;
};

/** order by variance() on columns of table "coach" */
export type ICoach_Variance_Order_By = {
  id?: InputMaybe<IOrder_By>;
  platform_fee?: InputMaybe<IOrder_By>;
  user_id?: InputMaybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "coupon". All fields are combined with a logical 'AND'. */
export type ICoupon_Bool_Exp = {
  _and?: InputMaybe<Array<ICoupon_Bool_Exp>>;
  _not?: InputMaybe<ICoupon_Bool_Exp>;
  _or?: InputMaybe<Array<ICoupon_Bool_Exp>>;
  created_at?: InputMaybe<ITimestamptz_Comparison_Exp>;
  duration?: InputMaybe<IString_Comparison_Exp>;
  duration_in_months?: InputMaybe<IInt_Comparison_Exp>;
  id?: InputMaybe<IInt_Comparison_Exp>;
  name?: InputMaybe<IString_Comparison_Exp>;
  percent_off?: InputMaybe<INumeric_Comparison_Exp>;
  promo_code?: InputMaybe<IString_Comparison_Exp>;
  stripe_coupon_id?: InputMaybe<IString_Comparison_Exp>;
  stripe_product_id?: InputMaybe<IString_Comparison_Exp>;
  subscription_plan?: InputMaybe<ISubscription_Plan_Bool_Exp>;
  times_redeemed?: InputMaybe<IInt_Comparison_Exp>;
  updated_at?: InputMaybe<ITimestamptz_Comparison_Exp>;
  valid?: InputMaybe<IBoolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "coupon" */
export enum ICoupon_Constraint {
  /** unique or primary key constraint on columns "stripe_coupon_id" */
  CouponStripeCouponIdKey = 'coupon_stripe_coupon_id_key',
  /** unique or primary key constraint on columns "id" */
  CouponsPkey = 'coupons_pkey'
}

/** input type for incrementing numeric columns in table "coupon" */
export type ICoupon_Inc_Input = {
  duration_in_months?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  percent_off?: InputMaybe<Scalars['numeric']>;
  times_redeemed?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "coupon" */
export type ICoupon_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  duration?: InputMaybe<Scalars['String']>;
  duration_in_months?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  percent_off?: InputMaybe<Scalars['numeric']>;
  promo_code?: InputMaybe<Scalars['String']>;
  stripe_coupon_id?: InputMaybe<Scalars['String']>;
  stripe_product_id?: InputMaybe<Scalars['String']>;
  subscription_plan?: InputMaybe<ISubscription_Plan_Obj_Rel_Insert_Input>;
  times_redeemed?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  valid?: InputMaybe<Scalars['Boolean']>;
};

/** on_conflict condition type for table "coupon" */
export type ICoupon_On_Conflict = {
  constraint: ICoupon_Constraint;
  update_columns?: Array<ICoupon_Update_Column>;
  where?: InputMaybe<ICoupon_Bool_Exp>;
};

/** Ordering options when selecting data from "coupon". */
export type ICoupon_Order_By = {
  created_at?: InputMaybe<IOrder_By>;
  duration?: InputMaybe<IOrder_By>;
  duration_in_months?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  name?: InputMaybe<IOrder_By>;
  percent_off?: InputMaybe<IOrder_By>;
  promo_code?: InputMaybe<IOrder_By>;
  stripe_coupon_id?: InputMaybe<IOrder_By>;
  stripe_product_id?: InputMaybe<IOrder_By>;
  subscription_plan?: InputMaybe<ISubscription_Plan_Order_By>;
  times_redeemed?: InputMaybe<IOrder_By>;
  updated_at?: InputMaybe<IOrder_By>;
  valid?: InputMaybe<IOrder_By>;
};

/** primary key columns input for table: coupon */
export type ICoupon_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "coupon" */
export enum ICoupon_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Duration = 'duration',
  /** column name */
  DurationInMonths = 'duration_in_months',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  PercentOff = 'percent_off',
  /** column name */
  PromoCode = 'promo_code',
  /** column name */
  StripeCouponId = 'stripe_coupon_id',
  /** column name */
  StripeProductId = 'stripe_product_id',
  /** column name */
  TimesRedeemed = 'times_redeemed',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Valid = 'valid'
}

/** input type for updating data in table "coupon" */
export type ICoupon_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  duration?: InputMaybe<Scalars['String']>;
  duration_in_months?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  percent_off?: InputMaybe<Scalars['numeric']>;
  promo_code?: InputMaybe<Scalars['String']>;
  stripe_coupon_id?: InputMaybe<Scalars['String']>;
  stripe_product_id?: InputMaybe<Scalars['String']>;
  times_redeemed?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  valid?: InputMaybe<Scalars['Boolean']>;
};

/** Streaming cursor of the table "coupon" */
export type ICoupon_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ICoupon_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ICoupon_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  duration?: InputMaybe<Scalars['String']>;
  duration_in_months?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  percent_off?: InputMaybe<Scalars['numeric']>;
  promo_code?: InputMaybe<Scalars['String']>;
  stripe_coupon_id?: InputMaybe<Scalars['String']>;
  stripe_product_id?: InputMaybe<Scalars['String']>;
  times_redeemed?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  valid?: InputMaybe<Scalars['Boolean']>;
};

/** update columns of table "coupon" */
export enum ICoupon_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Duration = 'duration',
  /** column name */
  DurationInMonths = 'duration_in_months',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  PercentOff = 'percent_off',
  /** column name */
  PromoCode = 'promo_code',
  /** column name */
  StripeCouponId = 'stripe_coupon_id',
  /** column name */
  StripeProductId = 'stripe_product_id',
  /** column name */
  TimesRedeemed = 'times_redeemed',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Valid = 'valid'
}

export type ICoupon_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ICoupon_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ICoupon_Set_Input>;
  /** filter the rows which have to be updated */
  where: ICoupon_Bool_Exp;
};

/** ordering argument of a cursor */
export enum ICursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type IDate_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']>;
  _gt?: InputMaybe<Scalars['date']>;
  _gte?: InputMaybe<Scalars['date']>;
  _in?: InputMaybe<Array<Scalars['date']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['date']>;
  _lte?: InputMaybe<Scalars['date']>;
  _neq?: InputMaybe<Scalars['date']>;
  _nin?: InputMaybe<Array<Scalars['date']>>;
};

export type IExercise_Aggregate_Bool_Exp = {
  count?: InputMaybe<IExercise_Aggregate_Bool_Exp_Count>;
};

export type IExercise_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<IExercise_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IExercise_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

/** order by aggregate values of table "exercise" */
export type IExercise_Aggregate_Order_By = {
  avg?: InputMaybe<IExercise_Avg_Order_By>;
  count?: InputMaybe<IOrder_By>;
  max?: InputMaybe<IExercise_Max_Order_By>;
  min?: InputMaybe<IExercise_Min_Order_By>;
  stddev?: InputMaybe<IExercise_Stddev_Order_By>;
  stddev_pop?: InputMaybe<IExercise_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<IExercise_Stddev_Samp_Order_By>;
  sum?: InputMaybe<IExercise_Sum_Order_By>;
  var_pop?: InputMaybe<IExercise_Var_Pop_Order_By>;
  var_samp?: InputMaybe<IExercise_Var_Samp_Order_By>;
  variance?: InputMaybe<IExercise_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "exercise" */
export type IExercise_Arr_Rel_Insert_Input = {
  data: Array<IExercise_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<IExercise_On_Conflict>;
};

/** order by avg() on columns of table "exercise" */
export type IExercise_Avg_Order_By = {
  coach_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "exercise". All fields are combined with a logical 'AND'. */
export type IExercise_Bool_Exp = {
  _and?: InputMaybe<Array<IExercise_Bool_Exp>>;
  _not?: InputMaybe<IExercise_Bool_Exp>;
  _or?: InputMaybe<Array<IExercise_Bool_Exp>>;
  circuit_exercises?: InputMaybe<ICircuit_Exercise_Bool_Exp>;
  circuit_exercises_aggregate?: InputMaybe<ICircuit_Exercise_Aggregate_Bool_Exp>;
  coach?: InputMaybe<ICoach_Bool_Exp>;
  coach_id?: InputMaybe<IInt_Comparison_Exp>;
  exercise_translations?: InputMaybe<IExercise_Translation_Bool_Exp>;
  exercise_translations_aggregate?: InputMaybe<IExercise_Translation_Aggregate_Bool_Exp>;
  id?: InputMaybe<IInt_Comparison_Exp>;
  media_url?: InputMaybe<IString_Comparison_Exp>;
  target?: InputMaybe<IString_Comparison_Exp>;
  type?: InputMaybe<IString_Comparison_Exp>;
};

/** unique or primary key constraints on table "exercise" */
export enum IExercise_Constraint {
  /** unique or primary key constraint on columns "id" */
  ExercisePkey = 'exercise_pkey'
}

/** input type for incrementing numeric columns in table "exercise" */
export type IExercise_Inc_Input = {
  coach_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "exercise" */
export type IExercise_Insert_Input = {
  circuit_exercises?: InputMaybe<ICircuit_Exercise_Arr_Rel_Insert_Input>;
  coach?: InputMaybe<ICoach_Obj_Rel_Insert_Input>;
  coach_id?: InputMaybe<Scalars['Int']>;
  exercise_translations?: InputMaybe<IExercise_Translation_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  media_url?: InputMaybe<Scalars['String']>;
  target?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** order by max() on columns of table "exercise" */
export type IExercise_Max_Order_By = {
  coach_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  media_url?: InputMaybe<IOrder_By>;
  target?: InputMaybe<IOrder_By>;
  type?: InputMaybe<IOrder_By>;
};

/** order by min() on columns of table "exercise" */
export type IExercise_Min_Order_By = {
  coach_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  media_url?: InputMaybe<IOrder_By>;
  target?: InputMaybe<IOrder_By>;
  type?: InputMaybe<IOrder_By>;
};

/** input type for inserting object relation for remote table "exercise" */
export type IExercise_Obj_Rel_Insert_Input = {
  data: IExercise_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<IExercise_On_Conflict>;
};

/** on_conflict condition type for table "exercise" */
export type IExercise_On_Conflict = {
  constraint: IExercise_Constraint;
  update_columns?: Array<IExercise_Update_Column>;
  where?: InputMaybe<IExercise_Bool_Exp>;
};

/** Ordering options when selecting data from "exercise". */
export type IExercise_Order_By = {
  circuit_exercises_aggregate?: InputMaybe<ICircuit_Exercise_Aggregate_Order_By>;
  coach?: InputMaybe<ICoach_Order_By>;
  coach_id?: InputMaybe<IOrder_By>;
  exercise_translations_aggregate?: InputMaybe<IExercise_Translation_Aggregate_Order_By>;
  id?: InputMaybe<IOrder_By>;
  media_url?: InputMaybe<IOrder_By>;
  target?: InputMaybe<IOrder_By>;
  type?: InputMaybe<IOrder_By>;
};

/** primary key columns input for table: exercise */
export type IExercise_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "exercise" */
export enum IExercise_Select_Column {
  /** column name */
  CoachId = 'coach_id',
  /** column name */
  Id = 'id',
  /** column name */
  MediaUrl = 'media_url',
  /** column name */
  Target = 'target',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "exercise" */
export type IExercise_Set_Input = {
  coach_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  media_url?: InputMaybe<Scalars['String']>;
  target?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** order by stddev() on columns of table "exercise" */
export type IExercise_Stddev_Order_By = {
  coach_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "exercise" */
export type IExercise_Stddev_Pop_Order_By = {
  coach_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "exercise" */
export type IExercise_Stddev_Samp_Order_By = {
  coach_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
};

/** Streaming cursor of the table "exercise" */
export type IExercise_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IExercise_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IExercise_Stream_Cursor_Value_Input = {
  coach_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  media_url?: InputMaybe<Scalars['String']>;
  target?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** order by sum() on columns of table "exercise" */
export type IExercise_Sum_Order_By = {
  coach_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
};

export type IExercise_Translation_Aggregate_Bool_Exp = {
  count?: InputMaybe<IExercise_Translation_Aggregate_Bool_Exp_Count>;
};

export type IExercise_Translation_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<IExercise_Translation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IExercise_Translation_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

/** order by aggregate values of table "exercise_translation" */
export type IExercise_Translation_Aggregate_Order_By = {
  avg?: InputMaybe<IExercise_Translation_Avg_Order_By>;
  count?: InputMaybe<IOrder_By>;
  max?: InputMaybe<IExercise_Translation_Max_Order_By>;
  min?: InputMaybe<IExercise_Translation_Min_Order_By>;
  stddev?: InputMaybe<IExercise_Translation_Stddev_Order_By>;
  stddev_pop?: InputMaybe<IExercise_Translation_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<IExercise_Translation_Stddev_Samp_Order_By>;
  sum?: InputMaybe<IExercise_Translation_Sum_Order_By>;
  var_pop?: InputMaybe<IExercise_Translation_Var_Pop_Order_By>;
  var_samp?: InputMaybe<IExercise_Translation_Var_Samp_Order_By>;
  variance?: InputMaybe<IExercise_Translation_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "exercise_translation" */
export type IExercise_Translation_Arr_Rel_Insert_Input = {
  data: Array<IExercise_Translation_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<IExercise_Translation_On_Conflict>;
};

/** order by avg() on columns of table "exercise_translation" */
export type IExercise_Translation_Avg_Order_By = {
  exercise_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "exercise_translation". All fields are combined with a logical 'AND'. */
export type IExercise_Translation_Bool_Exp = {
  _and?: InputMaybe<Array<IExercise_Translation_Bool_Exp>>;
  _not?: InputMaybe<IExercise_Translation_Bool_Exp>;
  _or?: InputMaybe<Array<IExercise_Translation_Bool_Exp>>;
  created_at?: InputMaybe<ITimestamptz_Comparison_Exp>;
  description?: InputMaybe<IString_Comparison_Exp>;
  exercise?: InputMaybe<IExercise_Bool_Exp>;
  exercise_id?: InputMaybe<IInt_Comparison_Exp>;
  id?: InputMaybe<IInt_Comparison_Exp>;
  locale?: InputMaybe<ILocale_Bool_Exp>;
  locale_id?: InputMaybe<IInt_Comparison_Exp>;
  name?: InputMaybe<IString_Comparison_Exp>;
};

/** unique or primary key constraints on table "exercise_translation" */
export enum IExercise_Translation_Constraint {
  /** unique or primary key constraint on columns "id" */
  ExerciseTranslationPkey = 'exercise_translation_pkey'
}

/** input type for incrementing numeric columns in table "exercise_translation" */
export type IExercise_Translation_Inc_Input = {
  exercise_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  locale_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "exercise_translation" */
export type IExercise_Translation_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  exercise?: InputMaybe<IExercise_Obj_Rel_Insert_Input>;
  exercise_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<ILocale_Obj_Rel_Insert_Input>;
  locale_id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** order by max() on columns of table "exercise_translation" */
export type IExercise_Translation_Max_Order_By = {
  created_at?: InputMaybe<IOrder_By>;
  description?: InputMaybe<IOrder_By>;
  exercise_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
  name?: InputMaybe<IOrder_By>;
};

/** order by min() on columns of table "exercise_translation" */
export type IExercise_Translation_Min_Order_By = {
  created_at?: InputMaybe<IOrder_By>;
  description?: InputMaybe<IOrder_By>;
  exercise_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
  name?: InputMaybe<IOrder_By>;
};

/** on_conflict condition type for table "exercise_translation" */
export type IExercise_Translation_On_Conflict = {
  constraint: IExercise_Translation_Constraint;
  update_columns?: Array<IExercise_Translation_Update_Column>;
  where?: InputMaybe<IExercise_Translation_Bool_Exp>;
};

/** Ordering options when selecting data from "exercise_translation". */
export type IExercise_Translation_Order_By = {
  created_at?: InputMaybe<IOrder_By>;
  description?: InputMaybe<IOrder_By>;
  exercise?: InputMaybe<IExercise_Order_By>;
  exercise_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  locale?: InputMaybe<ILocale_Order_By>;
  locale_id?: InputMaybe<IOrder_By>;
  name?: InputMaybe<IOrder_By>;
};

/** primary key columns input for table: exercise_translation */
export type IExercise_Translation_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "exercise_translation" */
export enum IExercise_Translation_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  ExerciseId = 'exercise_id',
  /** column name */
  Id = 'id',
  /** column name */
  LocaleId = 'locale_id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "exercise_translation" */
export type IExercise_Translation_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  exercise_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  locale_id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** order by stddev() on columns of table "exercise_translation" */
export type IExercise_Translation_Stddev_Order_By = {
  exercise_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "exercise_translation" */
export type IExercise_Translation_Stddev_Pop_Order_By = {
  exercise_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "exercise_translation" */
export type IExercise_Translation_Stddev_Samp_Order_By = {
  exercise_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
};

/** Streaming cursor of the table "exercise_translation" */
export type IExercise_Translation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IExercise_Translation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IExercise_Translation_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  exercise_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  locale_id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** order by sum() on columns of table "exercise_translation" */
export type IExercise_Translation_Sum_Order_By = {
  exercise_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
};

/** update columns of table "exercise_translation" */
export enum IExercise_Translation_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  ExerciseId = 'exercise_id',
  /** column name */
  Id = 'id',
  /** column name */
  LocaleId = 'locale_id',
  /** column name */
  Name = 'name'
}

export type IExercise_Translation_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<IExercise_Translation_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IExercise_Translation_Set_Input>;
  /** filter the rows which have to be updated */
  where: IExercise_Translation_Bool_Exp;
};

/** order by var_pop() on columns of table "exercise_translation" */
export type IExercise_Translation_Var_Pop_Order_By = {
  exercise_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
};

/** order by var_samp() on columns of table "exercise_translation" */
export type IExercise_Translation_Var_Samp_Order_By = {
  exercise_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
};

/** order by variance() on columns of table "exercise_translation" */
export type IExercise_Translation_Variance_Order_By = {
  exercise_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
};

/** update columns of table "exercise" */
export enum IExercise_Update_Column {
  /** column name */
  CoachId = 'coach_id',
  /** column name */
  Id = 'id',
  /** column name */
  MediaUrl = 'media_url',
  /** column name */
  Target = 'target',
  /** column name */
  Type = 'type'
}

export type IExercise_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<IExercise_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IExercise_Set_Input>;
  /** filter the rows which have to be updated */
  where: IExercise_Bool_Exp;
};

/** order by var_pop() on columns of table "exercise" */
export type IExercise_Var_Pop_Order_By = {
  coach_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
};

/** order by var_samp() on columns of table "exercise" */
export type IExercise_Var_Samp_Order_By = {
  coach_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
};

/** order by variance() on columns of table "exercise" */
export type IExercise_Variance_Order_By = {
  coach_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
};

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type IFloat8_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['float8']>;
  _gt?: InputMaybe<Scalars['float8']>;
  _gte?: InputMaybe<Scalars['float8']>;
  _in?: InputMaybe<Array<Scalars['float8']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['float8']>;
  _lte?: InputMaybe<Scalars['float8']>;
  _neq?: InputMaybe<Scalars['float8']>;
  _nin?: InputMaybe<Array<Scalars['float8']>>;
};

/** Boolean expression to filter rows from the table "locale". All fields are combined with a logical 'AND'. */
export type ILocale_Bool_Exp = {
  _and?: InputMaybe<Array<ILocale_Bool_Exp>>;
  _not?: InputMaybe<ILocale_Bool_Exp>;
  _or?: InputMaybe<Array<ILocale_Bool_Exp>>;
  circuit_translations?: InputMaybe<ICircuit_Translation_Bool_Exp>;
  circuit_translations_aggregate?: InputMaybe<ICircuit_Translation_Aggregate_Bool_Exp>;
  coach_translations?: InputMaybe<ICoach_Translation_Bool_Exp>;
  coach_translations_aggregate?: InputMaybe<ICoach_Translation_Aggregate_Bool_Exp>;
  code?: InputMaybe<IString_Comparison_Exp>;
  created_at?: InputMaybe<ITimestamptz_Comparison_Exp>;
  exercise_translations?: InputMaybe<IExercise_Translation_Bool_Exp>;
  exercise_translations_aggregate?: InputMaybe<IExercise_Translation_Aggregate_Bool_Exp>;
  id?: InputMaybe<IInt_Comparison_Exp>;
  language?: InputMaybe<IString_Comparison_Exp>;
  review_translations?: InputMaybe<IReview_Translation_Bool_Exp>;
  review_translations_aggregate?: InputMaybe<IReview_Translation_Aggregate_Bool_Exp>;
  sport_translations?: InputMaybe<ISport_Translation_Bool_Exp>;
  sport_translations_aggregate?: InputMaybe<ISport_Translation_Aggregate_Bool_Exp>;
  subscription_plan_translations?: InputMaybe<ISubscription_Plan_Translation_Bool_Exp>;
  subscription_plan_translations_aggregate?: InputMaybe<ISubscription_Plan_Translation_Aggregate_Bool_Exp>;
  workout_altimetry_translations?: InputMaybe<IWorkout_Altimetry_Translation_Bool_Exp>;
  workout_altimetry_translations_aggregate?: InputMaybe<IWorkout_Altimetry_Translation_Aggregate_Bool_Exp>;
  workout_terrain_translations?: InputMaybe<IWorkout_Terrain_Translation_Bool_Exp>;
  workout_terrain_translations_aggregate?: InputMaybe<IWorkout_Terrain_Translation_Aggregate_Bool_Exp>;
  workout_type_translations?: InputMaybe<IWorkout_Type_Translation_Bool_Exp>;
  workout_type_translations_aggregate?: InputMaybe<IWorkout_Type_Translation_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "locale" */
export enum ILocale_Constraint {
  /** unique or primary key constraint on columns "code" */
  LocaleCodeKey = 'locale_code_key',
  /** unique or primary key constraint on columns "language" */
  LocaleLanguageKey = 'locale_language_key',
  /** unique or primary key constraint on columns "id" */
  LocalePkey = 'locale_pkey'
}

/** input type for incrementing numeric columns in table "locale" */
export type ILocale_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "locale" */
export type ILocale_Insert_Input = {
  circuit_translations?: InputMaybe<ICircuit_Translation_Arr_Rel_Insert_Input>;
  coach_translations?: InputMaybe<ICoach_Translation_Arr_Rel_Insert_Input>;
  code?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  exercise_translations?: InputMaybe<IExercise_Translation_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  language?: InputMaybe<Scalars['String']>;
  review_translations?: InputMaybe<IReview_Translation_Arr_Rel_Insert_Input>;
  sport_translations?: InputMaybe<ISport_Translation_Arr_Rel_Insert_Input>;
  subscription_plan_translations?: InputMaybe<ISubscription_Plan_Translation_Arr_Rel_Insert_Input>;
  workout_altimetry_translations?: InputMaybe<IWorkout_Altimetry_Translation_Arr_Rel_Insert_Input>;
  workout_terrain_translations?: InputMaybe<IWorkout_Terrain_Translation_Arr_Rel_Insert_Input>;
  workout_type_translations?: InputMaybe<IWorkout_Type_Translation_Arr_Rel_Insert_Input>;
};

/** input type for inserting object relation for remote table "locale" */
export type ILocale_Obj_Rel_Insert_Input = {
  data: ILocale_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ILocale_On_Conflict>;
};

/** on_conflict condition type for table "locale" */
export type ILocale_On_Conflict = {
  constraint: ILocale_Constraint;
  update_columns?: Array<ILocale_Update_Column>;
  where?: InputMaybe<ILocale_Bool_Exp>;
};

/** Ordering options when selecting data from "locale". */
export type ILocale_Order_By = {
  circuit_translations_aggregate?: InputMaybe<ICircuit_Translation_Aggregate_Order_By>;
  coach_translations_aggregate?: InputMaybe<ICoach_Translation_Aggregate_Order_By>;
  code?: InputMaybe<IOrder_By>;
  created_at?: InputMaybe<IOrder_By>;
  exercise_translations_aggregate?: InputMaybe<IExercise_Translation_Aggregate_Order_By>;
  id?: InputMaybe<IOrder_By>;
  language?: InputMaybe<IOrder_By>;
  review_translations_aggregate?: InputMaybe<IReview_Translation_Aggregate_Order_By>;
  sport_translations_aggregate?: InputMaybe<ISport_Translation_Aggregate_Order_By>;
  subscription_plan_translations_aggregate?: InputMaybe<ISubscription_Plan_Translation_Aggregate_Order_By>;
  workout_altimetry_translations_aggregate?: InputMaybe<IWorkout_Altimetry_Translation_Aggregate_Order_By>;
  workout_terrain_translations_aggregate?: InputMaybe<IWorkout_Terrain_Translation_Aggregate_Order_By>;
  workout_type_translations_aggregate?: InputMaybe<IWorkout_Type_Translation_Aggregate_Order_By>;
};

/** primary key columns input for table: locale */
export type ILocale_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "locale" */
export enum ILocale_Select_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Language = 'language'
}

/** input type for updating data in table "locale" */
export type ILocale_Set_Input = {
  code?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  language?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "locale" */
export type ILocale_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ILocale_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ILocale_Stream_Cursor_Value_Input = {
  code?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  language?: InputMaybe<Scalars['String']>;
};

/** update columns of table "locale" */
export enum ILocale_Update_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Language = 'language'
}

export type ILocale_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ILocale_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ILocale_Set_Input>;
  /** filter the rows which have to be updated */
  where: ILocale_Bool_Exp;
};

/** Boolean expression to compare columns of type "name". All fields are combined with logical 'AND'. */
export type IName_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['name']>;
  _gt?: InputMaybe<Scalars['name']>;
  _gte?: InputMaybe<Scalars['name']>;
  _in?: InputMaybe<Array<Scalars['name']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['name']>;
  _lte?: InputMaybe<Scalars['name']>;
  _neq?: InputMaybe<Scalars['name']>;
  _nin?: InputMaybe<Array<Scalars['name']>>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type INumeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']>;
  _gt?: InputMaybe<Scalars['numeric']>;
  _gte?: InputMaybe<Scalars['numeric']>;
  _in?: InputMaybe<Array<Scalars['numeric']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['numeric']>;
  _lte?: InputMaybe<Scalars['numeric']>;
  _neq?: InputMaybe<Scalars['numeric']>;
  _nin?: InputMaybe<Array<Scalars['numeric']>>;
};

/** column ordering options */
export enum IOrder_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** Boolean expression to filter rows from the table "review". All fields are combined with a logical 'AND'. */
export type IReview_Bool_Exp = {
  _and?: InputMaybe<Array<IReview_Bool_Exp>>;
  _not?: InputMaybe<IReview_Bool_Exp>;
  _or?: InputMaybe<Array<IReview_Bool_Exp>>;
  created_at?: InputMaybe<ITimestamptz_Comparison_Exp>;
  id?: InputMaybe<IInt_Comparison_Exp>;
  image?: InputMaybe<IString_Comparison_Exp>;
  name?: InputMaybe<IString_Comparison_Exp>;
  review_translations?: InputMaybe<IReview_Translation_Bool_Exp>;
  review_translations_aggregate?: InputMaybe<IReview_Translation_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "review" */
export enum IReview_Constraint {
  /** unique or primary key constraint on columns "id" */
  ReviewPkey = 'review_pkey'
}

/** input type for incrementing numeric columns in table "review" */
export type IReview_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "review" */
export type IReview_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  image?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  review_translations?: InputMaybe<IReview_Translation_Arr_Rel_Insert_Input>;
};

/** input type for inserting object relation for remote table "review" */
export type IReview_Obj_Rel_Insert_Input = {
  data: IReview_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<IReview_On_Conflict>;
};

/** on_conflict condition type for table "review" */
export type IReview_On_Conflict = {
  constraint: IReview_Constraint;
  update_columns?: Array<IReview_Update_Column>;
  where?: InputMaybe<IReview_Bool_Exp>;
};

/** Ordering options when selecting data from "review". */
export type IReview_Order_By = {
  created_at?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  image?: InputMaybe<IOrder_By>;
  name?: InputMaybe<IOrder_By>;
  review_translations_aggregate?: InputMaybe<IReview_Translation_Aggregate_Order_By>;
};

/** primary key columns input for table: review */
export type IReview_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "review" */
export enum IReview_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "review" */
export type IReview_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  image?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "review" */
export type IReview_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IReview_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IReview_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  image?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type IReview_Translation_Aggregate_Bool_Exp = {
  count?: InputMaybe<IReview_Translation_Aggregate_Bool_Exp_Count>;
};

export type IReview_Translation_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<IReview_Translation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IReview_Translation_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

/** order by aggregate values of table "review_translation" */
export type IReview_Translation_Aggregate_Order_By = {
  avg?: InputMaybe<IReview_Translation_Avg_Order_By>;
  count?: InputMaybe<IOrder_By>;
  max?: InputMaybe<IReview_Translation_Max_Order_By>;
  min?: InputMaybe<IReview_Translation_Min_Order_By>;
  stddev?: InputMaybe<IReview_Translation_Stddev_Order_By>;
  stddev_pop?: InputMaybe<IReview_Translation_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<IReview_Translation_Stddev_Samp_Order_By>;
  sum?: InputMaybe<IReview_Translation_Sum_Order_By>;
  var_pop?: InputMaybe<IReview_Translation_Var_Pop_Order_By>;
  var_samp?: InputMaybe<IReview_Translation_Var_Samp_Order_By>;
  variance?: InputMaybe<IReview_Translation_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "review_translation" */
export type IReview_Translation_Arr_Rel_Insert_Input = {
  data: Array<IReview_Translation_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<IReview_Translation_On_Conflict>;
};

/** order by avg() on columns of table "review_translation" */
export type IReview_Translation_Avg_Order_By = {
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
  review_id?: InputMaybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "review_translation". All fields are combined with a logical 'AND'. */
export type IReview_Translation_Bool_Exp = {
  _and?: InputMaybe<Array<IReview_Translation_Bool_Exp>>;
  _not?: InputMaybe<IReview_Translation_Bool_Exp>;
  _or?: InputMaybe<Array<IReview_Translation_Bool_Exp>>;
  created_at?: InputMaybe<ITimestamptz_Comparison_Exp>;
  id?: InputMaybe<IInt_Comparison_Exp>;
  locale?: InputMaybe<ILocale_Bool_Exp>;
  locale_id?: InputMaybe<IInt_Comparison_Exp>;
  review?: InputMaybe<IReview_Bool_Exp>;
  review_id?: InputMaybe<IInt_Comparison_Exp>;
  text?: InputMaybe<IString_Comparison_Exp>;
};

/** unique or primary key constraints on table "review_translation" */
export enum IReview_Translation_Constraint {
  /** unique or primary key constraint on columns "id" */
  ReviewTranslationPkey = 'review_translation_pkey'
}

/** input type for incrementing numeric columns in table "review_translation" */
export type IReview_Translation_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  locale_id?: InputMaybe<Scalars['Int']>;
  review_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "review_translation" */
export type IReview_Translation_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<ILocale_Obj_Rel_Insert_Input>;
  locale_id?: InputMaybe<Scalars['Int']>;
  review?: InputMaybe<IReview_Obj_Rel_Insert_Input>;
  review_id?: InputMaybe<Scalars['Int']>;
  text?: InputMaybe<Scalars['String']>;
};

/** order by max() on columns of table "review_translation" */
export type IReview_Translation_Max_Order_By = {
  created_at?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
  review_id?: InputMaybe<IOrder_By>;
  text?: InputMaybe<IOrder_By>;
};

/** order by min() on columns of table "review_translation" */
export type IReview_Translation_Min_Order_By = {
  created_at?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
  review_id?: InputMaybe<IOrder_By>;
  text?: InputMaybe<IOrder_By>;
};

/** on_conflict condition type for table "review_translation" */
export type IReview_Translation_On_Conflict = {
  constraint: IReview_Translation_Constraint;
  update_columns?: Array<IReview_Translation_Update_Column>;
  where?: InputMaybe<IReview_Translation_Bool_Exp>;
};

/** Ordering options when selecting data from "review_translation". */
export type IReview_Translation_Order_By = {
  created_at?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  locale?: InputMaybe<ILocale_Order_By>;
  locale_id?: InputMaybe<IOrder_By>;
  review?: InputMaybe<IReview_Order_By>;
  review_id?: InputMaybe<IOrder_By>;
  text?: InputMaybe<IOrder_By>;
};

/** primary key columns input for table: review_translation */
export type IReview_Translation_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "review_translation" */
export enum IReview_Translation_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LocaleId = 'locale_id',
  /** column name */
  ReviewId = 'review_id',
  /** column name */
  Text = 'text'
}

/** input type for updating data in table "review_translation" */
export type IReview_Translation_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  locale_id?: InputMaybe<Scalars['Int']>;
  review_id?: InputMaybe<Scalars['Int']>;
  text?: InputMaybe<Scalars['String']>;
};

/** order by stddev() on columns of table "review_translation" */
export type IReview_Translation_Stddev_Order_By = {
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
  review_id?: InputMaybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "review_translation" */
export type IReview_Translation_Stddev_Pop_Order_By = {
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
  review_id?: InputMaybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "review_translation" */
export type IReview_Translation_Stddev_Samp_Order_By = {
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
  review_id?: InputMaybe<IOrder_By>;
};

/** Streaming cursor of the table "review_translation" */
export type IReview_Translation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IReview_Translation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IReview_Translation_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  locale_id?: InputMaybe<Scalars['Int']>;
  review_id?: InputMaybe<Scalars['Int']>;
  text?: InputMaybe<Scalars['String']>;
};

/** order by sum() on columns of table "review_translation" */
export type IReview_Translation_Sum_Order_By = {
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
  review_id?: InputMaybe<IOrder_By>;
};

/** update columns of table "review_translation" */
export enum IReview_Translation_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LocaleId = 'locale_id',
  /** column name */
  ReviewId = 'review_id',
  /** column name */
  Text = 'text'
}

export type IReview_Translation_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<IReview_Translation_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IReview_Translation_Set_Input>;
  /** filter the rows which have to be updated */
  where: IReview_Translation_Bool_Exp;
};

/** order by var_pop() on columns of table "review_translation" */
export type IReview_Translation_Var_Pop_Order_By = {
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
  review_id?: InputMaybe<IOrder_By>;
};

/** order by var_samp() on columns of table "review_translation" */
export type IReview_Translation_Var_Samp_Order_By = {
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
  review_id?: InputMaybe<IOrder_By>;
};

/** order by variance() on columns of table "review_translation" */
export type IReview_Translation_Variance_Order_By = {
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
  review_id?: InputMaybe<IOrder_By>;
};

/** update columns of table "review" */
export enum IReview_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  Name = 'name'
}

export type IReview_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<IReview_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IReview_Set_Input>;
  /** filter the rows which have to be updated */
  where: IReview_Bool_Exp;
};

/** Boolean expression to filter rows from the table "sport". All fields are combined with a logical 'AND'. */
export type ISport_Bool_Exp = {
  _and?: InputMaybe<Array<ISport_Bool_Exp>>;
  _not?: InputMaybe<ISport_Bool_Exp>;
  _or?: InputMaybe<Array<ISport_Bool_Exp>>;
  athlete_blocks?: InputMaybe<IAthlete_Block_Bool_Exp>;
  athlete_blocks_aggregate?: InputMaybe<IAthlete_Block_Aggregate_Bool_Exp>;
  athlete_challenges?: InputMaybe<IAthlete_Challenge_Bool_Exp>;
  athlete_challenges_aggregate?: InputMaybe<IAthlete_Challenge_Aggregate_Bool_Exp>;
  athlete_weeks?: InputMaybe<IAthlete_Week_Bool_Exp>;
  athlete_weeks_aggregate?: InputMaybe<IAthlete_Week_Aggregate_Bool_Exp>;
  athletes?: InputMaybe<IAthlete_Bool_Exp>;
  athletes_aggregate?: InputMaybe<IAthlete_Aggregate_Bool_Exp>;
  avatar?: InputMaybe<IString_Comparison_Exp>;
  block_templates?: InputMaybe<IBlock_Template_Bool_Exp>;
  block_templates_aggregate?: InputMaybe<IBlock_Template_Aggregate_Bool_Exp>;
  circuits?: InputMaybe<ICircuit_Sport_Bool_Exp>;
  circuits_aggregate?: InputMaybe<ICircuit_Sport_Aggregate_Bool_Exp>;
  coaches?: InputMaybe<ICoach_Sport_Bool_Exp>;
  coaches_aggregate?: InputMaybe<ICoach_Sport_Aggregate_Bool_Exp>;
  id?: InputMaybe<IName_Comparison_Exp>;
  image?: InputMaybe<IString_Comparison_Exp>;
  name?: InputMaybe<IString_Comparison_Exp>;
  sport_translations?: InputMaybe<ISport_Translation_Bool_Exp>;
  sport_translations_aggregate?: InputMaybe<ISport_Translation_Aggregate_Bool_Exp>;
  subscription_plan_templates?: InputMaybe<ISubscription_Plan_Template_Bool_Exp>;
  subscription_plan_templates_aggregate?: InputMaybe<ISubscription_Plan_Template_Aggregate_Bool_Exp>;
  subscription_plans?: InputMaybe<ISubscription_Plan_Bool_Exp>;
  subscription_plans_aggregate?: InputMaybe<ISubscription_Plan_Aggregate_Bool_Exp>;
  week_templates?: InputMaybe<IWeek_Template_Bool_Exp>;
  week_templates_aggregate?: InputMaybe<IWeek_Template_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "sport" */
export enum ISport_Constraint {
  /** unique or primary key constraint on columns "id" */
  SportPkey = 'sport_pkey'
}

/** input type for inserting data into table "sport" */
export type ISport_Insert_Input = {
  athlete_blocks?: InputMaybe<IAthlete_Block_Arr_Rel_Insert_Input>;
  athlete_challenges?: InputMaybe<IAthlete_Challenge_Arr_Rel_Insert_Input>;
  athlete_weeks?: InputMaybe<IAthlete_Week_Arr_Rel_Insert_Input>;
  athletes?: InputMaybe<IAthlete_Arr_Rel_Insert_Input>;
  avatar?: InputMaybe<Scalars['String']>;
  block_templates?: InputMaybe<IBlock_Template_Arr_Rel_Insert_Input>;
  circuits?: InputMaybe<ICircuit_Sport_Arr_Rel_Insert_Input>;
  coaches?: InputMaybe<ICoach_Sport_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['name']>;
  image?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  sport_translations?: InputMaybe<ISport_Translation_Arr_Rel_Insert_Input>;
  subscription_plan_templates?: InputMaybe<ISubscription_Plan_Template_Arr_Rel_Insert_Input>;
  subscription_plans?: InputMaybe<ISubscription_Plan_Arr_Rel_Insert_Input>;
  week_templates?: InputMaybe<IWeek_Template_Arr_Rel_Insert_Input>;
};

/** input type for inserting object relation for remote table "sport" */
export type ISport_Obj_Rel_Insert_Input = {
  data: ISport_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ISport_On_Conflict>;
};

/** on_conflict condition type for table "sport" */
export type ISport_On_Conflict = {
  constraint: ISport_Constraint;
  update_columns?: Array<ISport_Update_Column>;
  where?: InputMaybe<ISport_Bool_Exp>;
};

/** Ordering options when selecting data from "sport". */
export type ISport_Order_By = {
  athlete_blocks_aggregate?: InputMaybe<IAthlete_Block_Aggregate_Order_By>;
  athlete_challenges_aggregate?: InputMaybe<IAthlete_Challenge_Aggregate_Order_By>;
  athlete_weeks_aggregate?: InputMaybe<IAthlete_Week_Aggregate_Order_By>;
  athletes_aggregate?: InputMaybe<IAthlete_Aggregate_Order_By>;
  avatar?: InputMaybe<IOrder_By>;
  block_templates_aggregate?: InputMaybe<IBlock_Template_Aggregate_Order_By>;
  circuits_aggregate?: InputMaybe<ICircuit_Sport_Aggregate_Order_By>;
  coaches_aggregate?: InputMaybe<ICoach_Sport_Aggregate_Order_By>;
  id?: InputMaybe<IOrder_By>;
  image?: InputMaybe<IOrder_By>;
  name?: InputMaybe<IOrder_By>;
  sport_translations_aggregate?: InputMaybe<ISport_Translation_Aggregate_Order_By>;
  subscription_plan_templates_aggregate?: InputMaybe<ISubscription_Plan_Template_Aggregate_Order_By>;
  subscription_plans_aggregate?: InputMaybe<ISubscription_Plan_Aggregate_Order_By>;
  week_templates_aggregate?: InputMaybe<IWeek_Template_Aggregate_Order_By>;
};

/** primary key columns input for table: sport */
export type ISport_Pk_Columns_Input = {
  id: Scalars['name'];
};

/** select columns of table "sport" */
export enum ISport_Select_Column {
  /** column name */
  Avatar = 'avatar',
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "sport" */
export type ISport_Set_Input = {
  avatar?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['name']>;
  image?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "sport" */
export type ISport_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ISport_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ISport_Stream_Cursor_Value_Input = {
  avatar?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['name']>;
  image?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type ISport_Translation_Aggregate_Bool_Exp = {
  count?: InputMaybe<ISport_Translation_Aggregate_Bool_Exp_Count>;
};

export type ISport_Translation_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ISport_Translation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ISport_Translation_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

/** order by aggregate values of table "sport_translation" */
export type ISport_Translation_Aggregate_Order_By = {
  avg?: InputMaybe<ISport_Translation_Avg_Order_By>;
  count?: InputMaybe<IOrder_By>;
  max?: InputMaybe<ISport_Translation_Max_Order_By>;
  min?: InputMaybe<ISport_Translation_Min_Order_By>;
  stddev?: InputMaybe<ISport_Translation_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ISport_Translation_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ISport_Translation_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ISport_Translation_Sum_Order_By>;
  var_pop?: InputMaybe<ISport_Translation_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ISport_Translation_Var_Samp_Order_By>;
  variance?: InputMaybe<ISport_Translation_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "sport_translation" */
export type ISport_Translation_Arr_Rel_Insert_Input = {
  data: Array<ISport_Translation_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ISport_Translation_On_Conflict>;
};

/** order by avg() on columns of table "sport_translation" */
export type ISport_Translation_Avg_Order_By = {
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "sport_translation". All fields are combined with a logical 'AND'. */
export type ISport_Translation_Bool_Exp = {
  _and?: InputMaybe<Array<ISport_Translation_Bool_Exp>>;
  _not?: InputMaybe<ISport_Translation_Bool_Exp>;
  _or?: InputMaybe<Array<ISport_Translation_Bool_Exp>>;
  created_at?: InputMaybe<ITimestamptz_Comparison_Exp>;
  description?: InputMaybe<IString_Comparison_Exp>;
  id?: InputMaybe<IInt_Comparison_Exp>;
  locale?: InputMaybe<ILocale_Bool_Exp>;
  locale_id?: InputMaybe<IInt_Comparison_Exp>;
  sport?: InputMaybe<ISport_Bool_Exp>;
  sport_id?: InputMaybe<IName_Comparison_Exp>;
  title?: InputMaybe<IString_Comparison_Exp>;
};

/** unique or primary key constraints on table "sport_translation" */
export enum ISport_Translation_Constraint {
  /** unique or primary key constraint on columns "id" */
  SportTranslationPkey = 'sport_translation_pkey'
}

/** input type for incrementing numeric columns in table "sport_translation" */
export type ISport_Translation_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  locale_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "sport_translation" */
export type ISport_Translation_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<ILocale_Obj_Rel_Insert_Input>;
  locale_id?: InputMaybe<Scalars['Int']>;
  sport?: InputMaybe<ISport_Obj_Rel_Insert_Input>;
  sport_id?: InputMaybe<Scalars['name']>;
  title?: InputMaybe<Scalars['String']>;
};

/** order by max() on columns of table "sport_translation" */
export type ISport_Translation_Max_Order_By = {
  created_at?: InputMaybe<IOrder_By>;
  description?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
  title?: InputMaybe<IOrder_By>;
};

/** order by min() on columns of table "sport_translation" */
export type ISport_Translation_Min_Order_By = {
  created_at?: InputMaybe<IOrder_By>;
  description?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
  title?: InputMaybe<IOrder_By>;
};

/** on_conflict condition type for table "sport_translation" */
export type ISport_Translation_On_Conflict = {
  constraint: ISport_Translation_Constraint;
  update_columns?: Array<ISport_Translation_Update_Column>;
  where?: InputMaybe<ISport_Translation_Bool_Exp>;
};

/** Ordering options when selecting data from "sport_translation". */
export type ISport_Translation_Order_By = {
  created_at?: InputMaybe<IOrder_By>;
  description?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  locale?: InputMaybe<ILocale_Order_By>;
  locale_id?: InputMaybe<IOrder_By>;
  sport?: InputMaybe<ISport_Order_By>;
  sport_id?: InputMaybe<IOrder_By>;
  title?: InputMaybe<IOrder_By>;
};

/** primary key columns input for table: sport_translation */
export type ISport_Translation_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "sport_translation" */
export enum ISport_Translation_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  LocaleId = 'locale_id',
  /** column name */
  SportId = 'sport_id',
  /** column name */
  Title = 'title'
}

/** input type for updating data in table "sport_translation" */
export type ISport_Translation_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  locale_id?: InputMaybe<Scalars['Int']>;
  sport_id?: InputMaybe<Scalars['name']>;
  title?: InputMaybe<Scalars['String']>;
};

/** order by stddev() on columns of table "sport_translation" */
export type ISport_Translation_Stddev_Order_By = {
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "sport_translation" */
export type ISport_Translation_Stddev_Pop_Order_By = {
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "sport_translation" */
export type ISport_Translation_Stddev_Samp_Order_By = {
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
};

/** Streaming cursor of the table "sport_translation" */
export type ISport_Translation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ISport_Translation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ISport_Translation_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  locale_id?: InputMaybe<Scalars['Int']>;
  sport_id?: InputMaybe<Scalars['name']>;
  title?: InputMaybe<Scalars['String']>;
};

/** order by sum() on columns of table "sport_translation" */
export type ISport_Translation_Sum_Order_By = {
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
};

/** update columns of table "sport_translation" */
export enum ISport_Translation_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  LocaleId = 'locale_id',
  /** column name */
  SportId = 'sport_id',
  /** column name */
  Title = 'title'
}

export type ISport_Translation_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ISport_Translation_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ISport_Translation_Set_Input>;
  /** filter the rows which have to be updated */
  where: ISport_Translation_Bool_Exp;
};

/** order by var_pop() on columns of table "sport_translation" */
export type ISport_Translation_Var_Pop_Order_By = {
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
};

/** order by var_samp() on columns of table "sport_translation" */
export type ISport_Translation_Var_Samp_Order_By = {
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
};

/** order by variance() on columns of table "sport_translation" */
export type ISport_Translation_Variance_Order_By = {
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
};

/** update columns of table "sport" */
export enum ISport_Update_Column {
  /** column name */
  Avatar = 'avatar',
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  Name = 'name'
}

export type ISport_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ISport_Set_Input>;
  /** filter the rows which have to be updated */
  where: ISport_Bool_Exp;
};

export type ISubscription_Aggregate_Bool_Exp = {
  count?: InputMaybe<ISubscription_Aggregate_Bool_Exp_Count>;
};

export type ISubscription_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ISubscription_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ISubscription_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

/** order by aggregate values of table "subscription" */
export type ISubscription_Aggregate_Order_By = {
  avg?: InputMaybe<ISubscription_Avg_Order_By>;
  count?: InputMaybe<IOrder_By>;
  max?: InputMaybe<ISubscription_Max_Order_By>;
  min?: InputMaybe<ISubscription_Min_Order_By>;
  stddev?: InputMaybe<ISubscription_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ISubscription_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ISubscription_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ISubscription_Sum_Order_By>;
  var_pop?: InputMaybe<ISubscription_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ISubscription_Var_Samp_Order_By>;
  variance?: InputMaybe<ISubscription_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "subscription" */
export type ISubscription_Arr_Rel_Insert_Input = {
  data: Array<ISubscription_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ISubscription_On_Conflict>;
};

/** order by avg() on columns of table "subscription" */
export type ISubscription_Avg_Order_By = {
  athlete_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  interval_count?: InputMaybe<IOrder_By>;
  price?: InputMaybe<IOrder_By>;
  subscription_plan_id?: InputMaybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "subscription". All fields are combined with a logical 'AND'. */
export type ISubscription_Bool_Exp = {
  _and?: InputMaybe<Array<ISubscription_Bool_Exp>>;
  _not?: InputMaybe<ISubscription_Bool_Exp>;
  _or?: InputMaybe<Array<ISubscription_Bool_Exp>>;
  athlete?: InputMaybe<IAthlete_Bool_Exp>;
  athlete_id?: InputMaybe<IInt_Comparison_Exp>;
  created_at?: InputMaybe<ITimestamptz_Comparison_Exp>;
  date_end?: InputMaybe<IDate_Comparison_Exp>;
  date_start?: InputMaybe<IDate_Comparison_Exp>;
  id?: InputMaybe<IInt_Comparison_Exp>;
  interval_count?: InputMaybe<IInt_Comparison_Exp>;
  price?: InputMaybe<IInt_Comparison_Exp>;
  status?: InputMaybe<IString_Comparison_Exp>;
  stripe_subscription_id?: InputMaybe<IString_Comparison_Exp>;
  subscription_payments?: InputMaybe<ISubscription_Payment_Bool_Exp>;
  subscription_payments_aggregate?: InputMaybe<ISubscription_Payment_Aggregate_Bool_Exp>;
  subscription_plan?: InputMaybe<ISubscription_Plan_Bool_Exp>;
  subscription_plan_id?: InputMaybe<IInt_Comparison_Exp>;
};

/** unique or primary key constraints on table "subscription" */
export enum ISubscription_Constraint {
  /** unique or primary key constraint on columns "id" */
  SubscriptionPkey = 'subscription_pkey',
  /** unique or primary key constraint on columns "stripe_subscription_id" */
  SubscriptionStripeSubscriptionIdKey = 'subscription_stripe_subscription_id_key'
}

/** input type for incrementing numeric columns in table "subscription" */
export type ISubscription_Inc_Input = {
  athlete_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  interval_count?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['Int']>;
  subscription_plan_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "subscription" */
export type ISubscription_Insert_Input = {
  athlete?: InputMaybe<IAthlete_Obj_Rel_Insert_Input>;
  athlete_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  date_end?: InputMaybe<Scalars['date']>;
  date_start?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['Int']>;
  interval_count?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  stripe_subscription_id?: InputMaybe<Scalars['String']>;
  subscription_payments?: InputMaybe<ISubscription_Payment_Arr_Rel_Insert_Input>;
  subscription_plan?: InputMaybe<ISubscription_Plan_Obj_Rel_Insert_Input>;
  subscription_plan_id?: InputMaybe<Scalars['Int']>;
};

/** order by max() on columns of table "subscription" */
export type ISubscription_Max_Order_By = {
  athlete_id?: InputMaybe<IOrder_By>;
  created_at?: InputMaybe<IOrder_By>;
  date_end?: InputMaybe<IOrder_By>;
  date_start?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  interval_count?: InputMaybe<IOrder_By>;
  price?: InputMaybe<IOrder_By>;
  status?: InputMaybe<IOrder_By>;
  stripe_subscription_id?: InputMaybe<IOrder_By>;
  subscription_plan_id?: InputMaybe<IOrder_By>;
};

/** order by min() on columns of table "subscription" */
export type ISubscription_Min_Order_By = {
  athlete_id?: InputMaybe<IOrder_By>;
  created_at?: InputMaybe<IOrder_By>;
  date_end?: InputMaybe<IOrder_By>;
  date_start?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  interval_count?: InputMaybe<IOrder_By>;
  price?: InputMaybe<IOrder_By>;
  status?: InputMaybe<IOrder_By>;
  stripe_subscription_id?: InputMaybe<IOrder_By>;
  subscription_plan_id?: InputMaybe<IOrder_By>;
};

/** input type for inserting object relation for remote table "subscription" */
export type ISubscription_Obj_Rel_Insert_Input = {
  data: ISubscription_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ISubscription_On_Conflict>;
};

/** on_conflict condition type for table "subscription" */
export type ISubscription_On_Conflict = {
  constraint: ISubscription_Constraint;
  update_columns?: Array<ISubscription_Update_Column>;
  where?: InputMaybe<ISubscription_Bool_Exp>;
};

/** Ordering options when selecting data from "subscription". */
export type ISubscription_Order_By = {
  athlete?: InputMaybe<IAthlete_Order_By>;
  athlete_id?: InputMaybe<IOrder_By>;
  created_at?: InputMaybe<IOrder_By>;
  date_end?: InputMaybe<IOrder_By>;
  date_start?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  interval_count?: InputMaybe<IOrder_By>;
  price?: InputMaybe<IOrder_By>;
  status?: InputMaybe<IOrder_By>;
  stripe_subscription_id?: InputMaybe<IOrder_By>;
  subscription_payments_aggregate?: InputMaybe<ISubscription_Payment_Aggregate_Order_By>;
  subscription_plan?: InputMaybe<ISubscription_Plan_Order_By>;
  subscription_plan_id?: InputMaybe<IOrder_By>;
};

export type ISubscription_Payment_Aggregate_Bool_Exp = {
  avg?: InputMaybe<ISubscription_Payment_Aggregate_Bool_Exp_Avg>;
  corr?: InputMaybe<ISubscription_Payment_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<ISubscription_Payment_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<ISubscription_Payment_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<ISubscription_Payment_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<ISubscription_Payment_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<ISubscription_Payment_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<ISubscription_Payment_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<ISubscription_Payment_Aggregate_Bool_Exp_Var_Samp>;
};

export type ISubscription_Payment_Aggregate_Bool_Exp_Avg = {
  arguments: ISubscription_Payment_Select_Column_Subscription_Payment_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ISubscription_Payment_Bool_Exp>;
  predicate: IFloat8_Comparison_Exp;
};

export type ISubscription_Payment_Aggregate_Bool_Exp_Corr = {
  arguments: ISubscription_Payment_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ISubscription_Payment_Bool_Exp>;
  predicate: IFloat8_Comparison_Exp;
};

export type ISubscription_Payment_Aggregate_Bool_Exp_Corr_Arguments = {
  X: ISubscription_Payment_Select_Column_Subscription_Payment_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: ISubscription_Payment_Select_Column_Subscription_Payment_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type ISubscription_Payment_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ISubscription_Payment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ISubscription_Payment_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

export type ISubscription_Payment_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: ISubscription_Payment_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ISubscription_Payment_Bool_Exp>;
  predicate: IFloat8_Comparison_Exp;
};

export type ISubscription_Payment_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: ISubscription_Payment_Select_Column_Subscription_Payment_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: ISubscription_Payment_Select_Column_Subscription_Payment_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type ISubscription_Payment_Aggregate_Bool_Exp_Max = {
  arguments: ISubscription_Payment_Select_Column_Subscription_Payment_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ISubscription_Payment_Bool_Exp>;
  predicate: IFloat8_Comparison_Exp;
};

export type ISubscription_Payment_Aggregate_Bool_Exp_Min = {
  arguments: ISubscription_Payment_Select_Column_Subscription_Payment_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ISubscription_Payment_Bool_Exp>;
  predicate: IFloat8_Comparison_Exp;
};

export type ISubscription_Payment_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: ISubscription_Payment_Select_Column_Subscription_Payment_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ISubscription_Payment_Bool_Exp>;
  predicate: IFloat8_Comparison_Exp;
};

export type ISubscription_Payment_Aggregate_Bool_Exp_Sum = {
  arguments: ISubscription_Payment_Select_Column_Subscription_Payment_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ISubscription_Payment_Bool_Exp>;
  predicate: IFloat8_Comparison_Exp;
};

export type ISubscription_Payment_Aggregate_Bool_Exp_Var_Samp = {
  arguments: ISubscription_Payment_Select_Column_Subscription_Payment_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ISubscription_Payment_Bool_Exp>;
  predicate: IFloat8_Comparison_Exp;
};

/** order by aggregate values of table "subscription_payment" */
export type ISubscription_Payment_Aggregate_Order_By = {
  avg?: InputMaybe<ISubscription_Payment_Avg_Order_By>;
  count?: InputMaybe<IOrder_By>;
  max?: InputMaybe<ISubscription_Payment_Max_Order_By>;
  min?: InputMaybe<ISubscription_Payment_Min_Order_By>;
  stddev?: InputMaybe<ISubscription_Payment_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ISubscription_Payment_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ISubscription_Payment_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ISubscription_Payment_Sum_Order_By>;
  var_pop?: InputMaybe<ISubscription_Payment_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ISubscription_Payment_Var_Samp_Order_By>;
  variance?: InputMaybe<ISubscription_Payment_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "subscription_payment" */
export type ISubscription_Payment_Arr_Rel_Insert_Input = {
  data: Array<ISubscription_Payment_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ISubscription_Payment_On_Conflict>;
};

/** order by avg() on columns of table "subscription_payment" */
export type ISubscription_Payment_Avg_Order_By = {
  amount?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  platform_fee?: InputMaybe<IOrder_By>;
  subscription_id?: InputMaybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "subscription_payment". All fields are combined with a logical 'AND'. */
export type ISubscription_Payment_Bool_Exp = {
  _and?: InputMaybe<Array<ISubscription_Payment_Bool_Exp>>;
  _not?: InputMaybe<ISubscription_Payment_Bool_Exp>;
  _or?: InputMaybe<Array<ISubscription_Payment_Bool_Exp>>;
  amount?: InputMaybe<IFloat8_Comparison_Exp>;
  created_at?: InputMaybe<ITimestamptz_Comparison_Exp>;
  discount_name?: InputMaybe<IString_Comparison_Exp>;
  discount_percentage?: InputMaybe<IString_Comparison_Exp>;
  id?: InputMaybe<IInt_Comparison_Exp>;
  platform_fee?: InputMaybe<IFloat8_Comparison_Exp>;
  stripe_charge_id?: InputMaybe<IString_Comparison_Exp>;
  subscription?: InputMaybe<ISubscription_Bool_Exp>;
  subscription_id?: InputMaybe<IInt_Comparison_Exp>;
  updated_at?: InputMaybe<ITimestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "subscription_payment" */
export enum ISubscription_Payment_Constraint {
  /** unique or primary key constraint on columns "id" */
  SubscriptionPaymentPkey = 'subscription_payment_pkey'
}

/** input type for incrementing numeric columns in table "subscription_payment" */
export type ISubscription_Payment_Inc_Input = {
  amount?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['Int']>;
  platform_fee?: InputMaybe<Scalars['float8']>;
  subscription_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "subscription_payment" */
export type ISubscription_Payment_Insert_Input = {
  amount?: InputMaybe<Scalars['float8']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  discount_name?: InputMaybe<Scalars['String']>;
  discount_percentage?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  platform_fee?: InputMaybe<Scalars['float8']>;
  stripe_charge_id?: InputMaybe<Scalars['String']>;
  subscription?: InputMaybe<ISubscription_Obj_Rel_Insert_Input>;
  subscription_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "subscription_payment" */
export type ISubscription_Payment_Max_Order_By = {
  amount?: InputMaybe<IOrder_By>;
  created_at?: InputMaybe<IOrder_By>;
  discount_name?: InputMaybe<IOrder_By>;
  discount_percentage?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  platform_fee?: InputMaybe<IOrder_By>;
  stripe_charge_id?: InputMaybe<IOrder_By>;
  subscription_id?: InputMaybe<IOrder_By>;
  updated_at?: InputMaybe<IOrder_By>;
};

/** order by min() on columns of table "subscription_payment" */
export type ISubscription_Payment_Min_Order_By = {
  amount?: InputMaybe<IOrder_By>;
  created_at?: InputMaybe<IOrder_By>;
  discount_name?: InputMaybe<IOrder_By>;
  discount_percentage?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  platform_fee?: InputMaybe<IOrder_By>;
  stripe_charge_id?: InputMaybe<IOrder_By>;
  subscription_id?: InputMaybe<IOrder_By>;
  updated_at?: InputMaybe<IOrder_By>;
};

/** on_conflict condition type for table "subscription_payment" */
export type ISubscription_Payment_On_Conflict = {
  constraint: ISubscription_Payment_Constraint;
  update_columns?: Array<ISubscription_Payment_Update_Column>;
  where?: InputMaybe<ISubscription_Payment_Bool_Exp>;
};

/** Ordering options when selecting data from "subscription_payment". */
export type ISubscription_Payment_Order_By = {
  amount?: InputMaybe<IOrder_By>;
  created_at?: InputMaybe<IOrder_By>;
  discount_name?: InputMaybe<IOrder_By>;
  discount_percentage?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  platform_fee?: InputMaybe<IOrder_By>;
  stripe_charge_id?: InputMaybe<IOrder_By>;
  subscription?: InputMaybe<ISubscription_Order_By>;
  subscription_id?: InputMaybe<IOrder_By>;
  updated_at?: InputMaybe<IOrder_By>;
};

/** primary key columns input for table: subscription_payment */
export type ISubscription_Payment_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "subscription_payment" */
export enum ISubscription_Payment_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DiscountName = 'discount_name',
  /** column name */
  DiscountPercentage = 'discount_percentage',
  /** column name */
  Id = 'id',
  /** column name */
  PlatformFee = 'platform_fee',
  /** column name */
  StripeChargeId = 'stripe_charge_id',
  /** column name */
  SubscriptionId = 'subscription_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "subscription_payment_aggregate_bool_exp_avg_arguments_columns" columns of table "subscription_payment" */
export enum ISubscription_Payment_Select_Column_Subscription_Payment_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Amount = 'amount',
  /** column name */
  PlatformFee = 'platform_fee'
}

/** select "subscription_payment_aggregate_bool_exp_corr_arguments_columns" columns of table "subscription_payment" */
export enum ISubscription_Payment_Select_Column_Subscription_Payment_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Amount = 'amount',
  /** column name */
  PlatformFee = 'platform_fee'
}

/** select "subscription_payment_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "subscription_payment" */
export enum ISubscription_Payment_Select_Column_Subscription_Payment_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Amount = 'amount',
  /** column name */
  PlatformFee = 'platform_fee'
}

/** select "subscription_payment_aggregate_bool_exp_max_arguments_columns" columns of table "subscription_payment" */
export enum ISubscription_Payment_Select_Column_Subscription_Payment_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Amount = 'amount',
  /** column name */
  PlatformFee = 'platform_fee'
}

/** select "subscription_payment_aggregate_bool_exp_min_arguments_columns" columns of table "subscription_payment" */
export enum ISubscription_Payment_Select_Column_Subscription_Payment_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Amount = 'amount',
  /** column name */
  PlatformFee = 'platform_fee'
}

/** select "subscription_payment_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "subscription_payment" */
export enum ISubscription_Payment_Select_Column_Subscription_Payment_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Amount = 'amount',
  /** column name */
  PlatformFee = 'platform_fee'
}

/** select "subscription_payment_aggregate_bool_exp_sum_arguments_columns" columns of table "subscription_payment" */
export enum ISubscription_Payment_Select_Column_Subscription_Payment_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Amount = 'amount',
  /** column name */
  PlatformFee = 'platform_fee'
}

/** select "subscription_payment_aggregate_bool_exp_var_samp_arguments_columns" columns of table "subscription_payment" */
export enum ISubscription_Payment_Select_Column_Subscription_Payment_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Amount = 'amount',
  /** column name */
  PlatformFee = 'platform_fee'
}

/** input type for updating data in table "subscription_payment" */
export type ISubscription_Payment_Set_Input = {
  amount?: InputMaybe<Scalars['float8']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  discount_name?: InputMaybe<Scalars['String']>;
  discount_percentage?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  platform_fee?: InputMaybe<Scalars['float8']>;
  stripe_charge_id?: InputMaybe<Scalars['String']>;
  subscription_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** order by stddev() on columns of table "subscription_payment" */
export type ISubscription_Payment_Stddev_Order_By = {
  amount?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  platform_fee?: InputMaybe<IOrder_By>;
  subscription_id?: InputMaybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "subscription_payment" */
export type ISubscription_Payment_Stddev_Pop_Order_By = {
  amount?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  platform_fee?: InputMaybe<IOrder_By>;
  subscription_id?: InputMaybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "subscription_payment" */
export type ISubscription_Payment_Stddev_Samp_Order_By = {
  amount?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  platform_fee?: InputMaybe<IOrder_By>;
  subscription_id?: InputMaybe<IOrder_By>;
};

/** Streaming cursor of the table "subscription_payment" */
export type ISubscription_Payment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ISubscription_Payment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ISubscription_Payment_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['float8']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  discount_name?: InputMaybe<Scalars['String']>;
  discount_percentage?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  platform_fee?: InputMaybe<Scalars['float8']>;
  stripe_charge_id?: InputMaybe<Scalars['String']>;
  subscription_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** order by sum() on columns of table "subscription_payment" */
export type ISubscription_Payment_Sum_Order_By = {
  amount?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  platform_fee?: InputMaybe<IOrder_By>;
  subscription_id?: InputMaybe<IOrder_By>;
};

/** update columns of table "subscription_payment" */
export enum ISubscription_Payment_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DiscountName = 'discount_name',
  /** column name */
  DiscountPercentage = 'discount_percentage',
  /** column name */
  Id = 'id',
  /** column name */
  PlatformFee = 'platform_fee',
  /** column name */
  StripeChargeId = 'stripe_charge_id',
  /** column name */
  SubscriptionId = 'subscription_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type ISubscription_Payment_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ISubscription_Payment_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ISubscription_Payment_Set_Input>;
  /** filter the rows which have to be updated */
  where: ISubscription_Payment_Bool_Exp;
};

/** order by var_pop() on columns of table "subscription_payment" */
export type ISubscription_Payment_Var_Pop_Order_By = {
  amount?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  platform_fee?: InputMaybe<IOrder_By>;
  subscription_id?: InputMaybe<IOrder_By>;
};

/** order by var_samp() on columns of table "subscription_payment" */
export type ISubscription_Payment_Var_Samp_Order_By = {
  amount?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  platform_fee?: InputMaybe<IOrder_By>;
  subscription_id?: InputMaybe<IOrder_By>;
};

/** order by variance() on columns of table "subscription_payment" */
export type ISubscription_Payment_Variance_Order_By = {
  amount?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  platform_fee?: InputMaybe<IOrder_By>;
  subscription_id?: InputMaybe<IOrder_By>;
};

/** primary key columns input for table: subscription */
export type ISubscription_Pk_Columns_Input = {
  id: Scalars['Int'];
};

export type ISubscription_Plan_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<ISubscription_Plan_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<ISubscription_Plan_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<ISubscription_Plan_Aggregate_Bool_Exp_Count>;
};

export type ISubscription_Plan_Aggregate_Bool_Exp_Bool_And = {
  arguments: ISubscription_Plan_Select_Column_Subscription_Plan_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ISubscription_Plan_Bool_Exp>;
  predicate: IBoolean_Comparison_Exp;
};

export type ISubscription_Plan_Aggregate_Bool_Exp_Bool_Or = {
  arguments: ISubscription_Plan_Select_Column_Subscription_Plan_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ISubscription_Plan_Bool_Exp>;
  predicate: IBoolean_Comparison_Exp;
};

export type ISubscription_Plan_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ISubscription_Plan_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ISubscription_Plan_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

/** order by aggregate values of table "subscription_plan" */
export type ISubscription_Plan_Aggregate_Order_By = {
  avg?: InputMaybe<ISubscription_Plan_Avg_Order_By>;
  count?: InputMaybe<IOrder_By>;
  max?: InputMaybe<ISubscription_Plan_Max_Order_By>;
  min?: InputMaybe<ISubscription_Plan_Min_Order_By>;
  stddev?: InputMaybe<ISubscription_Plan_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ISubscription_Plan_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ISubscription_Plan_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ISubscription_Plan_Sum_Order_By>;
  var_pop?: InputMaybe<ISubscription_Plan_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ISubscription_Plan_Var_Samp_Order_By>;
  variance?: InputMaybe<ISubscription_Plan_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "subscription_plan" */
export type ISubscription_Plan_Arr_Rel_Insert_Input = {
  data: Array<ISubscription_Plan_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ISubscription_Plan_On_Conflict>;
};

/** order by avg() on columns of table "subscription_plan" */
export type ISubscription_Plan_Avg_Order_By = {
  biannualy_discount?: InputMaybe<IOrder_By>;
  coach_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  level?: InputMaybe<IOrder_By>;
  min_duration?: InputMaybe<IOrder_By>;
  quarterly_discount?: InputMaybe<IOrder_By>;
  recomended_duration?: InputMaybe<IOrder_By>;
  weekly_price?: InputMaybe<IOrder_By>;
  yearly_discount?: InputMaybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "subscription_plan". All fields are combined with a logical 'AND'. */
export type ISubscription_Plan_Bool_Exp = {
  _and?: InputMaybe<Array<ISubscription_Plan_Bool_Exp>>;
  _not?: InputMaybe<ISubscription_Plan_Bool_Exp>;
  _or?: InputMaybe<Array<ISubscription_Plan_Bool_Exp>>;
  biannualy_discount?: InputMaybe<INumeric_Comparison_Exp>;
  coach?: InputMaybe<ICoach_Bool_Exp>;
  coach_id?: InputMaybe<IInt_Comparison_Exp>;
  created_at?: InputMaybe<ITimestamptz_Comparison_Exp>;
  id?: InputMaybe<IInt_Comparison_Exp>;
  image?: InputMaybe<IString_Comparison_Exp>;
  is_verified?: InputMaybe<IBoolean_Comparison_Exp>;
  level?: InputMaybe<IInt_Comparison_Exp>;
  min_duration?: InputMaybe<INumeric_Comparison_Exp>;
  quarterly_discount?: InputMaybe<INumeric_Comparison_Exp>;
  recomended_duration?: InputMaybe<INumeric_Comparison_Exp>;
  sport?: InputMaybe<ISport_Bool_Exp>;
  sport_id?: InputMaybe<IString_Comparison_Exp>;
  stripe_product_id?: InputMaybe<IString_Comparison_Exp>;
  subscription_plan_prices?: InputMaybe<ISubscription_Plan_Price_Bool_Exp>;
  subscription_plan_prices_aggregate?: InputMaybe<ISubscription_Plan_Price_Aggregate_Bool_Exp>;
  subscription_plan_translations?: InputMaybe<ISubscription_Plan_Translation_Bool_Exp>;
  subscription_plan_translations_aggregate?: InputMaybe<ISubscription_Plan_Translation_Aggregate_Bool_Exp>;
  subscriptions?: InputMaybe<ISubscription_Bool_Exp>;
  subscriptions_aggregate?: InputMaybe<ISubscription_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<ITimestamptz_Comparison_Exp>;
  weekly_price?: InputMaybe<INumeric_Comparison_Exp>;
  yearly_discount?: InputMaybe<INumeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "subscription_plan" */
export enum ISubscription_Plan_Constraint {
  /** unique or primary key constraint on columns "id" */
  SubscriptionPlanPkey = 'subscription_plan_pkey'
}

/** input type for incrementing numeric columns in table "subscription_plan" */
export type ISubscription_Plan_Inc_Input = {
  biannualy_discount?: InputMaybe<Scalars['numeric']>;
  coach_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  level?: InputMaybe<Scalars['Int']>;
  min_duration?: InputMaybe<Scalars['numeric']>;
  quarterly_discount?: InputMaybe<Scalars['numeric']>;
  recomended_duration?: InputMaybe<Scalars['numeric']>;
  weekly_price?: InputMaybe<Scalars['numeric']>;
  yearly_discount?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "subscription_plan" */
export type ISubscription_Plan_Insert_Input = {
  biannualy_discount?: InputMaybe<Scalars['numeric']>;
  coach?: InputMaybe<ICoach_Obj_Rel_Insert_Input>;
  coach_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  image?: InputMaybe<Scalars['String']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  min_duration?: InputMaybe<Scalars['numeric']>;
  quarterly_discount?: InputMaybe<Scalars['numeric']>;
  recomended_duration?: InputMaybe<Scalars['numeric']>;
  sport?: InputMaybe<ISport_Obj_Rel_Insert_Input>;
  sport_id?: InputMaybe<Scalars['String']>;
  stripe_product_id?: InputMaybe<Scalars['String']>;
  subscription_plan_prices?: InputMaybe<ISubscription_Plan_Price_Arr_Rel_Insert_Input>;
  subscription_plan_translations?: InputMaybe<ISubscription_Plan_Translation_Arr_Rel_Insert_Input>;
  subscriptions?: InputMaybe<ISubscription_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  weekly_price?: InputMaybe<Scalars['numeric']>;
  yearly_discount?: InputMaybe<Scalars['numeric']>;
};

/** order by max() on columns of table "subscription_plan" */
export type ISubscription_Plan_Max_Order_By = {
  biannualy_discount?: InputMaybe<IOrder_By>;
  coach_id?: InputMaybe<IOrder_By>;
  created_at?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  image?: InputMaybe<IOrder_By>;
  level?: InputMaybe<IOrder_By>;
  min_duration?: InputMaybe<IOrder_By>;
  quarterly_discount?: InputMaybe<IOrder_By>;
  recomended_duration?: InputMaybe<IOrder_By>;
  sport_id?: InputMaybe<IOrder_By>;
  stripe_product_id?: InputMaybe<IOrder_By>;
  updated_at?: InputMaybe<IOrder_By>;
  weekly_price?: InputMaybe<IOrder_By>;
  yearly_discount?: InputMaybe<IOrder_By>;
};

/** order by min() on columns of table "subscription_plan" */
export type ISubscription_Plan_Min_Order_By = {
  biannualy_discount?: InputMaybe<IOrder_By>;
  coach_id?: InputMaybe<IOrder_By>;
  created_at?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  image?: InputMaybe<IOrder_By>;
  level?: InputMaybe<IOrder_By>;
  min_duration?: InputMaybe<IOrder_By>;
  quarterly_discount?: InputMaybe<IOrder_By>;
  recomended_duration?: InputMaybe<IOrder_By>;
  sport_id?: InputMaybe<IOrder_By>;
  stripe_product_id?: InputMaybe<IOrder_By>;
  updated_at?: InputMaybe<IOrder_By>;
  weekly_price?: InputMaybe<IOrder_By>;
  yearly_discount?: InputMaybe<IOrder_By>;
};

/** input type for inserting object relation for remote table "subscription_plan" */
export type ISubscription_Plan_Obj_Rel_Insert_Input = {
  data: ISubscription_Plan_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ISubscription_Plan_On_Conflict>;
};

/** on_conflict condition type for table "subscription_plan" */
export type ISubscription_Plan_On_Conflict = {
  constraint: ISubscription_Plan_Constraint;
  update_columns?: Array<ISubscription_Plan_Update_Column>;
  where?: InputMaybe<ISubscription_Plan_Bool_Exp>;
};

/** Ordering options when selecting data from "subscription_plan". */
export type ISubscription_Plan_Order_By = {
  biannualy_discount?: InputMaybe<IOrder_By>;
  coach?: InputMaybe<ICoach_Order_By>;
  coach_id?: InputMaybe<IOrder_By>;
  created_at?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  image?: InputMaybe<IOrder_By>;
  is_verified?: InputMaybe<IOrder_By>;
  level?: InputMaybe<IOrder_By>;
  min_duration?: InputMaybe<IOrder_By>;
  quarterly_discount?: InputMaybe<IOrder_By>;
  recomended_duration?: InputMaybe<IOrder_By>;
  sport?: InputMaybe<ISport_Order_By>;
  sport_id?: InputMaybe<IOrder_By>;
  stripe_product_id?: InputMaybe<IOrder_By>;
  subscription_plan_prices_aggregate?: InputMaybe<ISubscription_Plan_Price_Aggregate_Order_By>;
  subscription_plan_translations_aggregate?: InputMaybe<ISubscription_Plan_Translation_Aggregate_Order_By>;
  subscriptions_aggregate?: InputMaybe<ISubscription_Aggregate_Order_By>;
  updated_at?: InputMaybe<IOrder_By>;
  weekly_price?: InputMaybe<IOrder_By>;
  yearly_discount?: InputMaybe<IOrder_By>;
};

/** primary key columns input for table: subscription_plan */
export type ISubscription_Plan_Pk_Columns_Input = {
  id: Scalars['Int'];
};

export type ISubscription_Plan_Price_Aggregate_Bool_Exp = {
  count?: InputMaybe<ISubscription_Plan_Price_Aggregate_Bool_Exp_Count>;
};

export type ISubscription_Plan_Price_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ISubscription_Plan_Price_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ISubscription_Plan_Price_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

/** order by aggregate values of table "subscription_plan_price" */
export type ISubscription_Plan_Price_Aggregate_Order_By = {
  avg?: InputMaybe<ISubscription_Plan_Price_Avg_Order_By>;
  count?: InputMaybe<IOrder_By>;
  max?: InputMaybe<ISubscription_Plan_Price_Max_Order_By>;
  min?: InputMaybe<ISubscription_Plan_Price_Min_Order_By>;
  stddev?: InputMaybe<ISubscription_Plan_Price_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ISubscription_Plan_Price_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ISubscription_Plan_Price_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ISubscription_Plan_Price_Sum_Order_By>;
  var_pop?: InputMaybe<ISubscription_Plan_Price_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ISubscription_Plan_Price_Var_Samp_Order_By>;
  variance?: InputMaybe<ISubscription_Plan_Price_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "subscription_plan_price" */
export type ISubscription_Plan_Price_Arr_Rel_Insert_Input = {
  data: Array<ISubscription_Plan_Price_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ISubscription_Plan_Price_On_Conflict>;
};

/** order by avg() on columns of table "subscription_plan_price" */
export type ISubscription_Plan_Price_Avg_Order_By = {
  id?: InputMaybe<IOrder_By>;
  interval_count?: InputMaybe<IOrder_By>;
  subscription_plan_id?: InputMaybe<IOrder_By>;
  unit_amount?: InputMaybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "subscription_plan_price". All fields are combined with a logical 'AND'. */
export type ISubscription_Plan_Price_Bool_Exp = {
  _and?: InputMaybe<Array<ISubscription_Plan_Price_Bool_Exp>>;
  _not?: InputMaybe<ISubscription_Plan_Price_Bool_Exp>;
  _or?: InputMaybe<Array<ISubscription_Plan_Price_Bool_Exp>>;
  created_at?: InputMaybe<ITimestamptz_Comparison_Exp>;
  id?: InputMaybe<IInt_Comparison_Exp>;
  interval_count?: InputMaybe<INumeric_Comparison_Exp>;
  stripe_lookup_key?: InputMaybe<IString_Comparison_Exp>;
  stripe_price_id?: InputMaybe<IString_Comparison_Exp>;
  subscription_plan?: InputMaybe<ISubscription_Plan_Bool_Exp>;
  subscription_plan_id?: InputMaybe<IInt_Comparison_Exp>;
  unit_amount?: InputMaybe<INumeric_Comparison_Exp>;
  updated_at?: InputMaybe<ITimestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "subscription_plan_price" */
export enum ISubscription_Plan_Price_Constraint {
  /** unique or primary key constraint on columns "id" */
  SubscriptionPlanPricePkey = 'subscription_plan_price_pkey'
}

/** input type for incrementing numeric columns in table "subscription_plan_price" */
export type ISubscription_Plan_Price_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  interval_count?: InputMaybe<Scalars['numeric']>;
  subscription_plan_id?: InputMaybe<Scalars['Int']>;
  unit_amount?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "subscription_plan_price" */
export type ISubscription_Plan_Price_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  interval_count?: InputMaybe<Scalars['numeric']>;
  stripe_lookup_key?: InputMaybe<Scalars['String']>;
  stripe_price_id?: InputMaybe<Scalars['String']>;
  subscription_plan?: InputMaybe<ISubscription_Plan_Obj_Rel_Insert_Input>;
  subscription_plan_id?: InputMaybe<Scalars['Int']>;
  unit_amount?: InputMaybe<Scalars['numeric']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "subscription_plan_price" */
export type ISubscription_Plan_Price_Max_Order_By = {
  created_at?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  interval_count?: InputMaybe<IOrder_By>;
  stripe_lookup_key?: InputMaybe<IOrder_By>;
  stripe_price_id?: InputMaybe<IOrder_By>;
  subscription_plan_id?: InputMaybe<IOrder_By>;
  unit_amount?: InputMaybe<IOrder_By>;
  updated_at?: InputMaybe<IOrder_By>;
};

/** order by min() on columns of table "subscription_plan_price" */
export type ISubscription_Plan_Price_Min_Order_By = {
  created_at?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  interval_count?: InputMaybe<IOrder_By>;
  stripe_lookup_key?: InputMaybe<IOrder_By>;
  stripe_price_id?: InputMaybe<IOrder_By>;
  subscription_plan_id?: InputMaybe<IOrder_By>;
  unit_amount?: InputMaybe<IOrder_By>;
  updated_at?: InputMaybe<IOrder_By>;
};

/** on_conflict condition type for table "subscription_plan_price" */
export type ISubscription_Plan_Price_On_Conflict = {
  constraint: ISubscription_Plan_Price_Constraint;
  update_columns?: Array<ISubscription_Plan_Price_Update_Column>;
  where?: InputMaybe<ISubscription_Plan_Price_Bool_Exp>;
};

/** Ordering options when selecting data from "subscription_plan_price". */
export type ISubscription_Plan_Price_Order_By = {
  created_at?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  interval_count?: InputMaybe<IOrder_By>;
  stripe_lookup_key?: InputMaybe<IOrder_By>;
  stripe_price_id?: InputMaybe<IOrder_By>;
  subscription_plan?: InputMaybe<ISubscription_Plan_Order_By>;
  subscription_plan_id?: InputMaybe<IOrder_By>;
  unit_amount?: InputMaybe<IOrder_By>;
  updated_at?: InputMaybe<IOrder_By>;
};

/** primary key columns input for table: subscription_plan_price */
export type ISubscription_Plan_Price_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "subscription_plan_price" */
export enum ISubscription_Plan_Price_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IntervalCount = 'interval_count',
  /** column name */
  StripeLookupKey = 'stripe_lookup_key',
  /** column name */
  StripePriceId = 'stripe_price_id',
  /** column name */
  SubscriptionPlanId = 'subscription_plan_id',
  /** column name */
  UnitAmount = 'unit_amount',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "subscription_plan_price" */
export type ISubscription_Plan_Price_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  interval_count?: InputMaybe<Scalars['numeric']>;
  stripe_lookup_key?: InputMaybe<Scalars['String']>;
  stripe_price_id?: InputMaybe<Scalars['String']>;
  subscription_plan_id?: InputMaybe<Scalars['Int']>;
  unit_amount?: InputMaybe<Scalars['numeric']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** order by stddev() on columns of table "subscription_plan_price" */
export type ISubscription_Plan_Price_Stddev_Order_By = {
  id?: InputMaybe<IOrder_By>;
  interval_count?: InputMaybe<IOrder_By>;
  subscription_plan_id?: InputMaybe<IOrder_By>;
  unit_amount?: InputMaybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "subscription_plan_price" */
export type ISubscription_Plan_Price_Stddev_Pop_Order_By = {
  id?: InputMaybe<IOrder_By>;
  interval_count?: InputMaybe<IOrder_By>;
  subscription_plan_id?: InputMaybe<IOrder_By>;
  unit_amount?: InputMaybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "subscription_plan_price" */
export type ISubscription_Plan_Price_Stddev_Samp_Order_By = {
  id?: InputMaybe<IOrder_By>;
  interval_count?: InputMaybe<IOrder_By>;
  subscription_plan_id?: InputMaybe<IOrder_By>;
  unit_amount?: InputMaybe<IOrder_By>;
};

/** Streaming cursor of the table "subscription_plan_price" */
export type ISubscription_Plan_Price_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ISubscription_Plan_Price_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ISubscription_Plan_Price_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  interval_count?: InputMaybe<Scalars['numeric']>;
  stripe_lookup_key?: InputMaybe<Scalars['String']>;
  stripe_price_id?: InputMaybe<Scalars['String']>;
  subscription_plan_id?: InputMaybe<Scalars['Int']>;
  unit_amount?: InputMaybe<Scalars['numeric']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** order by sum() on columns of table "subscription_plan_price" */
export type ISubscription_Plan_Price_Sum_Order_By = {
  id?: InputMaybe<IOrder_By>;
  interval_count?: InputMaybe<IOrder_By>;
  subscription_plan_id?: InputMaybe<IOrder_By>;
  unit_amount?: InputMaybe<IOrder_By>;
};

/** update columns of table "subscription_plan_price" */
export enum ISubscription_Plan_Price_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IntervalCount = 'interval_count',
  /** column name */
  StripeLookupKey = 'stripe_lookup_key',
  /** column name */
  StripePriceId = 'stripe_price_id',
  /** column name */
  SubscriptionPlanId = 'subscription_plan_id',
  /** column name */
  UnitAmount = 'unit_amount',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type ISubscription_Plan_Price_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ISubscription_Plan_Price_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ISubscription_Plan_Price_Set_Input>;
  /** filter the rows which have to be updated */
  where: ISubscription_Plan_Price_Bool_Exp;
};

/** order by var_pop() on columns of table "subscription_plan_price" */
export type ISubscription_Plan_Price_Var_Pop_Order_By = {
  id?: InputMaybe<IOrder_By>;
  interval_count?: InputMaybe<IOrder_By>;
  subscription_plan_id?: InputMaybe<IOrder_By>;
  unit_amount?: InputMaybe<IOrder_By>;
};

/** order by var_samp() on columns of table "subscription_plan_price" */
export type ISubscription_Plan_Price_Var_Samp_Order_By = {
  id?: InputMaybe<IOrder_By>;
  interval_count?: InputMaybe<IOrder_By>;
  subscription_plan_id?: InputMaybe<IOrder_By>;
  unit_amount?: InputMaybe<IOrder_By>;
};

/** order by variance() on columns of table "subscription_plan_price" */
export type ISubscription_Plan_Price_Variance_Order_By = {
  id?: InputMaybe<IOrder_By>;
  interval_count?: InputMaybe<IOrder_By>;
  subscription_plan_id?: InputMaybe<IOrder_By>;
  unit_amount?: InputMaybe<IOrder_By>;
};

/** select columns of table "subscription_plan" */
export enum ISubscription_Plan_Select_Column {
  /** column name */
  BiannualyDiscount = 'biannualy_discount',
  /** column name */
  CoachId = 'coach_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  Level = 'level',
  /** column name */
  MinDuration = 'min_duration',
  /** column name */
  QuarterlyDiscount = 'quarterly_discount',
  /** column name */
  RecomendedDuration = 'recomended_duration',
  /** column name */
  SportId = 'sport_id',
  /** column name */
  StripeProductId = 'stripe_product_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WeeklyPrice = 'weekly_price',
  /** column name */
  YearlyDiscount = 'yearly_discount'
}

/** select "subscription_plan_aggregate_bool_exp_bool_and_arguments_columns" columns of table "subscription_plan" */
export enum ISubscription_Plan_Select_Column_Subscription_Plan_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsVerified = 'is_verified'
}

/** select "subscription_plan_aggregate_bool_exp_bool_or_arguments_columns" columns of table "subscription_plan" */
export enum ISubscription_Plan_Select_Column_Subscription_Plan_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsVerified = 'is_verified'
}

/** input type for updating data in table "subscription_plan" */
export type ISubscription_Plan_Set_Input = {
  biannualy_discount?: InputMaybe<Scalars['numeric']>;
  coach_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  image?: InputMaybe<Scalars['String']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  min_duration?: InputMaybe<Scalars['numeric']>;
  quarterly_discount?: InputMaybe<Scalars['numeric']>;
  recomended_duration?: InputMaybe<Scalars['numeric']>;
  sport_id?: InputMaybe<Scalars['String']>;
  stripe_product_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  weekly_price?: InputMaybe<Scalars['numeric']>;
  yearly_discount?: InputMaybe<Scalars['numeric']>;
};

/** order by stddev() on columns of table "subscription_plan" */
export type ISubscription_Plan_Stddev_Order_By = {
  biannualy_discount?: InputMaybe<IOrder_By>;
  coach_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  level?: InputMaybe<IOrder_By>;
  min_duration?: InputMaybe<IOrder_By>;
  quarterly_discount?: InputMaybe<IOrder_By>;
  recomended_duration?: InputMaybe<IOrder_By>;
  weekly_price?: InputMaybe<IOrder_By>;
  yearly_discount?: InputMaybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "subscription_plan" */
export type ISubscription_Plan_Stddev_Pop_Order_By = {
  biannualy_discount?: InputMaybe<IOrder_By>;
  coach_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  level?: InputMaybe<IOrder_By>;
  min_duration?: InputMaybe<IOrder_By>;
  quarterly_discount?: InputMaybe<IOrder_By>;
  recomended_duration?: InputMaybe<IOrder_By>;
  weekly_price?: InputMaybe<IOrder_By>;
  yearly_discount?: InputMaybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "subscription_plan" */
export type ISubscription_Plan_Stddev_Samp_Order_By = {
  biannualy_discount?: InputMaybe<IOrder_By>;
  coach_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  level?: InputMaybe<IOrder_By>;
  min_duration?: InputMaybe<IOrder_By>;
  quarterly_discount?: InputMaybe<IOrder_By>;
  recomended_duration?: InputMaybe<IOrder_By>;
  weekly_price?: InputMaybe<IOrder_By>;
  yearly_discount?: InputMaybe<IOrder_By>;
};

/** Streaming cursor of the table "subscription_plan" */
export type ISubscription_Plan_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ISubscription_Plan_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ISubscription_Plan_Stream_Cursor_Value_Input = {
  biannualy_discount?: InputMaybe<Scalars['numeric']>;
  coach_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  image?: InputMaybe<Scalars['String']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  min_duration?: InputMaybe<Scalars['numeric']>;
  quarterly_discount?: InputMaybe<Scalars['numeric']>;
  recomended_duration?: InputMaybe<Scalars['numeric']>;
  sport_id?: InputMaybe<Scalars['String']>;
  stripe_product_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  weekly_price?: InputMaybe<Scalars['numeric']>;
  yearly_discount?: InputMaybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "subscription_plan" */
export type ISubscription_Plan_Sum_Order_By = {
  biannualy_discount?: InputMaybe<IOrder_By>;
  coach_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  level?: InputMaybe<IOrder_By>;
  min_duration?: InputMaybe<IOrder_By>;
  quarterly_discount?: InputMaybe<IOrder_By>;
  recomended_duration?: InputMaybe<IOrder_By>;
  weekly_price?: InputMaybe<IOrder_By>;
  yearly_discount?: InputMaybe<IOrder_By>;
};

export type ISubscription_Plan_Template_Aggregate_Bool_Exp = {
  count?: InputMaybe<ISubscription_Plan_Template_Aggregate_Bool_Exp_Count>;
};

export type ISubscription_Plan_Template_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ISubscription_Plan_Template_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ISubscription_Plan_Template_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

/** order by aggregate values of table "subscription_plan_template" */
export type ISubscription_Plan_Template_Aggregate_Order_By = {
  avg?: InputMaybe<ISubscription_Plan_Template_Avg_Order_By>;
  count?: InputMaybe<IOrder_By>;
  max?: InputMaybe<ISubscription_Plan_Template_Max_Order_By>;
  min?: InputMaybe<ISubscription_Plan_Template_Min_Order_By>;
  stddev?: InputMaybe<ISubscription_Plan_Template_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ISubscription_Plan_Template_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ISubscription_Plan_Template_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ISubscription_Plan_Template_Sum_Order_By>;
  var_pop?: InputMaybe<ISubscription_Plan_Template_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ISubscription_Plan_Template_Var_Samp_Order_By>;
  variance?: InputMaybe<ISubscription_Plan_Template_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "subscription_plan_template" */
export type ISubscription_Plan_Template_Arr_Rel_Insert_Input = {
  data: Array<ISubscription_Plan_Template_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ISubscription_Plan_Template_On_Conflict>;
};

/** order by avg() on columns of table "subscription_plan_template" */
export type ISubscription_Plan_Template_Avg_Order_By = {
  biannualy_discount?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  level?: InputMaybe<IOrder_By>;
  min_duration?: InputMaybe<IOrder_By>;
  quarterly_discount?: InputMaybe<IOrder_By>;
  recomended_duration?: InputMaybe<IOrder_By>;
  weekly_price?: InputMaybe<IOrder_By>;
  yearly_discount?: InputMaybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "subscription_plan_template". All fields are combined with a logical 'AND'. */
export type ISubscription_Plan_Template_Bool_Exp = {
  _and?: InputMaybe<Array<ISubscription_Plan_Template_Bool_Exp>>;
  _not?: InputMaybe<ISubscription_Plan_Template_Bool_Exp>;
  _or?: InputMaybe<Array<ISubscription_Plan_Template_Bool_Exp>>;
  biannualy_discount?: InputMaybe<INumeric_Comparison_Exp>;
  created_at?: InputMaybe<ITimestamptz_Comparison_Exp>;
  id?: InputMaybe<IInt_Comparison_Exp>;
  level?: InputMaybe<IInt_Comparison_Exp>;
  min_duration?: InputMaybe<INumeric_Comparison_Exp>;
  quarterly_discount?: InputMaybe<INumeric_Comparison_Exp>;
  recomended_duration?: InputMaybe<INumeric_Comparison_Exp>;
  sport?: InputMaybe<ISport_Bool_Exp>;
  sport_id?: InputMaybe<IString_Comparison_Exp>;
  weekly_price?: InputMaybe<INumeric_Comparison_Exp>;
  yearly_discount?: InputMaybe<INumeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "subscription_plan_template" */
export enum ISubscription_Plan_Template_Constraint {
  /** unique or primary key constraint on columns "id" */
  SubscriptionPlanTemplatePkey = 'subscription_plan_template_pkey'
}

/** input type for incrementing numeric columns in table "subscription_plan_template" */
export type ISubscription_Plan_Template_Inc_Input = {
  biannualy_discount?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['Int']>;
  level?: InputMaybe<Scalars['Int']>;
  min_duration?: InputMaybe<Scalars['numeric']>;
  quarterly_discount?: InputMaybe<Scalars['numeric']>;
  recomended_duration?: InputMaybe<Scalars['numeric']>;
  weekly_price?: InputMaybe<Scalars['numeric']>;
  yearly_discount?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "subscription_plan_template" */
export type ISubscription_Plan_Template_Insert_Input = {
  biannualy_discount?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  level?: InputMaybe<Scalars['Int']>;
  min_duration?: InputMaybe<Scalars['numeric']>;
  quarterly_discount?: InputMaybe<Scalars['numeric']>;
  recomended_duration?: InputMaybe<Scalars['numeric']>;
  sport?: InputMaybe<ISport_Obj_Rel_Insert_Input>;
  sport_id?: InputMaybe<Scalars['String']>;
  weekly_price?: InputMaybe<Scalars['numeric']>;
  yearly_discount?: InputMaybe<Scalars['numeric']>;
};

/** order by max() on columns of table "subscription_plan_template" */
export type ISubscription_Plan_Template_Max_Order_By = {
  biannualy_discount?: InputMaybe<IOrder_By>;
  created_at?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  level?: InputMaybe<IOrder_By>;
  min_duration?: InputMaybe<IOrder_By>;
  quarterly_discount?: InputMaybe<IOrder_By>;
  recomended_duration?: InputMaybe<IOrder_By>;
  sport_id?: InputMaybe<IOrder_By>;
  weekly_price?: InputMaybe<IOrder_By>;
  yearly_discount?: InputMaybe<IOrder_By>;
};

/** order by min() on columns of table "subscription_plan_template" */
export type ISubscription_Plan_Template_Min_Order_By = {
  biannualy_discount?: InputMaybe<IOrder_By>;
  created_at?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  level?: InputMaybe<IOrder_By>;
  min_duration?: InputMaybe<IOrder_By>;
  quarterly_discount?: InputMaybe<IOrder_By>;
  recomended_duration?: InputMaybe<IOrder_By>;
  sport_id?: InputMaybe<IOrder_By>;
  weekly_price?: InputMaybe<IOrder_By>;
  yearly_discount?: InputMaybe<IOrder_By>;
};

/** on_conflict condition type for table "subscription_plan_template" */
export type ISubscription_Plan_Template_On_Conflict = {
  constraint: ISubscription_Plan_Template_Constraint;
  update_columns?: Array<ISubscription_Plan_Template_Update_Column>;
  where?: InputMaybe<ISubscription_Plan_Template_Bool_Exp>;
};

/** Ordering options when selecting data from "subscription_plan_template". */
export type ISubscription_Plan_Template_Order_By = {
  biannualy_discount?: InputMaybe<IOrder_By>;
  created_at?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  level?: InputMaybe<IOrder_By>;
  min_duration?: InputMaybe<IOrder_By>;
  quarterly_discount?: InputMaybe<IOrder_By>;
  recomended_duration?: InputMaybe<IOrder_By>;
  sport?: InputMaybe<ISport_Order_By>;
  sport_id?: InputMaybe<IOrder_By>;
  weekly_price?: InputMaybe<IOrder_By>;
  yearly_discount?: InputMaybe<IOrder_By>;
};

/** primary key columns input for table: subscription_plan_template */
export type ISubscription_Plan_Template_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "subscription_plan_template" */
export enum ISubscription_Plan_Template_Select_Column {
  /** column name */
  BiannualyDiscount = 'biannualy_discount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Level = 'level',
  /** column name */
  MinDuration = 'min_duration',
  /** column name */
  QuarterlyDiscount = 'quarterly_discount',
  /** column name */
  RecomendedDuration = 'recomended_duration',
  /** column name */
  SportId = 'sport_id',
  /** column name */
  WeeklyPrice = 'weekly_price',
  /** column name */
  YearlyDiscount = 'yearly_discount'
}

/** input type for updating data in table "subscription_plan_template" */
export type ISubscription_Plan_Template_Set_Input = {
  biannualy_discount?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  level?: InputMaybe<Scalars['Int']>;
  min_duration?: InputMaybe<Scalars['numeric']>;
  quarterly_discount?: InputMaybe<Scalars['numeric']>;
  recomended_duration?: InputMaybe<Scalars['numeric']>;
  sport_id?: InputMaybe<Scalars['String']>;
  weekly_price?: InputMaybe<Scalars['numeric']>;
  yearly_discount?: InputMaybe<Scalars['numeric']>;
};

/** order by stddev() on columns of table "subscription_plan_template" */
export type ISubscription_Plan_Template_Stddev_Order_By = {
  biannualy_discount?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  level?: InputMaybe<IOrder_By>;
  min_duration?: InputMaybe<IOrder_By>;
  quarterly_discount?: InputMaybe<IOrder_By>;
  recomended_duration?: InputMaybe<IOrder_By>;
  weekly_price?: InputMaybe<IOrder_By>;
  yearly_discount?: InputMaybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "subscription_plan_template" */
export type ISubscription_Plan_Template_Stddev_Pop_Order_By = {
  biannualy_discount?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  level?: InputMaybe<IOrder_By>;
  min_duration?: InputMaybe<IOrder_By>;
  quarterly_discount?: InputMaybe<IOrder_By>;
  recomended_duration?: InputMaybe<IOrder_By>;
  weekly_price?: InputMaybe<IOrder_By>;
  yearly_discount?: InputMaybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "subscription_plan_template" */
export type ISubscription_Plan_Template_Stddev_Samp_Order_By = {
  biannualy_discount?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  level?: InputMaybe<IOrder_By>;
  min_duration?: InputMaybe<IOrder_By>;
  quarterly_discount?: InputMaybe<IOrder_By>;
  recomended_duration?: InputMaybe<IOrder_By>;
  weekly_price?: InputMaybe<IOrder_By>;
  yearly_discount?: InputMaybe<IOrder_By>;
};

/** Streaming cursor of the table "subscription_plan_template" */
export type ISubscription_Plan_Template_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ISubscription_Plan_Template_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ISubscription_Plan_Template_Stream_Cursor_Value_Input = {
  biannualy_discount?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  level?: InputMaybe<Scalars['Int']>;
  min_duration?: InputMaybe<Scalars['numeric']>;
  quarterly_discount?: InputMaybe<Scalars['numeric']>;
  recomended_duration?: InputMaybe<Scalars['numeric']>;
  sport_id?: InputMaybe<Scalars['String']>;
  weekly_price?: InputMaybe<Scalars['numeric']>;
  yearly_discount?: InputMaybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "subscription_plan_template" */
export type ISubscription_Plan_Template_Sum_Order_By = {
  biannualy_discount?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  level?: InputMaybe<IOrder_By>;
  min_duration?: InputMaybe<IOrder_By>;
  quarterly_discount?: InputMaybe<IOrder_By>;
  recomended_duration?: InputMaybe<IOrder_By>;
  weekly_price?: InputMaybe<IOrder_By>;
  yearly_discount?: InputMaybe<IOrder_By>;
};

/** update columns of table "subscription_plan_template" */
export enum ISubscription_Plan_Template_Update_Column {
  /** column name */
  BiannualyDiscount = 'biannualy_discount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Level = 'level',
  /** column name */
  MinDuration = 'min_duration',
  /** column name */
  QuarterlyDiscount = 'quarterly_discount',
  /** column name */
  RecomendedDuration = 'recomended_duration',
  /** column name */
  SportId = 'sport_id',
  /** column name */
  WeeklyPrice = 'weekly_price',
  /** column name */
  YearlyDiscount = 'yearly_discount'
}

export type ISubscription_Plan_Template_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ISubscription_Plan_Template_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ISubscription_Plan_Template_Set_Input>;
  /** filter the rows which have to be updated */
  where: ISubscription_Plan_Template_Bool_Exp;
};

/** order by var_pop() on columns of table "subscription_plan_template" */
export type ISubscription_Plan_Template_Var_Pop_Order_By = {
  biannualy_discount?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  level?: InputMaybe<IOrder_By>;
  min_duration?: InputMaybe<IOrder_By>;
  quarterly_discount?: InputMaybe<IOrder_By>;
  recomended_duration?: InputMaybe<IOrder_By>;
  weekly_price?: InputMaybe<IOrder_By>;
  yearly_discount?: InputMaybe<IOrder_By>;
};

/** order by var_samp() on columns of table "subscription_plan_template" */
export type ISubscription_Plan_Template_Var_Samp_Order_By = {
  biannualy_discount?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  level?: InputMaybe<IOrder_By>;
  min_duration?: InputMaybe<IOrder_By>;
  quarterly_discount?: InputMaybe<IOrder_By>;
  recomended_duration?: InputMaybe<IOrder_By>;
  weekly_price?: InputMaybe<IOrder_By>;
  yearly_discount?: InputMaybe<IOrder_By>;
};

/** order by variance() on columns of table "subscription_plan_template" */
export type ISubscription_Plan_Template_Variance_Order_By = {
  biannualy_discount?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  level?: InputMaybe<IOrder_By>;
  min_duration?: InputMaybe<IOrder_By>;
  quarterly_discount?: InputMaybe<IOrder_By>;
  recomended_duration?: InputMaybe<IOrder_By>;
  weekly_price?: InputMaybe<IOrder_By>;
  yearly_discount?: InputMaybe<IOrder_By>;
};

export type ISubscription_Plan_Translation_Aggregate_Bool_Exp = {
  count?: InputMaybe<ISubscription_Plan_Translation_Aggregate_Bool_Exp_Count>;
};

export type ISubscription_Plan_Translation_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ISubscription_Plan_Translation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ISubscription_Plan_Translation_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

/** order by aggregate values of table "subscription_plan_translation" */
export type ISubscription_Plan_Translation_Aggregate_Order_By = {
  avg?: InputMaybe<ISubscription_Plan_Translation_Avg_Order_By>;
  count?: InputMaybe<IOrder_By>;
  max?: InputMaybe<ISubscription_Plan_Translation_Max_Order_By>;
  min?: InputMaybe<ISubscription_Plan_Translation_Min_Order_By>;
  stddev?: InputMaybe<ISubscription_Plan_Translation_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ISubscription_Plan_Translation_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ISubscription_Plan_Translation_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ISubscription_Plan_Translation_Sum_Order_By>;
  var_pop?: InputMaybe<ISubscription_Plan_Translation_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ISubscription_Plan_Translation_Var_Samp_Order_By>;
  variance?: InputMaybe<ISubscription_Plan_Translation_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "subscription_plan_translation" */
export type ISubscription_Plan_Translation_Arr_Rel_Insert_Input = {
  data: Array<ISubscription_Plan_Translation_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ISubscription_Plan_Translation_On_Conflict>;
};

/** order by avg() on columns of table "subscription_plan_translation" */
export type ISubscription_Plan_Translation_Avg_Order_By = {
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
  subscription_plan_id?: InputMaybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "subscription_plan_translation". All fields are combined with a logical 'AND'. */
export type ISubscription_Plan_Translation_Bool_Exp = {
  _and?: InputMaybe<Array<ISubscription_Plan_Translation_Bool_Exp>>;
  _not?: InputMaybe<ISubscription_Plan_Translation_Bool_Exp>;
  _or?: InputMaybe<Array<ISubscription_Plan_Translation_Bool_Exp>>;
  created_at?: InputMaybe<ITimestamptz_Comparison_Exp>;
  description?: InputMaybe<IString_Comparison_Exp>;
  id?: InputMaybe<IInt_Comparison_Exp>;
  locale?: InputMaybe<ILocale_Bool_Exp>;
  locale_id?: InputMaybe<IInt_Comparison_Exp>;
  subscription_plan?: InputMaybe<ISubscription_Plan_Bool_Exp>;
  subscription_plan_id?: InputMaybe<IInt_Comparison_Exp>;
};

/** unique or primary key constraints on table "subscription_plan_translation" */
export enum ISubscription_Plan_Translation_Constraint {
  /** unique or primary key constraint on columns "id" */
  SubscriptionPlanTranslationPkey = 'subscription_plan_translation_pkey'
}

/** input type for incrementing numeric columns in table "subscription_plan_translation" */
export type ISubscription_Plan_Translation_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  locale_id?: InputMaybe<Scalars['Int']>;
  subscription_plan_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "subscription_plan_translation" */
export type ISubscription_Plan_Translation_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<ILocale_Obj_Rel_Insert_Input>;
  locale_id?: InputMaybe<Scalars['Int']>;
  subscription_plan?: InputMaybe<ISubscription_Plan_Obj_Rel_Insert_Input>;
  subscription_plan_id?: InputMaybe<Scalars['Int']>;
};

/** order by max() on columns of table "subscription_plan_translation" */
export type ISubscription_Plan_Translation_Max_Order_By = {
  created_at?: InputMaybe<IOrder_By>;
  description?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
  subscription_plan_id?: InputMaybe<IOrder_By>;
};

/** order by min() on columns of table "subscription_plan_translation" */
export type ISubscription_Plan_Translation_Min_Order_By = {
  created_at?: InputMaybe<IOrder_By>;
  description?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
  subscription_plan_id?: InputMaybe<IOrder_By>;
};

/** on_conflict condition type for table "subscription_plan_translation" */
export type ISubscription_Plan_Translation_On_Conflict = {
  constraint: ISubscription_Plan_Translation_Constraint;
  update_columns?: Array<ISubscription_Plan_Translation_Update_Column>;
  where?: InputMaybe<ISubscription_Plan_Translation_Bool_Exp>;
};

/** Ordering options when selecting data from "subscription_plan_translation". */
export type ISubscription_Plan_Translation_Order_By = {
  created_at?: InputMaybe<IOrder_By>;
  description?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  locale?: InputMaybe<ILocale_Order_By>;
  locale_id?: InputMaybe<IOrder_By>;
  subscription_plan?: InputMaybe<ISubscription_Plan_Order_By>;
  subscription_plan_id?: InputMaybe<IOrder_By>;
};

/** primary key columns input for table: subscription_plan_translation */
export type ISubscription_Plan_Translation_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "subscription_plan_translation" */
export enum ISubscription_Plan_Translation_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  LocaleId = 'locale_id',
  /** column name */
  SubscriptionPlanId = 'subscription_plan_id'
}

/** input type for updating data in table "subscription_plan_translation" */
export type ISubscription_Plan_Translation_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  locale_id?: InputMaybe<Scalars['Int']>;
  subscription_plan_id?: InputMaybe<Scalars['Int']>;
};

/** order by stddev() on columns of table "subscription_plan_translation" */
export type ISubscription_Plan_Translation_Stddev_Order_By = {
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
  subscription_plan_id?: InputMaybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "subscription_plan_translation" */
export type ISubscription_Plan_Translation_Stddev_Pop_Order_By = {
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
  subscription_plan_id?: InputMaybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "subscription_plan_translation" */
export type ISubscription_Plan_Translation_Stddev_Samp_Order_By = {
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
  subscription_plan_id?: InputMaybe<IOrder_By>;
};

/** Streaming cursor of the table "subscription_plan_translation" */
export type ISubscription_Plan_Translation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ISubscription_Plan_Translation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ISubscription_Plan_Translation_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  locale_id?: InputMaybe<Scalars['Int']>;
  subscription_plan_id?: InputMaybe<Scalars['Int']>;
};

/** order by sum() on columns of table "subscription_plan_translation" */
export type ISubscription_Plan_Translation_Sum_Order_By = {
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
  subscription_plan_id?: InputMaybe<IOrder_By>;
};

/** update columns of table "subscription_plan_translation" */
export enum ISubscription_Plan_Translation_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  LocaleId = 'locale_id',
  /** column name */
  SubscriptionPlanId = 'subscription_plan_id'
}

export type ISubscription_Plan_Translation_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ISubscription_Plan_Translation_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ISubscription_Plan_Translation_Set_Input>;
  /** filter the rows which have to be updated */
  where: ISubscription_Plan_Translation_Bool_Exp;
};

/** order by var_pop() on columns of table "subscription_plan_translation" */
export type ISubscription_Plan_Translation_Var_Pop_Order_By = {
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
  subscription_plan_id?: InputMaybe<IOrder_By>;
};

/** order by var_samp() on columns of table "subscription_plan_translation" */
export type ISubscription_Plan_Translation_Var_Samp_Order_By = {
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
  subscription_plan_id?: InputMaybe<IOrder_By>;
};

/** order by variance() on columns of table "subscription_plan_translation" */
export type ISubscription_Plan_Translation_Variance_Order_By = {
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
  subscription_plan_id?: InputMaybe<IOrder_By>;
};

/** update columns of table "subscription_plan" */
export enum ISubscription_Plan_Update_Column {
  /** column name */
  BiannualyDiscount = 'biannualy_discount',
  /** column name */
  CoachId = 'coach_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  Level = 'level',
  /** column name */
  MinDuration = 'min_duration',
  /** column name */
  QuarterlyDiscount = 'quarterly_discount',
  /** column name */
  RecomendedDuration = 'recomended_duration',
  /** column name */
  SportId = 'sport_id',
  /** column name */
  StripeProductId = 'stripe_product_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WeeklyPrice = 'weekly_price',
  /** column name */
  YearlyDiscount = 'yearly_discount'
}

export type ISubscription_Plan_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ISubscription_Plan_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ISubscription_Plan_Set_Input>;
  /** filter the rows which have to be updated */
  where: ISubscription_Plan_Bool_Exp;
};

/** order by var_pop() on columns of table "subscription_plan" */
export type ISubscription_Plan_Var_Pop_Order_By = {
  biannualy_discount?: InputMaybe<IOrder_By>;
  coach_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  level?: InputMaybe<IOrder_By>;
  min_duration?: InputMaybe<IOrder_By>;
  quarterly_discount?: InputMaybe<IOrder_By>;
  recomended_duration?: InputMaybe<IOrder_By>;
  weekly_price?: InputMaybe<IOrder_By>;
  yearly_discount?: InputMaybe<IOrder_By>;
};

/** order by var_samp() on columns of table "subscription_plan" */
export type ISubscription_Plan_Var_Samp_Order_By = {
  biannualy_discount?: InputMaybe<IOrder_By>;
  coach_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  level?: InputMaybe<IOrder_By>;
  min_duration?: InputMaybe<IOrder_By>;
  quarterly_discount?: InputMaybe<IOrder_By>;
  recomended_duration?: InputMaybe<IOrder_By>;
  weekly_price?: InputMaybe<IOrder_By>;
  yearly_discount?: InputMaybe<IOrder_By>;
};

/** order by variance() on columns of table "subscription_plan" */
export type ISubscription_Plan_Variance_Order_By = {
  biannualy_discount?: InputMaybe<IOrder_By>;
  coach_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  level?: InputMaybe<IOrder_By>;
  min_duration?: InputMaybe<IOrder_By>;
  quarterly_discount?: InputMaybe<IOrder_By>;
  recomended_duration?: InputMaybe<IOrder_By>;
  weekly_price?: InputMaybe<IOrder_By>;
  yearly_discount?: InputMaybe<IOrder_By>;
};

/** select columns of table "subscription" */
export enum ISubscription_Select_Column {
  /** column name */
  AthleteId = 'athlete_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DateEnd = 'date_end',
  /** column name */
  DateStart = 'date_start',
  /** column name */
  Id = 'id',
  /** column name */
  IntervalCount = 'interval_count',
  /** column name */
  Price = 'price',
  /** column name */
  Status = 'status',
  /** column name */
  StripeSubscriptionId = 'stripe_subscription_id',
  /** column name */
  SubscriptionPlanId = 'subscription_plan_id'
}

/** input type for updating data in table "subscription" */
export type ISubscription_Set_Input = {
  athlete_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  date_end?: InputMaybe<Scalars['date']>;
  date_start?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['Int']>;
  interval_count?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  stripe_subscription_id?: InputMaybe<Scalars['String']>;
  subscription_plan_id?: InputMaybe<Scalars['Int']>;
};

/** order by stddev() on columns of table "subscription" */
export type ISubscription_Stddev_Order_By = {
  athlete_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  interval_count?: InputMaybe<IOrder_By>;
  price?: InputMaybe<IOrder_By>;
  subscription_plan_id?: InputMaybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "subscription" */
export type ISubscription_Stddev_Pop_Order_By = {
  athlete_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  interval_count?: InputMaybe<IOrder_By>;
  price?: InputMaybe<IOrder_By>;
  subscription_plan_id?: InputMaybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "subscription" */
export type ISubscription_Stddev_Samp_Order_By = {
  athlete_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  interval_count?: InputMaybe<IOrder_By>;
  price?: InputMaybe<IOrder_By>;
  subscription_plan_id?: InputMaybe<IOrder_By>;
};

/** Streaming cursor of the table "subscription" */
export type ISubscription_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ISubscription_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ISubscription_Stream_Cursor_Value_Input = {
  athlete_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  date_end?: InputMaybe<Scalars['date']>;
  date_start?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['Int']>;
  interval_count?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  stripe_subscription_id?: InputMaybe<Scalars['String']>;
  subscription_plan_id?: InputMaybe<Scalars['Int']>;
};

/** order by sum() on columns of table "subscription" */
export type ISubscription_Sum_Order_By = {
  athlete_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  interval_count?: InputMaybe<IOrder_By>;
  price?: InputMaybe<IOrder_By>;
  subscription_plan_id?: InputMaybe<IOrder_By>;
};

/** update columns of table "subscription" */
export enum ISubscription_Update_Column {
  /** column name */
  AthleteId = 'athlete_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DateEnd = 'date_end',
  /** column name */
  DateStart = 'date_start',
  /** column name */
  Id = 'id',
  /** column name */
  IntervalCount = 'interval_count',
  /** column name */
  Price = 'price',
  /** column name */
  Status = 'status',
  /** column name */
  StripeSubscriptionId = 'stripe_subscription_id',
  /** column name */
  SubscriptionPlanId = 'subscription_plan_id'
}

export type ISubscription_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ISubscription_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ISubscription_Set_Input>;
  /** filter the rows which have to be updated */
  where: ISubscription_Bool_Exp;
};

/** order by var_pop() on columns of table "subscription" */
export type ISubscription_Var_Pop_Order_By = {
  athlete_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  interval_count?: InputMaybe<IOrder_By>;
  price?: InputMaybe<IOrder_By>;
  subscription_plan_id?: InputMaybe<IOrder_By>;
};

/** order by var_samp() on columns of table "subscription" */
export type ISubscription_Var_Samp_Order_By = {
  athlete_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  interval_count?: InputMaybe<IOrder_By>;
  price?: InputMaybe<IOrder_By>;
  subscription_plan_id?: InputMaybe<IOrder_By>;
};

/** order by variance() on columns of table "subscription" */
export type ISubscription_Variance_Order_By = {
  athlete_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  interval_count?: InputMaybe<IOrder_By>;
  price?: InputMaybe<IOrder_By>;
  subscription_plan_id?: InputMaybe<IOrder_By>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type ITimestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']>;
  _gt?: InputMaybe<Scalars['timestamptz']>;
  _gte?: InputMaybe<Scalars['timestamptz']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamptz']>;
  _lte?: InputMaybe<Scalars['timestamptz']>;
  _neq?: InputMaybe<Scalars['timestamptz']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']>>;
};

/** Boolean expression to filter rows from the table "user". All fields are combined with a logical 'AND'. */
export type IUser_Bool_Exp = {
  _and?: InputMaybe<Array<IUser_Bool_Exp>>;
  _not?: InputMaybe<IUser_Bool_Exp>;
  _or?: InputMaybe<Array<IUser_Bool_Exp>>;
  athlete?: InputMaybe<IAthlete_Bool_Exp>;
  coach?: InputMaybe<ICoach_Bool_Exp>;
  coaches?: InputMaybe<ICoach_Bool_Exp>;
  coaches_aggregate?: InputMaybe<ICoach_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<ITimestamptz_Comparison_Exp>;
  email?: InputMaybe<IString_Comparison_Exp>;
  id?: InputMaybe<IInt_Comparison_Exp>;
  keycloak_id?: InputMaybe<IUuid_Comparison_Exp>;
  name?: InputMaybe<IString_Comparison_Exp>;
  recovery_token?: InputMaybe<IString_Comparison_Exp>;
  strava_access_token?: InputMaybe<IString_Comparison_Exp>;
  type?: InputMaybe<IString_Comparison_Exp>;
  updated_at?: InputMaybe<ITimestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "user" */
export enum IUser_Constraint {
  /** unique or primary key constraint on columns "type", "email" */
  UserEmailTypeKey = 'user_email_type_key',
  /** unique or primary key constraint on columns "keycloak_id" */
  UserKeycloakIdKey = 'user_keycloak_id_key',
  /** unique or primary key constraint on columns "id" */
  UserPkey = 'user_pkey'
}

/** input type for incrementing numeric columns in table "user" */
export type IUser_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user" */
export type IUser_Insert_Input = {
  athlete?: InputMaybe<IAthlete_Obj_Rel_Insert_Input>;
  coach?: InputMaybe<ICoach_Obj_Rel_Insert_Input>;
  coaches?: InputMaybe<ICoach_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  keycloak_id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  recovery_token?: InputMaybe<Scalars['String']>;
  strava_access_token?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** input type for inserting object relation for remote table "user" */
export type IUser_Obj_Rel_Insert_Input = {
  data: IUser_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<IUser_On_Conflict>;
};

/** on_conflict condition type for table "user" */
export type IUser_On_Conflict = {
  constraint: IUser_Constraint;
  update_columns?: Array<IUser_Update_Column>;
  where?: InputMaybe<IUser_Bool_Exp>;
};

/** Ordering options when selecting data from "user". */
export type IUser_Order_By = {
  athlete?: InputMaybe<IAthlete_Order_By>;
  coach?: InputMaybe<ICoach_Order_By>;
  coaches_aggregate?: InputMaybe<ICoach_Aggregate_Order_By>;
  created_at?: InputMaybe<IOrder_By>;
  email?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  keycloak_id?: InputMaybe<IOrder_By>;
  name?: InputMaybe<IOrder_By>;
  recovery_token?: InputMaybe<IOrder_By>;
  strava_access_token?: InputMaybe<IOrder_By>;
  type?: InputMaybe<IOrder_By>;
  updated_at?: InputMaybe<IOrder_By>;
};

/** primary key columns input for table: user */
export type IUser_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "user" */
export enum IUser_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  KeycloakId = 'keycloak_id',
  /** column name */
  Name = 'name',
  /** column name */
  RecoveryToken = 'recovery_token',
  /** column name */
  StravaAccessToken = 'strava_access_token',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "user" */
export type IUser_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  keycloak_id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  recovery_token?: InputMaybe<Scalars['String']>;
  strava_access_token?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "user" */
export type IUser_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IUser_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IUser_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  keycloak_id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  recovery_token?: InputMaybe<Scalars['String']>;
  strava_access_token?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "user" */
export enum IUser_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  KeycloakId = 'keycloak_id',
  /** column name */
  Name = 'name',
  /** column name */
  RecoveryToken = 'recovery_token',
  /** column name */
  StravaAccessToken = 'strava_access_token',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type IUser_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<IUser_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IUser_Set_Input>;
  /** filter the rows which have to be updated */
  where: IUser_Bool_Exp;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type IUuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']>;
  _gt?: InputMaybe<Scalars['uuid']>;
  _gte?: InputMaybe<Scalars['uuid']>;
  _in?: InputMaybe<Array<Scalars['uuid']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['uuid']>;
  _lte?: InputMaybe<Scalars['uuid']>;
  _neq?: InputMaybe<Scalars['uuid']>;
  _nin?: InputMaybe<Array<Scalars['uuid']>>;
};

export type IWeek_Template_Aggregate_Bool_Exp = {
  count?: InputMaybe<IWeek_Template_Aggregate_Bool_Exp_Count>;
};

export type IWeek_Template_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<IWeek_Template_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IWeek_Template_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

/** order by aggregate values of table "week_template" */
export type IWeek_Template_Aggregate_Order_By = {
  avg?: InputMaybe<IWeek_Template_Avg_Order_By>;
  count?: InputMaybe<IOrder_By>;
  max?: InputMaybe<IWeek_Template_Max_Order_By>;
  min?: InputMaybe<IWeek_Template_Min_Order_By>;
  stddev?: InputMaybe<IWeek_Template_Stddev_Order_By>;
  stddev_pop?: InputMaybe<IWeek_Template_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<IWeek_Template_Stddev_Samp_Order_By>;
  sum?: InputMaybe<IWeek_Template_Sum_Order_By>;
  var_pop?: InputMaybe<IWeek_Template_Var_Pop_Order_By>;
  var_samp?: InputMaybe<IWeek_Template_Var_Samp_Order_By>;
  variance?: InputMaybe<IWeek_Template_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "week_template" */
export type IWeek_Template_Arr_Rel_Insert_Input = {
  data: Array<IWeek_Template_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<IWeek_Template_On_Conflict>;
};

/** order by avg() on columns of table "week_template" */
export type IWeek_Template_Avg_Order_By = {
  block_template_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  order?: InputMaybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "week_template". All fields are combined with a logical 'AND'. */
export type IWeek_Template_Bool_Exp = {
  _and?: InputMaybe<Array<IWeek_Template_Bool_Exp>>;
  _not?: InputMaybe<IWeek_Template_Bool_Exp>;
  _or?: InputMaybe<Array<IWeek_Template_Bool_Exp>>;
  block_template?: InputMaybe<IBlock_Template_Bool_Exp>;
  block_template_id?: InputMaybe<IInt_Comparison_Exp>;
  created_at?: InputMaybe<ITimestamptz_Comparison_Exp>;
  id?: InputMaybe<IInt_Comparison_Exp>;
  name?: InputMaybe<IString_Comparison_Exp>;
  order?: InputMaybe<IInt_Comparison_Exp>;
  sport?: InputMaybe<ISport_Bool_Exp>;
  sport_id?: InputMaybe<IString_Comparison_Exp>;
  updated_at?: InputMaybe<ITimestamptz_Comparison_Exp>;
  workout_templates?: InputMaybe<IWorkout_Template_Bool_Exp>;
  workout_templates_aggregate?: InputMaybe<IWorkout_Template_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "week_template" */
export enum IWeek_Template_Constraint {
  /** unique or primary key constraint on columns "id" */
  WeekTemplatePkey = 'week_template_pkey'
}

/** input type for incrementing numeric columns in table "week_template" */
export type IWeek_Template_Inc_Input = {
  block_template_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "week_template" */
export type IWeek_Template_Insert_Input = {
  block_template?: InputMaybe<IBlock_Template_Obj_Rel_Insert_Input>;
  block_template_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  sport?: InputMaybe<ISport_Obj_Rel_Insert_Input>;
  sport_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workout_templates?: InputMaybe<IWorkout_Template_Arr_Rel_Insert_Input>;
};

/** order by max() on columns of table "week_template" */
export type IWeek_Template_Max_Order_By = {
  block_template_id?: InputMaybe<IOrder_By>;
  created_at?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  name?: InputMaybe<IOrder_By>;
  order?: InputMaybe<IOrder_By>;
  sport_id?: InputMaybe<IOrder_By>;
  updated_at?: InputMaybe<IOrder_By>;
};

/** order by min() on columns of table "week_template" */
export type IWeek_Template_Min_Order_By = {
  block_template_id?: InputMaybe<IOrder_By>;
  created_at?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  name?: InputMaybe<IOrder_By>;
  order?: InputMaybe<IOrder_By>;
  sport_id?: InputMaybe<IOrder_By>;
  updated_at?: InputMaybe<IOrder_By>;
};

/** input type for inserting object relation for remote table "week_template" */
export type IWeek_Template_Obj_Rel_Insert_Input = {
  data: IWeek_Template_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<IWeek_Template_On_Conflict>;
};

/** on_conflict condition type for table "week_template" */
export type IWeek_Template_On_Conflict = {
  constraint: IWeek_Template_Constraint;
  update_columns?: Array<IWeek_Template_Update_Column>;
  where?: InputMaybe<IWeek_Template_Bool_Exp>;
};

/** Ordering options when selecting data from "week_template". */
export type IWeek_Template_Order_By = {
  block_template?: InputMaybe<IBlock_Template_Order_By>;
  block_template_id?: InputMaybe<IOrder_By>;
  created_at?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  name?: InputMaybe<IOrder_By>;
  order?: InputMaybe<IOrder_By>;
  sport?: InputMaybe<ISport_Order_By>;
  sport_id?: InputMaybe<IOrder_By>;
  updated_at?: InputMaybe<IOrder_By>;
  workout_templates_aggregate?: InputMaybe<IWorkout_Template_Aggregate_Order_By>;
};

/** primary key columns input for table: week_template */
export type IWeek_Template_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "week_template" */
export enum IWeek_Template_Select_Column {
  /** column name */
  BlockTemplateId = 'block_template_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  SportId = 'sport_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "week_template" */
export type IWeek_Template_Set_Input = {
  block_template_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  sport_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** order by stddev() on columns of table "week_template" */
export type IWeek_Template_Stddev_Order_By = {
  block_template_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  order?: InputMaybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "week_template" */
export type IWeek_Template_Stddev_Pop_Order_By = {
  block_template_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  order?: InputMaybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "week_template" */
export type IWeek_Template_Stddev_Samp_Order_By = {
  block_template_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  order?: InputMaybe<IOrder_By>;
};

/** Streaming cursor of the table "week_template" */
export type IWeek_Template_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IWeek_Template_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IWeek_Template_Stream_Cursor_Value_Input = {
  block_template_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  sport_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** order by sum() on columns of table "week_template" */
export type IWeek_Template_Sum_Order_By = {
  block_template_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  order?: InputMaybe<IOrder_By>;
};

/** update columns of table "week_template" */
export enum IWeek_Template_Update_Column {
  /** column name */
  BlockTemplateId = 'block_template_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  SportId = 'sport_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type IWeek_Template_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<IWeek_Template_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IWeek_Template_Set_Input>;
  /** filter the rows which have to be updated */
  where: IWeek_Template_Bool_Exp;
};

/** order by var_pop() on columns of table "week_template" */
export type IWeek_Template_Var_Pop_Order_By = {
  block_template_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  order?: InputMaybe<IOrder_By>;
};

/** order by var_samp() on columns of table "week_template" */
export type IWeek_Template_Var_Samp_Order_By = {
  block_template_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  order?: InputMaybe<IOrder_By>;
};

/** order by variance() on columns of table "week_template" */
export type IWeek_Template_Variance_Order_By = {
  block_template_id?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  order?: InputMaybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "workout_altimetry". All fields are combined with a logical 'AND'. */
export type IWorkout_Altimetry_Bool_Exp = {
  _and?: InputMaybe<Array<IWorkout_Altimetry_Bool_Exp>>;
  _not?: InputMaybe<IWorkout_Altimetry_Bool_Exp>;
  _or?: InputMaybe<Array<IWorkout_Altimetry_Bool_Exp>>;
  athlete_profile_altimetry_adjustments?: InputMaybe<IAthlete_Profile_Altimetry_Adjustment_Bool_Exp>;
  athlete_profile_altimetry_adjustments_aggregate?: InputMaybe<IAthlete_Profile_Altimetry_Adjustment_Aggregate_Bool_Exp>;
  athlete_workouts?: InputMaybe<IAthlete_Workout_Bool_Exp>;
  athlete_workouts_aggregate?: InputMaybe<IAthlete_Workout_Aggregate_Bool_Exp>;
  coefficient?: InputMaybe<INumeric_Comparison_Exp>;
  icon?: InputMaybe<IString_Comparison_Exp>;
  id?: InputMaybe<IInt_Comparison_Exp>;
  name?: InputMaybe<IString_Comparison_Exp>;
  workout_altimetry_translations?: InputMaybe<IWorkout_Altimetry_Translation_Bool_Exp>;
  workout_altimetry_translations_aggregate?: InputMaybe<IWorkout_Altimetry_Translation_Aggregate_Bool_Exp>;
  workout_altimetry_workout_types?: InputMaybe<IWorkout_Altimetry_Workout_Type_Bool_Exp>;
  workout_altimetry_workout_types_aggregate?: InputMaybe<IWorkout_Altimetry_Workout_Type_Aggregate_Bool_Exp>;
  workout_templates?: InputMaybe<IWorkout_Template_Bool_Exp>;
  workout_templates_aggregate?: InputMaybe<IWorkout_Template_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "workout_altimetry" */
export enum IWorkout_Altimetry_Constraint {
  /** unique or primary key constraint on columns "id" */
  WorkoutAltimetryPkey = 'workout_altimetry_pkey'
}

/** input type for incrementing numeric columns in table "workout_altimetry" */
export type IWorkout_Altimetry_Inc_Input = {
  coefficient?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "workout_altimetry" */
export type IWorkout_Altimetry_Insert_Input = {
  athlete_profile_altimetry_adjustments?: InputMaybe<IAthlete_Profile_Altimetry_Adjustment_Arr_Rel_Insert_Input>;
  athlete_workouts?: InputMaybe<IAthlete_Workout_Arr_Rel_Insert_Input>;
  coefficient?: InputMaybe<Scalars['numeric']>;
  icon?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  workout_altimetry_translations?: InputMaybe<IWorkout_Altimetry_Translation_Arr_Rel_Insert_Input>;
  workout_altimetry_workout_types?: InputMaybe<IWorkout_Altimetry_Workout_Type_Arr_Rel_Insert_Input>;
  workout_templates?: InputMaybe<IWorkout_Template_Arr_Rel_Insert_Input>;
};

/** input type for inserting object relation for remote table "workout_altimetry" */
export type IWorkout_Altimetry_Obj_Rel_Insert_Input = {
  data: IWorkout_Altimetry_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<IWorkout_Altimetry_On_Conflict>;
};

/** on_conflict condition type for table "workout_altimetry" */
export type IWorkout_Altimetry_On_Conflict = {
  constraint: IWorkout_Altimetry_Constraint;
  update_columns?: Array<IWorkout_Altimetry_Update_Column>;
  where?: InputMaybe<IWorkout_Altimetry_Bool_Exp>;
};

/** Ordering options when selecting data from "workout_altimetry". */
export type IWorkout_Altimetry_Order_By = {
  athlete_profile_altimetry_adjustments_aggregate?: InputMaybe<IAthlete_Profile_Altimetry_Adjustment_Aggregate_Order_By>;
  athlete_workouts_aggregate?: InputMaybe<IAthlete_Workout_Aggregate_Order_By>;
  coefficient?: InputMaybe<IOrder_By>;
  icon?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  name?: InputMaybe<IOrder_By>;
  workout_altimetry_translations_aggregate?: InputMaybe<IWorkout_Altimetry_Translation_Aggregate_Order_By>;
  workout_altimetry_workout_types_aggregate?: InputMaybe<IWorkout_Altimetry_Workout_Type_Aggregate_Order_By>;
  workout_templates_aggregate?: InputMaybe<IWorkout_Template_Aggregate_Order_By>;
};

/** primary key columns input for table: workout_altimetry */
export type IWorkout_Altimetry_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "workout_altimetry" */
export enum IWorkout_Altimetry_Select_Column {
  /** column name */
  Coefficient = 'coefficient',
  /** column name */
  Icon = 'icon',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "workout_altimetry" */
export type IWorkout_Altimetry_Set_Input = {
  coefficient?: InputMaybe<Scalars['numeric']>;
  icon?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "workout_altimetry" */
export type IWorkout_Altimetry_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IWorkout_Altimetry_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IWorkout_Altimetry_Stream_Cursor_Value_Input = {
  coefficient?: InputMaybe<Scalars['numeric']>;
  icon?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

export type IWorkout_Altimetry_Translation_Aggregate_Bool_Exp = {
  count?: InputMaybe<IWorkout_Altimetry_Translation_Aggregate_Bool_Exp_Count>;
};

export type IWorkout_Altimetry_Translation_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<IWorkout_Altimetry_Translation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IWorkout_Altimetry_Translation_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

/** order by aggregate values of table "workout_altimetry_translation" */
export type IWorkout_Altimetry_Translation_Aggregate_Order_By = {
  avg?: InputMaybe<IWorkout_Altimetry_Translation_Avg_Order_By>;
  count?: InputMaybe<IOrder_By>;
  max?: InputMaybe<IWorkout_Altimetry_Translation_Max_Order_By>;
  min?: InputMaybe<IWorkout_Altimetry_Translation_Min_Order_By>;
  stddev?: InputMaybe<IWorkout_Altimetry_Translation_Stddev_Order_By>;
  stddev_pop?: InputMaybe<IWorkout_Altimetry_Translation_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<IWorkout_Altimetry_Translation_Stddev_Samp_Order_By>;
  sum?: InputMaybe<IWorkout_Altimetry_Translation_Sum_Order_By>;
  var_pop?: InputMaybe<IWorkout_Altimetry_Translation_Var_Pop_Order_By>;
  var_samp?: InputMaybe<IWorkout_Altimetry_Translation_Var_Samp_Order_By>;
  variance?: InputMaybe<IWorkout_Altimetry_Translation_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "workout_altimetry_translation" */
export type IWorkout_Altimetry_Translation_Arr_Rel_Insert_Input = {
  data: Array<IWorkout_Altimetry_Translation_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<IWorkout_Altimetry_Translation_On_Conflict>;
};

/** order by avg() on columns of table "workout_altimetry_translation" */
export type IWorkout_Altimetry_Translation_Avg_Order_By = {
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
  workout_altimetry_id?: InputMaybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "workout_altimetry_translation". All fields are combined with a logical 'AND'. */
export type IWorkout_Altimetry_Translation_Bool_Exp = {
  _and?: InputMaybe<Array<IWorkout_Altimetry_Translation_Bool_Exp>>;
  _not?: InputMaybe<IWorkout_Altimetry_Translation_Bool_Exp>;
  _or?: InputMaybe<Array<IWorkout_Altimetry_Translation_Bool_Exp>>;
  created_at?: InputMaybe<ITimestamptz_Comparison_Exp>;
  description?: InputMaybe<IString_Comparison_Exp>;
  id?: InputMaybe<IInt_Comparison_Exp>;
  locale?: InputMaybe<ILocale_Bool_Exp>;
  locale_id?: InputMaybe<IInt_Comparison_Exp>;
  workout_altimetry?: InputMaybe<IWorkout_Altimetry_Bool_Exp>;
  workout_altimetry_id?: InputMaybe<IInt_Comparison_Exp>;
};

/** unique or primary key constraints on table "workout_altimetry_translation" */
export enum IWorkout_Altimetry_Translation_Constraint {
  /** unique or primary key constraint on columns "id" */
  WorkoutAltimetryTranslationPkey = 'workout_altimetry_translation_pkey'
}

/** input type for incrementing numeric columns in table "workout_altimetry_translation" */
export type IWorkout_Altimetry_Translation_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  locale_id?: InputMaybe<Scalars['Int']>;
  workout_altimetry_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "workout_altimetry_translation" */
export type IWorkout_Altimetry_Translation_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<ILocale_Obj_Rel_Insert_Input>;
  locale_id?: InputMaybe<Scalars['Int']>;
  workout_altimetry?: InputMaybe<IWorkout_Altimetry_Obj_Rel_Insert_Input>;
  workout_altimetry_id?: InputMaybe<Scalars['Int']>;
};

/** order by max() on columns of table "workout_altimetry_translation" */
export type IWorkout_Altimetry_Translation_Max_Order_By = {
  created_at?: InputMaybe<IOrder_By>;
  description?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
  workout_altimetry_id?: InputMaybe<IOrder_By>;
};

/** order by min() on columns of table "workout_altimetry_translation" */
export type IWorkout_Altimetry_Translation_Min_Order_By = {
  created_at?: InputMaybe<IOrder_By>;
  description?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
  workout_altimetry_id?: InputMaybe<IOrder_By>;
};

/** on_conflict condition type for table "workout_altimetry_translation" */
export type IWorkout_Altimetry_Translation_On_Conflict = {
  constraint: IWorkout_Altimetry_Translation_Constraint;
  update_columns?: Array<IWorkout_Altimetry_Translation_Update_Column>;
  where?: InputMaybe<IWorkout_Altimetry_Translation_Bool_Exp>;
};

/** Ordering options when selecting data from "workout_altimetry_translation". */
export type IWorkout_Altimetry_Translation_Order_By = {
  created_at?: InputMaybe<IOrder_By>;
  description?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  locale?: InputMaybe<ILocale_Order_By>;
  locale_id?: InputMaybe<IOrder_By>;
  workout_altimetry?: InputMaybe<IWorkout_Altimetry_Order_By>;
  workout_altimetry_id?: InputMaybe<IOrder_By>;
};

/** primary key columns input for table: workout_altimetry_translation */
export type IWorkout_Altimetry_Translation_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "workout_altimetry_translation" */
export enum IWorkout_Altimetry_Translation_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  LocaleId = 'locale_id',
  /** column name */
  WorkoutAltimetryId = 'workout_altimetry_id'
}

/** input type for updating data in table "workout_altimetry_translation" */
export type IWorkout_Altimetry_Translation_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  locale_id?: InputMaybe<Scalars['Int']>;
  workout_altimetry_id?: InputMaybe<Scalars['Int']>;
};

/** order by stddev() on columns of table "workout_altimetry_translation" */
export type IWorkout_Altimetry_Translation_Stddev_Order_By = {
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
  workout_altimetry_id?: InputMaybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "workout_altimetry_translation" */
export type IWorkout_Altimetry_Translation_Stddev_Pop_Order_By = {
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
  workout_altimetry_id?: InputMaybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "workout_altimetry_translation" */
export type IWorkout_Altimetry_Translation_Stddev_Samp_Order_By = {
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
  workout_altimetry_id?: InputMaybe<IOrder_By>;
};

/** Streaming cursor of the table "workout_altimetry_translation" */
export type IWorkout_Altimetry_Translation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IWorkout_Altimetry_Translation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IWorkout_Altimetry_Translation_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  locale_id?: InputMaybe<Scalars['Int']>;
  workout_altimetry_id?: InputMaybe<Scalars['Int']>;
};

/** order by sum() on columns of table "workout_altimetry_translation" */
export type IWorkout_Altimetry_Translation_Sum_Order_By = {
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
  workout_altimetry_id?: InputMaybe<IOrder_By>;
};

/** update columns of table "workout_altimetry_translation" */
export enum IWorkout_Altimetry_Translation_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  LocaleId = 'locale_id',
  /** column name */
  WorkoutAltimetryId = 'workout_altimetry_id'
}

export type IWorkout_Altimetry_Translation_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<IWorkout_Altimetry_Translation_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IWorkout_Altimetry_Translation_Set_Input>;
  /** filter the rows which have to be updated */
  where: IWorkout_Altimetry_Translation_Bool_Exp;
};

/** order by var_pop() on columns of table "workout_altimetry_translation" */
export type IWorkout_Altimetry_Translation_Var_Pop_Order_By = {
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
  workout_altimetry_id?: InputMaybe<IOrder_By>;
};

/** order by var_samp() on columns of table "workout_altimetry_translation" */
export type IWorkout_Altimetry_Translation_Var_Samp_Order_By = {
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
  workout_altimetry_id?: InputMaybe<IOrder_By>;
};

/** order by variance() on columns of table "workout_altimetry_translation" */
export type IWorkout_Altimetry_Translation_Variance_Order_By = {
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
  workout_altimetry_id?: InputMaybe<IOrder_By>;
};

/** update columns of table "workout_altimetry" */
export enum IWorkout_Altimetry_Update_Column {
  /** column name */
  Coefficient = 'coefficient',
  /** column name */
  Icon = 'icon',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type IWorkout_Altimetry_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<IWorkout_Altimetry_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IWorkout_Altimetry_Set_Input>;
  /** filter the rows which have to be updated */
  where: IWorkout_Altimetry_Bool_Exp;
};

export type IWorkout_Altimetry_Workout_Type_Aggregate_Bool_Exp = {
  count?: InputMaybe<IWorkout_Altimetry_Workout_Type_Aggregate_Bool_Exp_Count>;
};

export type IWorkout_Altimetry_Workout_Type_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<IWorkout_Altimetry_Workout_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IWorkout_Altimetry_Workout_Type_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

/** order by aggregate values of table "workout_altimetry_workout_type" */
export type IWorkout_Altimetry_Workout_Type_Aggregate_Order_By = {
  avg?: InputMaybe<IWorkout_Altimetry_Workout_Type_Avg_Order_By>;
  count?: InputMaybe<IOrder_By>;
  max?: InputMaybe<IWorkout_Altimetry_Workout_Type_Max_Order_By>;
  min?: InputMaybe<IWorkout_Altimetry_Workout_Type_Min_Order_By>;
  stddev?: InputMaybe<IWorkout_Altimetry_Workout_Type_Stddev_Order_By>;
  stddev_pop?: InputMaybe<IWorkout_Altimetry_Workout_Type_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<IWorkout_Altimetry_Workout_Type_Stddev_Samp_Order_By>;
  sum?: InputMaybe<IWorkout_Altimetry_Workout_Type_Sum_Order_By>;
  var_pop?: InputMaybe<IWorkout_Altimetry_Workout_Type_Var_Pop_Order_By>;
  var_samp?: InputMaybe<IWorkout_Altimetry_Workout_Type_Var_Samp_Order_By>;
  variance?: InputMaybe<IWorkout_Altimetry_Workout_Type_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "workout_altimetry_workout_type" */
export type IWorkout_Altimetry_Workout_Type_Arr_Rel_Insert_Input = {
  data: Array<IWorkout_Altimetry_Workout_Type_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<IWorkout_Altimetry_Workout_Type_On_Conflict>;
};

/** order by avg() on columns of table "workout_altimetry_workout_type" */
export type IWorkout_Altimetry_Workout_Type_Avg_Order_By = {
  id?: InputMaybe<IOrder_By>;
  workout_altimetry_id?: InputMaybe<IOrder_By>;
  workout_type_id?: InputMaybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "workout_altimetry_workout_type". All fields are combined with a logical 'AND'. */
export type IWorkout_Altimetry_Workout_Type_Bool_Exp = {
  _and?: InputMaybe<Array<IWorkout_Altimetry_Workout_Type_Bool_Exp>>;
  _not?: InputMaybe<IWorkout_Altimetry_Workout_Type_Bool_Exp>;
  _or?: InputMaybe<Array<IWorkout_Altimetry_Workout_Type_Bool_Exp>>;
  id?: InputMaybe<IInt_Comparison_Exp>;
  workout_altimetry?: InputMaybe<IWorkout_Altimetry_Bool_Exp>;
  workout_altimetry_id?: InputMaybe<IInt_Comparison_Exp>;
  workout_type?: InputMaybe<IWorkout_Type_Bool_Exp>;
  workout_type_id?: InputMaybe<IInt_Comparison_Exp>;
};

/** unique or primary key constraints on table "workout_altimetry_workout_type" */
export enum IWorkout_Altimetry_Workout_Type_Constraint {
  /** unique or primary key constraint on columns "workout_type_id", "workout_altimetry_id" */
  WorkoutAltimetryWorkoutTypeAltimetryIdTypeIdKey = 'workout_altimetry_workout_type_altimetry_id_type_id_key',
  /** unique or primary key constraint on columns "id" */
  WorkoutAltimetryWorkoutTypePkey = 'workout_altimetry_workout_type_pkey'
}

/** input type for incrementing numeric columns in table "workout_altimetry_workout_type" */
export type IWorkout_Altimetry_Workout_Type_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  workout_altimetry_id?: InputMaybe<Scalars['Int']>;
  workout_type_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "workout_altimetry_workout_type" */
export type IWorkout_Altimetry_Workout_Type_Insert_Input = {
  id?: InputMaybe<Scalars['Int']>;
  workout_altimetry?: InputMaybe<IWorkout_Altimetry_Obj_Rel_Insert_Input>;
  workout_altimetry_id?: InputMaybe<Scalars['Int']>;
  workout_type?: InputMaybe<IWorkout_Type_Obj_Rel_Insert_Input>;
  workout_type_id?: InputMaybe<Scalars['Int']>;
};

/** order by max() on columns of table "workout_altimetry_workout_type" */
export type IWorkout_Altimetry_Workout_Type_Max_Order_By = {
  id?: InputMaybe<IOrder_By>;
  workout_altimetry_id?: InputMaybe<IOrder_By>;
  workout_type_id?: InputMaybe<IOrder_By>;
};

/** order by min() on columns of table "workout_altimetry_workout_type" */
export type IWorkout_Altimetry_Workout_Type_Min_Order_By = {
  id?: InputMaybe<IOrder_By>;
  workout_altimetry_id?: InputMaybe<IOrder_By>;
  workout_type_id?: InputMaybe<IOrder_By>;
};

/** on_conflict condition type for table "workout_altimetry_workout_type" */
export type IWorkout_Altimetry_Workout_Type_On_Conflict = {
  constraint: IWorkout_Altimetry_Workout_Type_Constraint;
  update_columns?: Array<IWorkout_Altimetry_Workout_Type_Update_Column>;
  where?: InputMaybe<IWorkout_Altimetry_Workout_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "workout_altimetry_workout_type". */
export type IWorkout_Altimetry_Workout_Type_Order_By = {
  id?: InputMaybe<IOrder_By>;
  workout_altimetry?: InputMaybe<IWorkout_Altimetry_Order_By>;
  workout_altimetry_id?: InputMaybe<IOrder_By>;
  workout_type?: InputMaybe<IWorkout_Type_Order_By>;
  workout_type_id?: InputMaybe<IOrder_By>;
};

/** primary key columns input for table: workout_altimetry_workout_type */
export type IWorkout_Altimetry_Workout_Type_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "workout_altimetry_workout_type" */
export enum IWorkout_Altimetry_Workout_Type_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  WorkoutAltimetryId = 'workout_altimetry_id',
  /** column name */
  WorkoutTypeId = 'workout_type_id'
}

/** input type for updating data in table "workout_altimetry_workout_type" */
export type IWorkout_Altimetry_Workout_Type_Set_Input = {
  id?: InputMaybe<Scalars['Int']>;
  workout_altimetry_id?: InputMaybe<Scalars['Int']>;
  workout_type_id?: InputMaybe<Scalars['Int']>;
};

/** order by stddev() on columns of table "workout_altimetry_workout_type" */
export type IWorkout_Altimetry_Workout_Type_Stddev_Order_By = {
  id?: InputMaybe<IOrder_By>;
  workout_altimetry_id?: InputMaybe<IOrder_By>;
  workout_type_id?: InputMaybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "workout_altimetry_workout_type" */
export type IWorkout_Altimetry_Workout_Type_Stddev_Pop_Order_By = {
  id?: InputMaybe<IOrder_By>;
  workout_altimetry_id?: InputMaybe<IOrder_By>;
  workout_type_id?: InputMaybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "workout_altimetry_workout_type" */
export type IWorkout_Altimetry_Workout_Type_Stddev_Samp_Order_By = {
  id?: InputMaybe<IOrder_By>;
  workout_altimetry_id?: InputMaybe<IOrder_By>;
  workout_type_id?: InputMaybe<IOrder_By>;
};

/** Streaming cursor of the table "workout_altimetry_workout_type" */
export type IWorkout_Altimetry_Workout_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IWorkout_Altimetry_Workout_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IWorkout_Altimetry_Workout_Type_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']>;
  workout_altimetry_id?: InputMaybe<Scalars['Int']>;
  workout_type_id?: InputMaybe<Scalars['Int']>;
};

/** order by sum() on columns of table "workout_altimetry_workout_type" */
export type IWorkout_Altimetry_Workout_Type_Sum_Order_By = {
  id?: InputMaybe<IOrder_By>;
  workout_altimetry_id?: InputMaybe<IOrder_By>;
  workout_type_id?: InputMaybe<IOrder_By>;
};

/** update columns of table "workout_altimetry_workout_type" */
export enum IWorkout_Altimetry_Workout_Type_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  WorkoutAltimetryId = 'workout_altimetry_id',
  /** column name */
  WorkoutTypeId = 'workout_type_id'
}

export type IWorkout_Altimetry_Workout_Type_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<IWorkout_Altimetry_Workout_Type_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IWorkout_Altimetry_Workout_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: IWorkout_Altimetry_Workout_Type_Bool_Exp;
};

/** order by var_pop() on columns of table "workout_altimetry_workout_type" */
export type IWorkout_Altimetry_Workout_Type_Var_Pop_Order_By = {
  id?: InputMaybe<IOrder_By>;
  workout_altimetry_id?: InputMaybe<IOrder_By>;
  workout_type_id?: InputMaybe<IOrder_By>;
};

/** order by var_samp() on columns of table "workout_altimetry_workout_type" */
export type IWorkout_Altimetry_Workout_Type_Var_Samp_Order_By = {
  id?: InputMaybe<IOrder_By>;
  workout_altimetry_id?: InputMaybe<IOrder_By>;
  workout_type_id?: InputMaybe<IOrder_By>;
};

/** order by variance() on columns of table "workout_altimetry_workout_type" */
export type IWorkout_Altimetry_Workout_Type_Variance_Order_By = {
  id?: InputMaybe<IOrder_By>;
  workout_altimetry_id?: InputMaybe<IOrder_By>;
  workout_type_id?: InputMaybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "workout_duration". All fields are combined with a logical 'AND'. */
export type IWorkout_Duration_Bool_Exp = {
  _and?: InputMaybe<Array<IWorkout_Duration_Bool_Exp>>;
  _not?: InputMaybe<IWorkout_Duration_Bool_Exp>;
  _or?: InputMaybe<Array<IWorkout_Duration_Bool_Exp>>;
  coefficient?: InputMaybe<INumeric_Comparison_Exp>;
  duration?: InputMaybe<INumeric_Comparison_Exp>;
  id?: InputMaybe<IInt_Comparison_Exp>;
};

/** unique or primary key constraints on table "workout_duration" */
export enum IWorkout_Duration_Constraint {
  /** unique or primary key constraint on columns "id" */
  WorkoutDurationPkey = 'workout_duration_pkey'
}

/** input type for incrementing numeric columns in table "workout_duration" */
export type IWorkout_Duration_Inc_Input = {
  coefficient?: InputMaybe<Scalars['numeric']>;
  duration?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "workout_duration" */
export type IWorkout_Duration_Insert_Input = {
  coefficient?: InputMaybe<Scalars['numeric']>;
  duration?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** on_conflict condition type for table "workout_duration" */
export type IWorkout_Duration_On_Conflict = {
  constraint: IWorkout_Duration_Constraint;
  update_columns?: Array<IWorkout_Duration_Update_Column>;
  where?: InputMaybe<IWorkout_Duration_Bool_Exp>;
};

/** Ordering options when selecting data from "workout_duration". */
export type IWorkout_Duration_Order_By = {
  coefficient?: InputMaybe<IOrder_By>;
  duration?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
};

/** primary key columns input for table: workout_duration */
export type IWorkout_Duration_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "workout_duration" */
export enum IWorkout_Duration_Select_Column {
  /** column name */
  Coefficient = 'coefficient',
  /** column name */
  Duration = 'duration',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "workout_duration" */
export type IWorkout_Duration_Set_Input = {
  coefficient?: InputMaybe<Scalars['numeric']>;
  duration?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** Streaming cursor of the table "workout_duration" */
export type IWorkout_Duration_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IWorkout_Duration_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IWorkout_Duration_Stream_Cursor_Value_Input = {
  coefficient?: InputMaybe<Scalars['numeric']>;
  duration?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** update columns of table "workout_duration" */
export enum IWorkout_Duration_Update_Column {
  /** column name */
  Coefficient = 'coefficient',
  /** column name */
  Duration = 'duration',
  /** column name */
  Id = 'id'
}

export type IWorkout_Duration_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<IWorkout_Duration_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IWorkout_Duration_Set_Input>;
  /** filter the rows which have to be updated */
  where: IWorkout_Duration_Bool_Exp;
};

export type IWorkout_Section_Template_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<IWorkout_Section_Template_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<IWorkout_Section_Template_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<IWorkout_Section_Template_Aggregate_Bool_Exp_Count>;
};

export type IWorkout_Section_Template_Aggregate_Bool_Exp_Bool_And = {
  arguments: IWorkout_Section_Template_Select_Column_Workout_Section_Template_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IWorkout_Section_Template_Bool_Exp>;
  predicate: IBoolean_Comparison_Exp;
};

export type IWorkout_Section_Template_Aggregate_Bool_Exp_Bool_Or = {
  arguments: IWorkout_Section_Template_Select_Column_Workout_Section_Template_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IWorkout_Section_Template_Bool_Exp>;
  predicate: IBoolean_Comparison_Exp;
};

export type IWorkout_Section_Template_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<IWorkout_Section_Template_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IWorkout_Section_Template_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

/** order by aggregate values of table "workout_section_template" */
export type IWorkout_Section_Template_Aggregate_Order_By = {
  avg?: InputMaybe<IWorkout_Section_Template_Avg_Order_By>;
  count?: InputMaybe<IOrder_By>;
  max?: InputMaybe<IWorkout_Section_Template_Max_Order_By>;
  min?: InputMaybe<IWorkout_Section_Template_Min_Order_By>;
  stddev?: InputMaybe<IWorkout_Section_Template_Stddev_Order_By>;
  stddev_pop?: InputMaybe<IWorkout_Section_Template_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<IWorkout_Section_Template_Stddev_Samp_Order_By>;
  sum?: InputMaybe<IWorkout_Section_Template_Sum_Order_By>;
  var_pop?: InputMaybe<IWorkout_Section_Template_Var_Pop_Order_By>;
  var_samp?: InputMaybe<IWorkout_Section_Template_Var_Samp_Order_By>;
  variance?: InputMaybe<IWorkout_Section_Template_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "workout_section_template" */
export type IWorkout_Section_Template_Arr_Rel_Insert_Input = {
  data: Array<IWorkout_Section_Template_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<IWorkout_Section_Template_On_Conflict>;
};

/** order by avg() on columns of table "workout_section_template" */
export type IWorkout_Section_Template_Avg_Order_By = {
  average_heart_rate?: InputMaybe<IOrder_By>;
  duration?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  max_heart_rate?: InputMaybe<IOrder_By>;
  order?: InputMaybe<IOrder_By>;
  series_id?: InputMaybe<IOrder_By>;
  speed?: InputMaybe<IOrder_By>;
  workout_template_id?: InputMaybe<IOrder_By>;
  workout_zone_id?: InputMaybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "workout_section_template". All fields are combined with a logical 'AND'. */
export type IWorkout_Section_Template_Bool_Exp = {
  _and?: InputMaybe<Array<IWorkout_Section_Template_Bool_Exp>>;
  _not?: InputMaybe<IWorkout_Section_Template_Bool_Exp>;
  _or?: InputMaybe<Array<IWorkout_Section_Template_Bool_Exp>>;
  athlete_workout_sections?: InputMaybe<IAthlete_Workout_Section_Bool_Exp>;
  athlete_workout_sections_aggregate?: InputMaybe<IAthlete_Workout_Section_Aggregate_Bool_Exp>;
  average_heart_rate?: InputMaybe<INumeric_Comparison_Exp>;
  created_at?: InputMaybe<ITimestamptz_Comparison_Exp>;
  duration?: InputMaybe<INumeric_Comparison_Exp>;
  id?: InputMaybe<IInt_Comparison_Exp>;
  is_main?: InputMaybe<IBoolean_Comparison_Exp>;
  max_heart_rate?: InputMaybe<IInt_Comparison_Exp>;
  order?: InputMaybe<IInt_Comparison_Exp>;
  series_id?: InputMaybe<IInt_Comparison_Exp>;
  speed?: InputMaybe<INumeric_Comparison_Exp>;
  type?: InputMaybe<IString_Comparison_Exp>;
  updated_at?: InputMaybe<ITimestamptz_Comparison_Exp>;
  workout_template?: InputMaybe<IWorkout_Template_Bool_Exp>;
  workout_template_id?: InputMaybe<IInt_Comparison_Exp>;
  workout_zone?: InputMaybe<IWorkout_Zone_Bool_Exp>;
  workout_zone_id?: InputMaybe<IInt_Comparison_Exp>;
};

/** unique or primary key constraints on table "workout_section_template" */
export enum IWorkout_Section_Template_Constraint {
  /** unique or primary key constraint on columns "id" */
  WorkoutSectionTemplatePkey = 'workout_section_template_pkey'
}

/** input type for incrementing numeric columns in table "workout_section_template" */
export type IWorkout_Section_Template_Inc_Input = {
  average_heart_rate?: InputMaybe<Scalars['numeric']>;
  duration?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['Int']>;
  max_heart_rate?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  series_id?: InputMaybe<Scalars['Int']>;
  speed?: InputMaybe<Scalars['numeric']>;
  workout_template_id?: InputMaybe<Scalars['Int']>;
  workout_zone_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "workout_section_template" */
export type IWorkout_Section_Template_Insert_Input = {
  athlete_workout_sections?: InputMaybe<IAthlete_Workout_Section_Arr_Rel_Insert_Input>;
  average_heart_rate?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  duration?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['Int']>;
  is_main?: InputMaybe<Scalars['Boolean']>;
  max_heart_rate?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  series_id?: InputMaybe<Scalars['Int']>;
  speed?: InputMaybe<Scalars['numeric']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workout_template?: InputMaybe<IWorkout_Template_Obj_Rel_Insert_Input>;
  workout_template_id?: InputMaybe<Scalars['Int']>;
  workout_zone?: InputMaybe<IWorkout_Zone_Obj_Rel_Insert_Input>;
  workout_zone_id?: InputMaybe<Scalars['Int']>;
};

/** order by max() on columns of table "workout_section_template" */
export type IWorkout_Section_Template_Max_Order_By = {
  average_heart_rate?: InputMaybe<IOrder_By>;
  created_at?: InputMaybe<IOrder_By>;
  duration?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  max_heart_rate?: InputMaybe<IOrder_By>;
  order?: InputMaybe<IOrder_By>;
  series_id?: InputMaybe<IOrder_By>;
  speed?: InputMaybe<IOrder_By>;
  type?: InputMaybe<IOrder_By>;
  updated_at?: InputMaybe<IOrder_By>;
  workout_template_id?: InputMaybe<IOrder_By>;
  workout_zone_id?: InputMaybe<IOrder_By>;
};

/** order by min() on columns of table "workout_section_template" */
export type IWorkout_Section_Template_Min_Order_By = {
  average_heart_rate?: InputMaybe<IOrder_By>;
  created_at?: InputMaybe<IOrder_By>;
  duration?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  max_heart_rate?: InputMaybe<IOrder_By>;
  order?: InputMaybe<IOrder_By>;
  series_id?: InputMaybe<IOrder_By>;
  speed?: InputMaybe<IOrder_By>;
  type?: InputMaybe<IOrder_By>;
  updated_at?: InputMaybe<IOrder_By>;
  workout_template_id?: InputMaybe<IOrder_By>;
  workout_zone_id?: InputMaybe<IOrder_By>;
};

/** input type for inserting object relation for remote table "workout_section_template" */
export type IWorkout_Section_Template_Obj_Rel_Insert_Input = {
  data: IWorkout_Section_Template_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<IWorkout_Section_Template_On_Conflict>;
};

/** on_conflict condition type for table "workout_section_template" */
export type IWorkout_Section_Template_On_Conflict = {
  constraint: IWorkout_Section_Template_Constraint;
  update_columns?: Array<IWorkout_Section_Template_Update_Column>;
  where?: InputMaybe<IWorkout_Section_Template_Bool_Exp>;
};

/** Ordering options when selecting data from "workout_section_template". */
export type IWorkout_Section_Template_Order_By = {
  athlete_workout_sections_aggregate?: InputMaybe<IAthlete_Workout_Section_Aggregate_Order_By>;
  average_heart_rate?: InputMaybe<IOrder_By>;
  created_at?: InputMaybe<IOrder_By>;
  duration?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  is_main?: InputMaybe<IOrder_By>;
  max_heart_rate?: InputMaybe<IOrder_By>;
  order?: InputMaybe<IOrder_By>;
  series_id?: InputMaybe<IOrder_By>;
  speed?: InputMaybe<IOrder_By>;
  type?: InputMaybe<IOrder_By>;
  updated_at?: InputMaybe<IOrder_By>;
  workout_template?: InputMaybe<IWorkout_Template_Order_By>;
  workout_template_id?: InputMaybe<IOrder_By>;
  workout_zone?: InputMaybe<IWorkout_Zone_Order_By>;
  workout_zone_id?: InputMaybe<IOrder_By>;
};

/** primary key columns input for table: workout_section_template */
export type IWorkout_Section_Template_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "workout_section_template" */
export enum IWorkout_Section_Template_Select_Column {
  /** column name */
  AverageHeartRate = 'average_heart_rate',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Duration = 'duration',
  /** column name */
  Id = 'id',
  /** column name */
  IsMain = 'is_main',
  /** column name */
  MaxHeartRate = 'max_heart_rate',
  /** column name */
  Order = 'order',
  /** column name */
  SeriesId = 'series_id',
  /** column name */
  Speed = 'speed',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WorkoutTemplateId = 'workout_template_id',
  /** column name */
  WorkoutZoneId = 'workout_zone_id'
}

/** select "workout_section_template_aggregate_bool_exp_bool_and_arguments_columns" columns of table "workout_section_template" */
export enum IWorkout_Section_Template_Select_Column_Workout_Section_Template_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsMain = 'is_main'
}

/** select "workout_section_template_aggregate_bool_exp_bool_or_arguments_columns" columns of table "workout_section_template" */
export enum IWorkout_Section_Template_Select_Column_Workout_Section_Template_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsMain = 'is_main'
}

/** input type for updating data in table "workout_section_template" */
export type IWorkout_Section_Template_Set_Input = {
  average_heart_rate?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  duration?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['Int']>;
  is_main?: InputMaybe<Scalars['Boolean']>;
  max_heart_rate?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  series_id?: InputMaybe<Scalars['Int']>;
  speed?: InputMaybe<Scalars['numeric']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workout_template_id?: InputMaybe<Scalars['Int']>;
  workout_zone_id?: InputMaybe<Scalars['Int']>;
};

/** order by stddev() on columns of table "workout_section_template" */
export type IWorkout_Section_Template_Stddev_Order_By = {
  average_heart_rate?: InputMaybe<IOrder_By>;
  duration?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  max_heart_rate?: InputMaybe<IOrder_By>;
  order?: InputMaybe<IOrder_By>;
  series_id?: InputMaybe<IOrder_By>;
  speed?: InputMaybe<IOrder_By>;
  workout_template_id?: InputMaybe<IOrder_By>;
  workout_zone_id?: InputMaybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "workout_section_template" */
export type IWorkout_Section_Template_Stddev_Pop_Order_By = {
  average_heart_rate?: InputMaybe<IOrder_By>;
  duration?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  max_heart_rate?: InputMaybe<IOrder_By>;
  order?: InputMaybe<IOrder_By>;
  series_id?: InputMaybe<IOrder_By>;
  speed?: InputMaybe<IOrder_By>;
  workout_template_id?: InputMaybe<IOrder_By>;
  workout_zone_id?: InputMaybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "workout_section_template" */
export type IWorkout_Section_Template_Stddev_Samp_Order_By = {
  average_heart_rate?: InputMaybe<IOrder_By>;
  duration?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  max_heart_rate?: InputMaybe<IOrder_By>;
  order?: InputMaybe<IOrder_By>;
  series_id?: InputMaybe<IOrder_By>;
  speed?: InputMaybe<IOrder_By>;
  workout_template_id?: InputMaybe<IOrder_By>;
  workout_zone_id?: InputMaybe<IOrder_By>;
};

/** Streaming cursor of the table "workout_section_template" */
export type IWorkout_Section_Template_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IWorkout_Section_Template_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IWorkout_Section_Template_Stream_Cursor_Value_Input = {
  average_heart_rate?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  duration?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['Int']>;
  is_main?: InputMaybe<Scalars['Boolean']>;
  max_heart_rate?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  series_id?: InputMaybe<Scalars['Int']>;
  speed?: InputMaybe<Scalars['numeric']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  workout_template_id?: InputMaybe<Scalars['Int']>;
  workout_zone_id?: InputMaybe<Scalars['Int']>;
};

/** order by sum() on columns of table "workout_section_template" */
export type IWorkout_Section_Template_Sum_Order_By = {
  average_heart_rate?: InputMaybe<IOrder_By>;
  duration?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  max_heart_rate?: InputMaybe<IOrder_By>;
  order?: InputMaybe<IOrder_By>;
  series_id?: InputMaybe<IOrder_By>;
  speed?: InputMaybe<IOrder_By>;
  workout_template_id?: InputMaybe<IOrder_By>;
  workout_zone_id?: InputMaybe<IOrder_By>;
};

/** update columns of table "workout_section_template" */
export enum IWorkout_Section_Template_Update_Column {
  /** column name */
  AverageHeartRate = 'average_heart_rate',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Duration = 'duration',
  /** column name */
  Id = 'id',
  /** column name */
  IsMain = 'is_main',
  /** column name */
  MaxHeartRate = 'max_heart_rate',
  /** column name */
  Order = 'order',
  /** column name */
  SeriesId = 'series_id',
  /** column name */
  Speed = 'speed',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WorkoutTemplateId = 'workout_template_id',
  /** column name */
  WorkoutZoneId = 'workout_zone_id'
}

export type IWorkout_Section_Template_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<IWorkout_Section_Template_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IWorkout_Section_Template_Set_Input>;
  /** filter the rows which have to be updated */
  where: IWorkout_Section_Template_Bool_Exp;
};

/** order by var_pop() on columns of table "workout_section_template" */
export type IWorkout_Section_Template_Var_Pop_Order_By = {
  average_heart_rate?: InputMaybe<IOrder_By>;
  duration?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  max_heart_rate?: InputMaybe<IOrder_By>;
  order?: InputMaybe<IOrder_By>;
  series_id?: InputMaybe<IOrder_By>;
  speed?: InputMaybe<IOrder_By>;
  workout_template_id?: InputMaybe<IOrder_By>;
  workout_zone_id?: InputMaybe<IOrder_By>;
};

/** order by var_samp() on columns of table "workout_section_template" */
export type IWorkout_Section_Template_Var_Samp_Order_By = {
  average_heart_rate?: InputMaybe<IOrder_By>;
  duration?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  max_heart_rate?: InputMaybe<IOrder_By>;
  order?: InputMaybe<IOrder_By>;
  series_id?: InputMaybe<IOrder_By>;
  speed?: InputMaybe<IOrder_By>;
  workout_template_id?: InputMaybe<IOrder_By>;
  workout_zone_id?: InputMaybe<IOrder_By>;
};

/** order by variance() on columns of table "workout_section_template" */
export type IWorkout_Section_Template_Variance_Order_By = {
  average_heart_rate?: InputMaybe<IOrder_By>;
  duration?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  max_heart_rate?: InputMaybe<IOrder_By>;
  order?: InputMaybe<IOrder_By>;
  series_id?: InputMaybe<IOrder_By>;
  speed?: InputMaybe<IOrder_By>;
  workout_template_id?: InputMaybe<IOrder_By>;
  workout_zone_id?: InputMaybe<IOrder_By>;
};

export type IWorkout_Template_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<IWorkout_Template_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<IWorkout_Template_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<IWorkout_Template_Aggregate_Bool_Exp_Count>;
};

export type IWorkout_Template_Aggregate_Bool_Exp_Bool_And = {
  arguments: IWorkout_Template_Select_Column_Workout_Template_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IWorkout_Template_Bool_Exp>;
  predicate: IBoolean_Comparison_Exp;
};

export type IWorkout_Template_Aggregate_Bool_Exp_Bool_Or = {
  arguments: IWorkout_Template_Select_Column_Workout_Template_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IWorkout_Template_Bool_Exp>;
  predicate: IBoolean_Comparison_Exp;
};

export type IWorkout_Template_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<IWorkout_Template_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IWorkout_Template_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

/** order by aggregate values of table "workout_template" */
export type IWorkout_Template_Aggregate_Order_By = {
  avg?: InputMaybe<IWorkout_Template_Avg_Order_By>;
  count?: InputMaybe<IOrder_By>;
  max?: InputMaybe<IWorkout_Template_Max_Order_By>;
  min?: InputMaybe<IWorkout_Template_Min_Order_By>;
  stddev?: InputMaybe<IWorkout_Template_Stddev_Order_By>;
  stddev_pop?: InputMaybe<IWorkout_Template_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<IWorkout_Template_Stddev_Samp_Order_By>;
  sum?: InputMaybe<IWorkout_Template_Sum_Order_By>;
  var_pop?: InputMaybe<IWorkout_Template_Var_Pop_Order_By>;
  var_samp?: InputMaybe<IWorkout_Template_Var_Samp_Order_By>;
  variance?: InputMaybe<IWorkout_Template_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "workout_template" */
export type IWorkout_Template_Arr_Rel_Insert_Input = {
  data: Array<IWorkout_Template_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<IWorkout_Template_On_Conflict>;
};

/** order by avg() on columns of table "workout_template" */
export type IWorkout_Template_Avg_Order_By = {
  cumulative_elevation?: InputMaybe<IOrder_By>;
  day?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  negative_elevation?: InputMaybe<IOrder_By>;
  positive_elevation?: InputMaybe<IOrder_By>;
  series_repetitions?: InputMaybe<IOrder_By>;
  stretching_circuit_id?: InputMaybe<IOrder_By>;
  stretching_circuit_repetitions?: InputMaybe<IOrder_By>;
  week_template_id?: InputMaybe<IOrder_By>;
  weight_circuit_id?: InputMaybe<IOrder_By>;
  weight_circuit_repetitions?: InputMaybe<IOrder_By>;
  workout_altimetry_id?: InputMaybe<IOrder_By>;
  workout_terrain_id?: InputMaybe<IOrder_By>;
  workout_type_id?: InputMaybe<IOrder_By>;
  workout_zone_id?: InputMaybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "workout_template". All fields are combined with a logical 'AND'. */
export type IWorkout_Template_Bool_Exp = {
  _and?: InputMaybe<Array<IWorkout_Template_Bool_Exp>>;
  _not?: InputMaybe<IWorkout_Template_Bool_Exp>;
  _or?: InputMaybe<Array<IWorkout_Template_Bool_Exp>>;
  athlete_workouts?: InputMaybe<IAthlete_Workout_Bool_Exp>;
  athlete_workouts_aggregate?: InputMaybe<IAthlete_Workout_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<ITimestamptz_Comparison_Exp>;
  cumulative_elevation?: InputMaybe<INumeric_Comparison_Exp>;
  day?: InputMaybe<IInt_Comparison_Exp>;
  id?: InputMaybe<IInt_Comparison_Exp>;
  is_primary?: InputMaybe<IBoolean_Comparison_Exp>;
  negative_elevation?: InputMaybe<INumeric_Comparison_Exp>;
  positive_elevation?: InputMaybe<INumeric_Comparison_Exp>;
  series?: InputMaybe<IString_Comparison_Exp>;
  series_repetitions?: InputMaybe<IInt_Comparison_Exp>;
  stretching_circuit?: InputMaybe<ICircuit_Bool_Exp>;
  stretching_circuit_id?: InputMaybe<IInt_Comparison_Exp>;
  stretching_circuit_repetitions?: InputMaybe<IInt_Comparison_Exp>;
  type?: InputMaybe<IString_Comparison_Exp>;
  updated_at?: InputMaybe<ITimestamptz_Comparison_Exp>;
  week_template?: InputMaybe<IWeek_Template_Bool_Exp>;
  week_template_id?: InputMaybe<IInt_Comparison_Exp>;
  weight_circuit?: InputMaybe<ICircuit_Bool_Exp>;
  weight_circuit_id?: InputMaybe<IInt_Comparison_Exp>;
  weight_circuit_repetitions?: InputMaybe<IInt_Comparison_Exp>;
  workout_altimetry?: InputMaybe<IWorkout_Altimetry_Bool_Exp>;
  workout_altimetry_id?: InputMaybe<IInt_Comparison_Exp>;
  workout_section_templates?: InputMaybe<IWorkout_Section_Template_Bool_Exp>;
  workout_section_templates_aggregate?: InputMaybe<IWorkout_Section_Template_Aggregate_Bool_Exp>;
  workout_terrain?: InputMaybe<IWorkout_Terrain_Bool_Exp>;
  workout_terrain_id?: InputMaybe<IInt_Comparison_Exp>;
  workout_type?: InputMaybe<IWorkout_Type_Bool_Exp>;
  workout_type_id?: InputMaybe<IInt_Comparison_Exp>;
  workout_zone?: InputMaybe<IWorkout_Zone_Bool_Exp>;
  workout_zone_id?: InputMaybe<IInt_Comparison_Exp>;
};

/** unique or primary key constraints on table "workout_template" */
export enum IWorkout_Template_Constraint {
  /** unique or primary key constraint on columns "day", "week_template_id", "is_primary" */
  UniqueWorkoutTemplatePerWeekKey = 'unique_workout_template_per_week_key',
  /** unique or primary key constraint on columns "id" */
  WorkoutTemplatePkey = 'workout_template_pkey'
}

/** input type for incrementing numeric columns in table "workout_template" */
export type IWorkout_Template_Inc_Input = {
  cumulative_elevation?: InputMaybe<Scalars['numeric']>;
  day?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  negative_elevation?: InputMaybe<Scalars['numeric']>;
  positive_elevation?: InputMaybe<Scalars['numeric']>;
  series_repetitions?: InputMaybe<Scalars['Int']>;
  stretching_circuit_id?: InputMaybe<Scalars['Int']>;
  stretching_circuit_repetitions?: InputMaybe<Scalars['Int']>;
  week_template_id?: InputMaybe<Scalars['Int']>;
  weight_circuit_id?: InputMaybe<Scalars['Int']>;
  weight_circuit_repetitions?: InputMaybe<Scalars['Int']>;
  workout_altimetry_id?: InputMaybe<Scalars['Int']>;
  workout_terrain_id?: InputMaybe<Scalars['Int']>;
  workout_type_id?: InputMaybe<Scalars['Int']>;
  workout_zone_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "workout_template" */
export type IWorkout_Template_Insert_Input = {
  athlete_workouts?: InputMaybe<IAthlete_Workout_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  cumulative_elevation?: InputMaybe<Scalars['numeric']>;
  day?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_primary?: InputMaybe<Scalars['Boolean']>;
  negative_elevation?: InputMaybe<Scalars['numeric']>;
  positive_elevation?: InputMaybe<Scalars['numeric']>;
  series?: InputMaybe<Scalars['String']>;
  series_repetitions?: InputMaybe<Scalars['Int']>;
  stretching_circuit?: InputMaybe<ICircuit_Obj_Rel_Insert_Input>;
  stretching_circuit_id?: InputMaybe<Scalars['Int']>;
  stretching_circuit_repetitions?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  week_template?: InputMaybe<IWeek_Template_Obj_Rel_Insert_Input>;
  week_template_id?: InputMaybe<Scalars['Int']>;
  weight_circuit?: InputMaybe<ICircuit_Obj_Rel_Insert_Input>;
  weight_circuit_id?: InputMaybe<Scalars['Int']>;
  weight_circuit_repetitions?: InputMaybe<Scalars['Int']>;
  workout_altimetry?: InputMaybe<IWorkout_Altimetry_Obj_Rel_Insert_Input>;
  workout_altimetry_id?: InputMaybe<Scalars['Int']>;
  workout_section_templates?: InputMaybe<IWorkout_Section_Template_Arr_Rel_Insert_Input>;
  workout_terrain?: InputMaybe<IWorkout_Terrain_Obj_Rel_Insert_Input>;
  workout_terrain_id?: InputMaybe<Scalars['Int']>;
  workout_type?: InputMaybe<IWorkout_Type_Obj_Rel_Insert_Input>;
  workout_type_id?: InputMaybe<Scalars['Int']>;
  workout_zone?: InputMaybe<IWorkout_Zone_Obj_Rel_Insert_Input>;
  workout_zone_id?: InputMaybe<Scalars['Int']>;
};

/** order by max() on columns of table "workout_template" */
export type IWorkout_Template_Max_Order_By = {
  created_at?: InputMaybe<IOrder_By>;
  cumulative_elevation?: InputMaybe<IOrder_By>;
  day?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  negative_elevation?: InputMaybe<IOrder_By>;
  positive_elevation?: InputMaybe<IOrder_By>;
  series?: InputMaybe<IOrder_By>;
  series_repetitions?: InputMaybe<IOrder_By>;
  stretching_circuit_id?: InputMaybe<IOrder_By>;
  stretching_circuit_repetitions?: InputMaybe<IOrder_By>;
  type?: InputMaybe<IOrder_By>;
  updated_at?: InputMaybe<IOrder_By>;
  week_template_id?: InputMaybe<IOrder_By>;
  weight_circuit_id?: InputMaybe<IOrder_By>;
  weight_circuit_repetitions?: InputMaybe<IOrder_By>;
  workout_altimetry_id?: InputMaybe<IOrder_By>;
  workout_terrain_id?: InputMaybe<IOrder_By>;
  workout_type_id?: InputMaybe<IOrder_By>;
  workout_zone_id?: InputMaybe<IOrder_By>;
};

/** order by min() on columns of table "workout_template" */
export type IWorkout_Template_Min_Order_By = {
  created_at?: InputMaybe<IOrder_By>;
  cumulative_elevation?: InputMaybe<IOrder_By>;
  day?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  negative_elevation?: InputMaybe<IOrder_By>;
  positive_elevation?: InputMaybe<IOrder_By>;
  series?: InputMaybe<IOrder_By>;
  series_repetitions?: InputMaybe<IOrder_By>;
  stretching_circuit_id?: InputMaybe<IOrder_By>;
  stretching_circuit_repetitions?: InputMaybe<IOrder_By>;
  type?: InputMaybe<IOrder_By>;
  updated_at?: InputMaybe<IOrder_By>;
  week_template_id?: InputMaybe<IOrder_By>;
  weight_circuit_id?: InputMaybe<IOrder_By>;
  weight_circuit_repetitions?: InputMaybe<IOrder_By>;
  workout_altimetry_id?: InputMaybe<IOrder_By>;
  workout_terrain_id?: InputMaybe<IOrder_By>;
  workout_type_id?: InputMaybe<IOrder_By>;
  workout_zone_id?: InputMaybe<IOrder_By>;
};

/** input type for inserting object relation for remote table "workout_template" */
export type IWorkout_Template_Obj_Rel_Insert_Input = {
  data: IWorkout_Template_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<IWorkout_Template_On_Conflict>;
};

/** on_conflict condition type for table "workout_template" */
export type IWorkout_Template_On_Conflict = {
  constraint: IWorkout_Template_Constraint;
  update_columns?: Array<IWorkout_Template_Update_Column>;
  where?: InputMaybe<IWorkout_Template_Bool_Exp>;
};

/** Ordering options when selecting data from "workout_template". */
export type IWorkout_Template_Order_By = {
  athlete_workouts_aggregate?: InputMaybe<IAthlete_Workout_Aggregate_Order_By>;
  created_at?: InputMaybe<IOrder_By>;
  cumulative_elevation?: InputMaybe<IOrder_By>;
  day?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  is_primary?: InputMaybe<IOrder_By>;
  negative_elevation?: InputMaybe<IOrder_By>;
  positive_elevation?: InputMaybe<IOrder_By>;
  series?: InputMaybe<IOrder_By>;
  series_repetitions?: InputMaybe<IOrder_By>;
  stretching_circuit?: InputMaybe<ICircuit_Order_By>;
  stretching_circuit_id?: InputMaybe<IOrder_By>;
  stretching_circuit_repetitions?: InputMaybe<IOrder_By>;
  type?: InputMaybe<IOrder_By>;
  updated_at?: InputMaybe<IOrder_By>;
  week_template?: InputMaybe<IWeek_Template_Order_By>;
  week_template_id?: InputMaybe<IOrder_By>;
  weight_circuit?: InputMaybe<ICircuit_Order_By>;
  weight_circuit_id?: InputMaybe<IOrder_By>;
  weight_circuit_repetitions?: InputMaybe<IOrder_By>;
  workout_altimetry?: InputMaybe<IWorkout_Altimetry_Order_By>;
  workout_altimetry_id?: InputMaybe<IOrder_By>;
  workout_section_templates_aggregate?: InputMaybe<IWorkout_Section_Template_Aggregate_Order_By>;
  workout_terrain?: InputMaybe<IWorkout_Terrain_Order_By>;
  workout_terrain_id?: InputMaybe<IOrder_By>;
  workout_type?: InputMaybe<IWorkout_Type_Order_By>;
  workout_type_id?: InputMaybe<IOrder_By>;
  workout_zone?: InputMaybe<IWorkout_Zone_Order_By>;
  workout_zone_id?: InputMaybe<IOrder_By>;
};

/** primary key columns input for table: workout_template */
export type IWorkout_Template_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "workout_template" */
export enum IWorkout_Template_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CumulativeElevation = 'cumulative_elevation',
  /** column name */
  Day = 'day',
  /** column name */
  Id = 'id',
  /** column name */
  IsPrimary = 'is_primary',
  /** column name */
  NegativeElevation = 'negative_elevation',
  /** column name */
  PositiveElevation = 'positive_elevation',
  /** column name */
  Series = 'series',
  /** column name */
  SeriesRepetitions = 'series_repetitions',
  /** column name */
  StretchingCircuitId = 'stretching_circuit_id',
  /** column name */
  StretchingCircuitRepetitions = 'stretching_circuit_repetitions',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WeekTemplateId = 'week_template_id',
  /** column name */
  WeightCircuitId = 'weight_circuit_id',
  /** column name */
  WeightCircuitRepetitions = 'weight_circuit_repetitions',
  /** column name */
  WorkoutAltimetryId = 'workout_altimetry_id',
  /** column name */
  WorkoutTerrainId = 'workout_terrain_id',
  /** column name */
  WorkoutTypeId = 'workout_type_id',
  /** column name */
  WorkoutZoneId = 'workout_zone_id'
}

/** select "workout_template_aggregate_bool_exp_bool_and_arguments_columns" columns of table "workout_template" */
export enum IWorkout_Template_Select_Column_Workout_Template_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsPrimary = 'is_primary'
}

/** select "workout_template_aggregate_bool_exp_bool_or_arguments_columns" columns of table "workout_template" */
export enum IWorkout_Template_Select_Column_Workout_Template_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsPrimary = 'is_primary'
}

/** input type for updating data in table "workout_template" */
export type IWorkout_Template_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  cumulative_elevation?: InputMaybe<Scalars['numeric']>;
  day?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_primary?: InputMaybe<Scalars['Boolean']>;
  negative_elevation?: InputMaybe<Scalars['numeric']>;
  positive_elevation?: InputMaybe<Scalars['numeric']>;
  series?: InputMaybe<Scalars['String']>;
  series_repetitions?: InputMaybe<Scalars['Int']>;
  stretching_circuit_id?: InputMaybe<Scalars['Int']>;
  stretching_circuit_repetitions?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  week_template_id?: InputMaybe<Scalars['Int']>;
  weight_circuit_id?: InputMaybe<Scalars['Int']>;
  weight_circuit_repetitions?: InputMaybe<Scalars['Int']>;
  workout_altimetry_id?: InputMaybe<Scalars['Int']>;
  workout_terrain_id?: InputMaybe<Scalars['Int']>;
  workout_type_id?: InputMaybe<Scalars['Int']>;
  workout_zone_id?: InputMaybe<Scalars['Int']>;
};

/** order by stddev() on columns of table "workout_template" */
export type IWorkout_Template_Stddev_Order_By = {
  cumulative_elevation?: InputMaybe<IOrder_By>;
  day?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  negative_elevation?: InputMaybe<IOrder_By>;
  positive_elevation?: InputMaybe<IOrder_By>;
  series_repetitions?: InputMaybe<IOrder_By>;
  stretching_circuit_id?: InputMaybe<IOrder_By>;
  stretching_circuit_repetitions?: InputMaybe<IOrder_By>;
  week_template_id?: InputMaybe<IOrder_By>;
  weight_circuit_id?: InputMaybe<IOrder_By>;
  weight_circuit_repetitions?: InputMaybe<IOrder_By>;
  workout_altimetry_id?: InputMaybe<IOrder_By>;
  workout_terrain_id?: InputMaybe<IOrder_By>;
  workout_type_id?: InputMaybe<IOrder_By>;
  workout_zone_id?: InputMaybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "workout_template" */
export type IWorkout_Template_Stddev_Pop_Order_By = {
  cumulative_elevation?: InputMaybe<IOrder_By>;
  day?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  negative_elevation?: InputMaybe<IOrder_By>;
  positive_elevation?: InputMaybe<IOrder_By>;
  series_repetitions?: InputMaybe<IOrder_By>;
  stretching_circuit_id?: InputMaybe<IOrder_By>;
  stretching_circuit_repetitions?: InputMaybe<IOrder_By>;
  week_template_id?: InputMaybe<IOrder_By>;
  weight_circuit_id?: InputMaybe<IOrder_By>;
  weight_circuit_repetitions?: InputMaybe<IOrder_By>;
  workout_altimetry_id?: InputMaybe<IOrder_By>;
  workout_terrain_id?: InputMaybe<IOrder_By>;
  workout_type_id?: InputMaybe<IOrder_By>;
  workout_zone_id?: InputMaybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "workout_template" */
export type IWorkout_Template_Stddev_Samp_Order_By = {
  cumulative_elevation?: InputMaybe<IOrder_By>;
  day?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  negative_elevation?: InputMaybe<IOrder_By>;
  positive_elevation?: InputMaybe<IOrder_By>;
  series_repetitions?: InputMaybe<IOrder_By>;
  stretching_circuit_id?: InputMaybe<IOrder_By>;
  stretching_circuit_repetitions?: InputMaybe<IOrder_By>;
  week_template_id?: InputMaybe<IOrder_By>;
  weight_circuit_id?: InputMaybe<IOrder_By>;
  weight_circuit_repetitions?: InputMaybe<IOrder_By>;
  workout_altimetry_id?: InputMaybe<IOrder_By>;
  workout_terrain_id?: InputMaybe<IOrder_By>;
  workout_type_id?: InputMaybe<IOrder_By>;
  workout_zone_id?: InputMaybe<IOrder_By>;
};

/** Streaming cursor of the table "workout_template" */
export type IWorkout_Template_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IWorkout_Template_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IWorkout_Template_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  cumulative_elevation?: InputMaybe<Scalars['numeric']>;
  day?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  is_primary?: InputMaybe<Scalars['Boolean']>;
  negative_elevation?: InputMaybe<Scalars['numeric']>;
  positive_elevation?: InputMaybe<Scalars['numeric']>;
  series?: InputMaybe<Scalars['String']>;
  series_repetitions?: InputMaybe<Scalars['Int']>;
  stretching_circuit_id?: InputMaybe<Scalars['Int']>;
  stretching_circuit_repetitions?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  week_template_id?: InputMaybe<Scalars['Int']>;
  weight_circuit_id?: InputMaybe<Scalars['Int']>;
  weight_circuit_repetitions?: InputMaybe<Scalars['Int']>;
  workout_altimetry_id?: InputMaybe<Scalars['Int']>;
  workout_terrain_id?: InputMaybe<Scalars['Int']>;
  workout_type_id?: InputMaybe<Scalars['Int']>;
  workout_zone_id?: InputMaybe<Scalars['Int']>;
};

/** order by sum() on columns of table "workout_template" */
export type IWorkout_Template_Sum_Order_By = {
  cumulative_elevation?: InputMaybe<IOrder_By>;
  day?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  negative_elevation?: InputMaybe<IOrder_By>;
  positive_elevation?: InputMaybe<IOrder_By>;
  series_repetitions?: InputMaybe<IOrder_By>;
  stretching_circuit_id?: InputMaybe<IOrder_By>;
  stretching_circuit_repetitions?: InputMaybe<IOrder_By>;
  week_template_id?: InputMaybe<IOrder_By>;
  weight_circuit_id?: InputMaybe<IOrder_By>;
  weight_circuit_repetitions?: InputMaybe<IOrder_By>;
  workout_altimetry_id?: InputMaybe<IOrder_By>;
  workout_terrain_id?: InputMaybe<IOrder_By>;
  workout_type_id?: InputMaybe<IOrder_By>;
  workout_zone_id?: InputMaybe<IOrder_By>;
};

/** update columns of table "workout_template" */
export enum IWorkout_Template_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CumulativeElevation = 'cumulative_elevation',
  /** column name */
  Day = 'day',
  /** column name */
  Id = 'id',
  /** column name */
  IsPrimary = 'is_primary',
  /** column name */
  NegativeElevation = 'negative_elevation',
  /** column name */
  PositiveElevation = 'positive_elevation',
  /** column name */
  Series = 'series',
  /** column name */
  SeriesRepetitions = 'series_repetitions',
  /** column name */
  StretchingCircuitId = 'stretching_circuit_id',
  /** column name */
  StretchingCircuitRepetitions = 'stretching_circuit_repetitions',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WeekTemplateId = 'week_template_id',
  /** column name */
  WeightCircuitId = 'weight_circuit_id',
  /** column name */
  WeightCircuitRepetitions = 'weight_circuit_repetitions',
  /** column name */
  WorkoutAltimetryId = 'workout_altimetry_id',
  /** column name */
  WorkoutTerrainId = 'workout_terrain_id',
  /** column name */
  WorkoutTypeId = 'workout_type_id',
  /** column name */
  WorkoutZoneId = 'workout_zone_id'
}

export type IWorkout_Template_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<IWorkout_Template_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IWorkout_Template_Set_Input>;
  /** filter the rows which have to be updated */
  where: IWorkout_Template_Bool_Exp;
};

/** order by var_pop() on columns of table "workout_template" */
export type IWorkout_Template_Var_Pop_Order_By = {
  cumulative_elevation?: InputMaybe<IOrder_By>;
  day?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  negative_elevation?: InputMaybe<IOrder_By>;
  positive_elevation?: InputMaybe<IOrder_By>;
  series_repetitions?: InputMaybe<IOrder_By>;
  stretching_circuit_id?: InputMaybe<IOrder_By>;
  stretching_circuit_repetitions?: InputMaybe<IOrder_By>;
  week_template_id?: InputMaybe<IOrder_By>;
  weight_circuit_id?: InputMaybe<IOrder_By>;
  weight_circuit_repetitions?: InputMaybe<IOrder_By>;
  workout_altimetry_id?: InputMaybe<IOrder_By>;
  workout_terrain_id?: InputMaybe<IOrder_By>;
  workout_type_id?: InputMaybe<IOrder_By>;
  workout_zone_id?: InputMaybe<IOrder_By>;
};

/** order by var_samp() on columns of table "workout_template" */
export type IWorkout_Template_Var_Samp_Order_By = {
  cumulative_elevation?: InputMaybe<IOrder_By>;
  day?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  negative_elevation?: InputMaybe<IOrder_By>;
  positive_elevation?: InputMaybe<IOrder_By>;
  series_repetitions?: InputMaybe<IOrder_By>;
  stretching_circuit_id?: InputMaybe<IOrder_By>;
  stretching_circuit_repetitions?: InputMaybe<IOrder_By>;
  week_template_id?: InputMaybe<IOrder_By>;
  weight_circuit_id?: InputMaybe<IOrder_By>;
  weight_circuit_repetitions?: InputMaybe<IOrder_By>;
  workout_altimetry_id?: InputMaybe<IOrder_By>;
  workout_terrain_id?: InputMaybe<IOrder_By>;
  workout_type_id?: InputMaybe<IOrder_By>;
  workout_zone_id?: InputMaybe<IOrder_By>;
};

/** order by variance() on columns of table "workout_template" */
export type IWorkout_Template_Variance_Order_By = {
  cumulative_elevation?: InputMaybe<IOrder_By>;
  day?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  negative_elevation?: InputMaybe<IOrder_By>;
  positive_elevation?: InputMaybe<IOrder_By>;
  series_repetitions?: InputMaybe<IOrder_By>;
  stretching_circuit_id?: InputMaybe<IOrder_By>;
  stretching_circuit_repetitions?: InputMaybe<IOrder_By>;
  week_template_id?: InputMaybe<IOrder_By>;
  weight_circuit_id?: InputMaybe<IOrder_By>;
  weight_circuit_repetitions?: InputMaybe<IOrder_By>;
  workout_altimetry_id?: InputMaybe<IOrder_By>;
  workout_terrain_id?: InputMaybe<IOrder_By>;
  workout_type_id?: InputMaybe<IOrder_By>;
  workout_zone_id?: InputMaybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "workout_terrain". All fields are combined with a logical 'AND'. */
export type IWorkout_Terrain_Bool_Exp = {
  _and?: InputMaybe<Array<IWorkout_Terrain_Bool_Exp>>;
  _not?: InputMaybe<IWorkout_Terrain_Bool_Exp>;
  _or?: InputMaybe<Array<IWorkout_Terrain_Bool_Exp>>;
  athlete_workouts?: InputMaybe<IAthlete_Workout_Bool_Exp>;
  athlete_workouts_aggregate?: InputMaybe<IAthlete_Workout_Aggregate_Bool_Exp>;
  coefficient?: InputMaybe<INumeric_Comparison_Exp>;
  icon?: InputMaybe<IString_Comparison_Exp>;
  id?: InputMaybe<IInt_Comparison_Exp>;
  workout_templates?: InputMaybe<IWorkout_Template_Bool_Exp>;
  workout_templates_aggregate?: InputMaybe<IWorkout_Template_Aggregate_Bool_Exp>;
  workout_terrain_translations?: InputMaybe<IWorkout_Terrain_Translation_Bool_Exp>;
  workout_terrain_translations_aggregate?: InputMaybe<IWorkout_Terrain_Translation_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "workout_terrain" */
export enum IWorkout_Terrain_Constraint {
  /** unique or primary key constraint on columns "id" */
  WorkoutTerrainsPkey = 'workout_terrains_pkey'
}

/** input type for incrementing numeric columns in table "workout_terrain" */
export type IWorkout_Terrain_Inc_Input = {
  coefficient?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "workout_terrain" */
export type IWorkout_Terrain_Insert_Input = {
  athlete_workouts?: InputMaybe<IAthlete_Workout_Arr_Rel_Insert_Input>;
  coefficient?: InputMaybe<Scalars['numeric']>;
  icon?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  workout_templates?: InputMaybe<IWorkout_Template_Arr_Rel_Insert_Input>;
  workout_terrain_translations?: InputMaybe<IWorkout_Terrain_Translation_Arr_Rel_Insert_Input>;
};

/** input type for inserting object relation for remote table "workout_terrain" */
export type IWorkout_Terrain_Obj_Rel_Insert_Input = {
  data: IWorkout_Terrain_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<IWorkout_Terrain_On_Conflict>;
};

/** on_conflict condition type for table "workout_terrain" */
export type IWorkout_Terrain_On_Conflict = {
  constraint: IWorkout_Terrain_Constraint;
  update_columns?: Array<IWorkout_Terrain_Update_Column>;
  where?: InputMaybe<IWorkout_Terrain_Bool_Exp>;
};

/** Ordering options when selecting data from "workout_terrain". */
export type IWorkout_Terrain_Order_By = {
  athlete_workouts_aggregate?: InputMaybe<IAthlete_Workout_Aggregate_Order_By>;
  coefficient?: InputMaybe<IOrder_By>;
  icon?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  workout_templates_aggregate?: InputMaybe<IWorkout_Template_Aggregate_Order_By>;
  workout_terrain_translations_aggregate?: InputMaybe<IWorkout_Terrain_Translation_Aggregate_Order_By>;
};

/** primary key columns input for table: workout_terrain */
export type IWorkout_Terrain_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "workout_terrain" */
export enum IWorkout_Terrain_Select_Column {
  /** column name */
  Coefficient = 'coefficient',
  /** column name */
  Icon = 'icon',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "workout_terrain" */
export type IWorkout_Terrain_Set_Input = {
  coefficient?: InputMaybe<Scalars['numeric']>;
  icon?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** Streaming cursor of the table "workout_terrain" */
export type IWorkout_Terrain_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IWorkout_Terrain_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IWorkout_Terrain_Stream_Cursor_Value_Input = {
  coefficient?: InputMaybe<Scalars['numeric']>;
  icon?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
};

export type IWorkout_Terrain_Translation_Aggregate_Bool_Exp = {
  count?: InputMaybe<IWorkout_Terrain_Translation_Aggregate_Bool_Exp_Count>;
};

export type IWorkout_Terrain_Translation_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<IWorkout_Terrain_Translation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IWorkout_Terrain_Translation_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

/** order by aggregate values of table "workout_terrain_translation" */
export type IWorkout_Terrain_Translation_Aggregate_Order_By = {
  avg?: InputMaybe<IWorkout_Terrain_Translation_Avg_Order_By>;
  count?: InputMaybe<IOrder_By>;
  max?: InputMaybe<IWorkout_Terrain_Translation_Max_Order_By>;
  min?: InputMaybe<IWorkout_Terrain_Translation_Min_Order_By>;
  stddev?: InputMaybe<IWorkout_Terrain_Translation_Stddev_Order_By>;
  stddev_pop?: InputMaybe<IWorkout_Terrain_Translation_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<IWorkout_Terrain_Translation_Stddev_Samp_Order_By>;
  sum?: InputMaybe<IWorkout_Terrain_Translation_Sum_Order_By>;
  var_pop?: InputMaybe<IWorkout_Terrain_Translation_Var_Pop_Order_By>;
  var_samp?: InputMaybe<IWorkout_Terrain_Translation_Var_Samp_Order_By>;
  variance?: InputMaybe<IWorkout_Terrain_Translation_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "workout_terrain_translation" */
export type IWorkout_Terrain_Translation_Arr_Rel_Insert_Input = {
  data: Array<IWorkout_Terrain_Translation_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<IWorkout_Terrain_Translation_On_Conflict>;
};

/** order by avg() on columns of table "workout_terrain_translation" */
export type IWorkout_Terrain_Translation_Avg_Order_By = {
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
  workout_terrain_id?: InputMaybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "workout_terrain_translation". All fields are combined with a logical 'AND'. */
export type IWorkout_Terrain_Translation_Bool_Exp = {
  _and?: InputMaybe<Array<IWorkout_Terrain_Translation_Bool_Exp>>;
  _not?: InputMaybe<IWorkout_Terrain_Translation_Bool_Exp>;
  _or?: InputMaybe<Array<IWorkout_Terrain_Translation_Bool_Exp>>;
  created_at?: InputMaybe<ITimestamptz_Comparison_Exp>;
  description?: InputMaybe<IString_Comparison_Exp>;
  id?: InputMaybe<IInt_Comparison_Exp>;
  locale?: InputMaybe<ILocale_Bool_Exp>;
  locale_id?: InputMaybe<IInt_Comparison_Exp>;
  name?: InputMaybe<IString_Comparison_Exp>;
  workout_terrain?: InputMaybe<IWorkout_Terrain_Bool_Exp>;
  workout_terrain_id?: InputMaybe<IInt_Comparison_Exp>;
};

/** unique or primary key constraints on table "workout_terrain_translation" */
export enum IWorkout_Terrain_Translation_Constraint {
  /** unique or primary key constraint on columns "id" */
  WorkoutTerrainTranslationPkey = 'workout_terrain_translation_pkey'
}

/** input type for incrementing numeric columns in table "workout_terrain_translation" */
export type IWorkout_Terrain_Translation_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  locale_id?: InputMaybe<Scalars['Int']>;
  workout_terrain_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "workout_terrain_translation" */
export type IWorkout_Terrain_Translation_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<ILocale_Obj_Rel_Insert_Input>;
  locale_id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  workout_terrain?: InputMaybe<IWorkout_Terrain_Obj_Rel_Insert_Input>;
  workout_terrain_id?: InputMaybe<Scalars['Int']>;
};

/** order by max() on columns of table "workout_terrain_translation" */
export type IWorkout_Terrain_Translation_Max_Order_By = {
  created_at?: InputMaybe<IOrder_By>;
  description?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
  name?: InputMaybe<IOrder_By>;
  workout_terrain_id?: InputMaybe<IOrder_By>;
};

/** order by min() on columns of table "workout_terrain_translation" */
export type IWorkout_Terrain_Translation_Min_Order_By = {
  created_at?: InputMaybe<IOrder_By>;
  description?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
  name?: InputMaybe<IOrder_By>;
  workout_terrain_id?: InputMaybe<IOrder_By>;
};

/** on_conflict condition type for table "workout_terrain_translation" */
export type IWorkout_Terrain_Translation_On_Conflict = {
  constraint: IWorkout_Terrain_Translation_Constraint;
  update_columns?: Array<IWorkout_Terrain_Translation_Update_Column>;
  where?: InputMaybe<IWorkout_Terrain_Translation_Bool_Exp>;
};

/** Ordering options when selecting data from "workout_terrain_translation". */
export type IWorkout_Terrain_Translation_Order_By = {
  created_at?: InputMaybe<IOrder_By>;
  description?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  locale?: InputMaybe<ILocale_Order_By>;
  locale_id?: InputMaybe<IOrder_By>;
  name?: InputMaybe<IOrder_By>;
  workout_terrain?: InputMaybe<IWorkout_Terrain_Order_By>;
  workout_terrain_id?: InputMaybe<IOrder_By>;
};

/** primary key columns input for table: workout_terrain_translation */
export type IWorkout_Terrain_Translation_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "workout_terrain_translation" */
export enum IWorkout_Terrain_Translation_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  LocaleId = 'locale_id',
  /** column name */
  Name = 'name',
  /** column name */
  WorkoutTerrainId = 'workout_terrain_id'
}

/** input type for updating data in table "workout_terrain_translation" */
export type IWorkout_Terrain_Translation_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  locale_id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  workout_terrain_id?: InputMaybe<Scalars['Int']>;
};

/** order by stddev() on columns of table "workout_terrain_translation" */
export type IWorkout_Terrain_Translation_Stddev_Order_By = {
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
  workout_terrain_id?: InputMaybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "workout_terrain_translation" */
export type IWorkout_Terrain_Translation_Stddev_Pop_Order_By = {
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
  workout_terrain_id?: InputMaybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "workout_terrain_translation" */
export type IWorkout_Terrain_Translation_Stddev_Samp_Order_By = {
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
  workout_terrain_id?: InputMaybe<IOrder_By>;
};

/** Streaming cursor of the table "workout_terrain_translation" */
export type IWorkout_Terrain_Translation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IWorkout_Terrain_Translation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IWorkout_Terrain_Translation_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  locale_id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  workout_terrain_id?: InputMaybe<Scalars['Int']>;
};

/** order by sum() on columns of table "workout_terrain_translation" */
export type IWorkout_Terrain_Translation_Sum_Order_By = {
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
  workout_terrain_id?: InputMaybe<IOrder_By>;
};

/** update columns of table "workout_terrain_translation" */
export enum IWorkout_Terrain_Translation_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  LocaleId = 'locale_id',
  /** column name */
  Name = 'name',
  /** column name */
  WorkoutTerrainId = 'workout_terrain_id'
}

export type IWorkout_Terrain_Translation_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<IWorkout_Terrain_Translation_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IWorkout_Terrain_Translation_Set_Input>;
  /** filter the rows which have to be updated */
  where: IWorkout_Terrain_Translation_Bool_Exp;
};

/** order by var_pop() on columns of table "workout_terrain_translation" */
export type IWorkout_Terrain_Translation_Var_Pop_Order_By = {
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
  workout_terrain_id?: InputMaybe<IOrder_By>;
};

/** order by var_samp() on columns of table "workout_terrain_translation" */
export type IWorkout_Terrain_Translation_Var_Samp_Order_By = {
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
  workout_terrain_id?: InputMaybe<IOrder_By>;
};

/** order by variance() on columns of table "workout_terrain_translation" */
export type IWorkout_Terrain_Translation_Variance_Order_By = {
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
  workout_terrain_id?: InputMaybe<IOrder_By>;
};

/** update columns of table "workout_terrain" */
export enum IWorkout_Terrain_Update_Column {
  /** column name */
  Coefficient = 'coefficient',
  /** column name */
  Icon = 'icon',
  /** column name */
  Id = 'id'
}

export type IWorkout_Terrain_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<IWorkout_Terrain_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IWorkout_Terrain_Set_Input>;
  /** filter the rows which have to be updated */
  where: IWorkout_Terrain_Bool_Exp;
};

/** Boolean expression to filter rows from the table "workout_type". All fields are combined with a logical 'AND'. */
export type IWorkout_Type_Bool_Exp = {
  _and?: InputMaybe<Array<IWorkout_Type_Bool_Exp>>;
  _not?: InputMaybe<IWorkout_Type_Bool_Exp>;
  _or?: InputMaybe<Array<IWorkout_Type_Bool_Exp>>;
  athlete_speeds?: InputMaybe<IAthlete_Speed_Bool_Exp>;
  athlete_speeds_aggregate?: InputMaybe<IAthlete_Speed_Aggregate_Bool_Exp>;
  athlete_workouts?: InputMaybe<IAthlete_Workout_Bool_Exp>;
  athlete_workouts_aggregate?: InputMaybe<IAthlete_Workout_Aggregate_Bool_Exp>;
  avatar?: InputMaybe<IString_Comparison_Exp>;
  created_at?: InputMaybe<ITimestamptz_Comparison_Exp>;
  id?: InputMaybe<IInt_Comparison_Exp>;
  workout_altimetry_workout_types?: InputMaybe<IWorkout_Altimetry_Workout_Type_Bool_Exp>;
  workout_altimetry_workout_types_aggregate?: InputMaybe<IWorkout_Altimetry_Workout_Type_Aggregate_Bool_Exp>;
  workout_templates?: InputMaybe<IWorkout_Template_Bool_Exp>;
  workout_templates_aggregate?: InputMaybe<IWorkout_Template_Aggregate_Bool_Exp>;
  workout_type_translations?: InputMaybe<IWorkout_Type_Translation_Bool_Exp>;
  workout_type_translations_aggregate?: InputMaybe<IWorkout_Type_Translation_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "workout_type" */
export enum IWorkout_Type_Constraint {
  /** unique or primary key constraint on columns "id" */
  WorkoutTypePkey = 'workout_type_pkey'
}

/** input type for incrementing numeric columns in table "workout_type" */
export type IWorkout_Type_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "workout_type" */
export type IWorkout_Type_Insert_Input = {
  athlete_speeds?: InputMaybe<IAthlete_Speed_Arr_Rel_Insert_Input>;
  athlete_workouts?: InputMaybe<IAthlete_Workout_Arr_Rel_Insert_Input>;
  avatar?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  workout_altimetry_workout_types?: InputMaybe<IWorkout_Altimetry_Workout_Type_Arr_Rel_Insert_Input>;
  workout_templates?: InputMaybe<IWorkout_Template_Arr_Rel_Insert_Input>;
  workout_type_translations?: InputMaybe<IWorkout_Type_Translation_Arr_Rel_Insert_Input>;
};

/** input type for inserting object relation for remote table "workout_type" */
export type IWorkout_Type_Obj_Rel_Insert_Input = {
  data: IWorkout_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<IWorkout_Type_On_Conflict>;
};

/** on_conflict condition type for table "workout_type" */
export type IWorkout_Type_On_Conflict = {
  constraint: IWorkout_Type_Constraint;
  update_columns?: Array<IWorkout_Type_Update_Column>;
  where?: InputMaybe<IWorkout_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "workout_type". */
export type IWorkout_Type_Order_By = {
  athlete_speeds_aggregate?: InputMaybe<IAthlete_Speed_Aggregate_Order_By>;
  athlete_workouts_aggregate?: InputMaybe<IAthlete_Workout_Aggregate_Order_By>;
  avatar?: InputMaybe<IOrder_By>;
  created_at?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  workout_altimetry_workout_types_aggregate?: InputMaybe<IWorkout_Altimetry_Workout_Type_Aggregate_Order_By>;
  workout_templates_aggregate?: InputMaybe<IWorkout_Template_Aggregate_Order_By>;
  workout_type_translations_aggregate?: InputMaybe<IWorkout_Type_Translation_Aggregate_Order_By>;
};

/** primary key columns input for table: workout_type */
export type IWorkout_Type_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "workout_type" */
export enum IWorkout_Type_Select_Column {
  /** column name */
  Avatar = 'avatar',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "workout_type" */
export type IWorkout_Type_Set_Input = {
  avatar?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** Streaming cursor of the table "workout_type" */
export type IWorkout_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IWorkout_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IWorkout_Type_Stream_Cursor_Value_Input = {
  avatar?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
};

export type IWorkout_Type_Translation_Aggregate_Bool_Exp = {
  count?: InputMaybe<IWorkout_Type_Translation_Aggregate_Bool_Exp_Count>;
};

export type IWorkout_Type_Translation_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<IWorkout_Type_Translation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<IWorkout_Type_Translation_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

/** order by aggregate values of table "workout_type_translation" */
export type IWorkout_Type_Translation_Aggregate_Order_By = {
  avg?: InputMaybe<IWorkout_Type_Translation_Avg_Order_By>;
  count?: InputMaybe<IOrder_By>;
  max?: InputMaybe<IWorkout_Type_Translation_Max_Order_By>;
  min?: InputMaybe<IWorkout_Type_Translation_Min_Order_By>;
  stddev?: InputMaybe<IWorkout_Type_Translation_Stddev_Order_By>;
  stddev_pop?: InputMaybe<IWorkout_Type_Translation_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<IWorkout_Type_Translation_Stddev_Samp_Order_By>;
  sum?: InputMaybe<IWorkout_Type_Translation_Sum_Order_By>;
  var_pop?: InputMaybe<IWorkout_Type_Translation_Var_Pop_Order_By>;
  var_samp?: InputMaybe<IWorkout_Type_Translation_Var_Samp_Order_By>;
  variance?: InputMaybe<IWorkout_Type_Translation_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "workout_type_translation" */
export type IWorkout_Type_Translation_Arr_Rel_Insert_Input = {
  data: Array<IWorkout_Type_Translation_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<IWorkout_Type_Translation_On_Conflict>;
};

/** order by avg() on columns of table "workout_type_translation" */
export type IWorkout_Type_Translation_Avg_Order_By = {
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
  workout_type_id?: InputMaybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "workout_type_translation". All fields are combined with a logical 'AND'. */
export type IWorkout_Type_Translation_Bool_Exp = {
  _and?: InputMaybe<Array<IWorkout_Type_Translation_Bool_Exp>>;
  _not?: InputMaybe<IWorkout_Type_Translation_Bool_Exp>;
  _or?: InputMaybe<Array<IWorkout_Type_Translation_Bool_Exp>>;
  created_at?: InputMaybe<ITimestamptz_Comparison_Exp>;
  id?: InputMaybe<IInt_Comparison_Exp>;
  locale?: InputMaybe<ILocale_Bool_Exp>;
  locale_id?: InputMaybe<IInt_Comparison_Exp>;
  name?: InputMaybe<IString_Comparison_Exp>;
  workout_type?: InputMaybe<IWorkout_Type_Bool_Exp>;
  workout_type_id?: InputMaybe<IInt_Comparison_Exp>;
};

/** unique or primary key constraints on table "workout_type_translation" */
export enum IWorkout_Type_Translation_Constraint {
  /** unique or primary key constraint on columns "id" */
  WorkoutTypeTranslationPkey = 'workout_type_translation_pkey'
}

/** input type for incrementing numeric columns in table "workout_type_translation" */
export type IWorkout_Type_Translation_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  locale_id?: InputMaybe<Scalars['Int']>;
  workout_type_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "workout_type_translation" */
export type IWorkout_Type_Translation_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<ILocale_Obj_Rel_Insert_Input>;
  locale_id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  workout_type?: InputMaybe<IWorkout_Type_Obj_Rel_Insert_Input>;
  workout_type_id?: InputMaybe<Scalars['Int']>;
};

/** order by max() on columns of table "workout_type_translation" */
export type IWorkout_Type_Translation_Max_Order_By = {
  created_at?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
  name?: InputMaybe<IOrder_By>;
  workout_type_id?: InputMaybe<IOrder_By>;
};

/** order by min() on columns of table "workout_type_translation" */
export type IWorkout_Type_Translation_Min_Order_By = {
  created_at?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
  name?: InputMaybe<IOrder_By>;
  workout_type_id?: InputMaybe<IOrder_By>;
};

/** on_conflict condition type for table "workout_type_translation" */
export type IWorkout_Type_Translation_On_Conflict = {
  constraint: IWorkout_Type_Translation_Constraint;
  update_columns?: Array<IWorkout_Type_Translation_Update_Column>;
  where?: InputMaybe<IWorkout_Type_Translation_Bool_Exp>;
};

/** Ordering options when selecting data from "workout_type_translation". */
export type IWorkout_Type_Translation_Order_By = {
  created_at?: InputMaybe<IOrder_By>;
  id?: InputMaybe<IOrder_By>;
  locale?: InputMaybe<ILocale_Order_By>;
  locale_id?: InputMaybe<IOrder_By>;
  name?: InputMaybe<IOrder_By>;
  workout_type?: InputMaybe<IWorkout_Type_Order_By>;
  workout_type_id?: InputMaybe<IOrder_By>;
};

/** primary key columns input for table: workout_type_translation */
export type IWorkout_Type_Translation_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "workout_type_translation" */
export enum IWorkout_Type_Translation_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LocaleId = 'locale_id',
  /** column name */
  Name = 'name',
  /** column name */
  WorkoutTypeId = 'workout_type_id'
}

/** input type for updating data in table "workout_type_translation" */
export type IWorkout_Type_Translation_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  locale_id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  workout_type_id?: InputMaybe<Scalars['Int']>;
};

/** order by stddev() on columns of table "workout_type_translation" */
export type IWorkout_Type_Translation_Stddev_Order_By = {
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
  workout_type_id?: InputMaybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "workout_type_translation" */
export type IWorkout_Type_Translation_Stddev_Pop_Order_By = {
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
  workout_type_id?: InputMaybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "workout_type_translation" */
export type IWorkout_Type_Translation_Stddev_Samp_Order_By = {
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
  workout_type_id?: InputMaybe<IOrder_By>;
};

/** Streaming cursor of the table "workout_type_translation" */
export type IWorkout_Type_Translation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IWorkout_Type_Translation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IWorkout_Type_Translation_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  locale_id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  workout_type_id?: InputMaybe<Scalars['Int']>;
};

/** order by sum() on columns of table "workout_type_translation" */
export type IWorkout_Type_Translation_Sum_Order_By = {
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
  workout_type_id?: InputMaybe<IOrder_By>;
};

/** update columns of table "workout_type_translation" */
export enum IWorkout_Type_Translation_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LocaleId = 'locale_id',
  /** column name */
  Name = 'name',
  /** column name */
  WorkoutTypeId = 'workout_type_id'
}

export type IWorkout_Type_Translation_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<IWorkout_Type_Translation_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IWorkout_Type_Translation_Set_Input>;
  /** filter the rows which have to be updated */
  where: IWorkout_Type_Translation_Bool_Exp;
};

/** order by var_pop() on columns of table "workout_type_translation" */
export type IWorkout_Type_Translation_Var_Pop_Order_By = {
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
  workout_type_id?: InputMaybe<IOrder_By>;
};

/** order by var_samp() on columns of table "workout_type_translation" */
export type IWorkout_Type_Translation_Var_Samp_Order_By = {
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
  workout_type_id?: InputMaybe<IOrder_By>;
};

/** order by variance() on columns of table "workout_type_translation" */
export type IWorkout_Type_Translation_Variance_Order_By = {
  id?: InputMaybe<IOrder_By>;
  locale_id?: InputMaybe<IOrder_By>;
  workout_type_id?: InputMaybe<IOrder_By>;
};

/** update columns of table "workout_type" */
export enum IWorkout_Type_Update_Column {
  /** column name */
  Avatar = 'avatar',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id'
}

export type IWorkout_Type_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<IWorkout_Type_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IWorkout_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: IWorkout_Type_Bool_Exp;
};

/** Boolean expression to filter rows from the table "workout_zone". All fields are combined with a logical 'AND'. */
export type IWorkout_Zone_Bool_Exp = {
  _and?: InputMaybe<Array<IWorkout_Zone_Bool_Exp>>;
  _not?: InputMaybe<IWorkout_Zone_Bool_Exp>;
  _or?: InputMaybe<Array<IWorkout_Zone_Bool_Exp>>;
  athlete_workout_sections?: InputMaybe<IAthlete_Workout_Section_Bool_Exp>;
  athlete_workout_sections_aggregate?: InputMaybe<IAthlete_Workout_Section_Aggregate_Bool_Exp>;
  athlete_workouts?: InputMaybe<IAthlete_Workout_Bool_Exp>;
  athlete_workouts_aggregate?: InputMaybe<IAthlete_Workout_Aggregate_Bool_Exp>;
  id?: InputMaybe<IInt_Comparison_Exp>;
  interval_end?: InputMaybe<INumeric_Comparison_Exp>;
  interval_start?: InputMaybe<INumeric_Comparison_Exp>;
  name?: InputMaybe<IString_Comparison_Exp>;
  workout_section_templates?: InputMaybe<IWorkout_Section_Template_Bool_Exp>;
  workout_section_templates_aggregate?: InputMaybe<IWorkout_Section_Template_Aggregate_Bool_Exp>;
  workout_templates?: InputMaybe<IWorkout_Template_Bool_Exp>;
  workout_templates_aggregate?: InputMaybe<IWorkout_Template_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "workout_zone" */
export enum IWorkout_Zone_Constraint {
  /** unique or primary key constraint on columns "id" */
  WorkoutZonePkey = 'workout_zone_pkey'
}

/** input type for incrementing numeric columns in table "workout_zone" */
export type IWorkout_Zone_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  interval_end?: InputMaybe<Scalars['numeric']>;
  interval_start?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "workout_zone" */
export type IWorkout_Zone_Insert_Input = {
  athlete_workout_sections?: InputMaybe<IAthlete_Workout_Section_Arr_Rel_Insert_Input>;
  athlete_workouts?: InputMaybe<IAthlete_Workout_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  interval_end?: InputMaybe<Scalars['numeric']>;
  interval_start?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  workout_section_templates?: InputMaybe<IWorkout_Section_Template_Arr_Rel_Insert_Input>;
  workout_templates?: InputMaybe<IWorkout_Template_Arr_Rel_Insert_Input>;
};

/** input type for inserting object relation for remote table "workout_zone" */
export type IWorkout_Zone_Obj_Rel_Insert_Input = {
  data: IWorkout_Zone_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<IWorkout_Zone_On_Conflict>;
};

/** on_conflict condition type for table "workout_zone" */
export type IWorkout_Zone_On_Conflict = {
  constraint: IWorkout_Zone_Constraint;
  update_columns?: Array<IWorkout_Zone_Update_Column>;
  where?: InputMaybe<IWorkout_Zone_Bool_Exp>;
};

/** Ordering options when selecting data from "workout_zone". */
export type IWorkout_Zone_Order_By = {
  athlete_workout_sections_aggregate?: InputMaybe<IAthlete_Workout_Section_Aggregate_Order_By>;
  athlete_workouts_aggregate?: InputMaybe<IAthlete_Workout_Aggregate_Order_By>;
  id?: InputMaybe<IOrder_By>;
  interval_end?: InputMaybe<IOrder_By>;
  interval_start?: InputMaybe<IOrder_By>;
  name?: InputMaybe<IOrder_By>;
  workout_section_templates_aggregate?: InputMaybe<IWorkout_Section_Template_Aggregate_Order_By>;
  workout_templates_aggregate?: InputMaybe<IWorkout_Template_Aggregate_Order_By>;
};

/** primary key columns input for table: workout_zone */
export type IWorkout_Zone_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "workout_zone" */
export enum IWorkout_Zone_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IntervalEnd = 'interval_end',
  /** column name */
  IntervalStart = 'interval_start',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "workout_zone" */
export type IWorkout_Zone_Set_Input = {
  id?: InputMaybe<Scalars['Int']>;
  interval_end?: InputMaybe<Scalars['numeric']>;
  interval_start?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "workout_zone" */
export type IWorkout_Zone_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IWorkout_Zone_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IWorkout_Zone_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']>;
  interval_end?: InputMaybe<Scalars['numeric']>;
  interval_start?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "workout_zone" */
export enum IWorkout_Zone_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IntervalEnd = 'interval_end',
  /** column name */
  IntervalStart = 'interval_start',
  /** column name */
  Name = 'name'
}

export type IWorkout_Zone_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<IWorkout_Zone_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IWorkout_Zone_Set_Input>;
  /** filter the rows which have to be updated */
  where: IWorkout_Zone_Bool_Exp;
};

export type IAssignWeeksToAthleteBlockMutationVariables = Exact<{
  athlete_id: Scalars['Int'];
  athlete_block_id?: InputMaybe<Scalars['Int']>;
  start_date: Scalars['String'];
  week_template_ids: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type IAssignWeeksToAthleteBlockMutation = { __typename?: 'mutation_root', assign_weeks_to_athlete: boolean };

export type IChangeAthleteBlockWeeksOrderMutationVariables = Exact<{
  new_order: Scalars['Int'];
  old_order: Scalars['Int'];
  athlete_block_id: Scalars['Int'];
}>;


export type IChangeAthleteBlockWeeksOrderMutation = { __typename?: 'mutation_root', reorder_athlete_werks?: boolean | undefined };

export type IChangeBlockWeeksOrderMutationVariables = Exact<{
  new_order: Scalars['Int'];
  old_order: Scalars['Int'];
  block_template_id: Scalars['Int'];
}>;


export type IChangeBlockWeeksOrderMutation = { __typename?: 'mutation_root', SetNewOrderTemp?: { __typename?: 'week_template_mutation_response', affected_rows: number } | undefined, UpdateGrater?: { __typename?: 'week_template_mutation_response', affected_rows: number } | undefined, UpdateLesser?: { __typename?: 'week_template_mutation_response', affected_rows: number } | undefined, SetNewOrder?: { __typename?: 'week_template_mutation_response', affected_rows: number } | undefined };

export type IChangeCircuitExerciseOrderMutationVariables = Exact<{
  newOrder: Scalars['Int'];
  oldOrder: Scalars['Int'];
  circuit_id: Scalars['Int'];
}>;


export type IChangeCircuitExerciseOrderMutation = { __typename?: 'mutation_root', SetNewOrderTemp?: { __typename?: 'circuit_exercise_mutation_response', affected_rows: number } | undefined, UpdateGrater?: { __typename?: 'circuit_exercise_mutation_response', affected_rows: number } | undefined, UpdateLesser?: { __typename?: 'circuit_exercise_mutation_response', affected_rows: number } | undefined, SetNewOrder?: { __typename?: 'circuit_exercise_mutation_response', affected_rows: number } | undefined };

export type ICopyWeekTemplatesToAnotherBlockTemplateMutationVariables = Exact<{
  new_block_template_id: Scalars['Int'];
  week_template_ids: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type ICopyWeekTemplatesToAnotherBlockTemplateMutation = { __typename?: 'mutation_root', copy_week_template_to_another_block_template: number };

export type IDeleteAthleteMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type IDeleteAthleteMutation = { __typename?: 'mutation_root', delete_athlete_by_pk?: { __typename?: 'athlete', id: number } | undefined };

export type IDeleteAthleteBlockMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type IDeleteAthleteBlockMutation = { __typename?: 'mutation_root', delete_athlete_block_by_pk?: { __typename?: 'athlete_block', id: number } | undefined };

export type IDeleteAthleteWeekMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type IDeleteAthleteWeekMutation = { __typename?: 'mutation_root', delete_athlete_week_by_pk?: { __typename?: 'athlete_week', id: number } | undefined };

export type IDeleteAthleteWorkoutMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type IDeleteAthleteWorkoutMutation = { __typename?: 'mutation_root', delete_athlete_workout_by_pk?: { __typename?: 'athlete_workout', id: number } | undefined };

export type IDeleteBlockTemplateMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type IDeleteBlockTemplateMutation = { __typename?: 'mutation_root', delete_block_template_by_pk?: { __typename?: 'block_template', id: number } | undefined };

export type IDeleteCircuitMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type IDeleteCircuitMutation = { __typename?: 'mutation_root', delete_circuit_by_pk?: { __typename?: 'circuit', id: number } | undefined };

export type IDeleteCircuitExerciseMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type IDeleteCircuitExerciseMutation = { __typename?: 'mutation_root', delete_circuit_exercise_by_pk?: { __typename?: 'circuit_exercise', id: number } | undefined };

export type IDeleteCouponMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type IDeleteCouponMutation = { __typename?: 'mutation_root', delete_coupon_by_pk?: { __typename?: 'coupon', id: number } | undefined };

export type IDeleteExerciseMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type IDeleteExerciseMutation = { __typename?: 'mutation_root', delete_exercise_by_pk?: { __typename?: 'exercise', id: number } | undefined };

export type IDeleteReviewMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type IDeleteReviewMutation = { __typename?: 'mutation_root', delete_review_by_pk?: { __typename?: 'review', id: number } | undefined };

export type IDeleteSubscriptionPlanMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type IDeleteSubscriptionPlanMutation = { __typename?: 'mutation_root', delete_subscription_plan_by_pk?: { __typename?: 'subscription_plan', id: number } | undefined };

export type IDeleteUserMutationVariables = Exact<{
  user_id: Scalars['Int'];
  keycloak_id: Scalars['String'];
}>;


export type IDeleteUserMutation = { __typename?: 'mutation_root', delete_user_keycloak: boolean };

export type IDeleteWeekTemplateMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type IDeleteWeekTemplateMutation = { __typename?: 'mutation_root', delete_week_template_by_pk?: { __typename?: 'week_template', id: number } | undefined };

export type IDeleteWorkoutTemplateMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type IDeleteWorkoutTemplateMutation = { __typename?: 'mutation_root', delete_workout_template_by_pk?: { __typename?: 'workout_template', id: number } | undefined };

export type IDuplicateBlockTemplateMutationVariables = Exact<{
  block_template_id: Scalars['Int'];
  user_id?: InputMaybe<Scalars['Int']>;
}>;


export type IDuplicateBlockTemplateMutation = { __typename?: 'mutation_root', duplicate_block_template: number };

export type IInsertAthleteBlockMutationVariables = Exact<{
  object: IAthlete_Block_Insert_Input;
}>;


export type IInsertAthleteBlockMutation = { __typename?: 'mutation_root', insert_athlete_block_one?: { __typename?: 'athlete_block', id: number } | undefined };

export type IInsertAthleteWeekMutationVariables = Exact<{
  object: IAthlete_Week_Insert_Input;
}>;


export type IInsertAthleteWeekMutation = { __typename?: 'mutation_root', insert_athlete_week_one?: { __typename?: 'athlete_week', id: number } | undefined };

export type IInsertAthleteWorkoutMutationVariables = Exact<{
  object: IAthlete_Workout_Insert_Input;
}>;


export type IInsertAthleteWorkoutMutation = { __typename?: 'mutation_root', insert_athlete_workout_one?: { __typename?: 'athlete_workout', id: number } | undefined };

export type IInsertAtlheteBiometricDataMutationVariables = Exact<{
  objects: Array<IAthlete_Biometric_Data_Insert_Input> | IAthlete_Biometric_Data_Insert_Input;
}>;


export type IInsertAtlheteBiometricDataMutation = { __typename?: 'mutation_root', insert_athlete_biometric_data?: { __typename?: 'athlete_biometric_data_mutation_response', returning: Array<{ __typename?: 'athlete_biometric_data', id: number }> } | undefined };

export type IInsertBlockTemplateMutationVariables = Exact<{
  object: IBlock_Template_Insert_Input;
}>;


export type IInsertBlockTemplateMutation = { __typename?: 'mutation_root', insert_block_template_one?: { __typename?: 'block_template', id: number } | undefined };

export type IInsertCircuitMutationVariables = Exact<{
  object: ICircuit_Insert_Input;
}>;


export type IInsertCircuitMutation = { __typename?: 'mutation_root', insert_circuit_one?: { __typename?: 'circuit', id: number } | undefined };

export type IInsertCircuitExerciseMutationVariables = Exact<{
  object: ICircuit_Exercise_Insert_Input;
}>;


export type IInsertCircuitExerciseMutation = { __typename?: 'mutation_root', insert_circuit_exercise_one?: { __typename?: 'circuit_exercise', id: number } | undefined };

export type IInsertCouponMutationVariables = Exact<{
  object: ICoupon_Insert_Input;
}>;


export type IInsertCouponMutation = { __typename?: 'mutation_root', insert_coupon_one?: { __typename?: 'coupon', id: number } | undefined };

export type IInsertExerciseMutationVariables = Exact<{
  object: IExercise_Insert_Input;
}>;


export type IInsertExerciseMutation = { __typename?: 'mutation_root', insert_exercise_one?: { __typename?: 'exercise', id: number } | undefined };

export type IInsertReviewMutationVariables = Exact<{
  name: Scalars['String'];
}>;


export type IInsertReviewMutation = { __typename?: 'mutation_root', insert_review_one?: { __typename?: 'review', id: number } | undefined };

export type IInsertSubscriptionPlanMutationVariables = Exact<{
  _set1: ISubscription_Plan_Insert_Input;
}>;


export type IInsertSubscriptionPlanMutation = { __typename?: 'mutation_root', insert_subscription_plan_one?: { __typename?: 'subscription_plan', id: number } | undefined };

export type IInsertSubscriptionPlanTemplateMutationVariables = Exact<{
  _set: ISubscription_Plan_Template_Insert_Input;
}>;


export type IInsertSubscriptionPlanTemplateMutation = { __typename?: 'mutation_root', insert_subscription_plan_template_one?: { __typename?: 'subscription_plan_template', id: number } | undefined };

export type IInsertWeekTemplateMutationVariables = Exact<{
  object: IWeek_Template_Insert_Input;
}>;


export type IInsertWeekTemplateMutation = { __typename?: 'mutation_root', insert_week_template_one?: { __typename?: 'week_template', id: number } | undefined };

export type IInsertWorkoutAltimetryMutationVariables = Exact<{
  coefficient?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  _set1: Array<IWorkout_Altimetry_Translation_Insert_Input> | IWorkout_Altimetry_Translation_Insert_Input;
  workout_altimetry_workout_type: Array<IWorkout_Altimetry_Workout_Type_Insert_Input> | IWorkout_Altimetry_Workout_Type_Insert_Input;
}>;


export type IInsertWorkoutAltimetryMutation = { __typename?: 'mutation_root', insert_workout_altimetry_one?: { __typename?: 'workout_altimetry', id: number } | undefined };

export type IInsertWorkoutDurationMutationVariables = Exact<{
  coefficient?: InputMaybe<Scalars['numeric']>;
  duration?: InputMaybe<Scalars['numeric']>;
}>;


export type IInsertWorkoutDurationMutation = { __typename?: 'mutation_root', insert_workout_duration_one?: { __typename?: 'workout_duration', id: number } | undefined };

export type IInsertWorkoutTemplateMutationVariables = Exact<{
  object: IWorkout_Template_Insert_Input;
}>;


export type IInsertWorkoutTemplateMutation = { __typename?: 'mutation_root', insert_workout_template_one?: { __typename?: 'workout_template', id: number } | undefined };

export type IInsertWorkoutTerrainMutationVariables = Exact<{
  coefficient?: InputMaybe<Scalars['numeric']>;
  _set1: Array<IWorkout_Terrain_Translation_Insert_Input> | IWorkout_Terrain_Translation_Insert_Input;
}>;


export type IInsertWorkoutTerrainMutation = { __typename?: 'mutation_root', insert_workout_terrain_one?: { __typename?: 'workout_terrain', id: number } | undefined };

export type IInsertWorkoutZoneMutationVariables = Exact<{
  interval_start?: InputMaybe<Scalars['numeric']>;
  interval_end?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
}>;


export type IInsertWorkoutZoneMutation = { __typename?: 'mutation_root', insert_workout_zone_one?: { __typename?: 'workout_zone', id: number } | undefined };

export type IRecoverPasswordMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type IRecoverPasswordMutation = { __typename?: 'mutation_root', recover_password?: boolean | undefined };

export type ISetNewCoachPasswordMutationVariables = Exact<{
  password: Scalars['String'];
  token: Scalars['String'];
}>;


export type ISetNewCoachPasswordMutation = { __typename?: 'mutation_root', set_new_coach_password?: boolean | undefined };

export type IUpdateAthleteBlockMutationVariables = Exact<{
  id: Scalars['Int'];
  _set: IAthlete_Block_Set_Input;
}>;


export type IUpdateAthleteBlockMutation = { __typename?: 'mutation_root', update_athlete_block_by_pk?: { __typename?: 'athlete_block', id: number } | undefined };

export type IUpdateAthleteCoachMutationVariables = Exact<{
  id: Scalars['Int'];
  coach_id: Scalars['Int'];
}>;


export type IUpdateAthleteCoachMutation = { __typename?: 'mutation_root', update_athlete_by_pk?: { __typename?: 'athlete', id: number } | undefined };

export type IUpdateAthletePlanAndProfileMutationVariables = Exact<{
  id: Scalars['Int'];
  athlete_profile_id: Scalars['Int'];
}>;


export type IUpdateAthletePlanAndProfileMutation = { __typename?: 'mutation_root', update_athlete_by_pk?: { __typename?: 'athlete', id: number } | undefined };

export type IUpdateAthleteProfileMutationVariables = Exact<{
  athlete_profile_set?: InputMaybe<IAthlete_Profile_Set_Input>;
  athlete_profile_id: Scalars['Int'];
  athlete_profile_altimetry_adjustments: Array<IAthlete_Profile_Altimetry_Adjustment_Insert_Input> | IAthlete_Profile_Altimetry_Adjustment_Insert_Input;
}>;


export type IUpdateAthleteProfileMutation = { __typename?: 'mutation_root', update_athlete_profile_by_pk?: { __typename?: 'athlete_profile', id: number } | undefined, insert_athlete_profile_altimetry_adjustment?: { __typename?: 'athlete_profile_altimetry_adjustment_mutation_response', returning: Array<{ __typename?: 'athlete_profile_altimetry_adjustment', id: number }> } | undefined };

export type IUpdateAthleteWeekMutationVariables = Exact<{
  id: Scalars['Int'];
  _set: IAthlete_Week_Set_Input;
}>;


export type IUpdateAthleteWeekMutation = { __typename?: 'mutation_root', update_athlete_week_by_pk?: { __typename?: 'athlete_week', id: number } | undefined };

export type IUpdateAthleteWorkoutMutationVariables = Exact<{
  athlete_workout_data: IAthlete_Workout_Set_Input;
  id: Scalars['Int'];
  workout_sections_data: Array<IAthlete_Workout_Section_Insert_Input> | IAthlete_Workout_Section_Insert_Input;
  workout_section_ids_to_delete: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type IUpdateAthleteWorkoutMutation = { __typename?: 'mutation_root', update_athlete_workout_by_pk?: { __typename?: 'athlete_workout', id: number } | undefined, insert_athlete_workout_section?: { __typename?: 'athlete_workout_section_mutation_response', affected_rows: number } | undefined, delete_athlete_workout_section?: { __typename?: 'athlete_workout_section_mutation_response', affected_rows: number } | undefined };

export type IUpdateAtlheteSpeedsMutationVariables = Exact<{
  _set: Array<IAthlete_Speed_Updates> | IAthlete_Speed_Updates;
}>;


export type IUpdateAtlheteSpeedsMutation = { __typename?: 'mutation_root', update_athlete_speed_many?: Array<{ __typename?: 'athlete_speed_mutation_response', returning: Array<{ __typename?: 'athlete_speed', id: number }> } | undefined> | undefined };

export type IUpdateBlockMutationVariables = Exact<{
  id: Scalars['Int'];
  _set: IBlock_Template_Set_Input;
}>;


export type IUpdateBlockMutation = { __typename?: 'mutation_root', update_block_template_by_pk?: { __typename?: 'block_template', id: number } | undefined };

export type IUpdateCircuitMutationVariables = Exact<{
  id: Scalars['Int'];
  _set: ICircuit_Set_Input;
  circuit_sports_to_remove?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  circuit_sports_to_add?: InputMaybe<Array<ICircuit_Sport_Insert_Input> | ICircuit_Sport_Insert_Input>;
  _set1: Array<ICircuit_Translation_Insert_Input> | ICircuit_Translation_Insert_Input;
  _set2: Array<ICircuit_Translation_Updates> | ICircuit_Translation_Updates;
}>;


export type IUpdateCircuitMutation = { __typename?: 'mutation_root', delete_circuit_sport?: { __typename?: 'circuit_sport_mutation_response', affected_rows: number } | undefined, insert_circuit_sport?: { __typename?: 'circuit_sport_mutation_response', affected_rows: number } | undefined, update_circuit_by_pk?: { __typename?: 'circuit', id: number } | undefined, insert_circuit_translation?: { __typename?: 'circuit_translation_mutation_response', affected_rows: number } | undefined, update_circuit_translation_many?: Array<{ __typename?: 'circuit_translation_mutation_response', affected_rows: number } | undefined> | undefined };

export type IUpdateCircuitExerciseMutationVariables = Exact<{
  _set: ICircuit_Exercise_Set_Input;
  id: Scalars['Int'];
}>;


export type IUpdateCircuitExerciseMutation = { __typename?: 'mutation_root', update_circuit_exercise_by_pk?: { __typename?: 'circuit_exercise', id: number } | undefined };

export type IUpdateCoachMutationVariables = Exact<{
  id: Scalars['Int'];
  name: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  profile_picture: Scalars['String'];
  spoken_languages: Scalars['_text'];
  platform_content_access: Scalars['Boolean'];
  platform_fee: Scalars['float8'];
  coach_sports_to_remove?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  coach_sports_to_add?: InputMaybe<Array<ICoach_Sport_Insert_Input> | ICoach_Sport_Insert_Input>;
  public?: InputMaybe<Scalars['Boolean']>;
  _set1: Array<ICoach_Translation_Insert_Input> | ICoach_Translation_Insert_Input;
  _set2: Array<ICoach_Translation_Updates> | ICoach_Translation_Updates;
}>;


export type IUpdateCoachMutation = { __typename?: 'mutation_root', delete_coach_sport?: { __typename?: 'coach_sport_mutation_response', returning: Array<{ __typename?: 'coach_sport', id: number }> } | undefined, insert_coach_sport?: { __typename?: 'coach_sport_mutation_response', returning: Array<{ __typename?: 'coach_sport', id: number }> } | undefined, update_coach_by_pk?: { __typename?: 'coach', id: number } | undefined, insert_coach_translation?: { __typename?: 'coach_translation_mutation_response', affected_rows: number } | undefined, update_coach_translation_many?: Array<{ __typename?: 'coach_translation_mutation_response', affected_rows: number } | undefined> | undefined };

export type IUpdateCoachBillingDataMutationVariables = Exact<{
  id: Scalars['Int'];
  fiscal_id_number: Scalars['String'];
  address_street: Scalars['String'];
  address_city: Scalars['String'];
  address_postal_code: Scalars['String'];
  address_country: Scalars['String'];
}>;


export type IUpdateCoachBillingDataMutation = { __typename?: 'mutation_root', update_coach_by_pk?: { __typename?: 'coach', id: number } | undefined };

export type IUpdateExerciseMutationVariables = Exact<{
  id: Scalars['Int'];
  _set: IExercise_Set_Input;
  _set1: Array<IExercise_Translation_Insert_Input> | IExercise_Translation_Insert_Input;
  _set2: Array<IExercise_Translation_Updates> | IExercise_Translation_Updates;
}>;


export type IUpdateExerciseMutation = { __typename?: 'mutation_root', update_exercise_by_pk?: { __typename?: 'exercise', id: number } | undefined, insert_exercise_translation?: { __typename?: 'exercise_translation_mutation_response', affected_rows: number } | undefined, update_exercise_translation_many?: Array<{ __typename?: 'exercise_translation_mutation_response', affected_rows: number } | undefined> | undefined };

export type IUpdateReviewMutationVariables = Exact<{
  id: Scalars['Int'];
  image: Scalars['String'];
  name: Scalars['String'];
  _set1: Array<IReview_Translation_Insert_Input> | IReview_Translation_Insert_Input;
  _set2: Array<IReview_Translation_Updates> | IReview_Translation_Updates;
}>;


export type IUpdateReviewMutation = { __typename?: 'mutation_root', update_review_by_pk?: { __typename?: 'review', id: number } | undefined, insert_review_translation?: { __typename?: 'review_translation_mutation_response', affected_rows: number } | undefined, update_review_translation_many?: Array<{ __typename?: 'review_translation_mutation_response', affected_rows: number } | undefined> | undefined };

export type IUpdateSportMutationVariables = Exact<{
  id: Scalars['name'];
  image?: InputMaybe<Scalars['String']>;
  _set1: Array<ISport_Translation_Insert_Input> | ISport_Translation_Insert_Input;
  _set2: Array<ISport_Translation_Updates> | ISport_Translation_Updates;
}>;


export type IUpdateSportMutation = { __typename?: 'mutation_root', update_sport_by_pk?: { __typename?: 'sport', id: any } | undefined, insert_sport_translation?: { __typename?: 'sport_translation_mutation_response', affected_rows: number } | undefined, update_sport_translation_many?: Array<{ __typename?: 'sport_translation_mutation_response', affected_rows: number } | undefined> | undefined };

export type IUpdateSubscriptionPlanMutationVariables = Exact<{
  id: Scalars['Int'];
  _set: ISubscription_Plan_Set_Input;
  _set2: Array<ISubscription_Plan_Translation_Insert_Input> | ISubscription_Plan_Translation_Insert_Input;
  _set3: Array<ISubscription_Plan_Translation_Updates> | ISubscription_Plan_Translation_Updates;
}>;


export type IUpdateSubscriptionPlanMutation = { __typename?: 'mutation_root', update_subscription_plan_by_pk?: { __typename?: 'subscription_plan', id: number } | undefined, insert_subscription_plan_translation?: { __typename?: 'subscription_plan_translation_mutation_response', affected_rows: number } | undefined, update_subscription_plan_translation_many?: Array<{ __typename?: 'subscription_plan_translation_mutation_response', affected_rows: number } | undefined> | undefined };

export type IUpdateSubscriptionPlanTemplateMutationVariables = Exact<{
  id: Scalars['Int'];
  _set: ISubscription_Plan_Template_Set_Input;
}>;


export type IUpdateSubscriptionPlanTemplateMutation = { __typename?: 'mutation_root', update_subscription_plan_template_by_pk?: { __typename?: 'subscription_plan_template', id: number } | undefined };

export type IUpdateWeekMutationVariables = Exact<{
  id: Scalars['Int'];
  _set: IWeek_Template_Set_Input;
}>;


export type IUpdateWeekMutation = { __typename?: 'mutation_root', update_week_template_by_pk?: { __typename?: 'week_template', id: number } | undefined };

export type IUpdateWorkoutAltimetryMutationVariables = Exact<{
  coefficient?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  _set1: Array<IWorkout_Altimetry_Translation_Insert_Input> | IWorkout_Altimetry_Translation_Insert_Input;
  _set2: Array<IWorkout_Altimetry_Translation_Updates> | IWorkout_Altimetry_Translation_Updates;
  id: Scalars['Int'];
  workout_altimetry_workout_type: Array<IWorkout_Altimetry_Workout_Type_Insert_Input> | IWorkout_Altimetry_Workout_Type_Insert_Input;
  workout_altimetry_workout_type_ids_to_delete?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type IUpdateWorkoutAltimetryMutation = { __typename?: 'mutation_root', update_workout_altimetry_by_pk?: { __typename?: 'workout_altimetry', id: number } | undefined, insert_workout_altimetry_translation?: { __typename?: 'workout_altimetry_translation_mutation_response', affected_rows: number } | undefined, update_workout_altimetry_translation_many?: Array<{ __typename?: 'workout_altimetry_translation_mutation_response', affected_rows: number } | undefined> | undefined, insert_workout_altimetry_workout_type?: { __typename?: 'workout_altimetry_workout_type_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'workout_altimetry_workout_type', id: number }> } | undefined, delete_workout_altimetry_workout_type?: { __typename?: 'workout_altimetry_workout_type_mutation_response', returning: Array<{ __typename?: 'workout_altimetry_workout_type', id: number }> } | undefined };

export type IUpdateWorkoutDurationMutationVariables = Exact<{
  coefficient?: InputMaybe<Scalars['numeric']>;
  duration?: InputMaybe<Scalars['numeric']>;
  id: Scalars['Int'];
}>;


export type IUpdateWorkoutDurationMutation = { __typename?: 'mutation_root', update_workout_duration_by_pk?: { __typename?: 'workout_duration', id: number } | undefined };

export type IUpdateWorkoutTemplateMutationVariables = Exact<{
  workout_template_data: IWorkout_Template_Set_Input;
  id: Scalars['Int'];
  workout_sections_data: Array<IWorkout_Section_Template_Insert_Input> | IWorkout_Section_Template_Insert_Input;
  workout_section_ids_to_delete: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type IUpdateWorkoutTemplateMutation = { __typename?: 'mutation_root', update_workout_template_by_pk?: { __typename?: 'workout_template', id: number } | undefined, insert_workout_section_template?: { __typename?: 'workout_section_template_mutation_response', affected_rows: number } | undefined, delete_workout_section_template?: { __typename?: 'workout_section_template_mutation_response', affected_rows: number } | undefined };

export type IUpdateWorkoutTerrainMutationVariables = Exact<{
  coefficient?: InputMaybe<Scalars['numeric']>;
  id: Scalars['Int'];
  _set1: Array<IWorkout_Terrain_Translation_Insert_Input> | IWorkout_Terrain_Translation_Insert_Input;
  _set2: Array<IWorkout_Terrain_Translation_Updates> | IWorkout_Terrain_Translation_Updates;
}>;


export type IUpdateWorkoutTerrainMutation = { __typename?: 'mutation_root', update_workout_terrain_by_pk?: { __typename?: 'workout_terrain', id: number } | undefined, insert_workout_terrain_translation?: { __typename?: 'workout_terrain_translation_mutation_response', affected_rows: number } | undefined, update_workout_terrain_translation_many?: Array<{ __typename?: 'workout_terrain_translation_mutation_response', affected_rows: number } | undefined> | undefined };

export type IUpdateWorkoutZoneMutationVariables = Exact<{
  interval_start?: InputMaybe<Scalars['numeric']>;
  interval_end?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
}>;


export type IUpdateWorkoutZoneMutation = { __typename?: 'mutation_root', update_workout_zone_by_pk?: { __typename?: 'workout_zone', id: number } | undefined };

export type IUpsertCircuitExercisesMutationVariables = Exact<{
  objects: Array<ICircuit_Exercise_Insert_Input> | ICircuit_Exercise_Insert_Input;
  circuit_exercise_ids_to_delete: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type IUpsertCircuitExercisesMutation = { __typename?: 'mutation_root', insert_circuit_exercise?: { __typename?: 'circuit_exercise_mutation_response', returning: Array<{ __typename?: 'circuit_exercise', id: number }> } | undefined, delete_circuit_exercise?: { __typename?: 'circuit_exercise_mutation_response', returning: Array<{ __typename?: 'circuit_exercise', id: number }> } | undefined };

export type IValidateCoachMutationVariables = Exact<{
  id: Scalars['Int'];
  user_id: Scalars['Int'];
  is_verified: Scalars['Boolean'];
  message: Scalars['String'];
  mail: Scalars['String'];
}>;


export type IValidateCoachMutation = { __typename?: 'mutation_root', validate_coach: { __typename?: 'validate_coach_res', id: number } };

export type IValidateSubscriptionPlanMutationVariables = Exact<{
  id: Scalars['Int'];
  is_verified: Scalars['Boolean'];
}>;


export type IValidateSubscriptionPlanMutation = { __typename?: 'mutation_root', update_subscription_plan_by_pk?: { __typename?: 'subscription_plan', id: number } | undefined };

export type IAthleteBiometricDataQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type IAthleteBiometricDataQuery = { __typename?: 'query_root', athlete_by_pk?: { __typename?: 'athlete', id: number, athlete_biometric_data: Array<{ __typename?: 'athlete_biometric_data', id: number, value?: number | undefined, biometric_parameter_id: string, created_at: string, file_url?: string | undefined, biometric_parameter: { __typename?: 'biometric_parameter', label?: string | undefined } }> } | undefined };

export type IAthleteBirthdayQueryVariables = Exact<{
  _month_day_gte?: InputMaybe<Scalars['Int']>;
  _month_day_lte?: InputMaybe<Scalars['Int']>;
}>;


export type IAthleteBirthdayQuery = { __typename?: 'query_root', athletes: Array<{ __typename?: 'athlete', birthday?: any | undefined, avatar?: string | undefined, name: string, id: number, user: { __typename?: 'user', email: string } }> };

export type IAthleteBirthdayCrossYearQueryVariables = Exact<{
  _month_day_gte?: InputMaybe<Scalars['Int']>;
  _month_day_lte?: InputMaybe<Scalars['Int']>;
}>;


export type IAthleteBirthdayCrossYearQuery = { __typename?: 'query_root', athletes: Array<{ __typename?: 'athlete', birthday?: any | undefined, avatar?: string | undefined, name: string, id: number, user: { __typename?: 'user', email: string } }> };

export type IAthleteBlocksQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type IAthleteBlocksQuery = { __typename?: 'query_root', athlete_by_pk?: { __typename?: 'athlete', id: number, athlete_profile_id?: number | undefined, coach_id?: number | undefined, sport_id?: string | undefined, athlete_challenges: Array<{ __typename?: 'athlete_challenge', description: string, time_done_hours?: number | undefined, time_done_minutes?: number | undefined, result?: string | undefined, id: number, date?: any | undefined, created_at: string, completed_at?: any | undefined, is_main?: boolean | undefined, time_goal_hours?: number | undefined, time_goal_minutes?: number | undefined, positive_univeness?: number | undefined, negative_univeness?: number | undefined, cumulated_univeness?: number | undefined, distance?: string | undefined }>, athlete_profile?: { __typename?: 'athlete_profile', id: number, param_effort?: number | undefined, param_motivation?: number | undefined, param_distance_variation?: number | undefined, param_calories?: number | undefined, param_ziut?: number | undefined, athlete_profile_altimetry_adjustments: Array<{ __typename?: 'athlete_profile_altimetry_adjustment', workout_altimetry_id: number, value: number }> } | undefined, athlete_biometric_data: Array<{ __typename?: 'athlete_biometric_data', id: number, value?: number | undefined, biometric_parameter_id: string, created_at: string, file_url?: string | undefined, biometric_parameter: { __typename?: 'biometric_parameter', label?: string | undefined } }>, athlete_speeds: Array<{ __typename?: 'athlete_speed', id: number, value: number, workout_type_id?: number | undefined }>, athlete_blocks: Array<{ __typename?: 'athlete_block', created_at: string, end_date?: any | undefined, id: number, name?: string | undefined, start_date?: any | undefined, sport_id?: string | undefined, athlete_id: number, athlete_weeks: Array<{ __typename?: 'athlete_week', id: number, name?: string | undefined, order: number, start_date?: any | undefined, end_date?: any | undefined, athlete_block_id: number, athlete_block: { __typename?: 'athlete_block', athlete_id: number, id: number } }> }> } | undefined };

export type IAthlete_Block_SummaryFragment = { __typename?: 'athlete_block', created_at: string, end_date?: any | undefined, id: number, name?: string | undefined, start_date?: any | undefined, sport_id?: string | undefined, athlete_id: number };

export type IAthleteDetailsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type IAthleteDetailsQuery = { __typename?: 'query_root', athlete_by_pk?: { __typename?: 'athlete', id: number, name: string, birthday?: any | undefined, avatar?: string | undefined, gender?: string | undefined, athlete_profile_id?: number | undefined, coach_id?: number | undefined, address_city?: string | undefined, address_postal_code?: string | undefined, address_street?: string | undefined, address_country?: string | undefined, phone?: string | undefined, status?: string | undefined, fiscal_id_number?: string | undefined, goal?: string | undefined, stripe_customer_id?: string | undefined, sport_id?: string | undefined, user_id: number, athlete_profile?: { __typename?: 'athlete_profile', gender: string, id: number, level: number, name: string, type: string, param_calories?: number | undefined, param_distance_variation?: number | undefined, param_effort?: number | undefined, param_motivation?: number | undefined, param_ziut?: number | undefined, athlete_profile_altimetry_adjustments: Array<{ __typename?: 'athlete_profile_altimetry_adjustment', id: number, value: number, workout_altimetry_id: number, workout_altimetry: { __typename?: 'workout_altimetry', name: string, id: number, workout_altimetry_workout_types: Array<{ __typename?: 'workout_altimetry_workout_type', id: number, workout_type: { __typename?: 'workout_type', id: number, avatar: string, workout_type_translations: Array<{ __typename?: 'workout_type_translation', name?: string | undefined, locale: { __typename?: 'locale', code: string } }> } }> } }> } | undefined, user: { __typename?: 'user', email: string }, athlete_biometric_data: Array<{ __typename?: 'athlete_biometric_data', id: number, value?: number | undefined, biometric_parameter_id: string, created_at: string, file_url?: string | undefined, biometric_parameter: { __typename?: 'biometric_parameter', label?: string | undefined } }>, athlete_speeds: Array<{ __typename?: 'athlete_speed', id: number, value: number, workout_type_id?: number | undefined, workout_type?: { __typename?: 'workout_type', id: number, avatar: string, workout_type_translations: Array<{ __typename?: 'workout_type_translation', name?: string | undefined, locale: { __typename?: 'locale', code: string } }> } | undefined }>, athlete_challenges: Array<{ __typename?: 'athlete_challenge', description: string, time_done_hours?: number | undefined, time_done_minutes?: number | undefined, result?: string | undefined, id: number, date?: any | undefined, created_at: string, completed_at?: any | undefined, is_main?: boolean | undefined, time_goal_hours?: number | undefined, time_goal_minutes?: number | undefined, positive_univeness?: number | undefined, negative_univeness?: number | undefined, cumulated_univeness?: number | undefined, distance?: string | undefined }>, athlete_blocks: Array<{ __typename?: 'athlete_block', created_at: string, end_date?: any | undefined, id: number, name?: string | undefined, start_date?: any | undefined, updated_at: string, sport_id?: string | undefined, athlete_id: number, athlete_weeks: Array<{ __typename?: 'athlete_week', created_at: string, end_date?: any | undefined, id: number, name?: string | undefined, order: number, sport_id: string, start_date?: any | undefined, updated_at: string, athlete_block_id: number, athlete_block: { __typename?: 'athlete_block', athlete_id: number, id: number }, athlete_workouts: Array<{ __typename?: 'athlete_workout', created_at: string, updated_at: string, athlete_week_id: number, date: any, day: number, id: number, is_primary?: boolean | undefined, workout_type_id?: number | undefined, motivation?: number | undefined, effort?: number | undefined, comments?: string | undefined, series?: string | undefined, strava_activity_id?: any | undefined, measured_calories?: number | undefined, calories?: number | undefined, zuit?: number | undefined, positive_elevation?: number | undefined, negative_elevation?: number | undefined, measured_positive_elevation?: number | undefined, measured_negative_elevation?: number | undefined, type?: string | undefined, stretching_circuit_id?: number | undefined, stretching_circuit_repetitions?: number | undefined, completed_stretching_circuit?: number | undefined, weight_circuit_id?: number | undefined, weight_circuit_repetitions?: number | undefined, completed_weight_circuit?: number | undefined, workout_altimetry_id: number, workout_terrain_id: number, cumulative_elevation?: number | undefined, measured_cumulative_elevation?: number | undefined, stretching_circuit?: { __typename?: 'circuit', id: number, type: string, circuit_translations: Array<{ __typename?: 'circuit_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string } }>, circuit_exercises: Array<{ __typename?: 'circuit_exercise', id: number, circuit_id: number, duration?: number | undefined, exercise_id: number, no_of_series?: number | undefined, order?: number | undefined, repetitions?: number | undefined, exercise: { __typename?: 'exercise', id: number, media_url: string, type: string, target?: string | undefined, exercise_translations: Array<{ __typename?: 'exercise_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string } }> } }> } | undefined, weight_circuit?: { __typename?: 'circuit', id: number, type: string, circuit_translations: Array<{ __typename?: 'circuit_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string } }>, circuit_exercises: Array<{ __typename?: 'circuit_exercise', id: number, circuit_id: number, duration?: number | undefined, exercise_id: number, no_of_series?: number | undefined, order?: number | undefined, repetitions?: number | undefined, exercise: { __typename?: 'exercise', id: number, media_url: string, type: string, target?: string | undefined, exercise_translations: Array<{ __typename?: 'exercise_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string } }> } }> } | undefined, workout_altimetry: { __typename?: 'workout_altimetry', coefficient: number, icon?: string | undefined, id: number, name: string, workout_altimetry_translations: Array<{ __typename?: 'workout_altimetry_translation', id: number, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }> }, workout_terrain: { __typename?: 'workout_terrain', coefficient: number, icon?: string | undefined, id: number, workout_terrain_translations: Array<{ __typename?: 'workout_terrain_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }> }, workout_type?: { __typename?: 'workout_type', id: number, avatar: string, workout_type_translations: Array<{ __typename?: 'workout_type_translation', name?: string | undefined, locale: { __typename?: 'locale', code: string } }> } | undefined, athlete_workout_sections: Array<{ __typename?: 'athlete_workout_section', athlete_workout_id: number, duration?: number | undefined, max_heart_rate?: number | undefined, speed?: number | undefined, speed_percentage?: number | undefined, average_heart_rate?: number | undefined, average_heart_rate_percentage?: number | undefined, measured_duration?: number | undefined, measured_max_heart_rate?: number | undefined, measured_speed?: number | undefined, measured_average_heart_rate?: number | undefined, id: number, type?: string | undefined, workout_zone_id?: number | undefined, order?: number | undefined, planned_stress_score?: number | undefined, executed_stress_score?: number | undefined, workout_zone?: { __typename?: 'workout_zone', name: string, id: number, interval_start: number, interval_end: number } | undefined }> }> }> }> } | undefined, athlete_profile: Array<{ __typename?: 'athlete_profile', gender: string, id: number, level: number, name: string, type: string }> };

export type IAthlete_BlockFragment = { __typename?: 'athlete_block', created_at: string, end_date?: any | undefined, id: number, name?: string | undefined, start_date?: any | undefined, updated_at: string, sport_id?: string | undefined, athlete_id: number, athlete_weeks: Array<{ __typename?: 'athlete_week', created_at: string, end_date?: any | undefined, id: number, name?: string | undefined, order: number, sport_id: string, start_date?: any | undefined, updated_at: string, athlete_block_id: number, athlete_block: { __typename?: 'athlete_block', athlete_id: number, id: number }, athlete_workouts: Array<{ __typename?: 'athlete_workout', created_at: string, updated_at: string, athlete_week_id: number, date: any, day: number, id: number, is_primary?: boolean | undefined, workout_type_id?: number | undefined, motivation?: number | undefined, effort?: number | undefined, comments?: string | undefined, series?: string | undefined, strava_activity_id?: any | undefined, measured_calories?: number | undefined, calories?: number | undefined, zuit?: number | undefined, positive_elevation?: number | undefined, negative_elevation?: number | undefined, measured_positive_elevation?: number | undefined, measured_negative_elevation?: number | undefined, type?: string | undefined, stretching_circuit_id?: number | undefined, stretching_circuit_repetitions?: number | undefined, completed_stretching_circuit?: number | undefined, weight_circuit_id?: number | undefined, weight_circuit_repetitions?: number | undefined, completed_weight_circuit?: number | undefined, workout_altimetry_id: number, workout_terrain_id: number, cumulative_elevation?: number | undefined, measured_cumulative_elevation?: number | undefined, stretching_circuit?: { __typename?: 'circuit', id: number, type: string, circuit_translations: Array<{ __typename?: 'circuit_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string } }>, circuit_exercises: Array<{ __typename?: 'circuit_exercise', id: number, circuit_id: number, duration?: number | undefined, exercise_id: number, no_of_series?: number | undefined, order?: number | undefined, repetitions?: number | undefined, exercise: { __typename?: 'exercise', id: number, media_url: string, type: string, target?: string | undefined, exercise_translations: Array<{ __typename?: 'exercise_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string } }> } }> } | undefined, weight_circuit?: { __typename?: 'circuit', id: number, type: string, circuit_translations: Array<{ __typename?: 'circuit_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string } }>, circuit_exercises: Array<{ __typename?: 'circuit_exercise', id: number, circuit_id: number, duration?: number | undefined, exercise_id: number, no_of_series?: number | undefined, order?: number | undefined, repetitions?: number | undefined, exercise: { __typename?: 'exercise', id: number, media_url: string, type: string, target?: string | undefined, exercise_translations: Array<{ __typename?: 'exercise_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string } }> } }> } | undefined, workout_altimetry: { __typename?: 'workout_altimetry', coefficient: number, icon?: string | undefined, id: number, name: string, workout_altimetry_translations: Array<{ __typename?: 'workout_altimetry_translation', id: number, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }> }, workout_terrain: { __typename?: 'workout_terrain', coefficient: number, icon?: string | undefined, id: number, workout_terrain_translations: Array<{ __typename?: 'workout_terrain_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }> }, workout_type?: { __typename?: 'workout_type', id: number, avatar: string, workout_type_translations: Array<{ __typename?: 'workout_type_translation', name?: string | undefined, locale: { __typename?: 'locale', code: string } }> } | undefined, athlete_workout_sections: Array<{ __typename?: 'athlete_workout_section', athlete_workout_id: number, duration?: number | undefined, max_heart_rate?: number | undefined, speed?: number | undefined, speed_percentage?: number | undefined, average_heart_rate?: number | undefined, average_heart_rate_percentage?: number | undefined, measured_duration?: number | undefined, measured_max_heart_rate?: number | undefined, measured_speed?: number | undefined, measured_average_heart_rate?: number | undefined, id: number, type?: string | undefined, workout_zone_id?: number | undefined, order?: number | undefined, planned_stress_score?: number | undefined, executed_stress_score?: number | undefined, workout_zone?: { __typename?: 'workout_zone', name: string, id: number, interval_start: number, interval_end: number } | undefined }> }> }> };

export type IAthlete_Week_BaseFragment = { __typename?: 'athlete_week', created_at: string, end_date?: any | undefined, id: number, name?: string | undefined, order: number, sport_id: string, start_date?: any | undefined, updated_at: string, athlete_block_id: number, athlete_block: { __typename?: 'athlete_block', athlete_id: number, id: number }, athlete_workouts: Array<{ __typename?: 'athlete_workout', created_at: string, updated_at: string, athlete_week_id: number, date: any, day: number, id: number, is_primary?: boolean | undefined, workout_type_id?: number | undefined, motivation?: number | undefined, effort?: number | undefined, comments?: string | undefined, series?: string | undefined, strava_activity_id?: any | undefined, measured_calories?: number | undefined, calories?: number | undefined, zuit?: number | undefined, positive_elevation?: number | undefined, negative_elevation?: number | undefined, measured_positive_elevation?: number | undefined, measured_negative_elevation?: number | undefined, type?: string | undefined, stretching_circuit_id?: number | undefined, stretching_circuit_repetitions?: number | undefined, completed_stretching_circuit?: number | undefined, weight_circuit_id?: number | undefined, weight_circuit_repetitions?: number | undefined, completed_weight_circuit?: number | undefined, workout_altimetry_id: number, workout_terrain_id: number, cumulative_elevation?: number | undefined, measured_cumulative_elevation?: number | undefined, stretching_circuit?: { __typename?: 'circuit', id: number, type: string, circuit_translations: Array<{ __typename?: 'circuit_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string } }>, circuit_exercises: Array<{ __typename?: 'circuit_exercise', id: number, circuit_id: number, duration?: number | undefined, exercise_id: number, no_of_series?: number | undefined, order?: number | undefined, repetitions?: number | undefined, exercise: { __typename?: 'exercise', id: number, media_url: string, type: string, target?: string | undefined, exercise_translations: Array<{ __typename?: 'exercise_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string } }> } }> } | undefined, weight_circuit?: { __typename?: 'circuit', id: number, type: string, circuit_translations: Array<{ __typename?: 'circuit_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string } }>, circuit_exercises: Array<{ __typename?: 'circuit_exercise', id: number, circuit_id: number, duration?: number | undefined, exercise_id: number, no_of_series?: number | undefined, order?: number | undefined, repetitions?: number | undefined, exercise: { __typename?: 'exercise', id: number, media_url: string, type: string, target?: string | undefined, exercise_translations: Array<{ __typename?: 'exercise_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string } }> } }> } | undefined, workout_altimetry: { __typename?: 'workout_altimetry', coefficient: number, icon?: string | undefined, id: number, name: string, workout_altimetry_translations: Array<{ __typename?: 'workout_altimetry_translation', id: number, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }> }, workout_terrain: { __typename?: 'workout_terrain', coefficient: number, icon?: string | undefined, id: number, workout_terrain_translations: Array<{ __typename?: 'workout_terrain_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }> }, workout_type?: { __typename?: 'workout_type', id: number, avatar: string, workout_type_translations: Array<{ __typename?: 'workout_type_translation', name?: string | undefined, locale: { __typename?: 'locale', code: string } }> } | undefined, athlete_workout_sections: Array<{ __typename?: 'athlete_workout_section', athlete_workout_id: number, duration?: number | undefined, max_heart_rate?: number | undefined, speed?: number | undefined, speed_percentage?: number | undefined, average_heart_rate?: number | undefined, average_heart_rate_percentage?: number | undefined, measured_duration?: number | undefined, measured_max_heart_rate?: number | undefined, measured_speed?: number | undefined, measured_average_heart_rate?: number | undefined, id: number, type?: string | undefined, workout_zone_id?: number | undefined, order?: number | undefined, planned_stress_score?: number | undefined, executed_stress_score?: number | undefined, workout_zone?: { __typename?: 'workout_zone', name: string, id: number, interval_start: number, interval_end: number } | undefined }> }> };

export type IAthlete_DetailsFragment = { __typename?: 'athlete', id: number, name: string, birthday?: any | undefined, avatar?: string | undefined, gender?: string | undefined, athlete_profile_id?: number | undefined, coach_id?: number | undefined, address_city?: string | undefined, address_postal_code?: string | undefined, address_street?: string | undefined, address_country?: string | undefined, phone?: string | undefined, status?: string | undefined, fiscal_id_number?: string | undefined, goal?: string | undefined, stripe_customer_id?: string | undefined, sport_id?: string | undefined, user_id: number, athlete_profile?: { __typename?: 'athlete_profile', gender: string, id: number, level: number, name: string, type: string, param_calories?: number | undefined, param_distance_variation?: number | undefined, param_effort?: number | undefined, param_motivation?: number | undefined, param_ziut?: number | undefined, athlete_profile_altimetry_adjustments: Array<{ __typename?: 'athlete_profile_altimetry_adjustment', id: number, value: number, workout_altimetry_id: number, workout_altimetry: { __typename?: 'workout_altimetry', name: string, id: number, workout_altimetry_workout_types: Array<{ __typename?: 'workout_altimetry_workout_type', id: number, workout_type: { __typename?: 'workout_type', id: number, avatar: string, workout_type_translations: Array<{ __typename?: 'workout_type_translation', name?: string | undefined, locale: { __typename?: 'locale', code: string } }> } }> } }> } | undefined, user: { __typename?: 'user', email: string }, athlete_biometric_data: Array<{ __typename?: 'athlete_biometric_data', id: number, value?: number | undefined, biometric_parameter_id: string, created_at: string, file_url?: string | undefined, biometric_parameter: { __typename?: 'biometric_parameter', label?: string | undefined } }>, athlete_speeds: Array<{ __typename?: 'athlete_speed', id: number, value: number, workout_type_id?: number | undefined, workout_type?: { __typename?: 'workout_type', id: number, avatar: string, workout_type_translations: Array<{ __typename?: 'workout_type_translation', name?: string | undefined, locale: { __typename?: 'locale', code: string } }> } | undefined }>, athlete_challenges: Array<{ __typename?: 'athlete_challenge', description: string, time_done_hours?: number | undefined, time_done_minutes?: number | undefined, result?: string | undefined, id: number, date?: any | undefined, created_at: string, completed_at?: any | undefined, is_main?: boolean | undefined, time_goal_hours?: number | undefined, time_goal_minutes?: number | undefined, positive_univeness?: number | undefined, negative_univeness?: number | undefined, cumulated_univeness?: number | undefined, distance?: string | undefined }>, athlete_blocks: Array<{ __typename?: 'athlete_block', created_at: string, end_date?: any | undefined, id: number, name?: string | undefined, start_date?: any | undefined, updated_at: string, sport_id?: string | undefined, athlete_id: number, athlete_weeks: Array<{ __typename?: 'athlete_week', created_at: string, end_date?: any | undefined, id: number, name?: string | undefined, order: number, sport_id: string, start_date?: any | undefined, updated_at: string, athlete_block_id: number, athlete_block: { __typename?: 'athlete_block', athlete_id: number, id: number }, athlete_workouts: Array<{ __typename?: 'athlete_workout', created_at: string, updated_at: string, athlete_week_id: number, date: any, day: number, id: number, is_primary?: boolean | undefined, workout_type_id?: number | undefined, motivation?: number | undefined, effort?: number | undefined, comments?: string | undefined, series?: string | undefined, strava_activity_id?: any | undefined, measured_calories?: number | undefined, calories?: number | undefined, zuit?: number | undefined, positive_elevation?: number | undefined, negative_elevation?: number | undefined, measured_positive_elevation?: number | undefined, measured_negative_elevation?: number | undefined, type?: string | undefined, stretching_circuit_id?: number | undefined, stretching_circuit_repetitions?: number | undefined, completed_stretching_circuit?: number | undefined, weight_circuit_id?: number | undefined, weight_circuit_repetitions?: number | undefined, completed_weight_circuit?: number | undefined, workout_altimetry_id: number, workout_terrain_id: number, cumulative_elevation?: number | undefined, measured_cumulative_elevation?: number | undefined, stretching_circuit?: { __typename?: 'circuit', id: number, type: string, circuit_translations: Array<{ __typename?: 'circuit_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string } }>, circuit_exercises: Array<{ __typename?: 'circuit_exercise', id: number, circuit_id: number, duration?: number | undefined, exercise_id: number, no_of_series?: number | undefined, order?: number | undefined, repetitions?: number | undefined, exercise: { __typename?: 'exercise', id: number, media_url: string, type: string, target?: string | undefined, exercise_translations: Array<{ __typename?: 'exercise_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string } }> } }> } | undefined, weight_circuit?: { __typename?: 'circuit', id: number, type: string, circuit_translations: Array<{ __typename?: 'circuit_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string } }>, circuit_exercises: Array<{ __typename?: 'circuit_exercise', id: number, circuit_id: number, duration?: number | undefined, exercise_id: number, no_of_series?: number | undefined, order?: number | undefined, repetitions?: number | undefined, exercise: { __typename?: 'exercise', id: number, media_url: string, type: string, target?: string | undefined, exercise_translations: Array<{ __typename?: 'exercise_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string } }> } }> } | undefined, workout_altimetry: { __typename?: 'workout_altimetry', coefficient: number, icon?: string | undefined, id: number, name: string, workout_altimetry_translations: Array<{ __typename?: 'workout_altimetry_translation', id: number, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }> }, workout_terrain: { __typename?: 'workout_terrain', coefficient: number, icon?: string | undefined, id: number, workout_terrain_translations: Array<{ __typename?: 'workout_terrain_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }> }, workout_type?: { __typename?: 'workout_type', id: number, avatar: string, workout_type_translations: Array<{ __typename?: 'workout_type_translation', name?: string | undefined, locale: { __typename?: 'locale', code: string } }> } | undefined, athlete_workout_sections: Array<{ __typename?: 'athlete_workout_section', athlete_workout_id: number, duration?: number | undefined, max_heart_rate?: number | undefined, speed?: number | undefined, speed_percentage?: number | undefined, average_heart_rate?: number | undefined, average_heart_rate_percentage?: number | undefined, measured_duration?: number | undefined, measured_max_heart_rate?: number | undefined, measured_speed?: number | undefined, measured_average_heart_rate?: number | undefined, id: number, type?: string | undefined, workout_zone_id?: number | undefined, order?: number | undefined, planned_stress_score?: number | undefined, executed_stress_score?: number | undefined, workout_zone?: { __typename?: 'workout_zone', name: string, id: number, interval_start: number, interval_end: number } | undefined }> }> }> }> };

export type IAthleteInfoQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type IAthleteInfoQuery = { __typename?: 'query_root', athlete_by_pk?: { __typename?: 'athlete', id: number, name: string, birthday?: any | undefined, avatar?: string | undefined, gender?: string | undefined, athlete_profile_id?: number | undefined, coach_id?: number | undefined, address_city?: string | undefined, address_postal_code?: string | undefined, address_street?: string | undefined, address_country?: string | undefined, phone?: string | undefined, status?: string | undefined, fiscal_id_number?: string | undefined, goal?: string | undefined, stripe_customer_id?: string | undefined, sport_id?: string | undefined, user_id: number, user: { __typename?: 'user', email: string } } | undefined, athlete_profile: Array<{ __typename?: 'athlete_profile', gender: string, id: number, level: number, name: string, type: string }> };

export type IAthleteProfileDetailsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type IAthleteProfileDetailsQuery = { __typename?: 'query_root', athlete_profile_by_pk?: { __typename?: 'athlete_profile', gender: string, id: number, level: number, name: string, type: string, param_calories?: number | undefined, param_distance_variation?: number | undefined, param_effort?: number | undefined, param_motivation?: number | undefined, param_ziut?: number | undefined, athlete_profile_altimetry_adjustments: Array<{ __typename?: 'athlete_profile_altimetry_adjustment', id: number, value: number, workout_altimetry_id: number, workout_altimetry: { __typename?: 'workout_altimetry', name: string, id: number, workout_altimetry_workout_types: Array<{ __typename?: 'workout_altimetry_workout_type', id: number, workout_type: { __typename?: 'workout_type', id: number, avatar: string, workout_type_translations: Array<{ __typename?: 'workout_type_translation', name?: string | undefined, locale: { __typename?: 'locale', code: string } }> } }> } }> } | undefined, workout_altimetry: Array<{ __typename?: 'workout_altimetry', name: string, id: number }> };

export type IAthlete_ProfileFragment = { __typename?: 'athlete_profile', gender: string, id: number, level: number, name: string, type: string, param_calories?: number | undefined, param_distance_variation?: number | undefined, param_effort?: number | undefined, param_motivation?: number | undefined, param_ziut?: number | undefined, athlete_profile_altimetry_adjustments: Array<{ __typename?: 'athlete_profile_altimetry_adjustment', id: number, value: number, workout_altimetry_id: number, workout_altimetry: { __typename?: 'workout_altimetry', name: string, id: number, workout_altimetry_workout_types: Array<{ __typename?: 'workout_altimetry_workout_type', id: number, workout_type: { __typename?: 'workout_type', id: number, avatar: string, workout_type_translations: Array<{ __typename?: 'workout_type_translation', name?: string | undefined, locale: { __typename?: 'locale', code: string } }> } }> } }> };

export type IAthlete_Profile_Altimetry_AdjustmentFragment = { __typename?: 'athlete_profile_altimetry_adjustment', id: number, value: number, workout_altimetry_id: number, workout_altimetry: { __typename?: 'workout_altimetry', name: string, id: number, workout_altimetry_workout_types: Array<{ __typename?: 'workout_altimetry_workout_type', id: number, workout_type: { __typename?: 'workout_type', id: number, avatar: string, workout_type_translations: Array<{ __typename?: 'workout_type_translation', name?: string | undefined, locale: { __typename?: 'locale', code: string } }> } }> } };

export type IAthleteProfilesListQueryVariables = Exact<{
  where?: InputMaybe<IAthlete_Profile_Bool_Exp>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IAthlete_Profile_Order_By> | IAthlete_Profile_Order_By>;
}>;


export type IAthleteProfilesListQuery = { __typename?: 'query_root', athlete_profile: Array<{ __typename?: 'athlete_profile', gender: string, id: number, level: number, name: string, type: string }> };

export type IAthlete_ProfileFragmentFragment = { __typename?: 'athlete_profile', gender: string, id: number, level: number, name: string, type: string };

export type IAthleteSpeedsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type IAthleteSpeedsQuery = { __typename?: 'query_root', athlete_by_pk?: { __typename?: 'athlete', id: number, athlete_speeds: Array<{ __typename?: 'athlete_speed', id: number, value: number, workout_type_id?: number | undefined, workout_type?: { __typename?: 'workout_type', id: number, avatar: string, workout_type_translations: Array<{ __typename?: 'workout_type_translation', name?: string | undefined, locale: { __typename?: 'locale', code: string } }> } | undefined }>, athlete_profile?: { __typename?: 'athlete_profile', athlete_profile_altimetry_adjustments: Array<{ __typename?: 'athlete_profile_altimetry_adjustment', workout_altimetry_id: number, value: number, workout_altimetry: { __typename?: 'workout_altimetry', id: number, name: string, workout_altimetry_translations: Array<{ __typename?: 'workout_altimetry_translation', id: number, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }>, workout_altimetry_workout_types: Array<{ __typename?: 'workout_altimetry_workout_type', workout_type: { __typename?: 'workout_type', id: number } }> } }> } | undefined } | undefined };

export type IAthleteWeekQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type IAthleteWeekQuery = { __typename?: 'query_root', athlete_week_by_pk?: { __typename?: 'athlete_week', created_at: string, end_date?: any | undefined, id: number, name?: string | undefined, order: number, sport_id: string, start_date?: any | undefined, updated_at: string, athlete_block_id: number, athlete_block: { __typename?: 'athlete_block', athlete_id: number, id: number }, athlete_workouts: Array<{ __typename?: 'athlete_workout', created_at: string, updated_at: string, athlete_week_id: number, date: any, day: number, id: number, is_primary?: boolean | undefined, workout_type_id?: number | undefined, motivation?: number | undefined, effort?: number | undefined, comments?: string | undefined, series?: string | undefined, strava_activity_id?: any | undefined, measured_calories?: number | undefined, calories?: number | undefined, zuit?: number | undefined, positive_elevation?: number | undefined, negative_elevation?: number | undefined, measured_positive_elevation?: number | undefined, measured_negative_elevation?: number | undefined, type?: string | undefined, stretching_circuit_id?: number | undefined, stretching_circuit_repetitions?: number | undefined, completed_stretching_circuit?: number | undefined, weight_circuit_id?: number | undefined, weight_circuit_repetitions?: number | undefined, completed_weight_circuit?: number | undefined, workout_altimetry_id: number, workout_terrain_id: number, cumulative_elevation?: number | undefined, measured_cumulative_elevation?: number | undefined, stretching_circuit?: { __typename?: 'circuit', id: number, type: string, circuit_translations: Array<{ __typename?: 'circuit_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string } }>, circuit_exercises: Array<{ __typename?: 'circuit_exercise', id: number, circuit_id: number, duration?: number | undefined, exercise_id: number, no_of_series?: number | undefined, order?: number | undefined, repetitions?: number | undefined, exercise: { __typename?: 'exercise', id: number, media_url: string, type: string, target?: string | undefined, exercise_translations: Array<{ __typename?: 'exercise_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string } }> } }> } | undefined, weight_circuit?: { __typename?: 'circuit', id: number, type: string, circuit_translations: Array<{ __typename?: 'circuit_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string } }>, circuit_exercises: Array<{ __typename?: 'circuit_exercise', id: number, circuit_id: number, duration?: number | undefined, exercise_id: number, no_of_series?: number | undefined, order?: number | undefined, repetitions?: number | undefined, exercise: { __typename?: 'exercise', id: number, media_url: string, type: string, target?: string | undefined, exercise_translations: Array<{ __typename?: 'exercise_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string } }> } }> } | undefined, workout_altimetry: { __typename?: 'workout_altimetry', coefficient: number, icon?: string | undefined, id: number, name: string, workout_altimetry_translations: Array<{ __typename?: 'workout_altimetry_translation', id: number, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }> }, workout_terrain: { __typename?: 'workout_terrain', coefficient: number, icon?: string | undefined, id: number, workout_terrain_translations: Array<{ __typename?: 'workout_terrain_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }> }, workout_type?: { __typename?: 'workout_type', id: number, avatar: string, workout_type_translations: Array<{ __typename?: 'workout_type_translation', name?: string | undefined, locale: { __typename?: 'locale', code: string } }> } | undefined, athlete_workout_sections: Array<{ __typename?: 'athlete_workout_section', athlete_workout_id: number, duration?: number | undefined, max_heart_rate?: number | undefined, speed?: number | undefined, speed_percentage?: number | undefined, average_heart_rate?: number | undefined, average_heart_rate_percentage?: number | undefined, measured_duration?: number | undefined, measured_max_heart_rate?: number | undefined, measured_speed?: number | undefined, measured_average_heart_rate?: number | undefined, id: number, type?: string | undefined, workout_zone_id?: number | undefined, order?: number | undefined, planned_stress_score?: number | undefined, executed_stress_score?: number | undefined, workout_zone?: { __typename?: 'workout_zone', name: string, id: number, interval_start: number, interval_end: number } | undefined }> }> } | undefined };

export type IAthlete_WeekFragment = { __typename?: 'athlete_week', created_at: string, end_date?: any | undefined, id: number, name?: string | undefined, order: number, sport_id: string, start_date?: any | undefined, updated_at: string, athlete_block_id: number, athlete_block: { __typename?: 'athlete_block', athlete_id: number, id: number }, athlete_workouts: Array<{ __typename?: 'athlete_workout', created_at: string, updated_at: string, athlete_week_id: number, date: any, day: number, id: number, is_primary?: boolean | undefined, workout_type_id?: number | undefined, motivation?: number | undefined, effort?: number | undefined, comments?: string | undefined, series?: string | undefined, strava_activity_id?: any | undefined, measured_calories?: number | undefined, calories?: number | undefined, zuit?: number | undefined, positive_elevation?: number | undefined, negative_elevation?: number | undefined, measured_positive_elevation?: number | undefined, measured_negative_elevation?: number | undefined, type?: string | undefined, stretching_circuit_id?: number | undefined, stretching_circuit_repetitions?: number | undefined, completed_stretching_circuit?: number | undefined, weight_circuit_id?: number | undefined, weight_circuit_repetitions?: number | undefined, completed_weight_circuit?: number | undefined, workout_altimetry_id: number, workout_terrain_id: number, cumulative_elevation?: number | undefined, measured_cumulative_elevation?: number | undefined, stretching_circuit?: { __typename?: 'circuit', id: number, type: string, circuit_translations: Array<{ __typename?: 'circuit_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string } }>, circuit_exercises: Array<{ __typename?: 'circuit_exercise', id: number, circuit_id: number, duration?: number | undefined, exercise_id: number, no_of_series?: number | undefined, order?: number | undefined, repetitions?: number | undefined, exercise: { __typename?: 'exercise', id: number, media_url: string, type: string, target?: string | undefined, exercise_translations: Array<{ __typename?: 'exercise_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string } }> } }> } | undefined, weight_circuit?: { __typename?: 'circuit', id: number, type: string, circuit_translations: Array<{ __typename?: 'circuit_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string } }>, circuit_exercises: Array<{ __typename?: 'circuit_exercise', id: number, circuit_id: number, duration?: number | undefined, exercise_id: number, no_of_series?: number | undefined, order?: number | undefined, repetitions?: number | undefined, exercise: { __typename?: 'exercise', id: number, media_url: string, type: string, target?: string | undefined, exercise_translations: Array<{ __typename?: 'exercise_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string } }> } }> } | undefined, workout_altimetry: { __typename?: 'workout_altimetry', coefficient: number, icon?: string | undefined, id: number, name: string, workout_altimetry_translations: Array<{ __typename?: 'workout_altimetry_translation', id: number, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }> }, workout_terrain: { __typename?: 'workout_terrain', coefficient: number, icon?: string | undefined, id: number, workout_terrain_translations: Array<{ __typename?: 'workout_terrain_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }> }, workout_type?: { __typename?: 'workout_type', id: number, avatar: string, workout_type_translations: Array<{ __typename?: 'workout_type_translation', name?: string | undefined, locale: { __typename?: 'locale', code: string } }> } | undefined, athlete_workout_sections: Array<{ __typename?: 'athlete_workout_section', athlete_workout_id: number, duration?: number | undefined, max_heart_rate?: number | undefined, speed?: number | undefined, speed_percentage?: number | undefined, average_heart_rate?: number | undefined, average_heart_rate_percentage?: number | undefined, measured_duration?: number | undefined, measured_max_heart_rate?: number | undefined, measured_speed?: number | undefined, measured_average_heart_rate?: number | undefined, id: number, type?: string | undefined, workout_zone_id?: number | undefined, order?: number | undefined, planned_stress_score?: number | undefined, executed_stress_score?: number | undefined, workout_zone?: { __typename?: 'workout_zone', name: string, id: number, interval_start: number, interval_end: number } | undefined }> }> };

export type IAthleteWeeksByBlockQueryVariables = Exact<{
  blockId: Scalars['Int'];
}>;


export type IAthleteWeeksByBlockQuery = { __typename?: 'query_root', athlete_week: Array<{ __typename?: 'athlete_week', id: number, name?: string | undefined, order: number, start_date?: any | undefined, end_date?: any | undefined, athlete_block_id: number, athlete_workouts: Array<{ __typename?: 'athlete_workout', athlete_week_id: number, date: any, day: number, id: number, is_primary?: boolean | undefined, workout_type_id?: number | undefined, motivation?: number | undefined, effort?: number | undefined, comments?: string | undefined, series?: string | undefined, strava_activity_id?: any | undefined, measured_calories?: number | undefined, calories?: number | undefined, zuit?: number | undefined, positive_elevation?: number | undefined, negative_elevation?: number | undefined, measured_positive_elevation?: number | undefined, measured_negative_elevation?: number | undefined, type?: string | undefined, stretching_circuit_id?: number | undefined, stretching_circuit_repetitions?: number | undefined, completed_stretching_circuit?: number | undefined, weight_circuit_id?: number | undefined, weight_circuit_repetitions?: number | undefined, completed_weight_circuit?: number | undefined, workout_altimetry_id: number, workout_terrain_id: number, cumulative_elevation?: number | undefined, measured_cumulative_elevation?: number | undefined, stretching_circuit?: { __typename?: 'circuit', id: number, type: string, circuit_translations: Array<{ __typename?: 'circuit_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string } }>, circuit_exercises: Array<{ __typename?: 'circuit_exercise', id: number, circuit_id: number, duration?: number | undefined, exercise_id: number, no_of_series?: number | undefined, order?: number | undefined, repetitions?: number | undefined, exercise: { __typename?: 'exercise', id: number, media_url: string, type: string, target?: string | undefined, exercise_translations: Array<{ __typename?: 'exercise_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string } }> } }> } | undefined, weight_circuit?: { __typename?: 'circuit', id: number, type: string, circuit_translations: Array<{ __typename?: 'circuit_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string } }>, circuit_exercises: Array<{ __typename?: 'circuit_exercise', id: number, circuit_id: number, duration?: number | undefined, exercise_id: number, no_of_series?: number | undefined, order?: number | undefined, repetitions?: number | undefined, exercise: { __typename?: 'exercise', id: number, media_url: string, type: string, target?: string | undefined, exercise_translations: Array<{ __typename?: 'exercise_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string } }> } }> } | undefined, workout_altimetry: { __typename?: 'workout_altimetry', coefficient: number, icon?: string | undefined, id: number, name: string, workout_altimetry_translations: Array<{ __typename?: 'workout_altimetry_translation', id: number, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }> }, workout_terrain: { __typename?: 'workout_terrain', coefficient: number, icon?: string | undefined, id: number, workout_terrain_translations: Array<{ __typename?: 'workout_terrain_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }> }, workout_type?: { __typename?: 'workout_type', id: number, avatar: string, workout_type_translations: Array<{ __typename?: 'workout_type_translation', name?: string | undefined, locale: { __typename?: 'locale', code: string } }> } | undefined, athlete_workout_sections: Array<{ __typename?: 'athlete_workout_section', athlete_workout_id: number, duration?: number | undefined, max_heart_rate?: number | undefined, speed?: number | undefined, speed_percentage?: number | undefined, average_heart_rate?: number | undefined, average_heart_rate_percentage?: number | undefined, measured_duration?: number | undefined, measured_max_heart_rate?: number | undefined, measured_speed?: number | undefined, measured_average_heart_rate?: number | undefined, id: number, type?: string | undefined, workout_zone_id?: number | undefined, order?: number | undefined, planned_stress_score?: number | undefined, executed_stress_score?: number | undefined, workout_zone?: { __typename?: 'workout_zone', name: string, id: number, interval_start: number, interval_end: number } | undefined }> }> }> };

export type IAthleteWithoutWorkoutsQueryVariables = Exact<{
  _gte_date: Scalars['date'];
  _lte_date: Scalars['date'];
}>;


export type IAthleteWithoutWorkoutsQuery = { __typename?: 'query_root', athletes: Array<{ __typename?: 'athlete', id: number, name: string, avatar?: string | undefined, athlete_blocks: Array<{ __typename?: 'athlete_block', athlete_weeks: Array<{ __typename?: 'athlete_week', athlete_workouts: Array<{ __typename?: 'athlete_workout', id: number, date: any }> }> }> }> };

export type IAthletesListQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IAthlete_Bool_Exp>;
  order_by?: InputMaybe<Array<IAthlete_Order_By> | IAthlete_Order_By>;
}>;


export type IAthletesListQuery = { __typename?: 'query_root', athlete: Array<{ __typename?: 'athlete', id: number, name: string, avatar?: string | undefined, birthday?: any | undefined, status?: string | undefined, goal?: string | undefined, user: { __typename?: 'user', id: number, email: string, keycloak_id?: any | undefined }, sport?: { __typename?: 'sport', id: any, name: string, avatar?: string | undefined, image?: string | undefined, sport_translations: Array<{ __typename?: 'sport_translation', id: number, title?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }> } | undefined, athlete_challenges: Array<{ __typename?: 'athlete_challenge', description: string, date?: any | undefined }> }>, sport: Array<{ __typename?: 'sport', id: any, name: string, avatar?: string | undefined, image?: string | undefined, sport_translations: Array<{ __typename?: 'sport_translation', id: number, title?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }> }>, total: { __typename?: 'athlete_aggregate', aggregate?: { __typename?: 'athlete_aggregate_fields', count: number } | undefined } };

export type IAthleteFragment = { __typename?: 'athlete', id: number, name: string, avatar?: string | undefined, birthday?: any | undefined, status?: string | undefined, goal?: string | undefined, user: { __typename?: 'user', id: number, email: string, keycloak_id?: any | undefined }, sport?: { __typename?: 'sport', id: any, name: string, avatar?: string | undefined, image?: string | undefined, sport_translations: Array<{ __typename?: 'sport_translation', id: number, title?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }> } | undefined, athlete_challenges: Array<{ __typename?: 'athlete_challenge', description: string, date?: any | undefined }> };

export type IAthletesUploadsQueryVariables = Exact<{
  _gte_date: Scalars['date'];
  _lte_date: Scalars['date'];
}>;


export type IAthletesUploadsQuery = { __typename?: 'query_root', athletes: Array<{ __typename?: 'athlete', id: number, name: string, avatar?: string | undefined, athlete_blocks: Array<{ __typename?: 'athlete_block', athlete_weeks: Array<{ __typename?: 'athlete_week', athlete_workouts: Array<{ __typename?: 'athlete_workout', id: number, date: any, comments?: string | undefined, workout_type?: { __typename?: 'workout_type', avatar: string } | undefined, athlete_workout_sections: Array<{ __typename?: 'athlete_workout_section', type?: string | undefined, workout_zone?: { __typename?: 'workout_zone', name: string } | undefined }> }> }> }> }> };

export type IBlockDetailsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type IBlockDetailsQuery = { __typename?: 'query_root', block_template_by_pk?: { __typename?: 'block_template', id: number, name: string, description?: string | undefined, coach_id?: number | undefined, sport_id: string, sport: { __typename?: 'sport', id: any, name: string, avatar?: string | undefined }, week_templates: Array<{ __typename?: 'week_template', block_template_id: number, id: number, name: string, order: number, workout_templates: Array<{ __typename?: 'workout_template', day: number, id: number, is_primary: boolean, workout_type_id?: number | undefined, positive_elevation?: number | undefined, negative_elevation?: number | undefined, series?: string | undefined, type?: string | undefined, weight_circuit_repetitions?: number | undefined, stretching_circuit_repetitions?: number | undefined, workout_altimetry: { __typename?: 'workout_altimetry', icon?: string | undefined, workout_altimetry_translations: Array<{ __typename?: 'workout_altimetry_translation', description?: string | undefined, locale: { __typename?: 'locale', code: string } }> }, workout_section_templates: Array<{ __typename?: 'workout_section_template', average_heart_rate: number, duration: number, id: number, max_heart_rate: number, speed?: number | undefined, type?: string | undefined, order?: number | undefined, workout_zone?: { __typename?: 'workout_zone', name: string } | undefined }>, stretching_circuit?: { __typename?: 'circuit', id: number, type: string, circuit_translations: Array<{ __typename?: 'circuit_translation', name?: string | undefined, locale: { __typename?: 'locale', code: string } }> } | undefined, weight_circuit?: { __typename?: 'circuit', id: number, type: string, circuit_translations: Array<{ __typename?: 'circuit_translation', name?: string | undefined, locale: { __typename?: 'locale', code: string } }> } | undefined, workout_terrain: { __typename?: 'workout_terrain', icon?: string | undefined, workout_terrain_translations: Array<{ __typename?: 'workout_terrain_translation', name?: string | undefined, locale: { __typename?: 'locale', code: string } }> }, workout_type?: { __typename?: 'workout_type', avatar: string, workout_type_translations: Array<{ __typename?: 'workout_type_translation', name?: string | undefined, locale: { __typename?: 'locale', code: string } }> } | undefined }> }> } | undefined };

export type IBlock_Details_Workout_Section_TemplateFragment = { __typename?: 'workout_section_template', average_heart_rate: number, duration: number, id: number, max_heart_rate: number, speed?: number | undefined, type?: string | undefined, order?: number | undefined, workout_zone?: { __typename?: 'workout_zone', name: string } | undefined };

export type IBlock_Details_Workout_TemplateFragment = { __typename?: 'workout_template', day: number, id: number, is_primary: boolean, workout_type_id?: number | undefined, positive_elevation?: number | undefined, negative_elevation?: number | undefined, series?: string | undefined, type?: string | undefined, weight_circuit_repetitions?: number | undefined, stretching_circuit_repetitions?: number | undefined, workout_altimetry: { __typename?: 'workout_altimetry', icon?: string | undefined, workout_altimetry_translations: Array<{ __typename?: 'workout_altimetry_translation', description?: string | undefined, locale: { __typename?: 'locale', code: string } }> }, workout_section_templates: Array<{ __typename?: 'workout_section_template', average_heart_rate: number, duration: number, id: number, max_heart_rate: number, speed?: number | undefined, type?: string | undefined, order?: number | undefined, workout_zone?: { __typename?: 'workout_zone', name: string } | undefined }>, stretching_circuit?: { __typename?: 'circuit', id: number, type: string, circuit_translations: Array<{ __typename?: 'circuit_translation', name?: string | undefined, locale: { __typename?: 'locale', code: string } }> } | undefined, weight_circuit?: { __typename?: 'circuit', id: number, type: string, circuit_translations: Array<{ __typename?: 'circuit_translation', name?: string | undefined, locale: { __typename?: 'locale', code: string } }> } | undefined, workout_terrain: { __typename?: 'workout_terrain', icon?: string | undefined, workout_terrain_translations: Array<{ __typename?: 'workout_terrain_translation', name?: string | undefined, locale: { __typename?: 'locale', code: string } }> }, workout_type?: { __typename?: 'workout_type', avatar: string, workout_type_translations: Array<{ __typename?: 'workout_type_translation', name?: string | undefined, locale: { __typename?: 'locale', code: string } }> } | undefined };

export type IBlock_Details_Circuit_TemplateFragment = { __typename?: 'circuit', id: number, type: string, circuit_translations: Array<{ __typename?: 'circuit_translation', name?: string | undefined, locale: { __typename?: 'locale', code: string } }> };

export type IBlock_Details_Week_TemplateFragment = { __typename?: 'week_template', block_template_id: number, id: number, name: string, order: number, workout_templates: Array<{ __typename?: 'workout_template', day: number, id: number, is_primary: boolean, workout_type_id?: number | undefined, positive_elevation?: number | undefined, negative_elevation?: number | undefined, series?: string | undefined, type?: string | undefined, weight_circuit_repetitions?: number | undefined, stretching_circuit_repetitions?: number | undefined, workout_altimetry: { __typename?: 'workout_altimetry', icon?: string | undefined, workout_altimetry_translations: Array<{ __typename?: 'workout_altimetry_translation', description?: string | undefined, locale: { __typename?: 'locale', code: string } }> }, workout_section_templates: Array<{ __typename?: 'workout_section_template', average_heart_rate: number, duration: number, id: number, max_heart_rate: number, speed?: number | undefined, type?: string | undefined, order?: number | undefined, workout_zone?: { __typename?: 'workout_zone', name: string } | undefined }>, stretching_circuit?: { __typename?: 'circuit', id: number, type: string, circuit_translations: Array<{ __typename?: 'circuit_translation', name?: string | undefined, locale: { __typename?: 'locale', code: string } }> } | undefined, weight_circuit?: { __typename?: 'circuit', id: number, type: string, circuit_translations: Array<{ __typename?: 'circuit_translation', name?: string | undefined, locale: { __typename?: 'locale', code: string } }> } | undefined, workout_terrain: { __typename?: 'workout_terrain', icon?: string | undefined, workout_terrain_translations: Array<{ __typename?: 'workout_terrain_translation', name?: string | undefined, locale: { __typename?: 'locale', code: string } }> }, workout_type?: { __typename?: 'workout_type', avatar: string, workout_type_translations: Array<{ __typename?: 'workout_type_translation', name?: string | undefined, locale: { __typename?: 'locale', code: string } }> } | undefined }> };

export type IBlock_Details_Sport_TemplateFragment = { __typename?: 'sport', id: any, name: string, avatar?: string | undefined };

export type IBlock_Details_Block_TemplateFragment = { __typename?: 'block_template', id: number, name: string, description?: string | undefined, coach_id?: number | undefined, sport_id: string, sport: { __typename?: 'sport', id: any, name: string, avatar?: string | undefined }, week_templates: Array<{ __typename?: 'week_template', block_template_id: number, id: number, name: string, order: number, workout_templates: Array<{ __typename?: 'workout_template', day: number, id: number, is_primary: boolean, workout_type_id?: number | undefined, positive_elevation?: number | undefined, negative_elevation?: number | undefined, series?: string | undefined, type?: string | undefined, weight_circuit_repetitions?: number | undefined, stretching_circuit_repetitions?: number | undefined, workout_altimetry: { __typename?: 'workout_altimetry', icon?: string | undefined, workout_altimetry_translations: Array<{ __typename?: 'workout_altimetry_translation', description?: string | undefined, locale: { __typename?: 'locale', code: string } }> }, workout_section_templates: Array<{ __typename?: 'workout_section_template', average_heart_rate: number, duration: number, id: number, max_heart_rate: number, speed?: number | undefined, type?: string | undefined, order?: number | undefined, workout_zone?: { __typename?: 'workout_zone', name: string } | undefined }>, stretching_circuit?: { __typename?: 'circuit', id: number, type: string, circuit_translations: Array<{ __typename?: 'circuit_translation', name?: string | undefined, locale: { __typename?: 'locale', code: string } }> } | undefined, weight_circuit?: { __typename?: 'circuit', id: number, type: string, circuit_translations: Array<{ __typename?: 'circuit_translation', name?: string | undefined, locale: { __typename?: 'locale', code: string } }> } | undefined, workout_terrain: { __typename?: 'workout_terrain', icon?: string | undefined, workout_terrain_translations: Array<{ __typename?: 'workout_terrain_translation', name?: string | undefined, locale: { __typename?: 'locale', code: string } }> }, workout_type?: { __typename?: 'workout_type', avatar: string, workout_type_translations: Array<{ __typename?: 'workout_type_translation', name?: string | undefined, locale: { __typename?: 'locale', code: string } }> } | undefined }> }> };

export type IBlockTemplatesListQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IBlock_Template_Order_By> | IBlock_Template_Order_By>;
  where?: InputMaybe<IBlock_Template_Bool_Exp>;
}>;


export type IBlockTemplatesListQuery = { __typename?: 'query_root', block_template: Array<{ __typename?: 'block_template', id: number, name: string, created_at: string, coach_id?: number | undefined, description?: string | undefined, sport_id: string, updated_at: string, coach?: { __typename?: 'coach', id: number, name: string } | undefined, sport: { __typename?: 'sport', id: any, name: string, avatar?: string | undefined, image?: string | undefined, sport_translations: Array<{ __typename?: 'sport_translation', id: number, title?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }> }, week_templates: Array<{ __typename?: 'week_template', name: string }> }>, sport: Array<{ __typename?: 'sport', id: any, name: string, avatar?: string | undefined, image?: string | undefined, sport_translations: Array<{ __typename?: 'sport_translation', id: number, title?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }> }>, total: { __typename?: 'block_template_aggregate', aggregate?: { __typename?: 'block_template_aggregate_fields', count: number } | undefined } };

export type IBlock_TemplateFragment = { __typename?: 'block_template', id: number, name: string, created_at: string, coach_id?: number | undefined, description?: string | undefined, sport_id: string, updated_at: string, coach?: { __typename?: 'coach', id: number, name: string } | undefined, sport: { __typename?: 'sport', id: any, name: string, avatar?: string | undefined, image?: string | undefined, sport_translations: Array<{ __typename?: 'sport_translation', id: number, title?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }> }, week_templates: Array<{ __typename?: 'week_template', name: string }> };

export type IBlocksWithWeeksListQueryVariables = Exact<{
  where_week?: InputMaybe<IWeek_Template_Bool_Exp>;
  where_block?: InputMaybe<IBlock_Template_Bool_Exp>;
}>;


export type IBlocksWithWeeksListQuery = { __typename?: 'query_root', block_template: Array<{ __typename?: 'block_template', name: string, id: number, sport_id: string, week_templates: Array<{ __typename?: 'week_template', id: number, name: string, sport_id: string }> }> };

export type IBlock_Template_Basic_InfoFragment = { __typename?: 'block_template', name: string, id: number, sport_id: string, week_templates: Array<{ __typename?: 'week_template', id: number, name: string, sport_id: string }> };

export type IWeek_Template_Basic_InfoFragment = { __typename?: 'week_template', id: number, name: string, sport_id: string };

export type ICircuitAndExercicesListQueryVariables = Exact<{
  where_circuit?: InputMaybe<ICircuit_Bool_Exp>;
  where_exercise?: InputMaybe<IExercise_Bool_Exp>;
}>;


export type ICircuitAndExercicesListQuery = { __typename?: 'query_root', circuit: Array<{ __typename?: 'circuit', coach_id?: number | undefined, id: number, type: string, sports: Array<{ __typename?: 'circuit_sport', id: number, sport: { __typename?: 'sport', id: any, name: string, avatar?: string | undefined, image?: string | undefined, sport_translations: Array<{ __typename?: 'sport_translation', id: number, title?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }> } }>, circuit_translations: Array<{ __typename?: 'circuit_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string } }>, circuit_exercises: Array<{ __typename?: 'circuit_exercise', id: number, circuit_id: number, duration?: number | undefined, exercise_id: number, no_of_series?: number | undefined, order?: number | undefined, repetitions?: number | undefined, exercise: { __typename?: 'exercise', id: number, media_url: string, type: string, target?: string | undefined, exercise_translations: Array<{ __typename?: 'exercise_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string } }> } }> }>, exercise: Array<{ __typename?: 'exercise', coach_id?: number | undefined, id: number, media_url: string, type: string, target?: string | undefined, exercise_translations: Array<{ __typename?: 'exercise_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string } }> }> };

export type ICircuitDetailsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ICircuitDetailsQuery = { __typename?: 'query_root', circuit_by_pk?: { __typename?: 'circuit', recovery_interval?: number | undefined, coach_id?: number | undefined, id: number, type: string, sports: Array<{ __typename?: 'circuit_sport', id: number, sport: { __typename?: 'sport', id: any, name: string, avatar?: string | undefined, image?: string | undefined, sport_translations: Array<{ __typename?: 'sport_translation', id: number, title?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }> } }>, circuit_translations: Array<{ __typename?: 'circuit_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string } }>, circuit_exercises: Array<{ __typename?: 'circuit_exercise', id: number, circuit_id: number, duration?: number | undefined, exercise_id: number, no_of_series?: number | undefined, order?: number | undefined, repetitions?: number | undefined, exercise: { __typename?: 'exercise', id: number, media_url: string, type: string, target?: string | undefined, exercise_translations: Array<{ __typename?: 'exercise_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string } }> } }> } | undefined };

export type ICoachBaseInfoQueryVariables = Exact<{
  keycloak_id: Scalars['uuid'];
}>;


export type ICoachBaseInfoQuery = { __typename?: 'query_root', user: Array<{ __typename?: 'user', id: number, name?: string | undefined, type?: string | undefined, coach?: { __typename?: 'coach', id: number, name: string, profile_picture?: string | undefined, platform_content_access: boolean, is_verified: boolean, sports: Array<{ __typename?: 'coach_sport', id: number, sport: { __typename?: 'sport', id: any, name: string, avatar?: string | undefined, image?: string | undefined, sport_translations: Array<{ __typename?: 'sport_translation', id: number, title?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }> } }> } | undefined }> };

export type ICoachBaseInfoFragment = { __typename?: 'user', id: number, name?: string | undefined, type?: string | undefined, coach?: { __typename?: 'coach', id: number, name: string, profile_picture?: string | undefined, platform_content_access: boolean, is_verified: boolean, sports: Array<{ __typename?: 'coach_sport', id: number, sport: { __typename?: 'sport', id: any, name: string, avatar?: string | undefined, image?: string | undefined, sport_translations: Array<{ __typename?: 'sport_translation', id: number, title?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }> } }> } | undefined };

export type ICoachDetailsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ICoachDetailsQuery = { __typename?: 'query_root', coach_by_pk?: { __typename?: 'coach', id: number, name: string, phone?: string | undefined, profile_picture?: string | undefined, user_id: number, is_verified: boolean, public?: boolean | undefined, spoken_languages?: string[] | undefined, platform_content_access: boolean, platform_fee: any, fiscal_id_number: string, address_street: string, address_city: string, address_country: string, address_postal_code: string, sports: Array<{ __typename?: 'coach_sport', id: number, sport: { __typename?: 'sport', id: any, name: string, avatar?: string | undefined, image?: string | undefined, sport_translations: Array<{ __typename?: 'sport_translation', id: number, title?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }> } }>, user: { __typename?: 'user', id: number, email: string }, coach_translations: Array<{ __typename?: 'coach_translation', id: number, bio?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }>, athletes: Array<{ __typename?: 'athlete', id: number, avatar?: string | undefined, birthday?: any | undefined, sport_id?: string | undefined, status?: string | undefined, goal?: string | undefined, gender?: string | undefined, name: string, athlete_profile_id?: number | undefined, user: { __typename?: 'user', email: string }, athlete_challenges: Array<{ __typename?: 'athlete_challenge', description: string }>, sport?: { __typename?: 'sport', id: any, name: string, avatar?: string | undefined, image?: string | undefined, sport_translations: Array<{ __typename?: 'sport_translation', id: number, title?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }> } | undefined, athlete_profile?: { __typename?: 'athlete_profile', id: number, name: string } | undefined, subscriptions: Array<{ __typename?: 'subscription', date_start: any, date_end: any, price?: number | undefined, status: string, interval_count?: number | undefined, subscription_plan: { __typename?: 'subscription_plan', level?: number | undefined, sport?: { __typename?: 'sport', id: any, name: string, avatar?: string | undefined, image?: string | undefined, sport_translations: Array<{ __typename?: 'sport_translation', id: number, title?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }> } | undefined, subscription_plan_translations: Array<{ __typename?: 'subscription_plan_translation', description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }> } }> }> } | undefined, sport: Array<{ __typename?: 'sport', id: any, name: string, avatar?: string | undefined, image?: string | undefined, sport_translations: Array<{ __typename?: 'sport_translation', id: number, title?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }> }> };

export type ICoachDetailsFragment = { __typename?: 'coach', id: number, name: string, phone?: string | undefined, profile_picture?: string | undefined, user_id: number, is_verified: boolean, public?: boolean | undefined, spoken_languages?: string[] | undefined, platform_content_access: boolean, platform_fee: any, fiscal_id_number: string, address_street: string, address_city: string, address_country: string, address_postal_code: string, sports: Array<{ __typename?: 'coach_sport', id: number, sport: { __typename?: 'sport', id: any, name: string, avatar?: string | undefined, image?: string | undefined, sport_translations: Array<{ __typename?: 'sport_translation', id: number, title?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }> } }>, user: { __typename?: 'user', id: number, email: string }, coach_translations: Array<{ __typename?: 'coach_translation', id: number, bio?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }>, athletes: Array<{ __typename?: 'athlete', id: number, avatar?: string | undefined, birthday?: any | undefined, sport_id?: string | undefined, status?: string | undefined, goal?: string | undefined, gender?: string | undefined, name: string, athlete_profile_id?: number | undefined, user: { __typename?: 'user', email: string }, athlete_challenges: Array<{ __typename?: 'athlete_challenge', description: string }>, sport?: { __typename?: 'sport', id: any, name: string, avatar?: string | undefined, image?: string | undefined, sport_translations: Array<{ __typename?: 'sport_translation', id: number, title?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }> } | undefined, athlete_profile?: { __typename?: 'athlete_profile', id: number, name: string } | undefined, subscriptions: Array<{ __typename?: 'subscription', date_start: any, date_end: any, price?: number | undefined, status: string, interval_count?: number | undefined, subscription_plan: { __typename?: 'subscription_plan', level?: number | undefined, sport?: { __typename?: 'sport', id: any, name: string, avatar?: string | undefined, image?: string | undefined, sport_translations: Array<{ __typename?: 'sport_translation', id: number, title?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }> } | undefined, subscription_plan_translations: Array<{ __typename?: 'subscription_plan_translation', description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }> } }> }> };

export type ICoachDetailsAthleteFragment = { __typename?: 'athlete', id: number, avatar?: string | undefined, birthday?: any | undefined, sport_id?: string | undefined, status?: string | undefined, goal?: string | undefined, gender?: string | undefined, name: string, athlete_profile_id?: number | undefined, user: { __typename?: 'user', email: string }, athlete_challenges: Array<{ __typename?: 'athlete_challenge', description: string }>, sport?: { __typename?: 'sport', id: any, name: string, avatar?: string | undefined, image?: string | undefined, sport_translations: Array<{ __typename?: 'sport_translation', id: number, title?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }> } | undefined, athlete_profile?: { __typename?: 'athlete_profile', id: number, name: string } | undefined, subscriptions: Array<{ __typename?: 'subscription', date_start: any, date_end: any, price?: number | undefined, status: string, interval_count?: number | undefined, subscription_plan: { __typename?: 'subscription_plan', level?: number | undefined, sport?: { __typename?: 'sport', id: any, name: string, avatar?: string | undefined, image?: string | undefined, sport_translations: Array<{ __typename?: 'sport_translation', id: number, title?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }> } | undefined, subscription_plan_translations: Array<{ __typename?: 'subscription_plan_translation', description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }> } }> };

export type ICoachDetailsAthleteSubscriptionFragment = { __typename?: 'subscription', date_start: any, date_end: any, price?: number | undefined, status: string, interval_count?: number | undefined, subscription_plan: { __typename?: 'subscription_plan', level?: number | undefined, sport?: { __typename?: 'sport', id: any, name: string, avatar?: string | undefined, image?: string | undefined, sport_translations: Array<{ __typename?: 'sport_translation', id: number, title?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }> } | undefined, subscription_plan_translations: Array<{ __typename?: 'subscription_plan_translation', description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }> } };

export type ICoachesListQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ICoach_Bool_Exp>;
}>;


export type ICoachesListQuery = { __typename?: 'query_root', coach: Array<{ __typename?: 'coach', id: number, name: string, created_at: string, user_id: number, profile_picture?: string | undefined, is_verified: boolean, user: { __typename?: 'user', email: string }, coach_translations: Array<{ __typename?: 'coach_translation', id: number, bio?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }>, sports: Array<{ __typename?: 'coach_sport', id: number, sport: { __typename?: 'sport', id: any, name: string, avatar?: string | undefined, image?: string | undefined, sport_translations: Array<{ __typename?: 'sport_translation', id: number, title?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }> } }>, no_of_athletes: { __typename?: 'athlete_aggregate', aggregate?: { __typename?: 'athlete_aggregate_fields', count: number } | undefined } }>, total: { __typename?: 'coach_aggregate', aggregate?: { __typename?: 'coach_aggregate_fields', count: number } | undefined } };

export type ICoachFragment = { __typename?: 'coach', id: number, name: string, created_at: string, user_id: number, profile_picture?: string | undefined, is_verified: boolean, user: { __typename?: 'user', email: string }, coach_translations: Array<{ __typename?: 'coach_translation', id: number, bio?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }>, sports: Array<{ __typename?: 'coach_sport', id: number, sport: { __typename?: 'sport', id: any, name: string, avatar?: string | undefined, image?: string | undefined, sport_translations: Array<{ __typename?: 'sport_translation', id: number, title?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }> } }>, no_of_athletes: { __typename?: 'athlete_aggregate', aggregate?: { __typename?: 'athlete_aggregate_fields', count: number } | undefined } };

export type ICouponsListQueryVariables = Exact<{
  where?: InputMaybe<ICoupon_Bool_Exp>;
  order_by?: InputMaybe<Array<ICoupon_Order_By> | ICoupon_Order_By>;
}>;


export type ICouponsListQuery = { __typename?: 'query_root', coupon: Array<{ __typename?: 'coupon', created_at: string, duration: string, duration_in_months?: number | undefined, id: number, name: string, percent_off: number, promo_code: string, times_redeemed?: number | undefined, updated_at: string, valid?: boolean | undefined, subscription_plan?: { __typename?: 'subscription_plan', id: number, image?: string | undefined, level?: number | undefined, is_verified?: boolean | undefined, coach_id?: number | undefined, min_duration?: number | undefined, quarterly_discount?: number | undefined, recomended_duration?: number | undefined, created_at: string, biannualy_discount?: number | undefined, weekly_price?: number | undefined, yearly_discount?: number | undefined, sport_id?: string | undefined, coach?: { __typename?: 'coach', id: number, name: string } | undefined, sport?: { __typename?: 'sport', id: any, name: string, avatar?: string | undefined, image?: string | undefined, sport_translations: Array<{ __typename?: 'sport_translation', id: number, title?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }> } | undefined, subscription_plan_translations: Array<{ __typename?: 'subscription_plan_translation', id: number, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }>, subscription_plan_prices: Array<{ __typename?: 'subscription_plan_price', id: number, interval_count: number, unit_amount: number }> } | undefined }> };

export type ICouponFragment = { __typename?: 'coupon', created_at: string, duration: string, duration_in_months?: number | undefined, id: number, name: string, percent_off: number, promo_code: string, times_redeemed?: number | undefined, updated_at: string, valid?: boolean | undefined, subscription_plan?: { __typename?: 'subscription_plan', id: number, image?: string | undefined, level?: number | undefined, is_verified?: boolean | undefined, coach_id?: number | undefined, min_duration?: number | undefined, quarterly_discount?: number | undefined, recomended_duration?: number | undefined, created_at: string, biannualy_discount?: number | undefined, weekly_price?: number | undefined, yearly_discount?: number | undefined, sport_id?: string | undefined, coach?: { __typename?: 'coach', id: number, name: string } | undefined, sport?: { __typename?: 'sport', id: any, name: string, avatar?: string | undefined, image?: string | undefined, sport_translations: Array<{ __typename?: 'sport_translation', id: number, title?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }> } | undefined, subscription_plan_translations: Array<{ __typename?: 'subscription_plan_translation', id: number, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }>, subscription_plan_prices: Array<{ __typename?: 'subscription_plan_price', id: number, interval_count: number, unit_amount: number }> } | undefined };

export type IExercisesListQueryVariables = Exact<{
  where?: InputMaybe<IExercise_Bool_Exp>;
}>;


export type IExercisesListQuery = { __typename?: 'query_root', exercise: Array<{ __typename?: 'exercise', id: number, media_url: string, type: string, target?: string | undefined, exercise_translations: Array<{ __typename?: 'exercise_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string } }> }> };

export type ILocalesListQueryVariables = Exact<{ [key: string]: never; }>;


export type ILocalesListQuery = { __typename?: 'query_root', locale: Array<{ __typename?: 'locale', id: number, code: string, language: string }> };

export type IReviewDetailsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type IReviewDetailsQuery = { __typename?: 'query_root', review_by_pk?: { __typename?: 'review', id: number, image?: string | undefined, name: string, review_translations: Array<{ __typename?: 'review_translation', id: number, text?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }> } | undefined };

export type IReviewsListQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IReview_Bool_Exp>;
}>;


export type IReviewsListQuery = { __typename?: 'query_root', review: Array<{ __typename?: 'review', image?: string | undefined, id: number, name: string, review_translations: Array<{ __typename?: 'review_translation', id: number, text?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }> }> };

export type ISportDetailsQueryVariables = Exact<{
  id: Scalars['name'];
}>;


export type ISportDetailsQuery = { __typename?: 'query_root', sport_by_pk?: { __typename?: 'sport', id: any, name: string, avatar?: string | undefined, image?: string | undefined, coaches: Array<{ __typename?: 'coach_sport', id: number, coach: { __typename?: 'coach', id: number, name: string, profile_picture?: string | undefined } }>, athletes: Array<{ __typename?: 'athlete', id: number, name: string, avatar?: string | undefined }>, subscription_plan_templates: Array<{ __typename?: 'subscription_plan_template', id: number, min_duration?: number | undefined, quarterly_discount?: number | undefined, recomended_duration?: number | undefined, created_at: string, biannualy_discount?: number | undefined, weekly_price?: number | undefined, yearly_discount?: number | undefined, sport_id?: string | undefined, level?: number | undefined }>, sport_translations: Array<{ __typename?: 'sport_translation', id: number, title?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }> } | undefined };

export type ISportsListQueryVariables = Exact<{
  where?: InputMaybe<ISport_Bool_Exp>;
}>;


export type ISportsListQuery = { __typename?: 'query_root', sport: Array<{ __typename?: 'sport', id: any, name: string, avatar?: string | undefined, image?: string | undefined, sport_translations: Array<{ __typename?: 'sport_translation', id: number, title?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }> }> };

export type ISubscriptionPaymentsListQueryVariables = Exact<{
  coach_id: Scalars['Int'];
  where: ISubscription_Payment_Bool_Exp;
}>;


export type ISubscriptionPaymentsListQuery = { __typename?: 'query_root', subscription_payment: Array<{ __typename?: 'subscription_payment', id: number, created_at: string, updated_at: string, discount_name?: string | undefined, discount_percentage?: string | undefined, amount: any, platform_fee: any, subscription: { __typename?: 'subscription', id: number, status: string, price?: number | undefined, date_start: any, date_end: any, athlete?: { __typename?: 'athlete', id: number, name: string, fiscal_id_number?: string | undefined } | undefined, subscription_plan: { __typename?: 'subscription_plan', id: number, level?: number | undefined, sport?: { __typename?: 'sport', id: any, name: string, avatar?: string | undefined, image?: string | undefined, sport_translations: Array<{ __typename?: 'sport_translation', id: number, title?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }> } | undefined, subscription_plan_translations: Array<{ __typename?: 'subscription_plan_translation', id: number, description?: string | undefined, created_at: string, locale: { __typename?: 'locale', id: number, code: string, language: string } }> } } }> };

export type ISubscriptionPlanDetailsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ISubscriptionPlanDetailsQuery = { __typename?: 'query_root', subscription_plan_by_pk?: { __typename?: 'subscription_plan', id: number, image?: string | undefined, level?: number | undefined, is_verified?: boolean | undefined, coach_id?: number | undefined, min_duration?: number | undefined, quarterly_discount?: number | undefined, recomended_duration?: number | undefined, created_at: string, biannualy_discount?: number | undefined, weekly_price?: number | undefined, yearly_discount?: number | undefined, sport_id?: string | undefined, coach?: { __typename?: 'coach', id: number, name: string } | undefined, sport?: { __typename?: 'sport', id: any, name: string, avatar?: string | undefined, image?: string | undefined, sport_translations: Array<{ __typename?: 'sport_translation', id: number, title?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }> } | undefined, subscription_plan_translations: Array<{ __typename?: 'subscription_plan_translation', id: number, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }>, subscription_plan_prices: Array<{ __typename?: 'subscription_plan_price', id: number, interval_count: number, unit_amount: number }> } | undefined };

export type ISubscription_Plan_DetailsFragment = { __typename?: 'subscription_plan', id: number, image?: string | undefined, level?: number | undefined, is_verified?: boolean | undefined, coach_id?: number | undefined, min_duration?: number | undefined, quarterly_discount?: number | undefined, recomended_duration?: number | undefined, created_at: string, biannualy_discount?: number | undefined, weekly_price?: number | undefined, yearly_discount?: number | undefined, sport_id?: string | undefined, coach?: { __typename?: 'coach', id: number, name: string } | undefined, sport?: { __typename?: 'sport', id: any, name: string, avatar?: string | undefined, image?: string | undefined, sport_translations: Array<{ __typename?: 'sport_translation', id: number, title?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }> } | undefined, subscription_plan_translations: Array<{ __typename?: 'subscription_plan_translation', id: number, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }>, subscription_plan_prices: Array<{ __typename?: 'subscription_plan_price', id: number, interval_count: number, unit_amount: number }> };

export type ISubscriptionPlanTemplateListQueryVariables = Exact<{
  where?: InputMaybe<ISubscription_Plan_Template_Bool_Exp>;
}>;


export type ISubscriptionPlanTemplateListQuery = { __typename?: 'query_root', subscription_plan_template: Array<{ __typename?: 'subscription_plan_template', id: number, min_duration?: number | undefined, quarterly_discount?: number | undefined, recomended_duration?: number | undefined, created_at: string, biannualy_discount?: number | undefined, weekly_price?: number | undefined, yearly_discount?: number | undefined, sport_id?: string | undefined, level?: number | undefined }> };

export type ISubscription_Plan_TemplateFragment = { __typename?: 'subscription_plan_template', id: number, min_duration?: number | undefined, quarterly_discount?: number | undefined, recomended_duration?: number | undefined, created_at: string, biannualy_discount?: number | undefined, weekly_price?: number | undefined, yearly_discount?: number | undefined, sport_id?: string | undefined, level?: number | undefined };

export type ISubscriptionsListQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ISubscription_Order_By> | ISubscription_Order_By>;
  where?: InputMaybe<ISubscription_Bool_Exp>;
}>;


export type ISubscriptionsListQuery = { __typename?: 'query_root', subscription: Array<{ __typename?: 'subscription', athlete_id?: number | undefined, created_at: string, date_end: any, date_start: any, id: number, status: string, subscription_plan_id: number, price?: number | undefined, interval_count?: number | undefined, athlete?: { __typename?: 'athlete', name: string, id: number, user_id: number } | undefined, subscription_plan: { __typename?: 'subscription_plan', id: number, level?: number | undefined, subscription_plan_translations: Array<{ __typename?: 'subscription_plan_translation', description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }> } }>, total: { __typename?: 'subscription_aggregate', aggregate?: { __typename?: 'subscription_aggregate_fields', count: number } | undefined } };

export type ISubscriptionFragment = { __typename?: 'subscription', athlete_id?: number | undefined, created_at: string, date_end: any, date_start: any, id: number, status: string, subscription_plan_id: number, price?: number | undefined, interval_count?: number | undefined, athlete?: { __typename?: 'athlete', name: string, id: number, user_id: number } | undefined, subscription_plan: { __typename?: 'subscription_plan', id: number, level?: number | undefined, subscription_plan_translations: Array<{ __typename?: 'subscription_plan_translation', description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }> } };

export type ISubscriptionPlansListQueryVariables = Exact<{
  where?: InputMaybe<ISubscription_Plan_Bool_Exp>;
}>;


export type ISubscriptionPlansListQuery = { __typename?: 'query_root', subscription_plan: Array<{ __typename?: 'subscription_plan', id: number, image?: string | undefined, level?: number | undefined, is_verified?: boolean | undefined, min_duration?: number | undefined, quarterly_discount?: number | undefined, recomended_duration?: number | undefined, created_at: string, biannualy_discount?: number | undefined, weekly_price?: number | undefined, yearly_discount?: number | undefined, sport_id?: string | undefined, stripe_product_id?: string | undefined, sport?: { __typename?: 'sport', id: any, name: string, avatar?: string | undefined, image?: string | undefined, sport_translations: Array<{ __typename?: 'sport_translation', id: number, title?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }> } | undefined, coach?: { __typename?: 'coach', id: number, name: string } | undefined, subscription_plan_prices: Array<{ __typename?: 'subscription_plan_price', id: number, interval_count: number, unit_amount: number }>, subscription_plan_translations: Array<{ __typename?: 'subscription_plan_translation', id: number, description?: string | undefined, created_at: string, subscription_plan_id: number, locale: { __typename?: 'locale', id: number, code: string, language: string } }> }> };

export type ISubscription_PlanFragment = { __typename?: 'subscription_plan', id: number, image?: string | undefined, level?: number | undefined, is_verified?: boolean | undefined, min_duration?: number | undefined, quarterly_discount?: number | undefined, recomended_duration?: number | undefined, created_at: string, biannualy_discount?: number | undefined, weekly_price?: number | undefined, yearly_discount?: number | undefined, sport_id?: string | undefined, stripe_product_id?: string | undefined, sport?: { __typename?: 'sport', id: any, name: string, avatar?: string | undefined, image?: string | undefined, sport_translations: Array<{ __typename?: 'sport_translation', id: number, title?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }> } | undefined, coach?: { __typename?: 'coach', id: number, name: string } | undefined, subscription_plan_prices: Array<{ __typename?: 'subscription_plan_price', id: number, interval_count: number, unit_amount: number }>, subscription_plan_translations: Array<{ __typename?: 'subscription_plan_translation', id: number, description?: string | undefined, created_at: string, subscription_plan_id: number, locale: { __typename?: 'locale', id: number, code: string, language: string } }> };

export type IWeekDetailsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type IWeekDetailsQuery = { __typename?: 'query_root', week_template_by_pk?: { __typename?: 'week_template', created_at: string, block_template_id: number, id: number, name: string, order: number, sport_id: string, updated_at: string, sport: { __typename?: 'sport', id: any, name: string, avatar?: string | undefined, image?: string | undefined, sport_translations: Array<{ __typename?: 'sport_translation', id: number, title?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }> }, workout_templates: Array<{ __typename?: 'workout_template', created_at: string, day: number, id: number, is_primary: boolean, workout_type_id?: number | undefined, workout_terrain_id: number, workout_zone_id?: number | undefined, stretching_circuit_id?: number | undefined, weight_circuit_id?: number | undefined, updated_at: string, week_template_id: number, workout_altimetry_id: number, workout_altimetry: { __typename?: 'workout_altimetry', id: number, name: string, icon?: string | undefined, workout_altimetry_translations: Array<{ __typename?: 'workout_altimetry_translation', id: number, description?: string | undefined, locale: { __typename?: 'locale', code: string, language: string } }> }, workout_section_templates: Array<{ __typename?: 'workout_section_template', average_heart_rate: number, created_at: string, duration: number, id: number, max_heart_rate: number, updated_at: string, workout_template_id: number }>, stretching_circuit?: { __typename?: 'circuit', id: number, type: string, circuit_translations: Array<{ __typename?: 'circuit_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string } }>, circuit_exercises: Array<{ __typename?: 'circuit_exercise', id: number, circuit_id: number, duration?: number | undefined, exercise_id: number, no_of_series?: number | undefined, order?: number | undefined, repetitions?: number | undefined, exercise: { __typename?: 'exercise', id: number, media_url: string, type: string, target?: string | undefined, exercise_translations: Array<{ __typename?: 'exercise_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string } }> } }> } | undefined, weight_circuit?: { __typename?: 'circuit', id: number, type: string, circuit_translations: Array<{ __typename?: 'circuit_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string } }>, circuit_exercises: Array<{ __typename?: 'circuit_exercise', id: number, circuit_id: number, duration?: number | undefined, exercise_id: number, no_of_series?: number | undefined, order?: number | undefined, repetitions?: number | undefined, exercise: { __typename?: 'exercise', id: number, media_url: string, type: string, target?: string | undefined, exercise_translations: Array<{ __typename?: 'exercise_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string } }> } }> } | undefined, workout_terrain: { __typename?: 'workout_terrain', icon?: string | undefined, id: number, workout_terrain_translations: Array<{ __typename?: 'workout_terrain_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', code: string, language: string } }> }, workout_type?: { __typename?: 'workout_type', id: number, avatar: string, workout_type_translations: Array<{ __typename?: 'workout_type_translation', name?: string | undefined, locale: { __typename?: 'locale', code: string } }> } | undefined, workout_zone?: { __typename?: 'workout_zone', id: number, name: string } | undefined }> } | undefined };

export type IWeek_Details_Workout_Section_TemplateFragment = { __typename?: 'workout_section_template', average_heart_rate: number, created_at: string, duration: number, id: number, max_heart_rate: number, updated_at: string, workout_template_id: number };

export type IWeek_Details_Workout_TemplateFragment = { __typename?: 'workout_template', created_at: string, day: number, id: number, is_primary: boolean, workout_type_id?: number | undefined, workout_terrain_id: number, workout_zone_id?: number | undefined, stretching_circuit_id?: number | undefined, weight_circuit_id?: number | undefined, updated_at: string, week_template_id: number, workout_altimetry_id: number, workout_altimetry: { __typename?: 'workout_altimetry', id: number, name: string, icon?: string | undefined, workout_altimetry_translations: Array<{ __typename?: 'workout_altimetry_translation', id: number, description?: string | undefined, locale: { __typename?: 'locale', code: string, language: string } }> }, workout_section_templates: Array<{ __typename?: 'workout_section_template', average_heart_rate: number, created_at: string, duration: number, id: number, max_heart_rate: number, updated_at: string, workout_template_id: number }>, stretching_circuit?: { __typename?: 'circuit', id: number, type: string, circuit_translations: Array<{ __typename?: 'circuit_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string } }>, circuit_exercises: Array<{ __typename?: 'circuit_exercise', id: number, circuit_id: number, duration?: number | undefined, exercise_id: number, no_of_series?: number | undefined, order?: number | undefined, repetitions?: number | undefined, exercise: { __typename?: 'exercise', id: number, media_url: string, type: string, target?: string | undefined, exercise_translations: Array<{ __typename?: 'exercise_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string } }> } }> } | undefined, weight_circuit?: { __typename?: 'circuit', id: number, type: string, circuit_translations: Array<{ __typename?: 'circuit_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string } }>, circuit_exercises: Array<{ __typename?: 'circuit_exercise', id: number, circuit_id: number, duration?: number | undefined, exercise_id: number, no_of_series?: number | undefined, order?: number | undefined, repetitions?: number | undefined, exercise: { __typename?: 'exercise', id: number, media_url: string, type: string, target?: string | undefined, exercise_translations: Array<{ __typename?: 'exercise_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string } }> } }> } | undefined, workout_terrain: { __typename?: 'workout_terrain', icon?: string | undefined, id: number, workout_terrain_translations: Array<{ __typename?: 'workout_terrain_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', code: string, language: string } }> }, workout_type?: { __typename?: 'workout_type', id: number, avatar: string, workout_type_translations: Array<{ __typename?: 'workout_type_translation', name?: string | undefined, locale: { __typename?: 'locale', code: string } }> } | undefined, workout_zone?: { __typename?: 'workout_zone', id: number, name: string } | undefined };

export type IWeek_Details_Week_TemplateFragment = { __typename?: 'week_template', created_at: string, block_template_id: number, id: number, name: string, order: number, sport_id: string, updated_at: string, sport: { __typename?: 'sport', id: any, name: string, avatar?: string | undefined, image?: string | undefined, sport_translations: Array<{ __typename?: 'sport_translation', id: number, title?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }> }, workout_templates: Array<{ __typename?: 'workout_template', created_at: string, day: number, id: number, is_primary: boolean, workout_type_id?: number | undefined, workout_terrain_id: number, workout_zone_id?: number | undefined, stretching_circuit_id?: number | undefined, weight_circuit_id?: number | undefined, updated_at: string, week_template_id: number, workout_altimetry_id: number, workout_altimetry: { __typename?: 'workout_altimetry', id: number, name: string, icon?: string | undefined, workout_altimetry_translations: Array<{ __typename?: 'workout_altimetry_translation', id: number, description?: string | undefined, locale: { __typename?: 'locale', code: string, language: string } }> }, workout_section_templates: Array<{ __typename?: 'workout_section_template', average_heart_rate: number, created_at: string, duration: number, id: number, max_heart_rate: number, updated_at: string, workout_template_id: number }>, stretching_circuit?: { __typename?: 'circuit', id: number, type: string, circuit_translations: Array<{ __typename?: 'circuit_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string } }>, circuit_exercises: Array<{ __typename?: 'circuit_exercise', id: number, circuit_id: number, duration?: number | undefined, exercise_id: number, no_of_series?: number | undefined, order?: number | undefined, repetitions?: number | undefined, exercise: { __typename?: 'exercise', id: number, media_url: string, type: string, target?: string | undefined, exercise_translations: Array<{ __typename?: 'exercise_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string } }> } }> } | undefined, weight_circuit?: { __typename?: 'circuit', id: number, type: string, circuit_translations: Array<{ __typename?: 'circuit_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string } }>, circuit_exercises: Array<{ __typename?: 'circuit_exercise', id: number, circuit_id: number, duration?: number | undefined, exercise_id: number, no_of_series?: number | undefined, order?: number | undefined, repetitions?: number | undefined, exercise: { __typename?: 'exercise', id: number, media_url: string, type: string, target?: string | undefined, exercise_translations: Array<{ __typename?: 'exercise_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string } }> } }> } | undefined, workout_terrain: { __typename?: 'workout_terrain', icon?: string | undefined, id: number, workout_terrain_translations: Array<{ __typename?: 'workout_terrain_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', code: string, language: string } }> }, workout_type?: { __typename?: 'workout_type', id: number, avatar: string, workout_type_translations: Array<{ __typename?: 'workout_type_translation', name?: string | undefined, locale: { __typename?: 'locale', code: string } }> } | undefined, workout_zone?: { __typename?: 'workout_zone', id: number, name: string } | undefined }> };

export type IWeekTemplatesListQueryVariables = Exact<{
  where?: InputMaybe<IWeek_Template_Bool_Exp>;
  order_by?: InputMaybe<Array<IWeek_Template_Order_By> | IWeek_Template_Order_By>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type IWeekTemplatesListQuery = { __typename?: 'query_root', week_template: Array<{ __typename?: 'week_template', id: number, name: string, sport_id: string, created_at: string, order: number, sport: { __typename?: 'sport', id: any, name: string, avatar?: string | undefined, image?: string | undefined, sport_translations: Array<{ __typename?: 'sport_translation', id: number, title?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }> } }>, sport: Array<{ __typename?: 'sport', id: any, name: string, avatar?: string | undefined, image?: string | undefined, sport_translations: Array<{ __typename?: 'sport_translation', id: number, title?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }> }>, total: { __typename?: 'week_template_aggregate', aggregate?: { __typename?: 'week_template_aggregate_fields', count: number } | undefined } };

export type IWeek_TemplateFragment = { __typename?: 'week_template', id: number, name: string, sport_id: string, created_at: string, order: number, sport: { __typename?: 'sport', id: any, name: string, avatar?: string | undefined, image?: string | undefined, sport_translations: Array<{ __typename?: 'sport_translation', id: number, title?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }> } };

export type IWorkoutAltimetriesQueryVariables = Exact<{
  where?: InputMaybe<IWorkout_Altimetry_Bool_Exp>;
}>;


export type IWorkoutAltimetriesQuery = { __typename?: 'query_root', workout_altimetry: Array<{ __typename?: 'workout_altimetry', id: number, name: string, coefficient: number, icon?: string | undefined, workout_altimetry_translations: Array<{ __typename?: 'workout_altimetry_translation', id: number, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }>, workout_altimetry_workout_types: Array<{ __typename?: 'workout_altimetry_workout_type', id: number, workout_type: { __typename?: 'workout_type', id: number, avatar: string, workout_type_translations: Array<{ __typename?: 'workout_type_translation', name?: string | undefined, locale: { __typename?: 'locale', code: string } }> } }> }>, workout_type: Array<{ __typename?: 'workout_type', id: number, avatar: string, workout_type_translations: Array<{ __typename?: 'workout_type_translation', name?: string | undefined, locale: { __typename?: 'locale', code: string } }> }> };

export type IWorkout_AltimetryFragment = { __typename?: 'workout_altimetry', id: number, name: string, coefficient: number, icon?: string | undefined, workout_altimetry_translations: Array<{ __typename?: 'workout_altimetry_translation', id: number, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }>, workout_altimetry_workout_types: Array<{ __typename?: 'workout_altimetry_workout_type', id: number, workout_type: { __typename?: 'workout_type', id: number, avatar: string, workout_type_translations: Array<{ __typename?: 'workout_type_translation', name?: string | undefined, locale: { __typename?: 'locale', code: string } }> } }> };

export type IWorkoutDurationsQueryVariables = Exact<{
  where?: InputMaybe<IWorkout_Duration_Bool_Exp>;
}>;


export type IWorkoutDurationsQuery = { __typename?: 'query_root', workout_duration: Array<{ __typename?: 'workout_duration', id: number, duration: number, coefficient: number }> };

export type IWorkout_DurationFragment = { __typename?: 'workout_duration', id: number, duration: number, coefficient: number };

export type IWorkoutParamsListQueryVariables = Exact<{
  workout_type_id?: InputMaybe<Scalars['Int']>;
}>;


export type IWorkoutParamsListQuery = { __typename?: 'query_root', workout_type: Array<{ __typename?: 'workout_type', id: number, avatar: string, workout_type_translations: Array<{ __typename?: 'workout_type_translation', name?: string | undefined, locale: { __typename?: 'locale', code: string } }> }>, workout_altimetry: Array<{ __typename?: 'workout_altimetry', id: number, name: string, icon?: string | undefined, coefficient: number, workout_altimetry_translations: Array<{ __typename?: 'workout_altimetry_translation', id: number, description?: string | undefined, locale: { __typename?: 'locale', code: string, language: string } }>, workout_altimetry_workout_types: Array<{ __typename?: 'workout_altimetry_workout_type', id: number, workout_type: { __typename?: 'workout_type', id: number, avatar: string, workout_type_translations: Array<{ __typename?: 'workout_type_translation', name?: string | undefined, locale: { __typename?: 'locale', code: string } }> } }> }>, workout_terrain: Array<{ __typename?: 'workout_terrain', id: number, icon?: string | undefined, workout_terrain_translations: Array<{ __typename?: 'workout_terrain_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', code: string, language: string } }> }>, workout_zone: Array<{ __typename?: 'workout_zone', id: number, name: string, interval_start: number, interval_end: number }>, circuit: Array<{ __typename?: 'circuit', id: number, type: string, circuit_translations: Array<{ __typename?: 'circuit_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string } }> }> };

export type IWorkoutTerrainsQueryVariables = Exact<{
  where?: InputMaybe<IWorkout_Terrain_Bool_Exp>;
}>;


export type IWorkoutTerrainsQuery = { __typename?: 'query_root', workout_terrain: Array<{ __typename?: 'workout_terrain', id: number, coefficient: number, icon?: string | undefined, workout_terrain_translations: Array<{ __typename?: 'workout_terrain_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }> }> };

export type IWorkout_TerrainFragment = { __typename?: 'workout_terrain', id: number, coefficient: number, icon?: string | undefined, workout_terrain_translations: Array<{ __typename?: 'workout_terrain_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }> };

export type IWorkoutZonesQueryVariables = Exact<{
  where?: InputMaybe<IWorkout_Zone_Bool_Exp>;
}>;


export type IWorkoutZonesQuery = { __typename?: 'query_root', workout_zone: Array<{ __typename?: 'workout_zone', id: number, name: string, interval_start: number, interval_end: number }> };

export type IWorkout_ZoneFragment = { __typename?: 'workout_zone', id: number, name: string, interval_start: number, interval_end: number };

export type IUserByEmailQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type IUserByEmailQuery = { __typename?: 'query_root', user: Array<{ __typename?: 'user', id: number, email: string }> };

export type IAthlete_ChallengeFragment = { __typename?: 'athlete_challenge', description: string, time_done_hours?: number | undefined, time_done_minutes?: number | undefined, result?: string | undefined, id: number, date?: any | undefined, created_at: string, completed_at?: any | undefined, is_main?: boolean | undefined, time_goal_hours?: number | undefined, time_goal_minutes?: number | undefined, positive_univeness?: number | undefined, negative_univeness?: number | undefined, cumulated_univeness?: number | undefined, distance?: string | undefined };

export type IAthlete_Details_Biometric_ParamFragment = { __typename?: 'athlete_biometric_data', id: number, value?: number | undefined, biometric_parameter_id: string, created_at: string, file_url?: string | undefined, biometric_parameter: { __typename?: 'biometric_parameter', label?: string | undefined } };

export type IStats_Athlete_ProfileFragment = { __typename?: 'athlete_profile', param_effort?: number | undefined, param_motivation?: number | undefined, param_distance_variation?: number | undefined, param_calories?: number | undefined, param_ziut?: number | undefined, athlete_profile_altimetry_adjustments: Array<{ __typename?: 'athlete_profile_altimetry_adjustment', workout_altimetry_id: number, value: number }> };

export type IStats_Athlete_WeekFragment = { __typename?: 'athlete_week', start_date?: any | undefined, end_date?: any | undefined, id: number, order: number, name?: string | undefined, sport_id: string, athlete_workouts: Array<{ __typename?: 'athlete_workout', athlete_week_id: number, date: any, day: number, id: number, is_primary?: boolean | undefined, workout_type_id?: number | undefined, workout_altimetry_id: number, workout_terrain_id: number, effort?: number | undefined, motivation?: number | undefined, calories?: number | undefined, measured_calories?: number | undefined, zuit?: number | undefined, positive_elevation?: number | undefined, negative_elevation?: number | undefined, measured_positive_elevation?: number | undefined, measured_negative_elevation?: number | undefined, series?: string | undefined, type?: string | undefined, weight_circuit_repetitions?: number | undefined, stretching_circuit_repetitions?: number | undefined, cumulative_elevation?: number | undefined, measured_cumulative_elevation?: number | undefined, athlete_workout_sections: Array<{ __typename?: 'athlete_workout_section', id: number, athlete_workout_id: number, duration?: number | undefined, measured_duration?: number | undefined, speed?: number | undefined, measured_speed?: number | undefined, average_heart_rate?: number | undefined, measured_average_heart_rate?: number | undefined, max_heart_rate?: number | undefined, measured_max_heart_rate?: number | undefined, type?: string | undefined, workout_zone_id?: number | undefined, is_main?: boolean | undefined }> }> };

export type IStats_Athlete_WorkoutFragment = { __typename?: 'athlete_workout', athlete_week_id: number, date: any, day: number, id: number, is_primary?: boolean | undefined, workout_type_id?: number | undefined, workout_altimetry_id: number, workout_terrain_id: number, effort?: number | undefined, motivation?: number | undefined, calories?: number | undefined, measured_calories?: number | undefined, zuit?: number | undefined, positive_elevation?: number | undefined, negative_elevation?: number | undefined, measured_positive_elevation?: number | undefined, measured_negative_elevation?: number | undefined, series?: string | undefined, type?: string | undefined, weight_circuit_repetitions?: number | undefined, stretching_circuit_repetitions?: number | undefined, cumulative_elevation?: number | undefined, measured_cumulative_elevation?: number | undefined, athlete_workout_sections: Array<{ __typename?: 'athlete_workout_section', id: number, athlete_workout_id: number, duration?: number | undefined, measured_duration?: number | undefined, speed?: number | undefined, measured_speed?: number | undefined, average_heart_rate?: number | undefined, measured_average_heart_rate?: number | undefined, max_heart_rate?: number | undefined, measured_max_heart_rate?: number | undefined, type?: string | undefined, workout_zone_id?: number | undefined, is_main?: boolean | undefined }> };

export type IAthlete_WorkoutFragment = { __typename?: 'athlete_workout', athlete_week_id: number, date: any, day: number, id: number, is_primary?: boolean | undefined, workout_type_id?: number | undefined, motivation?: number | undefined, effort?: number | undefined, comments?: string | undefined, series?: string | undefined, strava_activity_id?: any | undefined, measured_calories?: number | undefined, calories?: number | undefined, zuit?: number | undefined, positive_elevation?: number | undefined, negative_elevation?: number | undefined, measured_positive_elevation?: number | undefined, measured_negative_elevation?: number | undefined, type?: string | undefined, stretching_circuit_id?: number | undefined, stretching_circuit_repetitions?: number | undefined, completed_stretching_circuit?: number | undefined, weight_circuit_id?: number | undefined, weight_circuit_repetitions?: number | undefined, completed_weight_circuit?: number | undefined, workout_altimetry_id: number, workout_terrain_id: number, cumulative_elevation?: number | undefined, measured_cumulative_elevation?: number | undefined, stretching_circuit?: { __typename?: 'circuit', id: number, type: string, circuit_translations: Array<{ __typename?: 'circuit_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string } }>, circuit_exercises: Array<{ __typename?: 'circuit_exercise', id: number, circuit_id: number, duration?: number | undefined, exercise_id: number, no_of_series?: number | undefined, order?: number | undefined, repetitions?: number | undefined, exercise: { __typename?: 'exercise', id: number, media_url: string, type: string, target?: string | undefined, exercise_translations: Array<{ __typename?: 'exercise_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string } }> } }> } | undefined, weight_circuit?: { __typename?: 'circuit', id: number, type: string, circuit_translations: Array<{ __typename?: 'circuit_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string } }>, circuit_exercises: Array<{ __typename?: 'circuit_exercise', id: number, circuit_id: number, duration?: number | undefined, exercise_id: number, no_of_series?: number | undefined, order?: number | undefined, repetitions?: number | undefined, exercise: { __typename?: 'exercise', id: number, media_url: string, type: string, target?: string | undefined, exercise_translations: Array<{ __typename?: 'exercise_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string } }> } }> } | undefined, workout_altimetry: { __typename?: 'workout_altimetry', coefficient: number, icon?: string | undefined, id: number, name: string, workout_altimetry_translations: Array<{ __typename?: 'workout_altimetry_translation', id: number, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }> }, workout_terrain: { __typename?: 'workout_terrain', coefficient: number, icon?: string | undefined, id: number, workout_terrain_translations: Array<{ __typename?: 'workout_terrain_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }> }, workout_type?: { __typename?: 'workout_type', id: number, avatar: string, workout_type_translations: Array<{ __typename?: 'workout_type_translation', name?: string | undefined, locale: { __typename?: 'locale', code: string } }> } | undefined, athlete_workout_sections: Array<{ __typename?: 'athlete_workout_section', athlete_workout_id: number, duration?: number | undefined, max_heart_rate?: number | undefined, speed?: number | undefined, speed_percentage?: number | undefined, average_heart_rate?: number | undefined, average_heart_rate_percentage?: number | undefined, measured_duration?: number | undefined, measured_max_heart_rate?: number | undefined, measured_speed?: number | undefined, measured_average_heart_rate?: number | undefined, id: number, type?: string | undefined, workout_zone_id?: number | undefined, order?: number | undefined, planned_stress_score?: number | undefined, executed_stress_score?: number | undefined, workout_zone?: { __typename?: 'workout_zone', name: string, id: number, interval_start: number, interval_end: number } | undefined }> };

export type IAthlete_Workout_SectionFragment = { __typename?: 'athlete_workout_section', athlete_workout_id: number, duration?: number | undefined, max_heart_rate?: number | undefined, speed?: number | undefined, speed_percentage?: number | undefined, average_heart_rate?: number | undefined, average_heart_rate_percentage?: number | undefined, measured_duration?: number | undefined, measured_max_heart_rate?: number | undefined, measured_speed?: number | undefined, measured_average_heart_rate?: number | undefined, id: number, type?: string | undefined, workout_zone_id?: number | undefined, order?: number | undefined, planned_stress_score?: number | undefined, executed_stress_score?: number | undefined, workout_zone?: { __typename?: 'workout_zone', name: string, id: number, interval_start: number, interval_end: number } | undefined };

export type IStats_Biometric_DataFragment = { __typename?: 'athlete_biometric_data', biometric_parameter_id: string, value?: number | undefined };

export type ICircuitFragment = { __typename?: 'circuit', id: number, type: string, circuit_translations: Array<{ __typename?: 'circuit_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string } }>, circuit_exercises: Array<{ __typename?: 'circuit_exercise', id: number, circuit_id: number, duration?: number | undefined, exercise_id: number, no_of_series?: number | undefined, order?: number | undefined, repetitions?: number | undefined, exercise: { __typename?: 'exercise', id: number, media_url: string, type: string, target?: string | undefined, exercise_translations: Array<{ __typename?: 'exercise_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string } }> } }> };

export type ICircuit_ExerciseFragment = { __typename?: 'circuit_exercise', id: number, circuit_id: number, duration?: number | undefined, exercise_id: number, no_of_series?: number | undefined, order?: number | undefined, repetitions?: number | undefined, exercise: { __typename?: 'exercise', id: number, media_url: string, type: string, target?: string | undefined, exercise_translations: Array<{ __typename?: 'exercise_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string } }> } };

export type IExerciseFragment = { __typename?: 'exercise', id: number, media_url: string, type: string, target?: string | undefined, exercise_translations: Array<{ __typename?: 'exercise_translation', id: number, name?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string } }> };

export type IReviewFragment = { __typename?: 'review', image?: string | undefined, id: number, name: string, review_translations: Array<{ __typename?: 'review_translation', id: number, text?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }> };

export type ISportFragment = { __typename?: 'sport', id: any, name: string, avatar?: string | undefined, image?: string | undefined, sport_translations: Array<{ __typename?: 'sport_translation', id: number, title?: string | undefined, description?: string | undefined, locale: { __typename?: 'locale', id: number, code: string, language: string } }> };

export type IGetAthleteStressDataQueryVariables = Exact<{
  athleteId: Scalars['Int'];
  startDate: Scalars['date'];
  endDate: Scalars['date'];
}>;


export type IGetAthleteStressDataQuery = { __typename?: 'query_root', athlete_workout: Array<{ __typename?: 'athlete_workout', id: number, date: any, athlete_week_id: number, athlete_workout_sections: Array<{ __typename?: 'athlete_workout_section', id: number, executed_stress_score?: number | undefined }> }> };

export type IStatsAthleteDashboardQueryVariables = Exact<{
  athleteId: Scalars['Int'];
}>;


export type IStatsAthleteDashboardQuery = { __typename?: 'query_root', athlete_by_pk?: { __typename?: 'athlete', athlete_profile?: { __typename?: 'athlete_profile', param_effort?: number | undefined, param_motivation?: number | undefined, param_distance_variation?: number | undefined, param_calories?: number | undefined, param_ziut?: number | undefined, athlete_profile_altimetry_adjustments: Array<{ __typename?: 'athlete_profile_altimetry_adjustment', workout_altimetry_id: number, value: number }> } | undefined, athlete_biometric_data: Array<{ __typename?: 'athlete_biometric_data', biometric_parameter_id: string, value?: number | undefined }>, athlete_blocks: Array<{ __typename?: 'athlete_block', athlete_weeks: Array<{ __typename?: 'athlete_week', start_date?: any | undefined, end_date?: any | undefined, id: number, order: number, name?: string | undefined, sport_id: string, athlete_workouts: Array<{ __typename?: 'athlete_workout', athlete_week_id: number, date: any, day: number, id: number, is_primary?: boolean | undefined, workout_type_id?: number | undefined, workout_altimetry_id: number, workout_terrain_id: number, effort?: number | undefined, motivation?: number | undefined, calories?: number | undefined, measured_calories?: number | undefined, zuit?: number | undefined, positive_elevation?: number | undefined, negative_elevation?: number | undefined, measured_positive_elevation?: number | undefined, measured_negative_elevation?: number | undefined, series?: string | undefined, type?: string | undefined, weight_circuit_repetitions?: number | undefined, stretching_circuit_repetitions?: number | undefined, cumulative_elevation?: number | undefined, measured_cumulative_elevation?: number | undefined, athlete_workout_sections: Array<{ __typename?: 'athlete_workout_section', id: number, athlete_workout_id: number, duration?: number | undefined, measured_duration?: number | undefined, speed?: number | undefined, measured_speed?: number | undefined, average_heart_rate?: number | undefined, measured_average_heart_rate?: number | undefined, max_heart_rate?: number | undefined, measured_max_heart_rate?: number | undefined, type?: string | undefined, workout_zone_id?: number | undefined, is_main?: boolean | undefined }> }> }> }> } | undefined };

export const Athlete_Block_SummaryFragmentDoc = /*#__PURE__*/ gql`
    fragment athlete_block_summary on athlete_block {
  created_at
  end_date
  id
  name
  start_date
  sport_id
  athlete_id
}
    `;
export const Athlete_Profile_Altimetry_AdjustmentFragmentDoc = /*#__PURE__*/ gql`
    fragment athlete_profile_altimetry_adjustment on athlete_profile_altimetry_adjustment {
  id
  value
  workout_altimetry_id
  workout_altimetry {
    name
    id
    workout_altimetry_workout_types {
      id
      workout_type {
        id
        avatar
        workout_type_translations {
          name
          locale {
            code
          }
        }
      }
    }
  }
}
    `;
export const Athlete_ProfileFragmentDoc = /*#__PURE__*/ gql`
    fragment athlete_profile on athlete_profile {
  gender
  id
  level
  name
  type
  param_calories
  param_distance_variation
  param_effort
  param_motivation
  param_ziut
  athlete_profile_altimetry_adjustments {
    ...athlete_profile_altimetry_adjustment
  }
}
    ${Athlete_Profile_Altimetry_AdjustmentFragmentDoc}`;
export const Athlete_Details_Biometric_ParamFragmentDoc = /*#__PURE__*/ gql`
    fragment athlete_details_biometric_param on athlete_biometric_data {
  id
  value
  biometric_parameter_id
  created_at
  file_url
  biometric_parameter {
    label
  }
}
    `;
export const Athlete_ChallengeFragmentDoc = /*#__PURE__*/ gql`
    fragment athlete_challenge on athlete_challenge {
  description
  time_done_hours
  time_done_minutes
  result
  id
  date
  created_at
  completed_at
  is_main
  time_goal_hours
  time_goal_minutes
  positive_univeness
  negative_univeness
  cumulated_univeness
  distance
}
    `;
export const ExerciseFragmentDoc = /*#__PURE__*/ gql`
    fragment exercise on exercise {
  id
  media_url
  type
  target
  exercise_translations {
    id
    name
    description
    locale {
      id
      code
    }
  }
}
    `;
export const Circuit_ExerciseFragmentDoc = /*#__PURE__*/ gql`
    fragment circuit_exercise on circuit_exercise {
  id
  circuit_id
  duration
  exercise_id
  no_of_series
  order
  repetitions
  exercise {
    ...exercise
  }
}
    ${ExerciseFragmentDoc}`;
export const CircuitFragmentDoc = /*#__PURE__*/ gql`
    fragment circuit on circuit {
  id
  type
  circuit_translations {
    id
    name
    description
    locale {
      id
      code
    }
  }
  circuit_exercises {
    ...circuit_exercise
  }
}
    ${Circuit_ExerciseFragmentDoc}`;
export const Athlete_Workout_SectionFragmentDoc = /*#__PURE__*/ gql`
    fragment athlete_workout_section on athlete_workout_section {
  athlete_workout_id
  duration
  max_heart_rate
  speed
  speed_percentage
  average_heart_rate
  average_heart_rate_percentage
  measured_duration
  measured_max_heart_rate
  measured_speed
  measured_average_heart_rate
  id
  type
  workout_zone_id
  order
  workout_zone {
    name
    id
    interval_start
    interval_end
  }
  planned_stress_score
  executed_stress_score
}
    `;
export const Athlete_WorkoutFragmentDoc = /*#__PURE__*/ gql`
    fragment athlete_workout on athlete_workout {
  athlete_week_id
  date
  day
  id
  is_primary
  workout_type_id
  motivation
  effort
  comments
  series
  strava_activity_id
  measured_calories
  calories
  zuit
  positive_elevation
  negative_elevation
  cumulative_elevation: sum_elevation
  measured_positive_elevation
  measured_negative_elevation
  measured_cumulative_elevation: sum_measured_elevation
  type
  stretching_circuit_id
  stretching_circuit_repetitions
  completed_stretching_circuit
  weight_circuit_id
  weight_circuit_repetitions
  completed_weight_circuit
  workout_altimetry_id
  workout_terrain_id
  stretching_circuit {
    ...circuit
  }
  weight_circuit {
    ...circuit
  }
  workout_altimetry {
    coefficient
    icon
    id
    name
    workout_altimetry_translations {
      id
      description
      locale {
        id
        code
        language
      }
    }
  }
  workout_terrain {
    coefficient
    icon
    id
    workout_terrain_translations {
      id
      name
      description
      locale {
        id
        code
        language
      }
    }
  }
  workout_type {
    id
    avatar
    workout_type_translations {
      name
      locale {
        code
      }
    }
  }
  athlete_workout_sections(order_by: {order: asc}) {
    ...athlete_workout_section
  }
}
    ${CircuitFragmentDoc}
${Athlete_Workout_SectionFragmentDoc}`;
export const Athlete_Week_BaseFragmentDoc = /*#__PURE__*/ gql`
    fragment athlete_week_base on athlete_week {
  created_at
  end_date
  id
  name
  order
  sport_id
  start_date
  updated_at
  athlete_block_id
  athlete_block {
    athlete_id
    id
  }
  athlete_workouts(order_by: {day: asc}) {
    ...athlete_workout
    created_at
    updated_at
  }
}
    ${Athlete_WorkoutFragmentDoc}`;
export const Athlete_BlockFragmentDoc = /*#__PURE__*/ gql`
    fragment athlete_block on athlete_block {
  created_at
  end_date
  id
  name
  start_date
  athlete_weeks(order_by: {start_date: asc}) {
    ...athlete_week_base
  }
  updated_at
  sport_id
  athlete_id
}
    ${Athlete_Week_BaseFragmentDoc}`;
export const Athlete_DetailsFragmentDoc = /*#__PURE__*/ gql`
    fragment athlete_details on athlete {
  id
  name
  birthday
  avatar
  gender
  athlete_profile_id
  coach_id
  address_city
  address_postal_code
  address_street
  address_country
  phone
  status
  fiscal_id_number
  goal
  stripe_customer_id
  sport_id
  athlete_profile {
    ...athlete_profile
  }
  user {
    email
  }
  user_id
  athlete_biometric_data(order_by: {created_at: desc}) {
    ...athlete_details_biometric_param
  }
  athlete_speeds(order_by: {created_at: desc, workout_type_id: asc}) {
    id
    value
    workout_type_id
    workout_type {
      id
      avatar
      workout_type_translations {
        name
        locale {
          code
        }
      }
    }
  }
  athlete_challenges(order_by: {created_at: desc}) {
    ...athlete_challenge
  }
  athlete_blocks(order_by: {start_date: desc}) {
    ...athlete_block
  }
}
    ${Athlete_ProfileFragmentDoc}
${Athlete_Details_Biometric_ParamFragmentDoc}
${Athlete_ChallengeFragmentDoc}
${Athlete_BlockFragmentDoc}`;
export const Athlete_ProfileFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment athlete_profileFragment on athlete_profile {
  gender
  id
  level
  name
  type
}
    `;
export const Athlete_WeekFragmentDoc = /*#__PURE__*/ gql`
    fragment athlete_week on athlete_week {
  created_at
  end_date
  id
  name
  order
  sport_id
  start_date
  updated_at
  athlete_block_id
  athlete_block {
    athlete_id
    id
  }
  athlete_workouts(order_by: {day: asc}) {
    ...athlete_workout
    created_at
    updated_at
  }
}
    ${Athlete_WorkoutFragmentDoc}`;
export const SportFragmentDoc = /*#__PURE__*/ gql`
    fragment sport on sport {
  id
  name
  avatar
  image
  sport_translations {
    id
    title
    description
    locale {
      id
      code
      language
    }
  }
}
    `;
export const AthleteFragmentDoc = /*#__PURE__*/ gql`
    fragment athlete on athlete {
  id
  name
  avatar
  birthday
  user {
    id
    email
    keycloak_id
  }
  status
  goal
  sport {
    ...sport
  }
  athlete_challenges {
    description
    date
  }
}
    ${SportFragmentDoc}`;
export const Block_Details_Sport_TemplateFragmentDoc = /*#__PURE__*/ gql`
    fragment block_details_sport_template on sport {
  id
  name
  avatar
}
    `;
export const Block_Details_Workout_Section_TemplateFragmentDoc = /*#__PURE__*/ gql`
    fragment block_details_workout_section_template on workout_section_template {
  average_heart_rate
  duration
  id
  max_heart_rate
  speed
  type
  order
  workout_zone {
    name
  }
}
    `;
export const Block_Details_Circuit_TemplateFragmentDoc = /*#__PURE__*/ gql`
    fragment block_details_circuit_template on circuit {
  id
  type
  circuit_translations {
    name
    locale {
      code
    }
  }
}
    `;
export const Block_Details_Workout_TemplateFragmentDoc = /*#__PURE__*/ gql`
    fragment block_details_workout_template on workout_template {
  day
  id
  is_primary
  workout_type_id
  positive_elevation
  negative_elevation
  series
  type
  weight_circuit_repetitions
  stretching_circuit_repetitions
  workout_altimetry {
    icon
    workout_altimetry_translations {
      description
      locale {
        code
      }
    }
  }
  workout_section_templates(order_by: {order: asc}) {
    ...block_details_workout_section_template
  }
  stretching_circuit {
    ...block_details_circuit_template
  }
  weight_circuit {
    ...block_details_circuit_template
  }
  workout_terrain {
    icon
    workout_terrain_translations {
      name
      locale {
        code
      }
    }
  }
  workout_type {
    avatar
    workout_type_translations {
      name
      locale {
        code
      }
    }
  }
}
    ${Block_Details_Workout_Section_TemplateFragmentDoc}
${Block_Details_Circuit_TemplateFragmentDoc}`;
export const Block_Details_Week_TemplateFragmentDoc = /*#__PURE__*/ gql`
    fragment block_details_week_template on week_template {
  block_template_id
  id
  name
  order
  workout_templates {
    ...block_details_workout_template
  }
}
    ${Block_Details_Workout_TemplateFragmentDoc}`;
export const Block_Details_Block_TemplateFragmentDoc = /*#__PURE__*/ gql`
    fragment block_details_block_template on block_template {
  id
  name
  description
  sport {
    ...block_details_sport_template
  }
  coach_id
  sport_id
  week_templates(order_by: {order: asc}) {
    ...block_details_week_template
  }
}
    ${Block_Details_Sport_TemplateFragmentDoc}
${Block_Details_Week_TemplateFragmentDoc}`;
export const Block_TemplateFragmentDoc = /*#__PURE__*/ gql`
    fragment block_template on block_template {
  id
  name
  created_at
  coach_id
  description
  coach {
    id
    name
  }
  sport {
    ...sport
  }
  sport_id
  updated_at
  week_templates(order_by: {order: asc}) {
    name
  }
}
    ${SportFragmentDoc}`;
export const Week_Template_Basic_InfoFragmentDoc = /*#__PURE__*/ gql`
    fragment week_template_basic_info on week_template {
  id
  name
  sport_id
}
    `;
export const Block_Template_Basic_InfoFragmentDoc = /*#__PURE__*/ gql`
    fragment block_template_basic_info on block_template {
  name
  id
  sport_id
  week_templates(order_by: {order: asc}, where: $where_week) {
    ...week_template_basic_info
  }
}
    ${Week_Template_Basic_InfoFragmentDoc}`;
export const CoachBaseInfoFragmentDoc = /*#__PURE__*/ gql`
    fragment coachBaseInfo on user {
  id
  name
  type
  coach {
    id
    name
    profile_picture
    platform_content_access
    is_verified
    sports {
      id
      sport {
        ...sport
      }
    }
  }
}
    ${SportFragmentDoc}`;
export const CoachDetailsAthleteSubscriptionFragmentDoc = /*#__PURE__*/ gql`
    fragment coachDetailsAthleteSubscription on subscription {
  subscription_plan {
    level
    sport {
      ...sport
    }
    subscription_plan_translations {
      description
      locale {
        id
        code
        language
      }
    }
  }
  date_start
  date_end
  price
  status
  interval_count
}
    ${SportFragmentDoc}`;
export const CoachDetailsAthleteFragmentDoc = /*#__PURE__*/ gql`
    fragment coachDetailsAthlete on athlete {
  id
  avatar
  birthday
  sport_id
  status
  goal
  gender
  name
  athlete_profile_id
  user {
    email
  }
  athlete_challenges(order_by: {created_at: desc}, limit: 1) {
    description
  }
  sport {
    ...sport
  }
  athlete_profile {
    id
    name
  }
  subscriptions(where: {status: {_eq: "active"}}) {
    ...coachDetailsAthleteSubscription
  }
}
    ${SportFragmentDoc}
${CoachDetailsAthleteSubscriptionFragmentDoc}`;
export const CoachDetailsFragmentDoc = /*#__PURE__*/ gql`
    fragment coachDetails on coach {
  id
  name
  phone
  profile_picture
  user_id
  is_verified
  sports {
    id
    sport {
      ...sport
    }
  }
  public
  spoken_languages
  platform_content_access
  platform_fee
  fiscal_id_number
  address_street
  address_city
  address_country
  address_postal_code
  user {
    id
    email
  }
  coach_translations {
    id
    bio
    locale {
      id
      code
      language
    }
  }
  athletes {
    ...coachDetailsAthlete
  }
}
    ${SportFragmentDoc}
${CoachDetailsAthleteFragmentDoc}`;
export const CoachFragmentDoc = /*#__PURE__*/ gql`
    fragment coach on coach {
  id
  name
  user {
    email
  }
  coach_translations {
    id
    bio
    locale {
      id
      code
      language
    }
  }
  created_at
  user_id
  profile_picture
  is_verified
  sports {
    id
    sport {
      ...sport
    }
  }
  no_of_athletes: athletes_aggregate {
    aggregate {
      count(columns: id)
    }
  }
}
    ${SportFragmentDoc}`;
export const Subscription_Plan_DetailsFragmentDoc = /*#__PURE__*/ gql`
    fragment subscription_plan_details on subscription_plan {
  id
  image
  level
  is_verified
  coach_id
  coach {
    id
    name
  }
  sport {
    ...sport
  }
  min_duration
  subscription_plan_translations {
    id
    description
    locale {
      id
      code
      language
    }
  }
  quarterly_discount
  recomended_duration
  created_at
  biannualy_discount
  weekly_price
  yearly_discount
  sport_id
  subscription_plan_prices {
    id
    interval_count
    unit_amount
  }
}
    ${SportFragmentDoc}`;
export const CouponFragmentDoc = /*#__PURE__*/ gql`
    fragment coupon on coupon {
  created_at
  duration
  duration_in_months
  id
  subscription_plan {
    ...subscription_plan_details
  }
  name
  percent_off
  promo_code
  times_redeemed
  updated_at
  valid
}
    ${Subscription_Plan_DetailsFragmentDoc}`;
export const Subscription_Plan_TemplateFragmentDoc = /*#__PURE__*/ gql`
    fragment subscription_plan_template on subscription_plan_template {
  id
  min_duration
  quarterly_discount
  recomended_duration
  created_at
  biannualy_discount
  weekly_price
  yearly_discount
  sport_id
  level
}
    `;
export const SubscriptionFragmentDoc = /*#__PURE__*/ gql`
    fragment subscription on subscription {
  athlete {
    name
    id
    user_id
  }
  athlete_id
  created_at
  date_end
  date_start
  id
  status
  subscription_plan {
    id
    level
    subscription_plan_translations {
      description
      locale {
        id
        code
        language
      }
    }
  }
  subscription_plan_id
  price
  interval_count
}
    `;
export const Subscription_PlanFragmentDoc = /*#__PURE__*/ gql`
    fragment subscription_plan on subscription_plan {
  id
  image
  level
  is_verified
  min_duration
  quarterly_discount
  recomended_duration
  created_at
  biannualy_discount
  weekly_price
  yearly_discount
  sport_id
  stripe_product_id
  sport {
    ...sport
  }
  coach {
    id
    name
  }
  subscription_plan_prices {
    id
    interval_count
    unit_amount
  }
  subscription_plan_translations {
    id
    description
    created_at
    locale {
      id
      code
      language
    }
    subscription_plan_id
  }
}
    ${SportFragmentDoc}`;
export const Week_Details_Workout_Section_TemplateFragmentDoc = /*#__PURE__*/ gql`
    fragment week_details_workout_section_template on workout_section_template {
  average_heart_rate
  created_at
  duration
  id
  max_heart_rate
  updated_at
  workout_template_id
}
    `;
export const Week_Details_Workout_TemplateFragmentDoc = /*#__PURE__*/ gql`
    fragment week_details_workout_template on workout_template {
  created_at
  day
  id
  is_primary
  workout_type_id
  workout_terrain_id
  workout_zone_id
  stretching_circuit_id
  weight_circuit_id
  updated_at
  week_template_id
  workout_altimetry_id
  workout_altimetry {
    id
    name
    icon
    workout_altimetry_translations {
      id
      description
      locale {
        code
        language
      }
    }
  }
  workout_section_templates {
    ...week_details_workout_section_template
  }
  stretching_circuit {
    ...circuit
  }
  weight_circuit {
    ...circuit
  }
  workout_terrain {
    icon
    id
    workout_terrain_translations {
      id
      name
      description
      locale {
        code
        language
      }
    }
  }
  workout_type {
    id
    avatar
    workout_type_translations {
      name
      locale {
        code
      }
    }
  }
  workout_zone {
    id
    name
  }
}
    ${Week_Details_Workout_Section_TemplateFragmentDoc}
${CircuitFragmentDoc}`;
export const Week_Details_Week_TemplateFragmentDoc = /*#__PURE__*/ gql`
    fragment week_details_week_template on week_template {
  created_at
  block_template_id
  id
  name
  order
  sport_id
  sport {
    ...sport
  }
  updated_at
  workout_templates {
    ...week_details_workout_template
  }
}
    ${SportFragmentDoc}
${Week_Details_Workout_TemplateFragmentDoc}`;
export const Week_TemplateFragmentDoc = /*#__PURE__*/ gql`
    fragment week_template on week_template {
  id
  name
  sport_id
  created_at
  order
  sport {
    ...sport
  }
}
    ${SportFragmentDoc}`;
export const Workout_AltimetryFragmentDoc = /*#__PURE__*/ gql`
    fragment workout_altimetry on workout_altimetry {
  id
  name
  coefficient
  icon
  workout_altimetry_translations {
    id
    description
    locale {
      id
      code
      language
    }
  }
  workout_altimetry_workout_types {
    id
    workout_type {
      id
      avatar
      workout_type_translations {
        name
        locale {
          code
        }
      }
    }
  }
}
    `;
export const Workout_DurationFragmentDoc = /*#__PURE__*/ gql`
    fragment workout_duration on workout_duration {
  id
  duration
  coefficient
}
    `;
export const Workout_TerrainFragmentDoc = /*#__PURE__*/ gql`
    fragment workout_terrain on workout_terrain {
  id
  coefficient
  icon
  workout_terrain_translations {
    id
    name
    description
    locale {
      id
      code
      language
    }
  }
}
    `;
export const Workout_ZoneFragmentDoc = /*#__PURE__*/ gql`
    fragment workout_zone on workout_zone {
  id
  name
  interval_start
  interval_end
}
    `;
export const Stats_Athlete_ProfileFragmentDoc = /*#__PURE__*/ gql`
    fragment stats_athlete_profile on athlete_profile {
  param_effort
  param_motivation
  param_distance_variation
  param_calories
  param_ziut
  athlete_profile_altimetry_adjustments {
    workout_altimetry_id
    value
  }
}
    `;
export const Stats_Athlete_WorkoutFragmentDoc = /*#__PURE__*/ gql`
    fragment stats_athlete_workout on athlete_workout {
  athlete_week_id
  date
  day
  id
  is_primary
  workout_type_id
  workout_altimetry_id
  workout_terrain_id
  effort
  motivation
  calories
  measured_calories
  zuit
  positive_elevation
  negative_elevation
  measured_positive_elevation
  measured_negative_elevation
  cumulative_elevation: sum_elevation
  measured_cumulative_elevation: sum_measured_elevation
  series
  type
  weight_circuit_repetitions
  stretching_circuit_repetitions
  athlete_workout_sections {
    id
    athlete_workout_id
    duration
    measured_duration
    speed
    measured_speed
    average_heart_rate
    measured_average_heart_rate
    max_heart_rate
    measured_max_heart_rate
    type
    workout_zone_id
    is_main
  }
}
    `;
export const Stats_Athlete_WeekFragmentDoc = /*#__PURE__*/ gql`
    fragment stats_athlete_week on athlete_week {
  start_date
  end_date
  id
  order
  name
  sport_id
  athlete_workouts {
    ...stats_athlete_workout
  }
}
    ${Stats_Athlete_WorkoutFragmentDoc}`;
export const Stats_Biometric_DataFragmentDoc = /*#__PURE__*/ gql`
    fragment stats_biometric_data on athlete_biometric_data {
  biometric_parameter_id
  value
}
    `;
export const ReviewFragmentDoc = /*#__PURE__*/ gql`
    fragment review on review {
  image
  id
  name
  review_translations {
    id
    text
    locale {
      id
      code
      language
    }
  }
}
    `;
export const AssignWeeksToAthleteBlockDocument = /*#__PURE__*/ gql`
    mutation AssignWeeksToAthleteBlock($athlete_id: Int!, $athlete_block_id: Int, $start_date: String!, $week_template_ids: [Int!]!) {
  assign_weeks_to_athlete(
    athlete_id: $athlete_id
    athlete_block_id: $athlete_block_id
    start_date: $start_date
    week_template_ids: $week_template_ids
  )
}
    `;
export type IAssignWeeksToAthleteBlockMutationFn = Apollo.MutationFunction<IAssignWeeksToAthleteBlockMutation, IAssignWeeksToAthleteBlockMutationVariables>;
export function useAssignWeeksToAthleteBlockMutation(baseOptions?: Apollo.MutationHookOptions<IAssignWeeksToAthleteBlockMutation, IAssignWeeksToAthleteBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IAssignWeeksToAthleteBlockMutation, IAssignWeeksToAthleteBlockMutationVariables>(AssignWeeksToAthleteBlockDocument, options);
      }
export type AssignWeeksToAthleteBlockMutationHookResult = ReturnType<typeof useAssignWeeksToAthleteBlockMutation>;
export type AssignWeeksToAthleteBlockMutationResult = Apollo.MutationResult<IAssignWeeksToAthleteBlockMutation>;
export type AssignWeeksToAthleteBlockMutationOptions = Apollo.BaseMutationOptions<IAssignWeeksToAthleteBlockMutation, IAssignWeeksToAthleteBlockMutationVariables>;
export const ChangeAthleteBlockWeeksOrderDocument = /*#__PURE__*/ gql`
    mutation ChangeAthleteBlockWeeksOrder($new_order: Int!, $old_order: Int!, $athlete_block_id: Int!) {
  reorder_athlete_werks(
    athlete_block_id: $athlete_block_id
    new_order: $new_order
    old_order: $old_order
  )
}
    `;
export type IChangeAthleteBlockWeeksOrderMutationFn = Apollo.MutationFunction<IChangeAthleteBlockWeeksOrderMutation, IChangeAthleteBlockWeeksOrderMutationVariables>;
export function useChangeAthleteBlockWeeksOrderMutation(baseOptions?: Apollo.MutationHookOptions<IChangeAthleteBlockWeeksOrderMutation, IChangeAthleteBlockWeeksOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IChangeAthleteBlockWeeksOrderMutation, IChangeAthleteBlockWeeksOrderMutationVariables>(ChangeAthleteBlockWeeksOrderDocument, options);
      }
export type ChangeAthleteBlockWeeksOrderMutationHookResult = ReturnType<typeof useChangeAthleteBlockWeeksOrderMutation>;
export type ChangeAthleteBlockWeeksOrderMutationResult = Apollo.MutationResult<IChangeAthleteBlockWeeksOrderMutation>;
export type ChangeAthleteBlockWeeksOrderMutationOptions = Apollo.BaseMutationOptions<IChangeAthleteBlockWeeksOrderMutation, IChangeAthleteBlockWeeksOrderMutationVariables>;
export const ChangeBlockWeeksOrderDocument = /*#__PURE__*/ gql`
    mutation ChangeBlockWeeksOrder($new_order: Int!, $old_order: Int!, $block_template_id: Int!) {
  SetNewOrderTemp: update_week_template(
    where: {_and: [{order: {_eq: $old_order}, block_template_id: {_eq: $block_template_id}}]}
    _set: {order: -1, block_template_id: $block_template_id}
  ) {
    affected_rows
  }
  UpdateGrater: update_week_template(
    where: {_and: [{order: {_gte: $new_order}}, {order: {_lt: $old_order}, block_template_id: {_eq: $block_template_id}}]}
    _inc: {order: 1}
  ) {
    affected_rows
  }
  UpdateLesser: update_week_template(
    where: {_and: [{order: {_lte: $new_order}}, {order: {_gt: $old_order}, block_template_id: {_eq: $block_template_id}}]}
    _inc: {order: -1}
  ) {
    affected_rows
  }
  SetNewOrder: update_week_template(
    where: {order: {_eq: -1}, block_template_id: {_eq: $block_template_id}}
    _set: {order: $new_order}
  ) {
    affected_rows
  }
}
    `;
export type IChangeBlockWeeksOrderMutationFn = Apollo.MutationFunction<IChangeBlockWeeksOrderMutation, IChangeBlockWeeksOrderMutationVariables>;
export function useChangeBlockWeeksOrderMutation(baseOptions?: Apollo.MutationHookOptions<IChangeBlockWeeksOrderMutation, IChangeBlockWeeksOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IChangeBlockWeeksOrderMutation, IChangeBlockWeeksOrderMutationVariables>(ChangeBlockWeeksOrderDocument, options);
      }
export type ChangeBlockWeeksOrderMutationHookResult = ReturnType<typeof useChangeBlockWeeksOrderMutation>;
export type ChangeBlockWeeksOrderMutationResult = Apollo.MutationResult<IChangeBlockWeeksOrderMutation>;
export type ChangeBlockWeeksOrderMutationOptions = Apollo.BaseMutationOptions<IChangeBlockWeeksOrderMutation, IChangeBlockWeeksOrderMutationVariables>;
export const ChangeCircuitExerciseOrderDocument = /*#__PURE__*/ gql`
    mutation ChangeCircuitExerciseOrder($newOrder: Int!, $oldOrder: Int!, $circuit_id: Int!) {
  SetNewOrderTemp: update_circuit_exercise(
    where: {_and: [{order: {_eq: $oldOrder}, circuit_id: {_eq: $circuit_id}}]}
    _set: {order: -1, circuit_id: $circuit_id}
  ) {
    affected_rows
  }
  UpdateGrater: update_circuit_exercise(
    where: {_and: [{order: {_gte: $newOrder}}, {order: {_lt: $oldOrder}, circuit_id: {_eq: $circuit_id}}]}
    _inc: {order: 1}
  ) {
    affected_rows
  }
  UpdateLesser: update_circuit_exercise(
    where: {_and: [{order: {_lte: $newOrder}}, {order: {_gt: $oldOrder}, circuit_id: {_eq: $circuit_id}}]}
    _inc: {order: -1}
  ) {
    affected_rows
  }
  SetNewOrder: update_circuit_exercise(
    where: {order: {_eq: -1}, circuit_id: {_eq: $circuit_id}}
    _set: {order: $newOrder}
  ) {
    affected_rows
  }
}
    `;
export type IChangeCircuitExerciseOrderMutationFn = Apollo.MutationFunction<IChangeCircuitExerciseOrderMutation, IChangeCircuitExerciseOrderMutationVariables>;
export function useChangeCircuitExerciseOrderMutation(baseOptions?: Apollo.MutationHookOptions<IChangeCircuitExerciseOrderMutation, IChangeCircuitExerciseOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IChangeCircuitExerciseOrderMutation, IChangeCircuitExerciseOrderMutationVariables>(ChangeCircuitExerciseOrderDocument, options);
      }
export type ChangeCircuitExerciseOrderMutationHookResult = ReturnType<typeof useChangeCircuitExerciseOrderMutation>;
export type ChangeCircuitExerciseOrderMutationResult = Apollo.MutationResult<IChangeCircuitExerciseOrderMutation>;
export type ChangeCircuitExerciseOrderMutationOptions = Apollo.BaseMutationOptions<IChangeCircuitExerciseOrderMutation, IChangeCircuitExerciseOrderMutationVariables>;
export const CopyWeekTemplatesToAnotherBlockTemplateDocument = /*#__PURE__*/ gql`
    mutation CopyWeekTemplatesToAnotherBlockTemplate($new_block_template_id: Int!, $week_template_ids: [Int!]!) {
  copy_week_template_to_another_block_template(
    new_block_template_id: $new_block_template_id
    week_template_ids: $week_template_ids
  )
}
    `;
export type ICopyWeekTemplatesToAnotherBlockTemplateMutationFn = Apollo.MutationFunction<ICopyWeekTemplatesToAnotherBlockTemplateMutation, ICopyWeekTemplatesToAnotherBlockTemplateMutationVariables>;
export function useCopyWeekTemplatesToAnotherBlockTemplateMutation(baseOptions?: Apollo.MutationHookOptions<ICopyWeekTemplatesToAnotherBlockTemplateMutation, ICopyWeekTemplatesToAnotherBlockTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICopyWeekTemplatesToAnotherBlockTemplateMutation, ICopyWeekTemplatesToAnotherBlockTemplateMutationVariables>(CopyWeekTemplatesToAnotherBlockTemplateDocument, options);
      }
export type CopyWeekTemplatesToAnotherBlockTemplateMutationHookResult = ReturnType<typeof useCopyWeekTemplatesToAnotherBlockTemplateMutation>;
export type CopyWeekTemplatesToAnotherBlockTemplateMutationResult = Apollo.MutationResult<ICopyWeekTemplatesToAnotherBlockTemplateMutation>;
export type CopyWeekTemplatesToAnotherBlockTemplateMutationOptions = Apollo.BaseMutationOptions<ICopyWeekTemplatesToAnotherBlockTemplateMutation, ICopyWeekTemplatesToAnotherBlockTemplateMutationVariables>;
export const DeleteAthleteDocument = /*#__PURE__*/ gql`
    mutation DeleteAthlete($id: Int!) {
  delete_athlete_by_pk(id: $id) {
    id
  }
}
    `;
export type IDeleteAthleteMutationFn = Apollo.MutationFunction<IDeleteAthleteMutation, IDeleteAthleteMutationVariables>;
export function useDeleteAthleteMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteAthleteMutation, IDeleteAthleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteAthleteMutation, IDeleteAthleteMutationVariables>(DeleteAthleteDocument, options);
      }
export type DeleteAthleteMutationHookResult = ReturnType<typeof useDeleteAthleteMutation>;
export type DeleteAthleteMutationResult = Apollo.MutationResult<IDeleteAthleteMutation>;
export type DeleteAthleteMutationOptions = Apollo.BaseMutationOptions<IDeleteAthleteMutation, IDeleteAthleteMutationVariables>;
export const DeleteAthleteBlockDocument = /*#__PURE__*/ gql`
    mutation DeleteAthleteBlock($id: Int!) {
  delete_athlete_block_by_pk(id: $id) {
    id
  }
}
    `;
export type IDeleteAthleteBlockMutationFn = Apollo.MutationFunction<IDeleteAthleteBlockMutation, IDeleteAthleteBlockMutationVariables>;
export function useDeleteAthleteBlockMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteAthleteBlockMutation, IDeleteAthleteBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteAthleteBlockMutation, IDeleteAthleteBlockMutationVariables>(DeleteAthleteBlockDocument, options);
      }
export type DeleteAthleteBlockMutationHookResult = ReturnType<typeof useDeleteAthleteBlockMutation>;
export type DeleteAthleteBlockMutationResult = Apollo.MutationResult<IDeleteAthleteBlockMutation>;
export type DeleteAthleteBlockMutationOptions = Apollo.BaseMutationOptions<IDeleteAthleteBlockMutation, IDeleteAthleteBlockMutationVariables>;
export const DeleteAthleteWeekDocument = /*#__PURE__*/ gql`
    mutation DeleteAthleteWeek($id: Int!) {
  delete_athlete_week_by_pk(id: $id) {
    id
  }
}
    `;
export type IDeleteAthleteWeekMutationFn = Apollo.MutationFunction<IDeleteAthleteWeekMutation, IDeleteAthleteWeekMutationVariables>;
export function useDeleteAthleteWeekMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteAthleteWeekMutation, IDeleteAthleteWeekMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteAthleteWeekMutation, IDeleteAthleteWeekMutationVariables>(DeleteAthleteWeekDocument, options);
      }
export type DeleteAthleteWeekMutationHookResult = ReturnType<typeof useDeleteAthleteWeekMutation>;
export type DeleteAthleteWeekMutationResult = Apollo.MutationResult<IDeleteAthleteWeekMutation>;
export type DeleteAthleteWeekMutationOptions = Apollo.BaseMutationOptions<IDeleteAthleteWeekMutation, IDeleteAthleteWeekMutationVariables>;
export const DeleteAthleteWorkoutDocument = /*#__PURE__*/ gql`
    mutation DeleteAthleteWorkout($id: Int!) {
  delete_athlete_workout_by_pk(id: $id) {
    id
  }
}
    `;
export type IDeleteAthleteWorkoutMutationFn = Apollo.MutationFunction<IDeleteAthleteWorkoutMutation, IDeleteAthleteWorkoutMutationVariables>;
export function useDeleteAthleteWorkoutMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteAthleteWorkoutMutation, IDeleteAthleteWorkoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteAthleteWorkoutMutation, IDeleteAthleteWorkoutMutationVariables>(DeleteAthleteWorkoutDocument, options);
      }
export type DeleteAthleteWorkoutMutationHookResult = ReturnType<typeof useDeleteAthleteWorkoutMutation>;
export type DeleteAthleteWorkoutMutationResult = Apollo.MutationResult<IDeleteAthleteWorkoutMutation>;
export type DeleteAthleteWorkoutMutationOptions = Apollo.BaseMutationOptions<IDeleteAthleteWorkoutMutation, IDeleteAthleteWorkoutMutationVariables>;
export const DeleteBlockTemplateDocument = /*#__PURE__*/ gql`
    mutation DeleteBlockTemplate($id: Int!) {
  delete_block_template_by_pk(id: $id) {
    id
  }
}
    `;
export type IDeleteBlockTemplateMutationFn = Apollo.MutationFunction<IDeleteBlockTemplateMutation, IDeleteBlockTemplateMutationVariables>;
export function useDeleteBlockTemplateMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteBlockTemplateMutation, IDeleteBlockTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteBlockTemplateMutation, IDeleteBlockTemplateMutationVariables>(DeleteBlockTemplateDocument, options);
      }
export type DeleteBlockTemplateMutationHookResult = ReturnType<typeof useDeleteBlockTemplateMutation>;
export type DeleteBlockTemplateMutationResult = Apollo.MutationResult<IDeleteBlockTemplateMutation>;
export type DeleteBlockTemplateMutationOptions = Apollo.BaseMutationOptions<IDeleteBlockTemplateMutation, IDeleteBlockTemplateMutationVariables>;
export const DeleteCircuitDocument = /*#__PURE__*/ gql`
    mutation DeleteCircuit($id: Int!) {
  delete_circuit_by_pk(id: $id) {
    id
  }
}
    `;
export type IDeleteCircuitMutationFn = Apollo.MutationFunction<IDeleteCircuitMutation, IDeleteCircuitMutationVariables>;
export function useDeleteCircuitMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteCircuitMutation, IDeleteCircuitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteCircuitMutation, IDeleteCircuitMutationVariables>(DeleteCircuitDocument, options);
      }
export type DeleteCircuitMutationHookResult = ReturnType<typeof useDeleteCircuitMutation>;
export type DeleteCircuitMutationResult = Apollo.MutationResult<IDeleteCircuitMutation>;
export type DeleteCircuitMutationOptions = Apollo.BaseMutationOptions<IDeleteCircuitMutation, IDeleteCircuitMutationVariables>;
export const DeleteCircuitExerciseDocument = /*#__PURE__*/ gql`
    mutation DeleteCircuitExercise($id: Int!) {
  delete_circuit_exercise_by_pk(id: $id) {
    id
  }
}
    `;
export type IDeleteCircuitExerciseMutationFn = Apollo.MutationFunction<IDeleteCircuitExerciseMutation, IDeleteCircuitExerciseMutationVariables>;
export function useDeleteCircuitExerciseMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteCircuitExerciseMutation, IDeleteCircuitExerciseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteCircuitExerciseMutation, IDeleteCircuitExerciseMutationVariables>(DeleteCircuitExerciseDocument, options);
      }
export type DeleteCircuitExerciseMutationHookResult = ReturnType<typeof useDeleteCircuitExerciseMutation>;
export type DeleteCircuitExerciseMutationResult = Apollo.MutationResult<IDeleteCircuitExerciseMutation>;
export type DeleteCircuitExerciseMutationOptions = Apollo.BaseMutationOptions<IDeleteCircuitExerciseMutation, IDeleteCircuitExerciseMutationVariables>;
export const DeleteCouponDocument = /*#__PURE__*/ gql`
    mutation DeleteCoupon($id: Int!) {
  delete_coupon_by_pk(id: $id) {
    id
  }
}
    `;
export type IDeleteCouponMutationFn = Apollo.MutationFunction<IDeleteCouponMutation, IDeleteCouponMutationVariables>;
export function useDeleteCouponMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteCouponMutation, IDeleteCouponMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteCouponMutation, IDeleteCouponMutationVariables>(DeleteCouponDocument, options);
      }
export type DeleteCouponMutationHookResult = ReturnType<typeof useDeleteCouponMutation>;
export type DeleteCouponMutationResult = Apollo.MutationResult<IDeleteCouponMutation>;
export type DeleteCouponMutationOptions = Apollo.BaseMutationOptions<IDeleteCouponMutation, IDeleteCouponMutationVariables>;
export const DeleteExerciseDocument = /*#__PURE__*/ gql`
    mutation DeleteExercise($id: Int!) {
  delete_exercise_by_pk(id: $id) {
    id
  }
}
    `;
export type IDeleteExerciseMutationFn = Apollo.MutationFunction<IDeleteExerciseMutation, IDeleteExerciseMutationVariables>;
export function useDeleteExerciseMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteExerciseMutation, IDeleteExerciseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteExerciseMutation, IDeleteExerciseMutationVariables>(DeleteExerciseDocument, options);
      }
export type DeleteExerciseMutationHookResult = ReturnType<typeof useDeleteExerciseMutation>;
export type DeleteExerciseMutationResult = Apollo.MutationResult<IDeleteExerciseMutation>;
export type DeleteExerciseMutationOptions = Apollo.BaseMutationOptions<IDeleteExerciseMutation, IDeleteExerciseMutationVariables>;
export const DeleteReviewDocument = /*#__PURE__*/ gql`
    mutation DeleteReview($id: Int!) {
  delete_review_by_pk(id: $id) {
    id
  }
}
    `;
export type IDeleteReviewMutationFn = Apollo.MutationFunction<IDeleteReviewMutation, IDeleteReviewMutationVariables>;
export function useDeleteReviewMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteReviewMutation, IDeleteReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteReviewMutation, IDeleteReviewMutationVariables>(DeleteReviewDocument, options);
      }
export type DeleteReviewMutationHookResult = ReturnType<typeof useDeleteReviewMutation>;
export type DeleteReviewMutationResult = Apollo.MutationResult<IDeleteReviewMutation>;
export type DeleteReviewMutationOptions = Apollo.BaseMutationOptions<IDeleteReviewMutation, IDeleteReviewMutationVariables>;
export const DeleteSubscriptionPlanDocument = /*#__PURE__*/ gql`
    mutation DeleteSubscriptionPlan($id: Int!) {
  delete_subscription_plan_by_pk(id: $id) {
    id
  }
}
    `;
export type IDeleteSubscriptionPlanMutationFn = Apollo.MutationFunction<IDeleteSubscriptionPlanMutation, IDeleteSubscriptionPlanMutationVariables>;
export function useDeleteSubscriptionPlanMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteSubscriptionPlanMutation, IDeleteSubscriptionPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteSubscriptionPlanMutation, IDeleteSubscriptionPlanMutationVariables>(DeleteSubscriptionPlanDocument, options);
      }
export type DeleteSubscriptionPlanMutationHookResult = ReturnType<typeof useDeleteSubscriptionPlanMutation>;
export type DeleteSubscriptionPlanMutationResult = Apollo.MutationResult<IDeleteSubscriptionPlanMutation>;
export type DeleteSubscriptionPlanMutationOptions = Apollo.BaseMutationOptions<IDeleteSubscriptionPlanMutation, IDeleteSubscriptionPlanMutationVariables>;
export const DeleteUserDocument = /*#__PURE__*/ gql`
    mutation DeleteUser($user_id: Int!, $keycloak_id: String!) {
  delete_user_keycloak(user_id: $user_id, keycloak_id: $keycloak_id)
}
    `;
export type IDeleteUserMutationFn = Apollo.MutationFunction<IDeleteUserMutation, IDeleteUserMutationVariables>;
export function useDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteUserMutation, IDeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteUserMutation, IDeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<IDeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<IDeleteUserMutation, IDeleteUserMutationVariables>;
export const DeleteWeekTemplateDocument = /*#__PURE__*/ gql`
    mutation DeleteWeekTemplate($id: Int!) {
  delete_week_template_by_pk(id: $id) {
    id
  }
}
    `;
export type IDeleteWeekTemplateMutationFn = Apollo.MutationFunction<IDeleteWeekTemplateMutation, IDeleteWeekTemplateMutationVariables>;
export function useDeleteWeekTemplateMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteWeekTemplateMutation, IDeleteWeekTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteWeekTemplateMutation, IDeleteWeekTemplateMutationVariables>(DeleteWeekTemplateDocument, options);
      }
export type DeleteWeekTemplateMutationHookResult = ReturnType<typeof useDeleteWeekTemplateMutation>;
export type DeleteWeekTemplateMutationResult = Apollo.MutationResult<IDeleteWeekTemplateMutation>;
export type DeleteWeekTemplateMutationOptions = Apollo.BaseMutationOptions<IDeleteWeekTemplateMutation, IDeleteWeekTemplateMutationVariables>;
export const DeleteWorkoutTemplateDocument = /*#__PURE__*/ gql`
    mutation DeleteWorkoutTemplate($id: Int!) {
  delete_workout_template_by_pk(id: $id) {
    id
  }
}
    `;
export type IDeleteWorkoutTemplateMutationFn = Apollo.MutationFunction<IDeleteWorkoutTemplateMutation, IDeleteWorkoutTemplateMutationVariables>;
export function useDeleteWorkoutTemplateMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteWorkoutTemplateMutation, IDeleteWorkoutTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteWorkoutTemplateMutation, IDeleteWorkoutTemplateMutationVariables>(DeleteWorkoutTemplateDocument, options);
      }
export type DeleteWorkoutTemplateMutationHookResult = ReturnType<typeof useDeleteWorkoutTemplateMutation>;
export type DeleteWorkoutTemplateMutationResult = Apollo.MutationResult<IDeleteWorkoutTemplateMutation>;
export type DeleteWorkoutTemplateMutationOptions = Apollo.BaseMutationOptions<IDeleteWorkoutTemplateMutation, IDeleteWorkoutTemplateMutationVariables>;
export const DuplicateBlockTemplateDocument = /*#__PURE__*/ gql`
    mutation DuplicateBlockTemplate($block_template_id: Int!, $user_id: Int) {
  duplicate_block_template(
    block_template_id: $block_template_id
    user_id: $user_id
  )
}
    `;
export type IDuplicateBlockTemplateMutationFn = Apollo.MutationFunction<IDuplicateBlockTemplateMutation, IDuplicateBlockTemplateMutationVariables>;
export function useDuplicateBlockTemplateMutation(baseOptions?: Apollo.MutationHookOptions<IDuplicateBlockTemplateMutation, IDuplicateBlockTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDuplicateBlockTemplateMutation, IDuplicateBlockTemplateMutationVariables>(DuplicateBlockTemplateDocument, options);
      }
export type DuplicateBlockTemplateMutationHookResult = ReturnType<typeof useDuplicateBlockTemplateMutation>;
export type DuplicateBlockTemplateMutationResult = Apollo.MutationResult<IDuplicateBlockTemplateMutation>;
export type DuplicateBlockTemplateMutationOptions = Apollo.BaseMutationOptions<IDuplicateBlockTemplateMutation, IDuplicateBlockTemplateMutationVariables>;
export const InsertAthleteBlockDocument = /*#__PURE__*/ gql`
    mutation InsertAthleteBlock($object: athlete_block_insert_input!) {
  insert_athlete_block_one(object: $object) {
    id
  }
}
    `;
export type IInsertAthleteBlockMutationFn = Apollo.MutationFunction<IInsertAthleteBlockMutation, IInsertAthleteBlockMutationVariables>;
export function useInsertAthleteBlockMutation(baseOptions?: Apollo.MutationHookOptions<IInsertAthleteBlockMutation, IInsertAthleteBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IInsertAthleteBlockMutation, IInsertAthleteBlockMutationVariables>(InsertAthleteBlockDocument, options);
      }
export type InsertAthleteBlockMutationHookResult = ReturnType<typeof useInsertAthleteBlockMutation>;
export type InsertAthleteBlockMutationResult = Apollo.MutationResult<IInsertAthleteBlockMutation>;
export type InsertAthleteBlockMutationOptions = Apollo.BaseMutationOptions<IInsertAthleteBlockMutation, IInsertAthleteBlockMutationVariables>;
export const InsertAthleteWeekDocument = /*#__PURE__*/ gql`
    mutation InsertAthleteWeek($object: athlete_week_insert_input!) {
  insert_athlete_week_one(object: $object) {
    id
  }
}
    `;
export type IInsertAthleteWeekMutationFn = Apollo.MutationFunction<IInsertAthleteWeekMutation, IInsertAthleteWeekMutationVariables>;
export function useInsertAthleteWeekMutation(baseOptions?: Apollo.MutationHookOptions<IInsertAthleteWeekMutation, IInsertAthleteWeekMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IInsertAthleteWeekMutation, IInsertAthleteWeekMutationVariables>(InsertAthleteWeekDocument, options);
      }
export type InsertAthleteWeekMutationHookResult = ReturnType<typeof useInsertAthleteWeekMutation>;
export type InsertAthleteWeekMutationResult = Apollo.MutationResult<IInsertAthleteWeekMutation>;
export type InsertAthleteWeekMutationOptions = Apollo.BaseMutationOptions<IInsertAthleteWeekMutation, IInsertAthleteWeekMutationVariables>;
export const InsertAthleteWorkoutDocument = /*#__PURE__*/ gql`
    mutation InsertAthleteWorkout($object: athlete_workout_insert_input!) {
  insert_athlete_workout_one(object: $object) {
    id
  }
}
    `;
export type IInsertAthleteWorkoutMutationFn = Apollo.MutationFunction<IInsertAthleteWorkoutMutation, IInsertAthleteWorkoutMutationVariables>;
export function useInsertAthleteWorkoutMutation(baseOptions?: Apollo.MutationHookOptions<IInsertAthleteWorkoutMutation, IInsertAthleteWorkoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IInsertAthleteWorkoutMutation, IInsertAthleteWorkoutMutationVariables>(InsertAthleteWorkoutDocument, options);
      }
export type InsertAthleteWorkoutMutationHookResult = ReturnType<typeof useInsertAthleteWorkoutMutation>;
export type InsertAthleteWorkoutMutationResult = Apollo.MutationResult<IInsertAthleteWorkoutMutation>;
export type InsertAthleteWorkoutMutationOptions = Apollo.BaseMutationOptions<IInsertAthleteWorkoutMutation, IInsertAthleteWorkoutMutationVariables>;
export const InsertAtlheteBiometricDataDocument = /*#__PURE__*/ gql`
    mutation InsertAtlheteBiometricData($objects: [athlete_biometric_data_insert_input!]!) {
  insert_athlete_biometric_data(objects: $objects) {
    returning {
      id
    }
  }
}
    `;
export type IInsertAtlheteBiometricDataMutationFn = Apollo.MutationFunction<IInsertAtlheteBiometricDataMutation, IInsertAtlheteBiometricDataMutationVariables>;
export function useInsertAtlheteBiometricDataMutation(baseOptions?: Apollo.MutationHookOptions<IInsertAtlheteBiometricDataMutation, IInsertAtlheteBiometricDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IInsertAtlheteBiometricDataMutation, IInsertAtlheteBiometricDataMutationVariables>(InsertAtlheteBiometricDataDocument, options);
      }
export type InsertAtlheteBiometricDataMutationHookResult = ReturnType<typeof useInsertAtlheteBiometricDataMutation>;
export type InsertAtlheteBiometricDataMutationResult = Apollo.MutationResult<IInsertAtlheteBiometricDataMutation>;
export type InsertAtlheteBiometricDataMutationOptions = Apollo.BaseMutationOptions<IInsertAtlheteBiometricDataMutation, IInsertAtlheteBiometricDataMutationVariables>;
export const InsertBlockTemplateDocument = /*#__PURE__*/ gql`
    mutation InsertBlockTemplate($object: block_template_insert_input!) {
  insert_block_template_one(object: $object) {
    id
  }
}
    `;
export type IInsertBlockTemplateMutationFn = Apollo.MutationFunction<IInsertBlockTemplateMutation, IInsertBlockTemplateMutationVariables>;
export function useInsertBlockTemplateMutation(baseOptions?: Apollo.MutationHookOptions<IInsertBlockTemplateMutation, IInsertBlockTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IInsertBlockTemplateMutation, IInsertBlockTemplateMutationVariables>(InsertBlockTemplateDocument, options);
      }
export type InsertBlockTemplateMutationHookResult = ReturnType<typeof useInsertBlockTemplateMutation>;
export type InsertBlockTemplateMutationResult = Apollo.MutationResult<IInsertBlockTemplateMutation>;
export type InsertBlockTemplateMutationOptions = Apollo.BaseMutationOptions<IInsertBlockTemplateMutation, IInsertBlockTemplateMutationVariables>;
export const InsertCircuitDocument = /*#__PURE__*/ gql`
    mutation InsertCircuit($object: circuit_insert_input!) {
  insert_circuit_one(object: $object) {
    id
  }
}
    `;
export type IInsertCircuitMutationFn = Apollo.MutationFunction<IInsertCircuitMutation, IInsertCircuitMutationVariables>;
export function useInsertCircuitMutation(baseOptions?: Apollo.MutationHookOptions<IInsertCircuitMutation, IInsertCircuitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IInsertCircuitMutation, IInsertCircuitMutationVariables>(InsertCircuitDocument, options);
      }
export type InsertCircuitMutationHookResult = ReturnType<typeof useInsertCircuitMutation>;
export type InsertCircuitMutationResult = Apollo.MutationResult<IInsertCircuitMutation>;
export type InsertCircuitMutationOptions = Apollo.BaseMutationOptions<IInsertCircuitMutation, IInsertCircuitMutationVariables>;
export const InsertCircuitExerciseDocument = /*#__PURE__*/ gql`
    mutation InsertCircuitExercise($object: circuit_exercise_insert_input!) {
  insert_circuit_exercise_one(object: $object) {
    id
  }
}
    `;
export type IInsertCircuitExerciseMutationFn = Apollo.MutationFunction<IInsertCircuitExerciseMutation, IInsertCircuitExerciseMutationVariables>;
export function useInsertCircuitExerciseMutation(baseOptions?: Apollo.MutationHookOptions<IInsertCircuitExerciseMutation, IInsertCircuitExerciseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IInsertCircuitExerciseMutation, IInsertCircuitExerciseMutationVariables>(InsertCircuitExerciseDocument, options);
      }
export type InsertCircuitExerciseMutationHookResult = ReturnType<typeof useInsertCircuitExerciseMutation>;
export type InsertCircuitExerciseMutationResult = Apollo.MutationResult<IInsertCircuitExerciseMutation>;
export type InsertCircuitExerciseMutationOptions = Apollo.BaseMutationOptions<IInsertCircuitExerciseMutation, IInsertCircuitExerciseMutationVariables>;
export const InsertCouponDocument = /*#__PURE__*/ gql`
    mutation InsertCoupon($object: coupon_insert_input!) {
  insert_coupon_one(object: $object) {
    id
  }
}
    `;
export type IInsertCouponMutationFn = Apollo.MutationFunction<IInsertCouponMutation, IInsertCouponMutationVariables>;
export function useInsertCouponMutation(baseOptions?: Apollo.MutationHookOptions<IInsertCouponMutation, IInsertCouponMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IInsertCouponMutation, IInsertCouponMutationVariables>(InsertCouponDocument, options);
      }
export type InsertCouponMutationHookResult = ReturnType<typeof useInsertCouponMutation>;
export type InsertCouponMutationResult = Apollo.MutationResult<IInsertCouponMutation>;
export type InsertCouponMutationOptions = Apollo.BaseMutationOptions<IInsertCouponMutation, IInsertCouponMutationVariables>;
export const InsertExerciseDocument = /*#__PURE__*/ gql`
    mutation InsertExercise($object: exercise_insert_input!) {
  insert_exercise_one(object: $object) {
    id
  }
}
    `;
export type IInsertExerciseMutationFn = Apollo.MutationFunction<IInsertExerciseMutation, IInsertExerciseMutationVariables>;
export function useInsertExerciseMutation(baseOptions?: Apollo.MutationHookOptions<IInsertExerciseMutation, IInsertExerciseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IInsertExerciseMutation, IInsertExerciseMutationVariables>(InsertExerciseDocument, options);
      }
export type InsertExerciseMutationHookResult = ReturnType<typeof useInsertExerciseMutation>;
export type InsertExerciseMutationResult = Apollo.MutationResult<IInsertExerciseMutation>;
export type InsertExerciseMutationOptions = Apollo.BaseMutationOptions<IInsertExerciseMutation, IInsertExerciseMutationVariables>;
export const InsertReviewDocument = /*#__PURE__*/ gql`
    mutation InsertReview($name: String!) {
  insert_review_one(object: {name: $name}) {
    id
  }
}
    `;
export type IInsertReviewMutationFn = Apollo.MutationFunction<IInsertReviewMutation, IInsertReviewMutationVariables>;
export function useInsertReviewMutation(baseOptions?: Apollo.MutationHookOptions<IInsertReviewMutation, IInsertReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IInsertReviewMutation, IInsertReviewMutationVariables>(InsertReviewDocument, options);
      }
export type InsertReviewMutationHookResult = ReturnType<typeof useInsertReviewMutation>;
export type InsertReviewMutationResult = Apollo.MutationResult<IInsertReviewMutation>;
export type InsertReviewMutationOptions = Apollo.BaseMutationOptions<IInsertReviewMutation, IInsertReviewMutationVariables>;
export const InsertSubscriptionPlanDocument = /*#__PURE__*/ gql`
    mutation InsertSubscriptionPlan($_set1: subscription_plan_insert_input!) {
  insert_subscription_plan_one(object: $_set1) {
    id
  }
}
    `;
export type IInsertSubscriptionPlanMutationFn = Apollo.MutationFunction<IInsertSubscriptionPlanMutation, IInsertSubscriptionPlanMutationVariables>;
export function useInsertSubscriptionPlanMutation(baseOptions?: Apollo.MutationHookOptions<IInsertSubscriptionPlanMutation, IInsertSubscriptionPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IInsertSubscriptionPlanMutation, IInsertSubscriptionPlanMutationVariables>(InsertSubscriptionPlanDocument, options);
      }
export type InsertSubscriptionPlanMutationHookResult = ReturnType<typeof useInsertSubscriptionPlanMutation>;
export type InsertSubscriptionPlanMutationResult = Apollo.MutationResult<IInsertSubscriptionPlanMutation>;
export type InsertSubscriptionPlanMutationOptions = Apollo.BaseMutationOptions<IInsertSubscriptionPlanMutation, IInsertSubscriptionPlanMutationVariables>;
export const InsertSubscriptionPlanTemplateDocument = /*#__PURE__*/ gql`
    mutation InsertSubscriptionPlanTemplate($_set: subscription_plan_template_insert_input!) {
  insert_subscription_plan_template_one(object: $_set) {
    id
  }
}
    `;
export type IInsertSubscriptionPlanTemplateMutationFn = Apollo.MutationFunction<IInsertSubscriptionPlanTemplateMutation, IInsertSubscriptionPlanTemplateMutationVariables>;
export function useInsertSubscriptionPlanTemplateMutation(baseOptions?: Apollo.MutationHookOptions<IInsertSubscriptionPlanTemplateMutation, IInsertSubscriptionPlanTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IInsertSubscriptionPlanTemplateMutation, IInsertSubscriptionPlanTemplateMutationVariables>(InsertSubscriptionPlanTemplateDocument, options);
      }
export type InsertSubscriptionPlanTemplateMutationHookResult = ReturnType<typeof useInsertSubscriptionPlanTemplateMutation>;
export type InsertSubscriptionPlanTemplateMutationResult = Apollo.MutationResult<IInsertSubscriptionPlanTemplateMutation>;
export type InsertSubscriptionPlanTemplateMutationOptions = Apollo.BaseMutationOptions<IInsertSubscriptionPlanTemplateMutation, IInsertSubscriptionPlanTemplateMutationVariables>;
export const InsertWeekTemplateDocument = /*#__PURE__*/ gql`
    mutation InsertWeekTemplate($object: week_template_insert_input!) {
  insert_week_template_one(object: $object) {
    id
  }
}
    `;
export type IInsertWeekTemplateMutationFn = Apollo.MutationFunction<IInsertWeekTemplateMutation, IInsertWeekTemplateMutationVariables>;
export function useInsertWeekTemplateMutation(baseOptions?: Apollo.MutationHookOptions<IInsertWeekTemplateMutation, IInsertWeekTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IInsertWeekTemplateMutation, IInsertWeekTemplateMutationVariables>(InsertWeekTemplateDocument, options);
      }
export type InsertWeekTemplateMutationHookResult = ReturnType<typeof useInsertWeekTemplateMutation>;
export type InsertWeekTemplateMutationResult = Apollo.MutationResult<IInsertWeekTemplateMutation>;
export type InsertWeekTemplateMutationOptions = Apollo.BaseMutationOptions<IInsertWeekTemplateMutation, IInsertWeekTemplateMutationVariables>;
export const InsertWorkoutAltimetryDocument = /*#__PURE__*/ gql`
    mutation InsertWorkoutAltimetry($coefficient: numeric, $name: String, $_set1: [workout_altimetry_translation_insert_input!]!, $workout_altimetry_workout_type: [workout_altimetry_workout_type_insert_input!]!) {
  insert_workout_altimetry_one(
    object: {coefficient: $coefficient, name: $name, workout_altimetry_translations: {data: $_set1}, workout_altimetry_workout_types: {data: $workout_altimetry_workout_type}}
  ) {
    id
  }
}
    `;
export type IInsertWorkoutAltimetryMutationFn = Apollo.MutationFunction<IInsertWorkoutAltimetryMutation, IInsertWorkoutAltimetryMutationVariables>;
export function useInsertWorkoutAltimetryMutation(baseOptions?: Apollo.MutationHookOptions<IInsertWorkoutAltimetryMutation, IInsertWorkoutAltimetryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IInsertWorkoutAltimetryMutation, IInsertWorkoutAltimetryMutationVariables>(InsertWorkoutAltimetryDocument, options);
      }
export type InsertWorkoutAltimetryMutationHookResult = ReturnType<typeof useInsertWorkoutAltimetryMutation>;
export type InsertWorkoutAltimetryMutationResult = Apollo.MutationResult<IInsertWorkoutAltimetryMutation>;
export type InsertWorkoutAltimetryMutationOptions = Apollo.BaseMutationOptions<IInsertWorkoutAltimetryMutation, IInsertWorkoutAltimetryMutationVariables>;
export const InsertWorkoutDurationDocument = /*#__PURE__*/ gql`
    mutation InsertWorkoutDuration($coefficient: numeric, $duration: numeric) {
  insert_workout_duration_one(
    object: {coefficient: $coefficient, duration: $duration}
  ) {
    id
  }
}
    `;
export type IInsertWorkoutDurationMutationFn = Apollo.MutationFunction<IInsertWorkoutDurationMutation, IInsertWorkoutDurationMutationVariables>;
export function useInsertWorkoutDurationMutation(baseOptions?: Apollo.MutationHookOptions<IInsertWorkoutDurationMutation, IInsertWorkoutDurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IInsertWorkoutDurationMutation, IInsertWorkoutDurationMutationVariables>(InsertWorkoutDurationDocument, options);
      }
export type InsertWorkoutDurationMutationHookResult = ReturnType<typeof useInsertWorkoutDurationMutation>;
export type InsertWorkoutDurationMutationResult = Apollo.MutationResult<IInsertWorkoutDurationMutation>;
export type InsertWorkoutDurationMutationOptions = Apollo.BaseMutationOptions<IInsertWorkoutDurationMutation, IInsertWorkoutDurationMutationVariables>;
export const InsertWorkoutTemplateDocument = /*#__PURE__*/ gql`
    mutation InsertWorkoutTemplate($object: workout_template_insert_input!) {
  insert_workout_template_one(object: $object) {
    id
  }
}
    `;
export type IInsertWorkoutTemplateMutationFn = Apollo.MutationFunction<IInsertWorkoutTemplateMutation, IInsertWorkoutTemplateMutationVariables>;
export function useInsertWorkoutTemplateMutation(baseOptions?: Apollo.MutationHookOptions<IInsertWorkoutTemplateMutation, IInsertWorkoutTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IInsertWorkoutTemplateMutation, IInsertWorkoutTemplateMutationVariables>(InsertWorkoutTemplateDocument, options);
      }
export type InsertWorkoutTemplateMutationHookResult = ReturnType<typeof useInsertWorkoutTemplateMutation>;
export type InsertWorkoutTemplateMutationResult = Apollo.MutationResult<IInsertWorkoutTemplateMutation>;
export type InsertWorkoutTemplateMutationOptions = Apollo.BaseMutationOptions<IInsertWorkoutTemplateMutation, IInsertWorkoutTemplateMutationVariables>;
export const InsertWorkoutTerrainDocument = /*#__PURE__*/ gql`
    mutation InsertWorkoutTerrain($coefficient: numeric, $_set1: [workout_terrain_translation_insert_input!]!) {
  insert_workout_terrain_one(
    object: {coefficient: $coefficient, workout_terrain_translations: {data: $_set1}}
  ) {
    id
  }
}
    `;
export type IInsertWorkoutTerrainMutationFn = Apollo.MutationFunction<IInsertWorkoutTerrainMutation, IInsertWorkoutTerrainMutationVariables>;
export function useInsertWorkoutTerrainMutation(baseOptions?: Apollo.MutationHookOptions<IInsertWorkoutTerrainMutation, IInsertWorkoutTerrainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IInsertWorkoutTerrainMutation, IInsertWorkoutTerrainMutationVariables>(InsertWorkoutTerrainDocument, options);
      }
export type InsertWorkoutTerrainMutationHookResult = ReturnType<typeof useInsertWorkoutTerrainMutation>;
export type InsertWorkoutTerrainMutationResult = Apollo.MutationResult<IInsertWorkoutTerrainMutation>;
export type InsertWorkoutTerrainMutationOptions = Apollo.BaseMutationOptions<IInsertWorkoutTerrainMutation, IInsertWorkoutTerrainMutationVariables>;
export const InsertWorkoutZoneDocument = /*#__PURE__*/ gql`
    mutation InsertWorkoutZone($interval_start: numeric, $interval_end: numeric, $name: String) {
  insert_workout_zone_one(
    object: {interval_start: $interval_start, interval_end: $interval_end, name: $name}
  ) {
    id
  }
}
    `;
export type IInsertWorkoutZoneMutationFn = Apollo.MutationFunction<IInsertWorkoutZoneMutation, IInsertWorkoutZoneMutationVariables>;
export function useInsertWorkoutZoneMutation(baseOptions?: Apollo.MutationHookOptions<IInsertWorkoutZoneMutation, IInsertWorkoutZoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IInsertWorkoutZoneMutation, IInsertWorkoutZoneMutationVariables>(InsertWorkoutZoneDocument, options);
      }
export type InsertWorkoutZoneMutationHookResult = ReturnType<typeof useInsertWorkoutZoneMutation>;
export type InsertWorkoutZoneMutationResult = Apollo.MutationResult<IInsertWorkoutZoneMutation>;
export type InsertWorkoutZoneMutationOptions = Apollo.BaseMutationOptions<IInsertWorkoutZoneMutation, IInsertWorkoutZoneMutationVariables>;
export const RecoverPasswordDocument = /*#__PURE__*/ gql`
    mutation RecoverPassword($email: String!) {
  recover_password(email: $email, type: ["coach", "admin"])
}
    `;
export type IRecoverPasswordMutationFn = Apollo.MutationFunction<IRecoverPasswordMutation, IRecoverPasswordMutationVariables>;
export function useRecoverPasswordMutation(baseOptions?: Apollo.MutationHookOptions<IRecoverPasswordMutation, IRecoverPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IRecoverPasswordMutation, IRecoverPasswordMutationVariables>(RecoverPasswordDocument, options);
      }
export type RecoverPasswordMutationHookResult = ReturnType<typeof useRecoverPasswordMutation>;
export type RecoverPasswordMutationResult = Apollo.MutationResult<IRecoverPasswordMutation>;
export type RecoverPasswordMutationOptions = Apollo.BaseMutationOptions<IRecoverPasswordMutation, IRecoverPasswordMutationVariables>;
export const SetNewCoachPasswordDocument = /*#__PURE__*/ gql`
    mutation SetNewCoachPassword($password: String!, $token: String!) {
  set_new_coach_password(password: $password, token: $token)
}
    `;
export type ISetNewCoachPasswordMutationFn = Apollo.MutationFunction<ISetNewCoachPasswordMutation, ISetNewCoachPasswordMutationVariables>;
export function useSetNewCoachPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ISetNewCoachPasswordMutation, ISetNewCoachPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ISetNewCoachPasswordMutation, ISetNewCoachPasswordMutationVariables>(SetNewCoachPasswordDocument, options);
      }
export type SetNewCoachPasswordMutationHookResult = ReturnType<typeof useSetNewCoachPasswordMutation>;
export type SetNewCoachPasswordMutationResult = Apollo.MutationResult<ISetNewCoachPasswordMutation>;
export type SetNewCoachPasswordMutationOptions = Apollo.BaseMutationOptions<ISetNewCoachPasswordMutation, ISetNewCoachPasswordMutationVariables>;
export const UpdateAthleteBlockDocument = /*#__PURE__*/ gql`
    mutation UpdateAthleteBlock($id: Int!, $_set: athlete_block_set_input!) {
  update_athlete_block_by_pk(pk_columns: {id: $id}, _set: $_set) {
    id
  }
}
    `;
export type IUpdateAthleteBlockMutationFn = Apollo.MutationFunction<IUpdateAthleteBlockMutation, IUpdateAthleteBlockMutationVariables>;
export function useUpdateAthleteBlockMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateAthleteBlockMutation, IUpdateAthleteBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateAthleteBlockMutation, IUpdateAthleteBlockMutationVariables>(UpdateAthleteBlockDocument, options);
      }
export type UpdateAthleteBlockMutationHookResult = ReturnType<typeof useUpdateAthleteBlockMutation>;
export type UpdateAthleteBlockMutationResult = Apollo.MutationResult<IUpdateAthleteBlockMutation>;
export type UpdateAthleteBlockMutationOptions = Apollo.BaseMutationOptions<IUpdateAthleteBlockMutation, IUpdateAthleteBlockMutationVariables>;
export const UpdateAthleteCoachDocument = /*#__PURE__*/ gql`
    mutation UpdateAthleteCoach($id: Int!, $coach_id: Int!) {
  update_athlete_by_pk(pk_columns: {id: $id}, _set: {coach_id: $coach_id}) {
    id
  }
}
    `;
export type IUpdateAthleteCoachMutationFn = Apollo.MutationFunction<IUpdateAthleteCoachMutation, IUpdateAthleteCoachMutationVariables>;
export function useUpdateAthleteCoachMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateAthleteCoachMutation, IUpdateAthleteCoachMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateAthleteCoachMutation, IUpdateAthleteCoachMutationVariables>(UpdateAthleteCoachDocument, options);
      }
export type UpdateAthleteCoachMutationHookResult = ReturnType<typeof useUpdateAthleteCoachMutation>;
export type UpdateAthleteCoachMutationResult = Apollo.MutationResult<IUpdateAthleteCoachMutation>;
export type UpdateAthleteCoachMutationOptions = Apollo.BaseMutationOptions<IUpdateAthleteCoachMutation, IUpdateAthleteCoachMutationVariables>;
export const UpdateAthletePlanAndProfileDocument = /*#__PURE__*/ gql`
    mutation UpdateAthletePlanAndProfile($id: Int!, $athlete_profile_id: Int!) {
  update_athlete_by_pk(
    pk_columns: {id: $id}
    _set: {athlete_profile_id: $athlete_profile_id}
  ) {
    id
  }
}
    `;
export type IUpdateAthletePlanAndProfileMutationFn = Apollo.MutationFunction<IUpdateAthletePlanAndProfileMutation, IUpdateAthletePlanAndProfileMutationVariables>;
export function useUpdateAthletePlanAndProfileMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateAthletePlanAndProfileMutation, IUpdateAthletePlanAndProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateAthletePlanAndProfileMutation, IUpdateAthletePlanAndProfileMutationVariables>(UpdateAthletePlanAndProfileDocument, options);
      }
export type UpdateAthletePlanAndProfileMutationHookResult = ReturnType<typeof useUpdateAthletePlanAndProfileMutation>;
export type UpdateAthletePlanAndProfileMutationResult = Apollo.MutationResult<IUpdateAthletePlanAndProfileMutation>;
export type UpdateAthletePlanAndProfileMutationOptions = Apollo.BaseMutationOptions<IUpdateAthletePlanAndProfileMutation, IUpdateAthletePlanAndProfileMutationVariables>;
export const UpdateAthleteProfileDocument = /*#__PURE__*/ gql`
    mutation UpdateAthleteProfile($athlete_profile_set: athlete_profile_set_input, $athlete_profile_id: Int!, $athlete_profile_altimetry_adjustments: [athlete_profile_altimetry_adjustment_insert_input!]!) {
  update_athlete_profile_by_pk(
    pk_columns: {id: $athlete_profile_id}
    _set: $athlete_profile_set
  ) {
    id
  }
  insert_athlete_profile_altimetry_adjustment(
    objects: $athlete_profile_altimetry_adjustments
    on_conflict: {constraint: athlete_profile_altimetry_adjustment_pkey, update_columns: [value]}
  ) {
    returning {
      id
    }
  }
}
    `;
export type IUpdateAthleteProfileMutationFn = Apollo.MutationFunction<IUpdateAthleteProfileMutation, IUpdateAthleteProfileMutationVariables>;
export function useUpdateAthleteProfileMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateAthleteProfileMutation, IUpdateAthleteProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateAthleteProfileMutation, IUpdateAthleteProfileMutationVariables>(UpdateAthleteProfileDocument, options);
      }
export type UpdateAthleteProfileMutationHookResult = ReturnType<typeof useUpdateAthleteProfileMutation>;
export type UpdateAthleteProfileMutationResult = Apollo.MutationResult<IUpdateAthleteProfileMutation>;
export type UpdateAthleteProfileMutationOptions = Apollo.BaseMutationOptions<IUpdateAthleteProfileMutation, IUpdateAthleteProfileMutationVariables>;
export const UpdateAthleteWeekDocument = /*#__PURE__*/ gql`
    mutation UpdateAthleteWeek($id: Int!, $_set: athlete_week_set_input!) {
  update_athlete_week_by_pk(pk_columns: {id: $id}, _set: $_set) {
    id
  }
}
    `;
export type IUpdateAthleteWeekMutationFn = Apollo.MutationFunction<IUpdateAthleteWeekMutation, IUpdateAthleteWeekMutationVariables>;
export function useUpdateAthleteWeekMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateAthleteWeekMutation, IUpdateAthleteWeekMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateAthleteWeekMutation, IUpdateAthleteWeekMutationVariables>(UpdateAthleteWeekDocument, options);
      }
export type UpdateAthleteWeekMutationHookResult = ReturnType<typeof useUpdateAthleteWeekMutation>;
export type UpdateAthleteWeekMutationResult = Apollo.MutationResult<IUpdateAthleteWeekMutation>;
export type UpdateAthleteWeekMutationOptions = Apollo.BaseMutationOptions<IUpdateAthleteWeekMutation, IUpdateAthleteWeekMutationVariables>;
export const UpdateAthleteWorkoutDocument = /*#__PURE__*/ gql`
    mutation UpdateAthleteWorkout($athlete_workout_data: athlete_workout_set_input!, $id: Int!, $workout_sections_data: [athlete_workout_section_insert_input!]!, $workout_section_ids_to_delete: [Int!]!) {
  update_athlete_workout_by_pk(pk_columns: {id: $id}, _set: $athlete_workout_data) {
    id
  }
  insert_athlete_workout_section(
    objects: $workout_sections_data
    on_conflict: {constraint: athlete_workout_section_pkey, update_columns: [average_heart_rate, max_heart_rate, duration, speed, workout_zone_id, average_heart_rate_percentage, speed_percentage, order, type]}
  ) {
    affected_rows
  }
  delete_athlete_workout_section(
    where: {id: {_in: $workout_section_ids_to_delete}}
  ) {
    affected_rows
  }
}
    `;
export type IUpdateAthleteWorkoutMutationFn = Apollo.MutationFunction<IUpdateAthleteWorkoutMutation, IUpdateAthleteWorkoutMutationVariables>;
export function useUpdateAthleteWorkoutMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateAthleteWorkoutMutation, IUpdateAthleteWorkoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateAthleteWorkoutMutation, IUpdateAthleteWorkoutMutationVariables>(UpdateAthleteWorkoutDocument, options);
      }
export type UpdateAthleteWorkoutMutationHookResult = ReturnType<typeof useUpdateAthleteWorkoutMutation>;
export type UpdateAthleteWorkoutMutationResult = Apollo.MutationResult<IUpdateAthleteWorkoutMutation>;
export type UpdateAthleteWorkoutMutationOptions = Apollo.BaseMutationOptions<IUpdateAthleteWorkoutMutation, IUpdateAthleteWorkoutMutationVariables>;
export const UpdateAtlheteSpeedsDocument = /*#__PURE__*/ gql`
    mutation UpdateAtlheteSpeeds($_set: [athlete_speed_updates!]!) {
  update_athlete_speed_many(updates: $_set) {
    returning {
      id
    }
  }
}
    `;
export type IUpdateAtlheteSpeedsMutationFn = Apollo.MutationFunction<IUpdateAtlheteSpeedsMutation, IUpdateAtlheteSpeedsMutationVariables>;
export function useUpdateAtlheteSpeedsMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateAtlheteSpeedsMutation, IUpdateAtlheteSpeedsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateAtlheteSpeedsMutation, IUpdateAtlheteSpeedsMutationVariables>(UpdateAtlheteSpeedsDocument, options);
      }
export type UpdateAtlheteSpeedsMutationHookResult = ReturnType<typeof useUpdateAtlheteSpeedsMutation>;
export type UpdateAtlheteSpeedsMutationResult = Apollo.MutationResult<IUpdateAtlheteSpeedsMutation>;
export type UpdateAtlheteSpeedsMutationOptions = Apollo.BaseMutationOptions<IUpdateAtlheteSpeedsMutation, IUpdateAtlheteSpeedsMutationVariables>;
export const UpdateBlockDocument = /*#__PURE__*/ gql`
    mutation UpdateBlock($id: Int!, $_set: block_template_set_input!) {
  update_block_template_by_pk(pk_columns: {id: $id}, _set: $_set) {
    id
  }
}
    `;
export type IUpdateBlockMutationFn = Apollo.MutationFunction<IUpdateBlockMutation, IUpdateBlockMutationVariables>;
export function useUpdateBlockMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateBlockMutation, IUpdateBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateBlockMutation, IUpdateBlockMutationVariables>(UpdateBlockDocument, options);
      }
export type UpdateBlockMutationHookResult = ReturnType<typeof useUpdateBlockMutation>;
export type UpdateBlockMutationResult = Apollo.MutationResult<IUpdateBlockMutation>;
export type UpdateBlockMutationOptions = Apollo.BaseMutationOptions<IUpdateBlockMutation, IUpdateBlockMutationVariables>;
export const UpdateCircuitDocument = /*#__PURE__*/ gql`
    mutation UpdateCircuit($id: Int!, $_set: circuit_set_input!, $circuit_sports_to_remove: [Int!] = [], $circuit_sports_to_add: [circuit_sport_insert_input!] = [], $_set1: [circuit_translation_insert_input!]!, $_set2: [circuit_translation_updates!]!) {
  delete_circuit_sport(where: {id: {_in: $circuit_sports_to_remove}}) {
    affected_rows
  }
  insert_circuit_sport(objects: $circuit_sports_to_add) {
    affected_rows
  }
  update_circuit_by_pk(pk_columns: {id: $id}, _set: $_set) {
    id
  }
  insert_circuit_translation(objects: $_set1) {
    affected_rows
  }
  update_circuit_translation_many(updates: $_set2) {
    affected_rows
  }
}
    `;
export type IUpdateCircuitMutationFn = Apollo.MutationFunction<IUpdateCircuitMutation, IUpdateCircuitMutationVariables>;
export function useUpdateCircuitMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateCircuitMutation, IUpdateCircuitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateCircuitMutation, IUpdateCircuitMutationVariables>(UpdateCircuitDocument, options);
      }
export type UpdateCircuitMutationHookResult = ReturnType<typeof useUpdateCircuitMutation>;
export type UpdateCircuitMutationResult = Apollo.MutationResult<IUpdateCircuitMutation>;
export type UpdateCircuitMutationOptions = Apollo.BaseMutationOptions<IUpdateCircuitMutation, IUpdateCircuitMutationVariables>;
export const UpdateCircuitExerciseDocument = /*#__PURE__*/ gql`
    mutation UpdateCircuitExercise($_set: circuit_exercise_set_input!, $id: Int!) {
  update_circuit_exercise_by_pk(_set: $_set, pk_columns: {id: $id}) {
    id
  }
}
    `;
export type IUpdateCircuitExerciseMutationFn = Apollo.MutationFunction<IUpdateCircuitExerciseMutation, IUpdateCircuitExerciseMutationVariables>;
export function useUpdateCircuitExerciseMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateCircuitExerciseMutation, IUpdateCircuitExerciseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateCircuitExerciseMutation, IUpdateCircuitExerciseMutationVariables>(UpdateCircuitExerciseDocument, options);
      }
export type UpdateCircuitExerciseMutationHookResult = ReturnType<typeof useUpdateCircuitExerciseMutation>;
export type UpdateCircuitExerciseMutationResult = Apollo.MutationResult<IUpdateCircuitExerciseMutation>;
export type UpdateCircuitExerciseMutationOptions = Apollo.BaseMutationOptions<IUpdateCircuitExerciseMutation, IUpdateCircuitExerciseMutationVariables>;
export const UpdateCoachDocument = /*#__PURE__*/ gql`
    mutation UpdateCoach($id: Int!, $name: String!, $phone: String, $profile_picture: String!, $spoken_languages: _text!, $platform_content_access: Boolean!, $platform_fee: float8!, $coach_sports_to_remove: [Int!] = [], $coach_sports_to_add: [coach_sport_insert_input!] = [], $public: Boolean, $_set1: [coach_translation_insert_input!]!, $_set2: [coach_translation_updates!]!) {
  delete_coach_sport(where: {id: {_in: $coach_sports_to_remove}}) {
    returning {
      id
    }
  }
  insert_coach_sport(objects: $coach_sports_to_add) {
    returning {
      id
    }
  }
  update_coach_by_pk(
    pk_columns: {id: $id}
    _set: {name: $name, phone: $phone, profile_picture: $profile_picture, spoken_languages: $spoken_languages, public: $public, platform_content_access: $platform_content_access, platform_fee: $platform_fee}
  ) {
    id
  }
  insert_coach_translation(objects: $_set1) {
    affected_rows
  }
  update_coach_translation_many(updates: $_set2) {
    affected_rows
  }
}
    `;
export type IUpdateCoachMutationFn = Apollo.MutationFunction<IUpdateCoachMutation, IUpdateCoachMutationVariables>;
export function useUpdateCoachMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateCoachMutation, IUpdateCoachMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateCoachMutation, IUpdateCoachMutationVariables>(UpdateCoachDocument, options);
      }
export type UpdateCoachMutationHookResult = ReturnType<typeof useUpdateCoachMutation>;
export type UpdateCoachMutationResult = Apollo.MutationResult<IUpdateCoachMutation>;
export type UpdateCoachMutationOptions = Apollo.BaseMutationOptions<IUpdateCoachMutation, IUpdateCoachMutationVariables>;
export const UpdateCoachBillingDataDocument = /*#__PURE__*/ gql`
    mutation UpdateCoachBillingData($id: Int!, $fiscal_id_number: String!, $address_street: String!, $address_city: String!, $address_postal_code: String!, $address_country: String!) {
  update_coach_by_pk(
    pk_columns: {id: $id}
    _set: {fiscal_id_number: $fiscal_id_number, address_street: $address_street, address_city: $address_city, address_postal_code: $address_postal_code, address_country: $address_country}
  ) {
    id
  }
}
    `;
export type IUpdateCoachBillingDataMutationFn = Apollo.MutationFunction<IUpdateCoachBillingDataMutation, IUpdateCoachBillingDataMutationVariables>;
export function useUpdateCoachBillingDataMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateCoachBillingDataMutation, IUpdateCoachBillingDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateCoachBillingDataMutation, IUpdateCoachBillingDataMutationVariables>(UpdateCoachBillingDataDocument, options);
      }
export type UpdateCoachBillingDataMutationHookResult = ReturnType<typeof useUpdateCoachBillingDataMutation>;
export type UpdateCoachBillingDataMutationResult = Apollo.MutationResult<IUpdateCoachBillingDataMutation>;
export type UpdateCoachBillingDataMutationOptions = Apollo.BaseMutationOptions<IUpdateCoachBillingDataMutation, IUpdateCoachBillingDataMutationVariables>;
export const UpdateExerciseDocument = /*#__PURE__*/ gql`
    mutation UpdateExercise($id: Int!, $_set: exercise_set_input!, $_set1: [exercise_translation_insert_input!]!, $_set2: [exercise_translation_updates!]!) {
  update_exercise_by_pk(pk_columns: {id: $id}, _set: $_set) {
    id
  }
  insert_exercise_translation(objects: $_set1) {
    affected_rows
  }
  update_exercise_translation_many(updates: $_set2) {
    affected_rows
  }
}
    `;
export type IUpdateExerciseMutationFn = Apollo.MutationFunction<IUpdateExerciseMutation, IUpdateExerciseMutationVariables>;
export function useUpdateExerciseMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateExerciseMutation, IUpdateExerciseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateExerciseMutation, IUpdateExerciseMutationVariables>(UpdateExerciseDocument, options);
      }
export type UpdateExerciseMutationHookResult = ReturnType<typeof useUpdateExerciseMutation>;
export type UpdateExerciseMutationResult = Apollo.MutationResult<IUpdateExerciseMutation>;
export type UpdateExerciseMutationOptions = Apollo.BaseMutationOptions<IUpdateExerciseMutation, IUpdateExerciseMutationVariables>;
export const UpdateReviewDocument = /*#__PURE__*/ gql`
    mutation UpdateReview($id: Int!, $image: String!, $name: String!, $_set1: [review_translation_insert_input!]!, $_set2: [review_translation_updates!]!) {
  update_review_by_pk(pk_columns: {id: $id}, _set: {image: $image, name: $name}) {
    id
  }
  insert_review_translation(objects: $_set1) {
    affected_rows
  }
  update_review_translation_many(updates: $_set2) {
    affected_rows
  }
}
    `;
export type IUpdateReviewMutationFn = Apollo.MutationFunction<IUpdateReviewMutation, IUpdateReviewMutationVariables>;
export function useUpdateReviewMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateReviewMutation, IUpdateReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateReviewMutation, IUpdateReviewMutationVariables>(UpdateReviewDocument, options);
      }
export type UpdateReviewMutationHookResult = ReturnType<typeof useUpdateReviewMutation>;
export type UpdateReviewMutationResult = Apollo.MutationResult<IUpdateReviewMutation>;
export type UpdateReviewMutationOptions = Apollo.BaseMutationOptions<IUpdateReviewMutation, IUpdateReviewMutationVariables>;
export const UpdateSportDocument = /*#__PURE__*/ gql`
    mutation UpdateSport($id: name!, $image: String, $_set1: [sport_translation_insert_input!]!, $_set2: [sport_translation_updates!]!) {
  update_sport_by_pk(pk_columns: {id: $id}, _set: {image: $image}) {
    id
  }
  insert_sport_translation(objects: $_set1) {
    affected_rows
  }
  update_sport_translation_many(updates: $_set2) {
    affected_rows
  }
}
    `;
export type IUpdateSportMutationFn = Apollo.MutationFunction<IUpdateSportMutation, IUpdateSportMutationVariables>;
export function useUpdateSportMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateSportMutation, IUpdateSportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateSportMutation, IUpdateSportMutationVariables>(UpdateSportDocument, options);
      }
export type UpdateSportMutationHookResult = ReturnType<typeof useUpdateSportMutation>;
export type UpdateSportMutationResult = Apollo.MutationResult<IUpdateSportMutation>;
export type UpdateSportMutationOptions = Apollo.BaseMutationOptions<IUpdateSportMutation, IUpdateSportMutationVariables>;
export const UpdateSubscriptionPlanDocument = /*#__PURE__*/ gql`
    mutation UpdateSubscriptionPlan($id: Int!, $_set: subscription_plan_set_input!, $_set2: [subscription_plan_translation_insert_input!]!, $_set3: [subscription_plan_translation_updates!]!) {
  update_subscription_plan_by_pk(pk_columns: {id: $id}, _set: $_set) {
    id
  }
  insert_subscription_plan_translation(objects: $_set2) {
    affected_rows
  }
  update_subscription_plan_translation_many(updates: $_set3) {
    affected_rows
  }
}
    `;
export type IUpdateSubscriptionPlanMutationFn = Apollo.MutationFunction<IUpdateSubscriptionPlanMutation, IUpdateSubscriptionPlanMutationVariables>;
export function useUpdateSubscriptionPlanMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateSubscriptionPlanMutation, IUpdateSubscriptionPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateSubscriptionPlanMutation, IUpdateSubscriptionPlanMutationVariables>(UpdateSubscriptionPlanDocument, options);
      }
export type UpdateSubscriptionPlanMutationHookResult = ReturnType<typeof useUpdateSubscriptionPlanMutation>;
export type UpdateSubscriptionPlanMutationResult = Apollo.MutationResult<IUpdateSubscriptionPlanMutation>;
export type UpdateSubscriptionPlanMutationOptions = Apollo.BaseMutationOptions<IUpdateSubscriptionPlanMutation, IUpdateSubscriptionPlanMutationVariables>;
export const UpdateSubscriptionPlanTemplateDocument = /*#__PURE__*/ gql`
    mutation UpdateSubscriptionPlanTemplate($id: Int!, $_set: subscription_plan_template_set_input!) {
  update_subscription_plan_template_by_pk(pk_columns: {id: $id}, _set: $_set) {
    id
  }
}
    `;
export type IUpdateSubscriptionPlanTemplateMutationFn = Apollo.MutationFunction<IUpdateSubscriptionPlanTemplateMutation, IUpdateSubscriptionPlanTemplateMutationVariables>;
export function useUpdateSubscriptionPlanTemplateMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateSubscriptionPlanTemplateMutation, IUpdateSubscriptionPlanTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateSubscriptionPlanTemplateMutation, IUpdateSubscriptionPlanTemplateMutationVariables>(UpdateSubscriptionPlanTemplateDocument, options);
      }
export type UpdateSubscriptionPlanTemplateMutationHookResult = ReturnType<typeof useUpdateSubscriptionPlanTemplateMutation>;
export type UpdateSubscriptionPlanTemplateMutationResult = Apollo.MutationResult<IUpdateSubscriptionPlanTemplateMutation>;
export type UpdateSubscriptionPlanTemplateMutationOptions = Apollo.BaseMutationOptions<IUpdateSubscriptionPlanTemplateMutation, IUpdateSubscriptionPlanTemplateMutationVariables>;
export const UpdateWeekDocument = /*#__PURE__*/ gql`
    mutation UpdateWeek($id: Int!, $_set: week_template_set_input!) {
  update_week_template_by_pk(pk_columns: {id: $id}, _set: $_set) {
    id
  }
}
    `;
export type IUpdateWeekMutationFn = Apollo.MutationFunction<IUpdateWeekMutation, IUpdateWeekMutationVariables>;
export function useUpdateWeekMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateWeekMutation, IUpdateWeekMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateWeekMutation, IUpdateWeekMutationVariables>(UpdateWeekDocument, options);
      }
export type UpdateWeekMutationHookResult = ReturnType<typeof useUpdateWeekMutation>;
export type UpdateWeekMutationResult = Apollo.MutationResult<IUpdateWeekMutation>;
export type UpdateWeekMutationOptions = Apollo.BaseMutationOptions<IUpdateWeekMutation, IUpdateWeekMutationVariables>;
export const UpdateWorkoutAltimetryDocument = /*#__PURE__*/ gql`
    mutation UpdateWorkoutAltimetry($coefficient: numeric, $name: String, $_set1: [workout_altimetry_translation_insert_input!]!, $_set2: [workout_altimetry_translation_updates!]!, $id: Int!, $workout_altimetry_workout_type: [workout_altimetry_workout_type_insert_input!]!, $workout_altimetry_workout_type_ids_to_delete: [Int!] = []) {
  update_workout_altimetry_by_pk(
    pk_columns: {id: $id}
    _set: {coefficient: $coefficient, name: $name}
  ) {
    id
  }
  insert_workout_altimetry_translation(objects: $_set1) {
    affected_rows
  }
  update_workout_altimetry_translation_many(updates: $_set2) {
    affected_rows
  }
  insert_workout_altimetry_workout_type(
    objects: $workout_altimetry_workout_type
    on_conflict: {constraint: workout_altimetry_workout_type_altimetry_id_type_id_key, update_columns: [workout_type_id, workout_altimetry_id]}
  ) {
    affected_rows
    returning {
      id
    }
  }
  delete_workout_altimetry_workout_type(
    where: {id: {_in: $workout_altimetry_workout_type_ids_to_delete}}
  ) {
    returning {
      id
    }
  }
}
    `;
export type IUpdateWorkoutAltimetryMutationFn = Apollo.MutationFunction<IUpdateWorkoutAltimetryMutation, IUpdateWorkoutAltimetryMutationVariables>;
export function useUpdateWorkoutAltimetryMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateWorkoutAltimetryMutation, IUpdateWorkoutAltimetryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateWorkoutAltimetryMutation, IUpdateWorkoutAltimetryMutationVariables>(UpdateWorkoutAltimetryDocument, options);
      }
export type UpdateWorkoutAltimetryMutationHookResult = ReturnType<typeof useUpdateWorkoutAltimetryMutation>;
export type UpdateWorkoutAltimetryMutationResult = Apollo.MutationResult<IUpdateWorkoutAltimetryMutation>;
export type UpdateWorkoutAltimetryMutationOptions = Apollo.BaseMutationOptions<IUpdateWorkoutAltimetryMutation, IUpdateWorkoutAltimetryMutationVariables>;
export const UpdateWorkoutDurationDocument = /*#__PURE__*/ gql`
    mutation UpdateWorkoutDuration($coefficient: numeric, $duration: numeric, $id: Int!) {
  update_workout_duration_by_pk(
    pk_columns: {id: $id}
    _set: {coefficient: $coefficient, duration: $duration}
  ) {
    id
  }
}
    `;
export type IUpdateWorkoutDurationMutationFn = Apollo.MutationFunction<IUpdateWorkoutDurationMutation, IUpdateWorkoutDurationMutationVariables>;
export function useUpdateWorkoutDurationMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateWorkoutDurationMutation, IUpdateWorkoutDurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateWorkoutDurationMutation, IUpdateWorkoutDurationMutationVariables>(UpdateWorkoutDurationDocument, options);
      }
export type UpdateWorkoutDurationMutationHookResult = ReturnType<typeof useUpdateWorkoutDurationMutation>;
export type UpdateWorkoutDurationMutationResult = Apollo.MutationResult<IUpdateWorkoutDurationMutation>;
export type UpdateWorkoutDurationMutationOptions = Apollo.BaseMutationOptions<IUpdateWorkoutDurationMutation, IUpdateWorkoutDurationMutationVariables>;
export const UpdateWorkoutTemplateDocument = /*#__PURE__*/ gql`
    mutation UpdateWorkoutTemplate($workout_template_data: workout_template_set_input!, $id: Int!, $workout_sections_data: [workout_section_template_insert_input!]!, $workout_section_ids_to_delete: [Int!]!) {
  update_workout_template_by_pk(
    pk_columns: {id: $id}
    _set: $workout_template_data
  ) {
    id
  }
  insert_workout_section_template(
    objects: $workout_sections_data
    on_conflict: {constraint: workout_section_template_pkey, update_columns: [average_heart_rate, max_heart_rate, duration, type, workout_zone_id, order, speed]}
  ) {
    affected_rows
  }
  delete_workout_section_template(
    where: {id: {_in: $workout_section_ids_to_delete}}
  ) {
    affected_rows
  }
}
    `;
export type IUpdateWorkoutTemplateMutationFn = Apollo.MutationFunction<IUpdateWorkoutTemplateMutation, IUpdateWorkoutTemplateMutationVariables>;
export function useUpdateWorkoutTemplateMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateWorkoutTemplateMutation, IUpdateWorkoutTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateWorkoutTemplateMutation, IUpdateWorkoutTemplateMutationVariables>(UpdateWorkoutTemplateDocument, options);
      }
export type UpdateWorkoutTemplateMutationHookResult = ReturnType<typeof useUpdateWorkoutTemplateMutation>;
export type UpdateWorkoutTemplateMutationResult = Apollo.MutationResult<IUpdateWorkoutTemplateMutation>;
export type UpdateWorkoutTemplateMutationOptions = Apollo.BaseMutationOptions<IUpdateWorkoutTemplateMutation, IUpdateWorkoutTemplateMutationVariables>;
export const UpdateWorkoutTerrainDocument = /*#__PURE__*/ gql`
    mutation UpdateWorkoutTerrain($coefficient: numeric, $id: Int!, $_set1: [workout_terrain_translation_insert_input!]!, $_set2: [workout_terrain_translation_updates!]!) {
  update_workout_terrain_by_pk(
    pk_columns: {id: $id}
    _set: {coefficient: $coefficient}
  ) {
    id
  }
  insert_workout_terrain_translation(objects: $_set1) {
    affected_rows
  }
  update_workout_terrain_translation_many(updates: $_set2) {
    affected_rows
  }
}
    `;
export type IUpdateWorkoutTerrainMutationFn = Apollo.MutationFunction<IUpdateWorkoutTerrainMutation, IUpdateWorkoutTerrainMutationVariables>;
export function useUpdateWorkoutTerrainMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateWorkoutTerrainMutation, IUpdateWorkoutTerrainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateWorkoutTerrainMutation, IUpdateWorkoutTerrainMutationVariables>(UpdateWorkoutTerrainDocument, options);
      }
export type UpdateWorkoutTerrainMutationHookResult = ReturnType<typeof useUpdateWorkoutTerrainMutation>;
export type UpdateWorkoutTerrainMutationResult = Apollo.MutationResult<IUpdateWorkoutTerrainMutation>;
export type UpdateWorkoutTerrainMutationOptions = Apollo.BaseMutationOptions<IUpdateWorkoutTerrainMutation, IUpdateWorkoutTerrainMutationVariables>;
export const UpdateWorkoutZoneDocument = /*#__PURE__*/ gql`
    mutation UpdateWorkoutZone($interval_start: numeric, $interval_end: numeric, $name: String, $id: Int!) {
  update_workout_zone_by_pk(
    pk_columns: {id: $id}
    _set: {interval_start: $interval_start, interval_end: $interval_end, name: $name}
  ) {
    id
  }
}
    `;
export type IUpdateWorkoutZoneMutationFn = Apollo.MutationFunction<IUpdateWorkoutZoneMutation, IUpdateWorkoutZoneMutationVariables>;
export function useUpdateWorkoutZoneMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateWorkoutZoneMutation, IUpdateWorkoutZoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateWorkoutZoneMutation, IUpdateWorkoutZoneMutationVariables>(UpdateWorkoutZoneDocument, options);
      }
export type UpdateWorkoutZoneMutationHookResult = ReturnType<typeof useUpdateWorkoutZoneMutation>;
export type UpdateWorkoutZoneMutationResult = Apollo.MutationResult<IUpdateWorkoutZoneMutation>;
export type UpdateWorkoutZoneMutationOptions = Apollo.BaseMutationOptions<IUpdateWorkoutZoneMutation, IUpdateWorkoutZoneMutationVariables>;
export const UpsertCircuitExercisesDocument = /*#__PURE__*/ gql`
    mutation UpsertCircuitExercises($objects: [circuit_exercise_insert_input!]!, $circuit_exercise_ids_to_delete: [Int!]!) {
  insert_circuit_exercise(
    objects: $objects
    on_conflict: {constraint: circuit_exercise_pkey, update_columns: [duration, exercise_id, no_of_series, order, repetitions]}
  ) {
    returning {
      id
    }
  }
  delete_circuit_exercise(where: {id: {_in: $circuit_exercise_ids_to_delete}}) {
    returning {
      id
    }
  }
}
    `;
export type IUpsertCircuitExercisesMutationFn = Apollo.MutationFunction<IUpsertCircuitExercisesMutation, IUpsertCircuitExercisesMutationVariables>;
export function useUpsertCircuitExercisesMutation(baseOptions?: Apollo.MutationHookOptions<IUpsertCircuitExercisesMutation, IUpsertCircuitExercisesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpsertCircuitExercisesMutation, IUpsertCircuitExercisesMutationVariables>(UpsertCircuitExercisesDocument, options);
      }
export type UpsertCircuitExercisesMutationHookResult = ReturnType<typeof useUpsertCircuitExercisesMutation>;
export type UpsertCircuitExercisesMutationResult = Apollo.MutationResult<IUpsertCircuitExercisesMutation>;
export type UpsertCircuitExercisesMutationOptions = Apollo.BaseMutationOptions<IUpsertCircuitExercisesMutation, IUpsertCircuitExercisesMutationVariables>;
export const ValidateCoachDocument = /*#__PURE__*/ gql`
    mutation ValidateCoach($id: Int!, $user_id: Int!, $is_verified: Boolean!, $message: String!, $mail: String!) {
  validate_coach(
    inputs: {id: $id, user_id: $user_id, is_verified: $is_verified, message: $message, mail: $mail}
  ) {
    id
  }
}
    `;
export type IValidateCoachMutationFn = Apollo.MutationFunction<IValidateCoachMutation, IValidateCoachMutationVariables>;
export function useValidateCoachMutation(baseOptions?: Apollo.MutationHookOptions<IValidateCoachMutation, IValidateCoachMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IValidateCoachMutation, IValidateCoachMutationVariables>(ValidateCoachDocument, options);
      }
export type ValidateCoachMutationHookResult = ReturnType<typeof useValidateCoachMutation>;
export type ValidateCoachMutationResult = Apollo.MutationResult<IValidateCoachMutation>;
export type ValidateCoachMutationOptions = Apollo.BaseMutationOptions<IValidateCoachMutation, IValidateCoachMutationVariables>;
export const ValidateSubscriptionPlanDocument = /*#__PURE__*/ gql`
    mutation ValidateSubscriptionPlan($id: Int!, $is_verified: Boolean!) {
  update_subscription_plan_by_pk(
    pk_columns: {id: $id}
    _set: {is_verified: $is_verified}
  ) {
    id
  }
}
    `;
export type IValidateSubscriptionPlanMutationFn = Apollo.MutationFunction<IValidateSubscriptionPlanMutation, IValidateSubscriptionPlanMutationVariables>;
export function useValidateSubscriptionPlanMutation(baseOptions?: Apollo.MutationHookOptions<IValidateSubscriptionPlanMutation, IValidateSubscriptionPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IValidateSubscriptionPlanMutation, IValidateSubscriptionPlanMutationVariables>(ValidateSubscriptionPlanDocument, options);
      }
export type ValidateSubscriptionPlanMutationHookResult = ReturnType<typeof useValidateSubscriptionPlanMutation>;
export type ValidateSubscriptionPlanMutationResult = Apollo.MutationResult<IValidateSubscriptionPlanMutation>;
export type ValidateSubscriptionPlanMutationOptions = Apollo.BaseMutationOptions<IValidateSubscriptionPlanMutation, IValidateSubscriptionPlanMutationVariables>;
export const AthleteBiometricDataDocument = /*#__PURE__*/ gql`
    query AthleteBiometricData($id: Int!) {
  athlete_by_pk(id: $id) {
    id
    athlete_biometric_data(order_by: {created_at: desc}) {
      ...athlete_details_biometric_param
    }
  }
}
    ${Athlete_Details_Biometric_ParamFragmentDoc}`;
export function useAthleteBiometricDataQuery(baseOptions: Apollo.QueryHookOptions<IAthleteBiometricDataQuery, IAthleteBiometricDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IAthleteBiometricDataQuery, IAthleteBiometricDataQueryVariables>(AthleteBiometricDataDocument, options);
      }
export function useAthleteBiometricDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IAthleteBiometricDataQuery, IAthleteBiometricDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IAthleteBiometricDataQuery, IAthleteBiometricDataQueryVariables>(AthleteBiometricDataDocument, options);
        }
export type AthleteBiometricDataQueryHookResult = ReturnType<typeof useAthleteBiometricDataQuery>;
export type AthleteBiometricDataLazyQueryHookResult = ReturnType<typeof useAthleteBiometricDataLazyQuery>;
export type AthleteBiometricDataQueryResult = Apollo.QueryResult<IAthleteBiometricDataQuery, IAthleteBiometricDataQueryVariables>;
export const AthleteBirthdayDocument = /*#__PURE__*/ gql`
    query AthleteBirthday($_month_day_gte: Int, $_month_day_lte: Int) {
  athletes: athlete(
    order_by: {birthday_month_day: asc}
    where: {status: {_eq: "active"}, birthday_month_day: {_gte: $_month_day_gte, _lte: $_month_day_lte}}
  ) {
    user {
      email
    }
    birthday
    avatar
    name
    id
  }
}
    `;
export function useAthleteBirthdayQuery(baseOptions?: Apollo.QueryHookOptions<IAthleteBirthdayQuery, IAthleteBirthdayQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IAthleteBirthdayQuery, IAthleteBirthdayQueryVariables>(AthleteBirthdayDocument, options);
      }
export function useAthleteBirthdayLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IAthleteBirthdayQuery, IAthleteBirthdayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IAthleteBirthdayQuery, IAthleteBirthdayQueryVariables>(AthleteBirthdayDocument, options);
        }
export type AthleteBirthdayQueryHookResult = ReturnType<typeof useAthleteBirthdayQuery>;
export type AthleteBirthdayLazyQueryHookResult = ReturnType<typeof useAthleteBirthdayLazyQuery>;
export type AthleteBirthdayQueryResult = Apollo.QueryResult<IAthleteBirthdayQuery, IAthleteBirthdayQueryVariables>;
export const AthleteBirthdayCrossYearDocument = /*#__PURE__*/ gql`
    query AthleteBirthdayCrossYear($_month_day_gte: Int, $_month_day_lte: Int) {
  athletes: athlete(
    order_by: {birthday_month_day: asc}
    where: {status: {_eq: "active"}, _or: [{birthday_month_day: {_gte: $_month_day_gte}}, {birthday_month_day: {_lte: $_month_day_lte}}]}
  ) {
    user {
      email
    }
    birthday
    avatar
    name
    id
  }
}
    `;
export function useAthleteBirthdayCrossYearQuery(baseOptions?: Apollo.QueryHookOptions<IAthleteBirthdayCrossYearQuery, IAthleteBirthdayCrossYearQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IAthleteBirthdayCrossYearQuery, IAthleteBirthdayCrossYearQueryVariables>(AthleteBirthdayCrossYearDocument, options);
      }
export function useAthleteBirthdayCrossYearLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IAthleteBirthdayCrossYearQuery, IAthleteBirthdayCrossYearQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IAthleteBirthdayCrossYearQuery, IAthleteBirthdayCrossYearQueryVariables>(AthleteBirthdayCrossYearDocument, options);
        }
export type AthleteBirthdayCrossYearQueryHookResult = ReturnType<typeof useAthleteBirthdayCrossYearQuery>;
export type AthleteBirthdayCrossYearLazyQueryHookResult = ReturnType<typeof useAthleteBirthdayCrossYearLazyQuery>;
export type AthleteBirthdayCrossYearQueryResult = Apollo.QueryResult<IAthleteBirthdayCrossYearQuery, IAthleteBirthdayCrossYearQueryVariables>;
export const AthleteBlocksDocument = /*#__PURE__*/ gql`
    query AthleteBlocks($id: Int!) {
  athlete_by_pk(id: $id) {
    id
    athlete_profile_id
    coach_id
    sport_id
    athlete_challenges(order_by: {created_at: desc}) {
      ...athlete_challenge
    }
    athlete_profile {
      id
      param_effort
      param_motivation
      param_distance_variation
      param_calories
      param_ziut
      athlete_profile_altimetry_adjustments {
        workout_altimetry_id
        value
      }
    }
    athlete_biometric_data(order_by: {created_at: desc}) {
      ...athlete_details_biometric_param
    }
    athlete_speeds(order_by: {created_at: desc, workout_type_id: asc}) {
      id
      value
      workout_type_id
    }
    athlete_blocks(order_by: {start_date: desc}) {
      ...athlete_block_summary
      athlete_weeks(order_by: {start_date: asc}) {
        id
        name
        order
        start_date
        end_date
        athlete_block_id
        athlete_block {
          athlete_id
          id
        }
      }
    }
  }
}
    ${Athlete_ChallengeFragmentDoc}
${Athlete_Details_Biometric_ParamFragmentDoc}
${Athlete_Block_SummaryFragmentDoc}`;
export function useAthleteBlocksQuery(baseOptions: Apollo.QueryHookOptions<IAthleteBlocksQuery, IAthleteBlocksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IAthleteBlocksQuery, IAthleteBlocksQueryVariables>(AthleteBlocksDocument, options);
      }
export function useAthleteBlocksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IAthleteBlocksQuery, IAthleteBlocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IAthleteBlocksQuery, IAthleteBlocksQueryVariables>(AthleteBlocksDocument, options);
        }
export type AthleteBlocksQueryHookResult = ReturnType<typeof useAthleteBlocksQuery>;
export type AthleteBlocksLazyQueryHookResult = ReturnType<typeof useAthleteBlocksLazyQuery>;
export type AthleteBlocksQueryResult = Apollo.QueryResult<IAthleteBlocksQuery, IAthleteBlocksQueryVariables>;
export const AthleteDetailsDocument = /*#__PURE__*/ gql`
    query AthleteDetails($id: Int!) {
  athlete_by_pk(id: $id) {
    ...athlete_details
  }
  athlete_profile(order_by: {order: asc}) {
    ...athlete_profileFragment
  }
}
    ${Athlete_DetailsFragmentDoc}
${Athlete_ProfileFragmentFragmentDoc}`;
export function useAthleteDetailsQuery(baseOptions: Apollo.QueryHookOptions<IAthleteDetailsQuery, IAthleteDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IAthleteDetailsQuery, IAthleteDetailsQueryVariables>(AthleteDetailsDocument, options);
      }
export function useAthleteDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IAthleteDetailsQuery, IAthleteDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IAthleteDetailsQuery, IAthleteDetailsQueryVariables>(AthleteDetailsDocument, options);
        }
export type AthleteDetailsQueryHookResult = ReturnType<typeof useAthleteDetailsQuery>;
export type AthleteDetailsLazyQueryHookResult = ReturnType<typeof useAthleteDetailsLazyQuery>;
export type AthleteDetailsQueryResult = Apollo.QueryResult<IAthleteDetailsQuery, IAthleteDetailsQueryVariables>;
export const AthleteInfoDocument = /*#__PURE__*/ gql`
    query AthleteInfo($id: Int!) {
  athlete_by_pk(id: $id) {
    id
    name
    birthday
    avatar
    gender
    athlete_profile_id
    coach_id
    address_city
    address_postal_code
    address_street
    address_country
    phone
    status
    fiscal_id_number
    goal
    stripe_customer_id
    sport_id
    user {
      email
    }
    user_id
  }
  athlete_profile(order_by: {order: asc}) {
    ...athlete_profileFragment
  }
}
    ${Athlete_ProfileFragmentFragmentDoc}`;
export function useAthleteInfoQuery(baseOptions: Apollo.QueryHookOptions<IAthleteInfoQuery, IAthleteInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IAthleteInfoQuery, IAthleteInfoQueryVariables>(AthleteInfoDocument, options);
      }
export function useAthleteInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IAthleteInfoQuery, IAthleteInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IAthleteInfoQuery, IAthleteInfoQueryVariables>(AthleteInfoDocument, options);
        }
export type AthleteInfoQueryHookResult = ReturnType<typeof useAthleteInfoQuery>;
export type AthleteInfoLazyQueryHookResult = ReturnType<typeof useAthleteInfoLazyQuery>;
export type AthleteInfoQueryResult = Apollo.QueryResult<IAthleteInfoQuery, IAthleteInfoQueryVariables>;
export const AthleteProfileDetailsDocument = /*#__PURE__*/ gql`
    query AthleteProfileDetails($id: Int!) {
  athlete_profile_by_pk(id: $id) {
    ...athlete_profile
  }
  workout_altimetry(order_by: {coefficient: asc}) {
    name
    id
  }
}
    ${Athlete_ProfileFragmentDoc}`;
export function useAthleteProfileDetailsQuery(baseOptions: Apollo.QueryHookOptions<IAthleteProfileDetailsQuery, IAthleteProfileDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IAthleteProfileDetailsQuery, IAthleteProfileDetailsQueryVariables>(AthleteProfileDetailsDocument, options);
      }
export function useAthleteProfileDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IAthleteProfileDetailsQuery, IAthleteProfileDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IAthleteProfileDetailsQuery, IAthleteProfileDetailsQueryVariables>(AthleteProfileDetailsDocument, options);
        }
export type AthleteProfileDetailsQueryHookResult = ReturnType<typeof useAthleteProfileDetailsQuery>;
export type AthleteProfileDetailsLazyQueryHookResult = ReturnType<typeof useAthleteProfileDetailsLazyQuery>;
export type AthleteProfileDetailsQueryResult = Apollo.QueryResult<IAthleteProfileDetailsQuery, IAthleteProfileDetailsQueryVariables>;
export const AthleteProfilesListDocument = /*#__PURE__*/ gql`
    query AthleteProfilesList($where: athlete_profile_bool_exp, $offset: Int, $limit: Int, $order_by: [athlete_profile_order_by!] = {order: asc}) {
  athlete_profile(where: $where, order_by: $order_by) {
    ...athlete_profileFragment
  }
}
    ${Athlete_ProfileFragmentFragmentDoc}`;
export function useAthleteProfilesListQuery(baseOptions?: Apollo.QueryHookOptions<IAthleteProfilesListQuery, IAthleteProfilesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IAthleteProfilesListQuery, IAthleteProfilesListQueryVariables>(AthleteProfilesListDocument, options);
      }
export function useAthleteProfilesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IAthleteProfilesListQuery, IAthleteProfilesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IAthleteProfilesListQuery, IAthleteProfilesListQueryVariables>(AthleteProfilesListDocument, options);
        }
export type AthleteProfilesListQueryHookResult = ReturnType<typeof useAthleteProfilesListQuery>;
export type AthleteProfilesListLazyQueryHookResult = ReturnType<typeof useAthleteProfilesListLazyQuery>;
export type AthleteProfilesListQueryResult = Apollo.QueryResult<IAthleteProfilesListQuery, IAthleteProfilesListQueryVariables>;
export const AthleteSpeedsDocument = /*#__PURE__*/ gql`
    query AthleteSpeeds($id: Int!) {
  athlete_by_pk(id: $id) {
    id
    athlete_speeds(order_by: {created_at: desc, workout_type_id: asc}) {
      id
      value
      workout_type_id
      workout_type {
        id
        avatar
        workout_type_translations {
          name
          locale {
            code
          }
        }
      }
    }
    athlete_profile {
      athlete_profile_altimetry_adjustments {
        workout_altimetry_id
        value
        workout_altimetry {
          id
          name
          workout_altimetry_translations {
            id
            description
            locale {
              id
              code
              language
            }
          }
          workout_altimetry_workout_types {
            workout_type {
              id
            }
          }
        }
      }
    }
  }
}
    `;
export function useAthleteSpeedsQuery(baseOptions: Apollo.QueryHookOptions<IAthleteSpeedsQuery, IAthleteSpeedsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IAthleteSpeedsQuery, IAthleteSpeedsQueryVariables>(AthleteSpeedsDocument, options);
      }
export function useAthleteSpeedsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IAthleteSpeedsQuery, IAthleteSpeedsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IAthleteSpeedsQuery, IAthleteSpeedsQueryVariables>(AthleteSpeedsDocument, options);
        }
export type AthleteSpeedsQueryHookResult = ReturnType<typeof useAthleteSpeedsQuery>;
export type AthleteSpeedsLazyQueryHookResult = ReturnType<typeof useAthleteSpeedsLazyQuery>;
export type AthleteSpeedsQueryResult = Apollo.QueryResult<IAthleteSpeedsQuery, IAthleteSpeedsQueryVariables>;
export const AthleteWeekDocument = /*#__PURE__*/ gql`
    query AthleteWeek($id: Int!) {
  athlete_week_by_pk(id: $id) {
    ...athlete_week
  }
}
    ${Athlete_WeekFragmentDoc}`;
export function useAthleteWeekQuery(baseOptions: Apollo.QueryHookOptions<IAthleteWeekQuery, IAthleteWeekQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IAthleteWeekQuery, IAthleteWeekQueryVariables>(AthleteWeekDocument, options);
      }
export function useAthleteWeekLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IAthleteWeekQuery, IAthleteWeekQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IAthleteWeekQuery, IAthleteWeekQueryVariables>(AthleteWeekDocument, options);
        }
export type AthleteWeekQueryHookResult = ReturnType<typeof useAthleteWeekQuery>;
export type AthleteWeekLazyQueryHookResult = ReturnType<typeof useAthleteWeekLazyQuery>;
export type AthleteWeekQueryResult = Apollo.QueryResult<IAthleteWeekQuery, IAthleteWeekQueryVariables>;
export const AthleteWeeksByBlockDocument = /*#__PURE__*/ gql`
    query AthleteWeeksByBlock($blockId: Int!) {
  athlete_week(
    order_by: {start_date: asc}
    where: {athlete_block_id: {_eq: $blockId}}
  ) {
    id
    name
    order
    start_date
    end_date
    athlete_block_id
    athlete_workouts(order_by: {day: asc}) {
      ...athlete_workout
    }
  }
}
    ${Athlete_WorkoutFragmentDoc}`;
export function useAthleteWeeksByBlockQuery(baseOptions: Apollo.QueryHookOptions<IAthleteWeeksByBlockQuery, IAthleteWeeksByBlockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IAthleteWeeksByBlockQuery, IAthleteWeeksByBlockQueryVariables>(AthleteWeeksByBlockDocument, options);
      }
export function useAthleteWeeksByBlockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IAthleteWeeksByBlockQuery, IAthleteWeeksByBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IAthleteWeeksByBlockQuery, IAthleteWeeksByBlockQueryVariables>(AthleteWeeksByBlockDocument, options);
        }
export type AthleteWeeksByBlockQueryHookResult = ReturnType<typeof useAthleteWeeksByBlockQuery>;
export type AthleteWeeksByBlockLazyQueryHookResult = ReturnType<typeof useAthleteWeeksByBlockLazyQuery>;
export type AthleteWeeksByBlockQueryResult = Apollo.QueryResult<IAthleteWeeksByBlockQuery, IAthleteWeeksByBlockQueryVariables>;
export const AthleteWithoutWorkoutsDocument = /*#__PURE__*/ gql`
    query AthleteWithoutWorkouts($_gte_date: date!, $_lte_date: date!) {
  athletes: athlete(
    where: {status: {_eq: "active"}, _not: {athlete_blocks: {athlete_weeks: {athlete_workouts: {date: {_gte: $_gte_date, _lte: $_lte_date}}}}}}
  ) {
    id
    name
    avatar
    athlete_blocks(order_by: [{start_date: desc}], limit: 1) {
      athlete_weeks(order_by: [{start_date: desc}], limit: 1) {
        athlete_workouts(order_by: [{date: desc}], limit: 1) {
          id
          date
        }
      }
    }
  }
}
    `;
export function useAthleteWithoutWorkoutsQuery(baseOptions: Apollo.QueryHookOptions<IAthleteWithoutWorkoutsQuery, IAthleteWithoutWorkoutsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IAthleteWithoutWorkoutsQuery, IAthleteWithoutWorkoutsQueryVariables>(AthleteWithoutWorkoutsDocument, options);
      }
export function useAthleteWithoutWorkoutsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IAthleteWithoutWorkoutsQuery, IAthleteWithoutWorkoutsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IAthleteWithoutWorkoutsQuery, IAthleteWithoutWorkoutsQueryVariables>(AthleteWithoutWorkoutsDocument, options);
        }
export type AthleteWithoutWorkoutsQueryHookResult = ReturnType<typeof useAthleteWithoutWorkoutsQuery>;
export type AthleteWithoutWorkoutsLazyQueryHookResult = ReturnType<typeof useAthleteWithoutWorkoutsLazyQuery>;
export type AthleteWithoutWorkoutsQueryResult = Apollo.QueryResult<IAthleteWithoutWorkoutsQuery, IAthleteWithoutWorkoutsQueryVariables>;
export const AthletesListDocument = /*#__PURE__*/ gql`
    query AthletesList($limit: Int, $offset: Int, $where: athlete_bool_exp, $order_by: [athlete_order_by!] = {created_at: desc}) {
  athlete(limit: $limit, offset: $offset, order_by: $order_by, where: $where) {
    ...athlete
  }
  sport {
    ...sport
  }
  total: athlete_aggregate(where: $where) {
    aggregate {
      count(columns: id)
    }
  }
}
    ${AthleteFragmentDoc}
${SportFragmentDoc}`;
export function useAthletesListQuery(baseOptions?: Apollo.QueryHookOptions<IAthletesListQuery, IAthletesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IAthletesListQuery, IAthletesListQueryVariables>(AthletesListDocument, options);
      }
export function useAthletesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IAthletesListQuery, IAthletesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IAthletesListQuery, IAthletesListQueryVariables>(AthletesListDocument, options);
        }
export type AthletesListQueryHookResult = ReturnType<typeof useAthletesListQuery>;
export type AthletesListLazyQueryHookResult = ReturnType<typeof useAthletesListLazyQuery>;
export type AthletesListQueryResult = Apollo.QueryResult<IAthletesListQuery, IAthletesListQueryVariables>;
export const AthletesUploadsDocument = /*#__PURE__*/ gql`
    query AthletesUploads($_gte_date: date!, $_lte_date: date!) {
  athletes: athlete(
    where: {status: {_eq: "active"}, athlete_blocks: {start_date: {_lte: $_lte_date}, end_date: {_gte: $_gte_date}, athlete_weeks: {start_date: {_lte: $_lte_date}, end_date: {_gte: $_gte_date}, athlete_workouts: {date: {_gte: $_gte_date, _lte: $_lte_date}, _or: [{comments: {_is_null: false}}, {motivation: {_is_null: false}}, {effort: {_is_null: false}}, {athlete_workout_sections: {_or: [{measured_average_heart_rate: {_is_null: false}}, {measured_duration: {_is_null: false}}, {measured_max_heart_rate: {_is_null: false}}, {measured_speed: {_is_null: false}}]}}]}}}}
  ) {
    id
    name
    avatar
    athlete_blocks(
      where: {start_date: {_lte: $_lte_date}, end_date: {_gte: $_gte_date}}
      order_by: [{start_date: desc}]
    ) {
      athlete_weeks(
        where: {start_date: {_lte: $_lte_date}, end_date: {_gte: $_gte_date}}
        order_by: [{start_date: desc}]
      ) {
        athlete_workouts(
          where: {date: {_gte: $_gte_date, _lte: $_lte_date}, _or: [{comments: {_is_null: false}}, {motivation: {_is_null: false}}, {effort: {_is_null: false}}, {athlete_workout_sections: {_or: [{measured_average_heart_rate: {_is_null: false}}, {measured_duration: {_is_null: false}}, {measured_max_heart_rate: {_is_null: false}}, {measured_speed: {_is_null: false}}]}}]}
          order_by: [{date: desc}]
        ) {
          id
          date
          comments
          workout_type {
            avatar
          }
          athlete_workout_sections {
            type
            workout_zone {
              name
            }
          }
        }
      }
    }
  }
}
    `;
export function useAthletesUploadsQuery(baseOptions: Apollo.QueryHookOptions<IAthletesUploadsQuery, IAthletesUploadsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IAthletesUploadsQuery, IAthletesUploadsQueryVariables>(AthletesUploadsDocument, options);
      }
export function useAthletesUploadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IAthletesUploadsQuery, IAthletesUploadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IAthletesUploadsQuery, IAthletesUploadsQueryVariables>(AthletesUploadsDocument, options);
        }
export type AthletesUploadsQueryHookResult = ReturnType<typeof useAthletesUploadsQuery>;
export type AthletesUploadsLazyQueryHookResult = ReturnType<typeof useAthletesUploadsLazyQuery>;
export type AthletesUploadsQueryResult = Apollo.QueryResult<IAthletesUploadsQuery, IAthletesUploadsQueryVariables>;
export const BlockDetailsDocument = /*#__PURE__*/ gql`
    query BlockDetails($id: Int!) {
  block_template_by_pk(id: $id) {
    ...block_details_block_template
  }
}
    ${Block_Details_Block_TemplateFragmentDoc}`;
export function useBlockDetailsQuery(baseOptions: Apollo.QueryHookOptions<IBlockDetailsQuery, IBlockDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IBlockDetailsQuery, IBlockDetailsQueryVariables>(BlockDetailsDocument, options);
      }
export function useBlockDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IBlockDetailsQuery, IBlockDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IBlockDetailsQuery, IBlockDetailsQueryVariables>(BlockDetailsDocument, options);
        }
export type BlockDetailsQueryHookResult = ReturnType<typeof useBlockDetailsQuery>;
export type BlockDetailsLazyQueryHookResult = ReturnType<typeof useBlockDetailsLazyQuery>;
export type BlockDetailsQueryResult = Apollo.QueryResult<IBlockDetailsQuery, IBlockDetailsQueryVariables>;
export const BlockTemplatesListDocument = /*#__PURE__*/ gql`
    query BlockTemplatesList($limit: Int, $offset: Int, $order_by: [block_template_order_by!], $where: block_template_bool_exp) {
  block_template(
    limit: $limit
    offset: $offset
    order_by: $order_by
    where: $where
  ) {
    ...block_template
  }
  sport {
    ...sport
  }
  total: block_template_aggregate {
    aggregate {
      count(columns: id)
    }
  }
}
    ${Block_TemplateFragmentDoc}
${SportFragmentDoc}`;
export function useBlockTemplatesListQuery(baseOptions?: Apollo.QueryHookOptions<IBlockTemplatesListQuery, IBlockTemplatesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IBlockTemplatesListQuery, IBlockTemplatesListQueryVariables>(BlockTemplatesListDocument, options);
      }
export function useBlockTemplatesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IBlockTemplatesListQuery, IBlockTemplatesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IBlockTemplatesListQuery, IBlockTemplatesListQueryVariables>(BlockTemplatesListDocument, options);
        }
export type BlockTemplatesListQueryHookResult = ReturnType<typeof useBlockTemplatesListQuery>;
export type BlockTemplatesListLazyQueryHookResult = ReturnType<typeof useBlockTemplatesListLazyQuery>;
export type BlockTemplatesListQueryResult = Apollo.QueryResult<IBlockTemplatesListQuery, IBlockTemplatesListQueryVariables>;
export const BlocksWithWeeksListDocument = /*#__PURE__*/ gql`
    query BlocksWithWeeksList($where_week: week_template_bool_exp, $where_block: block_template_bool_exp) {
  block_template(where: $where_block) {
    ...block_template_basic_info
  }
}
    ${Block_Template_Basic_InfoFragmentDoc}`;
export function useBlocksWithWeeksListQuery(baseOptions?: Apollo.QueryHookOptions<IBlocksWithWeeksListQuery, IBlocksWithWeeksListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IBlocksWithWeeksListQuery, IBlocksWithWeeksListQueryVariables>(BlocksWithWeeksListDocument, options);
      }
export function useBlocksWithWeeksListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IBlocksWithWeeksListQuery, IBlocksWithWeeksListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IBlocksWithWeeksListQuery, IBlocksWithWeeksListQueryVariables>(BlocksWithWeeksListDocument, options);
        }
export type BlocksWithWeeksListQueryHookResult = ReturnType<typeof useBlocksWithWeeksListQuery>;
export type BlocksWithWeeksListLazyQueryHookResult = ReturnType<typeof useBlocksWithWeeksListLazyQuery>;
export type BlocksWithWeeksListQueryResult = Apollo.QueryResult<IBlocksWithWeeksListQuery, IBlocksWithWeeksListQueryVariables>;
export const CircuitAndExercicesListDocument = /*#__PURE__*/ gql`
    query CircuitAndExercicesList($where_circuit: circuit_bool_exp, $where_exercise: exercise_bool_exp) {
  circuit(where: $where_circuit) {
    ...circuit
    coach_id
    sports {
      id
      sport {
        ...sport
      }
    }
  }
  exercise(where: $where_exercise, order_by: {id: desc}) {
    ...exercise
    coach_id
  }
}
    ${CircuitFragmentDoc}
${SportFragmentDoc}
${ExerciseFragmentDoc}`;
export function useCircuitAndExercicesListQuery(baseOptions?: Apollo.QueryHookOptions<ICircuitAndExercicesListQuery, ICircuitAndExercicesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ICircuitAndExercicesListQuery, ICircuitAndExercicesListQueryVariables>(CircuitAndExercicesListDocument, options);
      }
export function useCircuitAndExercicesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ICircuitAndExercicesListQuery, ICircuitAndExercicesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ICircuitAndExercicesListQuery, ICircuitAndExercicesListQueryVariables>(CircuitAndExercicesListDocument, options);
        }
export type CircuitAndExercicesListQueryHookResult = ReturnType<typeof useCircuitAndExercicesListQuery>;
export type CircuitAndExercicesListLazyQueryHookResult = ReturnType<typeof useCircuitAndExercicesListLazyQuery>;
export type CircuitAndExercicesListQueryResult = Apollo.QueryResult<ICircuitAndExercicesListQuery, ICircuitAndExercicesListQueryVariables>;
export const CircuitDetailsDocument = /*#__PURE__*/ gql`
    query CircuitDetails($id: Int!) {
  circuit_by_pk(id: $id) {
    ...circuit
    recovery_interval
    coach_id
    sports {
      id
      sport {
        ...sport
      }
    }
  }
}
    ${CircuitFragmentDoc}
${SportFragmentDoc}`;
export function useCircuitDetailsQuery(baseOptions: Apollo.QueryHookOptions<ICircuitDetailsQuery, ICircuitDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ICircuitDetailsQuery, ICircuitDetailsQueryVariables>(CircuitDetailsDocument, options);
      }
export function useCircuitDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ICircuitDetailsQuery, ICircuitDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ICircuitDetailsQuery, ICircuitDetailsQueryVariables>(CircuitDetailsDocument, options);
        }
export type CircuitDetailsQueryHookResult = ReturnType<typeof useCircuitDetailsQuery>;
export type CircuitDetailsLazyQueryHookResult = ReturnType<typeof useCircuitDetailsLazyQuery>;
export type CircuitDetailsQueryResult = Apollo.QueryResult<ICircuitDetailsQuery, ICircuitDetailsQueryVariables>;
export const CoachBaseInfoDocument = /*#__PURE__*/ gql`
    query CoachBaseInfo($keycloak_id: uuid!) {
  user(where: {keycloak_id: {_eq: $keycloak_id}}) {
    ...coachBaseInfo
  }
}
    ${CoachBaseInfoFragmentDoc}`;
export function useCoachBaseInfoQuery(baseOptions: Apollo.QueryHookOptions<ICoachBaseInfoQuery, ICoachBaseInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ICoachBaseInfoQuery, ICoachBaseInfoQueryVariables>(CoachBaseInfoDocument, options);
      }
export function useCoachBaseInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ICoachBaseInfoQuery, ICoachBaseInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ICoachBaseInfoQuery, ICoachBaseInfoQueryVariables>(CoachBaseInfoDocument, options);
        }
export type CoachBaseInfoQueryHookResult = ReturnType<typeof useCoachBaseInfoQuery>;
export type CoachBaseInfoLazyQueryHookResult = ReturnType<typeof useCoachBaseInfoLazyQuery>;
export type CoachBaseInfoQueryResult = Apollo.QueryResult<ICoachBaseInfoQuery, ICoachBaseInfoQueryVariables>;
export const CoachDetailsDocument = /*#__PURE__*/ gql`
    query CoachDetails($id: Int!) {
  coach_by_pk(id: $id) {
    ...coachDetails
  }
  sport {
    ...sport
  }
}
    ${CoachDetailsFragmentDoc}
${SportFragmentDoc}`;
export function useCoachDetailsQuery(baseOptions: Apollo.QueryHookOptions<ICoachDetailsQuery, ICoachDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ICoachDetailsQuery, ICoachDetailsQueryVariables>(CoachDetailsDocument, options);
      }
export function useCoachDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ICoachDetailsQuery, ICoachDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ICoachDetailsQuery, ICoachDetailsQueryVariables>(CoachDetailsDocument, options);
        }
export type CoachDetailsQueryHookResult = ReturnType<typeof useCoachDetailsQuery>;
export type CoachDetailsLazyQueryHookResult = ReturnType<typeof useCoachDetailsLazyQuery>;
export type CoachDetailsQueryResult = Apollo.QueryResult<ICoachDetailsQuery, ICoachDetailsQueryVariables>;
export const CoachesListDocument = /*#__PURE__*/ gql`
    query CoachesList($limit: Int, $offset: Int, $where: coach_bool_exp = {}) {
  coach(limit: $limit, offset: $offset, where: $where) {
    ...coach
  }
  total: coach_aggregate {
    aggregate {
      count(columns: id)
    }
  }
}
    ${CoachFragmentDoc}`;
export function useCoachesListQuery(baseOptions?: Apollo.QueryHookOptions<ICoachesListQuery, ICoachesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ICoachesListQuery, ICoachesListQueryVariables>(CoachesListDocument, options);
      }
export function useCoachesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ICoachesListQuery, ICoachesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ICoachesListQuery, ICoachesListQueryVariables>(CoachesListDocument, options);
        }
export type CoachesListQueryHookResult = ReturnType<typeof useCoachesListQuery>;
export type CoachesListLazyQueryHookResult = ReturnType<typeof useCoachesListLazyQuery>;
export type CoachesListQueryResult = Apollo.QueryResult<ICoachesListQuery, ICoachesListQueryVariables>;
export const CouponsListDocument = /*#__PURE__*/ gql`
    query CouponsList($where: coupon_bool_exp, $order_by: [coupon_order_by!]) {
  coupon(where: $where, order_by: $order_by) {
    ...coupon
  }
}
    ${CouponFragmentDoc}`;
export function useCouponsListQuery(baseOptions?: Apollo.QueryHookOptions<ICouponsListQuery, ICouponsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ICouponsListQuery, ICouponsListQueryVariables>(CouponsListDocument, options);
      }
export function useCouponsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ICouponsListQuery, ICouponsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ICouponsListQuery, ICouponsListQueryVariables>(CouponsListDocument, options);
        }
export type CouponsListQueryHookResult = ReturnType<typeof useCouponsListQuery>;
export type CouponsListLazyQueryHookResult = ReturnType<typeof useCouponsListLazyQuery>;
export type CouponsListQueryResult = Apollo.QueryResult<ICouponsListQuery, ICouponsListQueryVariables>;
export const ExercisesListDocument = /*#__PURE__*/ gql`
    query ExercisesList($where: exercise_bool_exp) {
  exercise(where: $where, order_by: {id: desc}) {
    id
    media_url
    type
    target
    exercise_translations {
      id
      name
      description
      locale {
        id
        code
      }
    }
  }
}
    `;
export function useExercisesListQuery(baseOptions?: Apollo.QueryHookOptions<IExercisesListQuery, IExercisesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IExercisesListQuery, IExercisesListQueryVariables>(ExercisesListDocument, options);
      }
export function useExercisesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IExercisesListQuery, IExercisesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IExercisesListQuery, IExercisesListQueryVariables>(ExercisesListDocument, options);
        }
export type ExercisesListQueryHookResult = ReturnType<typeof useExercisesListQuery>;
export type ExercisesListLazyQueryHookResult = ReturnType<typeof useExercisesListLazyQuery>;
export type ExercisesListQueryResult = Apollo.QueryResult<IExercisesListQuery, IExercisesListQueryVariables>;
export const LocalesListDocument = /*#__PURE__*/ gql`
    query LocalesList {
  locale {
    id
    code
    language
  }
}
    `;
export function useLocalesListQuery(baseOptions?: Apollo.QueryHookOptions<ILocalesListQuery, ILocalesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ILocalesListQuery, ILocalesListQueryVariables>(LocalesListDocument, options);
      }
export function useLocalesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ILocalesListQuery, ILocalesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ILocalesListQuery, ILocalesListQueryVariables>(LocalesListDocument, options);
        }
export type LocalesListQueryHookResult = ReturnType<typeof useLocalesListQuery>;
export type LocalesListLazyQueryHookResult = ReturnType<typeof useLocalesListLazyQuery>;
export type LocalesListQueryResult = Apollo.QueryResult<ILocalesListQuery, ILocalesListQueryVariables>;
export const ReviewDetailsDocument = /*#__PURE__*/ gql`
    query ReviewDetails($id: Int!) {
  review_by_pk(id: $id) {
    review_translations {
      id
      text
      locale {
        id
        code
        language
      }
    }
    id
    image
    name
  }
}
    `;
export function useReviewDetailsQuery(baseOptions: Apollo.QueryHookOptions<IReviewDetailsQuery, IReviewDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IReviewDetailsQuery, IReviewDetailsQueryVariables>(ReviewDetailsDocument, options);
      }
export function useReviewDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IReviewDetailsQuery, IReviewDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IReviewDetailsQuery, IReviewDetailsQueryVariables>(ReviewDetailsDocument, options);
        }
export type ReviewDetailsQueryHookResult = ReturnType<typeof useReviewDetailsQuery>;
export type ReviewDetailsLazyQueryHookResult = ReturnType<typeof useReviewDetailsLazyQuery>;
export type ReviewDetailsQueryResult = Apollo.QueryResult<IReviewDetailsQuery, IReviewDetailsQueryVariables>;
export const ReviewsListDocument = /*#__PURE__*/ gql`
    query ReviewsList($limit: Int, $offset: Int, $where: review_bool_exp) {
  review(limit: $limit, offset: $offset, where: $where) {
    ...review
  }
}
    ${ReviewFragmentDoc}`;
export function useReviewsListQuery(baseOptions?: Apollo.QueryHookOptions<IReviewsListQuery, IReviewsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IReviewsListQuery, IReviewsListQueryVariables>(ReviewsListDocument, options);
      }
export function useReviewsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IReviewsListQuery, IReviewsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IReviewsListQuery, IReviewsListQueryVariables>(ReviewsListDocument, options);
        }
export type ReviewsListQueryHookResult = ReturnType<typeof useReviewsListQuery>;
export type ReviewsListLazyQueryHookResult = ReturnType<typeof useReviewsListLazyQuery>;
export type ReviewsListQueryResult = Apollo.QueryResult<IReviewsListQuery, IReviewsListQueryVariables>;
export const SportDetailsDocument = /*#__PURE__*/ gql`
    query SportDetails($id: name!) {
  sport_by_pk(id: $id) {
    ...sport
    coaches {
      id
      coach {
        id
        name
        profile_picture
      }
    }
    athletes {
      id
      name
      avatar
    }
    subscription_plan_templates {
      ...subscription_plan_template
    }
  }
}
    ${SportFragmentDoc}
${Subscription_Plan_TemplateFragmentDoc}`;
export function useSportDetailsQuery(baseOptions: Apollo.QueryHookOptions<ISportDetailsQuery, ISportDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ISportDetailsQuery, ISportDetailsQueryVariables>(SportDetailsDocument, options);
      }
export function useSportDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ISportDetailsQuery, ISportDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ISportDetailsQuery, ISportDetailsQueryVariables>(SportDetailsDocument, options);
        }
export type SportDetailsQueryHookResult = ReturnType<typeof useSportDetailsQuery>;
export type SportDetailsLazyQueryHookResult = ReturnType<typeof useSportDetailsLazyQuery>;
export type SportDetailsQueryResult = Apollo.QueryResult<ISportDetailsQuery, ISportDetailsQueryVariables>;
export const SportsListDocument = /*#__PURE__*/ gql`
    query SportsList($where: sport_bool_exp) {
  sport(where: $where, order_by: {name: asc}) {
    ...sport
  }
}
    ${SportFragmentDoc}`;
export function useSportsListQuery(baseOptions?: Apollo.QueryHookOptions<ISportsListQuery, ISportsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ISportsListQuery, ISportsListQueryVariables>(SportsListDocument, options);
      }
export function useSportsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ISportsListQuery, ISportsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ISportsListQuery, ISportsListQueryVariables>(SportsListDocument, options);
        }
export type SportsListQueryHookResult = ReturnType<typeof useSportsListQuery>;
export type SportsListLazyQueryHookResult = ReturnType<typeof useSportsListLazyQuery>;
export type SportsListQueryResult = Apollo.QueryResult<ISportsListQuery, ISportsListQueryVariables>;
export const SubscriptionPaymentsListDocument = /*#__PURE__*/ gql`
    query SubscriptionPaymentsList($coach_id: Int!, $where: subscription_payment_bool_exp!) {
  subscription_payment(
    where: {_and: [$where, {subscription: {subscription_plan: {coach_id: {_eq: $coach_id}}}}]}
    order_by: {created_at: desc}
  ) {
    id
    created_at
    updated_at
    discount_name
    discount_percentage
    amount
    platform_fee
    subscription {
      id
      athlete {
        id
        name
        fiscal_id_number
      }
      status
      price
      date_start
      date_end
      subscription_plan {
        id
        level
        sport {
          ...sport
        }
        subscription_plan_translations {
          id
          description
          created_at
          locale {
            id
            code
            language
          }
        }
      }
    }
  }
}
    ${SportFragmentDoc}`;
export function useSubscriptionPaymentsListQuery(baseOptions: Apollo.QueryHookOptions<ISubscriptionPaymentsListQuery, ISubscriptionPaymentsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ISubscriptionPaymentsListQuery, ISubscriptionPaymentsListQueryVariables>(SubscriptionPaymentsListDocument, options);
      }
export function useSubscriptionPaymentsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ISubscriptionPaymentsListQuery, ISubscriptionPaymentsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ISubscriptionPaymentsListQuery, ISubscriptionPaymentsListQueryVariables>(SubscriptionPaymentsListDocument, options);
        }
export type SubscriptionPaymentsListQueryHookResult = ReturnType<typeof useSubscriptionPaymentsListQuery>;
export type SubscriptionPaymentsListLazyQueryHookResult = ReturnType<typeof useSubscriptionPaymentsListLazyQuery>;
export type SubscriptionPaymentsListQueryResult = Apollo.QueryResult<ISubscriptionPaymentsListQuery, ISubscriptionPaymentsListQueryVariables>;
export const SubscriptionPlanDetailsDocument = /*#__PURE__*/ gql`
    query SubscriptionPlanDetails($id: Int!) {
  subscription_plan_by_pk(id: $id) {
    ...subscription_plan_details
  }
}
    ${Subscription_Plan_DetailsFragmentDoc}`;
export function useSubscriptionPlanDetailsQuery(baseOptions: Apollo.QueryHookOptions<ISubscriptionPlanDetailsQuery, ISubscriptionPlanDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ISubscriptionPlanDetailsQuery, ISubscriptionPlanDetailsQueryVariables>(SubscriptionPlanDetailsDocument, options);
      }
export function useSubscriptionPlanDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ISubscriptionPlanDetailsQuery, ISubscriptionPlanDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ISubscriptionPlanDetailsQuery, ISubscriptionPlanDetailsQueryVariables>(SubscriptionPlanDetailsDocument, options);
        }
export type SubscriptionPlanDetailsQueryHookResult = ReturnType<typeof useSubscriptionPlanDetailsQuery>;
export type SubscriptionPlanDetailsLazyQueryHookResult = ReturnType<typeof useSubscriptionPlanDetailsLazyQuery>;
export type SubscriptionPlanDetailsQueryResult = Apollo.QueryResult<ISubscriptionPlanDetailsQuery, ISubscriptionPlanDetailsQueryVariables>;
export const SubscriptionPlanTemplateListDocument = /*#__PURE__*/ gql`
    query SubscriptionPlanTemplateList($where: subscription_plan_template_bool_exp) {
  subscription_plan_template(where: $where) {
    ...subscription_plan_template
  }
}
    ${Subscription_Plan_TemplateFragmentDoc}`;
export function useSubscriptionPlanTemplateListQuery(baseOptions?: Apollo.QueryHookOptions<ISubscriptionPlanTemplateListQuery, ISubscriptionPlanTemplateListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ISubscriptionPlanTemplateListQuery, ISubscriptionPlanTemplateListQueryVariables>(SubscriptionPlanTemplateListDocument, options);
      }
export function useSubscriptionPlanTemplateListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ISubscriptionPlanTemplateListQuery, ISubscriptionPlanTemplateListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ISubscriptionPlanTemplateListQuery, ISubscriptionPlanTemplateListQueryVariables>(SubscriptionPlanTemplateListDocument, options);
        }
export type SubscriptionPlanTemplateListQueryHookResult = ReturnType<typeof useSubscriptionPlanTemplateListQuery>;
export type SubscriptionPlanTemplateListLazyQueryHookResult = ReturnType<typeof useSubscriptionPlanTemplateListLazyQuery>;
export type SubscriptionPlanTemplateListQueryResult = Apollo.QueryResult<ISubscriptionPlanTemplateListQuery, ISubscriptionPlanTemplateListQueryVariables>;
export const SubscriptionsListDocument = /*#__PURE__*/ gql`
    query SubscriptionsList($offset: Int, $limit: Int, $order_by: [subscription_order_by!], $where: subscription_bool_exp) {
  subscription(offset: $offset, limit: $limit, order_by: $order_by, where: $where) {
    ...subscription
  }
  total: subscription_aggregate {
    aggregate {
      count(columns: id)
    }
  }
}
    ${SubscriptionFragmentDoc}`;
export function useSubscriptionsListQuery(baseOptions?: Apollo.QueryHookOptions<ISubscriptionsListQuery, ISubscriptionsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ISubscriptionsListQuery, ISubscriptionsListQueryVariables>(SubscriptionsListDocument, options);
      }
export function useSubscriptionsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ISubscriptionsListQuery, ISubscriptionsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ISubscriptionsListQuery, ISubscriptionsListQueryVariables>(SubscriptionsListDocument, options);
        }
export type SubscriptionsListQueryHookResult = ReturnType<typeof useSubscriptionsListQuery>;
export type SubscriptionsListLazyQueryHookResult = ReturnType<typeof useSubscriptionsListLazyQuery>;
export type SubscriptionsListQueryResult = Apollo.QueryResult<ISubscriptionsListQuery, ISubscriptionsListQueryVariables>;
export const SubscriptionPlansListDocument = /*#__PURE__*/ gql`
    query SubscriptionPlansList($where: subscription_plan_bool_exp) {
  subscription_plan(where: $where) {
    ...subscription_plan
  }
}
    ${Subscription_PlanFragmentDoc}`;
export function useSubscriptionPlansListQuery(baseOptions?: Apollo.QueryHookOptions<ISubscriptionPlansListQuery, ISubscriptionPlansListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ISubscriptionPlansListQuery, ISubscriptionPlansListQueryVariables>(SubscriptionPlansListDocument, options);
      }
export function useSubscriptionPlansListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ISubscriptionPlansListQuery, ISubscriptionPlansListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ISubscriptionPlansListQuery, ISubscriptionPlansListQueryVariables>(SubscriptionPlansListDocument, options);
        }
export type SubscriptionPlansListQueryHookResult = ReturnType<typeof useSubscriptionPlansListQuery>;
export type SubscriptionPlansListLazyQueryHookResult = ReturnType<typeof useSubscriptionPlansListLazyQuery>;
export type SubscriptionPlansListQueryResult = Apollo.QueryResult<ISubscriptionPlansListQuery, ISubscriptionPlansListQueryVariables>;
export const WeekDetailsDocument = /*#__PURE__*/ gql`
    query WeekDetails($id: Int!) {
  week_template_by_pk(id: $id) {
    ...week_details_week_template
  }
}
    ${Week_Details_Week_TemplateFragmentDoc}`;
export function useWeekDetailsQuery(baseOptions: Apollo.QueryHookOptions<IWeekDetailsQuery, IWeekDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IWeekDetailsQuery, IWeekDetailsQueryVariables>(WeekDetailsDocument, options);
      }
export function useWeekDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IWeekDetailsQuery, IWeekDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IWeekDetailsQuery, IWeekDetailsQueryVariables>(WeekDetailsDocument, options);
        }
export type WeekDetailsQueryHookResult = ReturnType<typeof useWeekDetailsQuery>;
export type WeekDetailsLazyQueryHookResult = ReturnType<typeof useWeekDetailsLazyQuery>;
export type WeekDetailsQueryResult = Apollo.QueryResult<IWeekDetailsQuery, IWeekDetailsQueryVariables>;
export const WeekTemplatesListDocument = /*#__PURE__*/ gql`
    query WeekTemplatesList($where: week_template_bool_exp, $order_by: [week_template_order_by!] = {order: asc}, $offset: Int, $limit: Int) {
  week_template(
    where: $where
    order_by: $order_by
    offset: $offset
    limit: $limit
  ) {
    ...week_template
  }
  sport {
    ...sport
  }
  total: week_template_aggregate {
    aggregate {
      count(columns: id)
    }
  }
}
    ${Week_TemplateFragmentDoc}
${SportFragmentDoc}`;
export function useWeekTemplatesListQuery(baseOptions?: Apollo.QueryHookOptions<IWeekTemplatesListQuery, IWeekTemplatesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IWeekTemplatesListQuery, IWeekTemplatesListQueryVariables>(WeekTemplatesListDocument, options);
      }
export function useWeekTemplatesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IWeekTemplatesListQuery, IWeekTemplatesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IWeekTemplatesListQuery, IWeekTemplatesListQueryVariables>(WeekTemplatesListDocument, options);
        }
export type WeekTemplatesListQueryHookResult = ReturnType<typeof useWeekTemplatesListQuery>;
export type WeekTemplatesListLazyQueryHookResult = ReturnType<typeof useWeekTemplatesListLazyQuery>;
export type WeekTemplatesListQueryResult = Apollo.QueryResult<IWeekTemplatesListQuery, IWeekTemplatesListQueryVariables>;
export const WorkoutAltimetriesDocument = /*#__PURE__*/ gql`
    query WorkoutAltimetries($where: workout_altimetry_bool_exp) {
  workout_altimetry(where: $where, order_by: {coefficient: asc}) {
    ...workout_altimetry
  }
  workout_type {
    id
    avatar
    workout_type_translations {
      name
      locale {
        code
      }
    }
  }
}
    ${Workout_AltimetryFragmentDoc}`;
export function useWorkoutAltimetriesQuery(baseOptions?: Apollo.QueryHookOptions<IWorkoutAltimetriesQuery, IWorkoutAltimetriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IWorkoutAltimetriesQuery, IWorkoutAltimetriesQueryVariables>(WorkoutAltimetriesDocument, options);
      }
export function useWorkoutAltimetriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IWorkoutAltimetriesQuery, IWorkoutAltimetriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IWorkoutAltimetriesQuery, IWorkoutAltimetriesQueryVariables>(WorkoutAltimetriesDocument, options);
        }
export type WorkoutAltimetriesQueryHookResult = ReturnType<typeof useWorkoutAltimetriesQuery>;
export type WorkoutAltimetriesLazyQueryHookResult = ReturnType<typeof useWorkoutAltimetriesLazyQuery>;
export type WorkoutAltimetriesQueryResult = Apollo.QueryResult<IWorkoutAltimetriesQuery, IWorkoutAltimetriesQueryVariables>;
export const WorkoutDurationsDocument = /*#__PURE__*/ gql`
    query WorkoutDurations($where: workout_duration_bool_exp) {
  workout_duration(where: $where, order_by: {duration: asc}) {
    ...workout_duration
  }
}
    ${Workout_DurationFragmentDoc}`;
export function useWorkoutDurationsQuery(baseOptions?: Apollo.QueryHookOptions<IWorkoutDurationsQuery, IWorkoutDurationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IWorkoutDurationsQuery, IWorkoutDurationsQueryVariables>(WorkoutDurationsDocument, options);
      }
export function useWorkoutDurationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IWorkoutDurationsQuery, IWorkoutDurationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IWorkoutDurationsQuery, IWorkoutDurationsQueryVariables>(WorkoutDurationsDocument, options);
        }
export type WorkoutDurationsQueryHookResult = ReturnType<typeof useWorkoutDurationsQuery>;
export type WorkoutDurationsLazyQueryHookResult = ReturnType<typeof useWorkoutDurationsLazyQuery>;
export type WorkoutDurationsQueryResult = Apollo.QueryResult<IWorkoutDurationsQuery, IWorkoutDurationsQueryVariables>;
export const WorkoutParamsListDocument = /*#__PURE__*/ gql`
    query WorkoutParamsList($workout_type_id: Int = 0) {
  workout_type {
    id
    avatar
    workout_type_translations {
      name
      locale {
        code
      }
    }
  }
  workout_altimetry(
    where: {workout_altimetry_workout_types: {workout_type_id: {_eq: $workout_type_id}}}
    order_by: {coefficient: asc}
  ) {
    id
    name
    icon
    coefficient
    workout_altimetry_translations {
      id
      description
      locale {
        code
        language
      }
    }
    workout_altimetry_workout_types {
      id
      workout_type {
        id
        avatar
        workout_type_translations {
          name
          locale {
            code
          }
        }
      }
    }
  }
  workout_terrain {
    id
    icon
    workout_terrain_translations {
      id
      name
      description
      locale {
        code
        language
      }
    }
  }
  workout_zone(order_by: {id: asc}) {
    id
    name
    interval_start
    interval_end
  }
  circuit {
    id
    type
    circuit_translations {
      id
      name
      description
      locale {
        id
        code
      }
    }
  }
}
    `;
export function useWorkoutParamsListQuery(baseOptions?: Apollo.QueryHookOptions<IWorkoutParamsListQuery, IWorkoutParamsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IWorkoutParamsListQuery, IWorkoutParamsListQueryVariables>(WorkoutParamsListDocument, options);
      }
export function useWorkoutParamsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IWorkoutParamsListQuery, IWorkoutParamsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IWorkoutParamsListQuery, IWorkoutParamsListQueryVariables>(WorkoutParamsListDocument, options);
        }
export type WorkoutParamsListQueryHookResult = ReturnType<typeof useWorkoutParamsListQuery>;
export type WorkoutParamsListLazyQueryHookResult = ReturnType<typeof useWorkoutParamsListLazyQuery>;
export type WorkoutParamsListQueryResult = Apollo.QueryResult<IWorkoutParamsListQuery, IWorkoutParamsListQueryVariables>;
export const WorkoutTerrainsDocument = /*#__PURE__*/ gql`
    query WorkoutTerrains($where: workout_terrain_bool_exp) {
  workout_terrain(where: $where, order_by: {coefficient: asc}) {
    ...workout_terrain
  }
}
    ${Workout_TerrainFragmentDoc}`;
export function useWorkoutTerrainsQuery(baseOptions?: Apollo.QueryHookOptions<IWorkoutTerrainsQuery, IWorkoutTerrainsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IWorkoutTerrainsQuery, IWorkoutTerrainsQueryVariables>(WorkoutTerrainsDocument, options);
      }
export function useWorkoutTerrainsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IWorkoutTerrainsQuery, IWorkoutTerrainsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IWorkoutTerrainsQuery, IWorkoutTerrainsQueryVariables>(WorkoutTerrainsDocument, options);
        }
export type WorkoutTerrainsQueryHookResult = ReturnType<typeof useWorkoutTerrainsQuery>;
export type WorkoutTerrainsLazyQueryHookResult = ReturnType<typeof useWorkoutTerrainsLazyQuery>;
export type WorkoutTerrainsQueryResult = Apollo.QueryResult<IWorkoutTerrainsQuery, IWorkoutTerrainsQueryVariables>;
export const WorkoutZonesDocument = /*#__PURE__*/ gql`
    query WorkoutZones($where: workout_zone_bool_exp) {
  workout_zone(where: $where, order_by: {interval_start: asc}) {
    ...workout_zone
  }
}
    ${Workout_ZoneFragmentDoc}`;
export function useWorkoutZonesQuery(baseOptions?: Apollo.QueryHookOptions<IWorkoutZonesQuery, IWorkoutZonesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IWorkoutZonesQuery, IWorkoutZonesQueryVariables>(WorkoutZonesDocument, options);
      }
export function useWorkoutZonesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IWorkoutZonesQuery, IWorkoutZonesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IWorkoutZonesQuery, IWorkoutZonesQueryVariables>(WorkoutZonesDocument, options);
        }
export type WorkoutZonesQueryHookResult = ReturnType<typeof useWorkoutZonesQuery>;
export type WorkoutZonesLazyQueryHookResult = ReturnType<typeof useWorkoutZonesLazyQuery>;
export type WorkoutZonesQueryResult = Apollo.QueryResult<IWorkoutZonesQuery, IWorkoutZonesQueryVariables>;
export const UserByEmailDocument = /*#__PURE__*/ gql`
    query UserByEmail($email: String!) {
  user(where: {email: {_eq: $email}}) {
    id
    email
  }
}
    `;
export function useUserByEmailQuery(baseOptions: Apollo.QueryHookOptions<IUserByEmailQuery, IUserByEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IUserByEmailQuery, IUserByEmailQueryVariables>(UserByEmailDocument, options);
      }
export function useUserByEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IUserByEmailQuery, IUserByEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IUserByEmailQuery, IUserByEmailQueryVariables>(UserByEmailDocument, options);
        }
export type UserByEmailQueryHookResult = ReturnType<typeof useUserByEmailQuery>;
export type UserByEmailLazyQueryHookResult = ReturnType<typeof useUserByEmailLazyQuery>;
export type UserByEmailQueryResult = Apollo.QueryResult<IUserByEmailQuery, IUserByEmailQueryVariables>;
export const GetAthleteStressDataDocument = /*#__PURE__*/ gql`
    query GetAthleteStressData($athleteId: Int!, $startDate: date!, $endDate: date!) {
  athlete_workout(
    where: {date: {_gte: $startDate, _lte: $endDate}, athlete_week: {athlete_block: {athlete_id: {_eq: $athleteId}}}}
    order_by: {date: asc}
  ) {
    id
    date
    athlete_week_id
    athlete_workout_sections {
      id
      executed_stress_score
    }
  }
}
    `;
export function useGetAthleteStressDataQuery(baseOptions: Apollo.QueryHookOptions<IGetAthleteStressDataQuery, IGetAthleteStressDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetAthleteStressDataQuery, IGetAthleteStressDataQueryVariables>(GetAthleteStressDataDocument, options);
      }
export function useGetAthleteStressDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetAthleteStressDataQuery, IGetAthleteStressDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetAthleteStressDataQuery, IGetAthleteStressDataQueryVariables>(GetAthleteStressDataDocument, options);
        }
export type GetAthleteStressDataQueryHookResult = ReturnType<typeof useGetAthleteStressDataQuery>;
export type GetAthleteStressDataLazyQueryHookResult = ReturnType<typeof useGetAthleteStressDataLazyQuery>;
export type GetAthleteStressDataQueryResult = Apollo.QueryResult<IGetAthleteStressDataQuery, IGetAthleteStressDataQueryVariables>;
export const StatsAthleteDashboardDocument = /*#__PURE__*/ gql`
    query StatsAthleteDashboard($athleteId: Int!) {
  athlete_by_pk(id: $athleteId) {
    athlete_profile {
      ...stats_athlete_profile
    }
    athlete_biometric_data(order_by: {created_at: asc}) {
      ...stats_biometric_data
    }
    athlete_blocks(order_by: {start_date: desc}) {
      athlete_weeks {
        ...stats_athlete_week
      }
    }
  }
}
    ${Stats_Athlete_ProfileFragmentDoc}
${Stats_Biometric_DataFragmentDoc}
${Stats_Athlete_WeekFragmentDoc}`;
export function useStatsAthleteDashboardQuery(baseOptions: Apollo.QueryHookOptions<IStatsAthleteDashboardQuery, IStatsAthleteDashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IStatsAthleteDashboardQuery, IStatsAthleteDashboardQueryVariables>(StatsAthleteDashboardDocument, options);
      }
export function useStatsAthleteDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IStatsAthleteDashboardQuery, IStatsAthleteDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IStatsAthleteDashboardQuery, IStatsAthleteDashboardQueryVariables>(StatsAthleteDashboardDocument, options);
        }
export type StatsAthleteDashboardQueryHookResult = ReturnType<typeof useStatsAthleteDashboardQuery>;
export type StatsAthleteDashboardLazyQueryHookResult = ReturnType<typeof useStatsAthleteDashboardLazyQuery>;
export type StatsAthleteDashboardQueryResult = Apollo.QueryResult<IStatsAthleteDashboardQuery, IStatsAthleteDashboardQueryVariables>;